/**
 * GENERATED — DO NOT EDIT BY HAND.
 *
 * Source of truth: the Service-Layer OpenAPI document mirrored at
 *   packages/core/lib/src/wire/openapi/openapi.json
 * Generated by:
 *   pnpm gen:contracts   (scripts/gen-contracts.mjs, openapi-zod-client schemas-only)
 *
 * Hand-authoring any wire contract is BANNED. To change a contract, change the
 * SL spec, run `pnpm fetch:sl-openapi && pnpm gen:contracts`, and commit the diff.
 * The fail-on-drift gate (`pnpm gen:contracts:check`) enforces this.
 */

import { z } from "zod";

export const PlannerContextRequest = z.object({
  ref: z.union([z.string(), z.null()]).optional().default("main"),
  sprint_id: z.string().regex(/^SP-\d{3,}$/),
});
export const PlannerNodeEnvelope = z
  .object({
    artifact_refs: z.object({}).partial().passthrough(),
    dag_version: z.number().int(),
    node: z.string(),
    planner_fingerprint: z.string(),
    reused: z.boolean(),
    sprint_id: z.string(),
  })
  .passthrough();
export const ValidationError = z
  .object({
    ctx: z.object({}).partial().passthrough().optional(),
    input: z.unknown().optional(),
    loc: z.array(z.union([z.string(), z.number().int()])),
    msg: z.string(),
    type: z.string(),
  })
  .passthrough();
export const HTTPValidationError = z
  .object({ detail: z.array(ValidationError) })
  .partial()
  .passthrough();
export const PlannerPlanRequest = z.object({
  ref: z.union([z.string(), z.null()]).optional().default("main"),
  sprint_id: z.string().regex(/^SP-\d{3,}$/),
});
export const AutopilotSprintState = z
  .object({
    id: z.union([z.string(), z.null()]),
    intent_doc_path: z.union([z.string(), z.null()]),
    intent_doc_sha: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    prd_hash: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const AutopilotStateEnvelope = z
  .object({
    decisions: z.array(z.object({}).partial().passthrough()),
    revisions: z.array(z.object({}).partial().passthrough()),
    runs: z.array(z.object({}).partial().passthrough()),
    sprint: AutopilotSprintState,
  })
  .passthrough();
export const ImageRefOut = z.object({
  alt: z.string().min(1),
  url: z.string().min(1),
});
export const SeoMetaOut = z.object({
  description: z.union([z.string(), z.null()]),
  title: z.union([z.string(), z.null()]),
});
export const BlogPostOut = z.object({
  author: z.union([z.string(), z.null()]),
  body: z.string(),
  category: z.string().min(1),
  date: z.string().min(1),
  excerpt: z.string(),
  image: z.union([ImageRefOut, z.null()]),
  readingTime: z.string().min(1),
  seo: SeoMetaOut,
  slug: z.string().min(1),
  title: z.string().min(1),
});
export const ContentErrorOut = z.object({ error: z.string().min(1) });
export const FaqItemOut = z.object({
  answer: z.string(),
  category: z.string().min(1),
  id: z.string().min(1),
  question: z.string().min(1),
  sort: z.number().int(),
  topic: z.string().min(1),
});
export const IndustryProductOut = z.object({
  image: z.union([ImageRefOut, z.null()]),
  name: z.string().min(1),
  shortDescription: z.string(),
  slug: z.string().min(1),
});
export const IndustryOut = z.object({
  description: z.string(),
  heroImage: z.union([ImageRefOut, z.null()]),
  name: z.string().min(1),
  products: z.array(IndustryProductOut),
  seo: SeoMetaOut,
  slug: z.string().min(1),
});
export const IndustryChallengeOut = z.object({
  body: z.string(),
  heading: z.string().min(1),
});
export const FaqEntryOut = z.object({
  answer: z.string(),
  question: z.string().min(1),
});
export const IndustryPageOut = z.object({
  applications: z.string(),
  challenges: z.array(IndustryChallengeOut),
  faq: z.array(FaqEntryOut),
  h1: z.string().min(1),
  intro: z.string(),
  seo: SeoMetaOut,
  slug: z.string().min(1),
});
export const JobMetaOut = z.object({
  branche: z.string(),
  dauer: z.string(),
  ort: z.string(),
  pensum: z.string(),
  start: z.string(),
});
export const JobOut = z.object({
  anforderungen: z.array(z.string()),
  aufgaben: z.array(z.string()),
  benefits: z.array(z.string()),
  intro: z.string(),
  meta: JobMetaOut,
  seo: SeoMetaOut,
  slug: z.string().min(1),
  subtitle: z.string().min(1),
  title: z.string().min(1),
});
export const LegalDocumentOut = z.object({
  body: z.string(),
  key: z.enum(["impressum", "agb", "datenschutz", "avb"]),
  seo: SeoMetaOut,
  title: z.string().min(1),
});
export const NavigationItemOut = z.object({
  href: z.string().min(1),
  key: z.string().min(1),
  label: z.string().min(1),
  sort: z.number().int(),
});
export const CallToActionOut = z.object({
  href: z.string().min(1),
  label: z.string().min(1),
});
export const HeroBlockOut = z.object({
  cta: z.union([CallToActionOut, z.null()]),
  headline: z.string().min(1),
  media: z.union([ImageRefOut, z.null()]),
  sub: z.string(),
  type: z.literal("hero"),
});
export const TextItemOut = z.object({ body: z.string(), title: z.string().min(1) });
export const ValueRowsBlockOut = z.object({
  heading: z.union([z.string(), z.null()]).optional(),
  items: z.array(TextItemOut),
  type: z.literal("valueRows"),
});
export const StepsBlockOut = z.object({
  heading: z.union([z.string(), z.null()]).optional(),
  items: z.array(TextItemOut),
  type: z.literal("steps"),
});
export const CtaBandBlockOut = z.object({
  cta: z.union([CallToActionOut, z.null()]),
  secondaryCta: z.union([CallToActionOut, z.null()]).optional(),
  text: z.string(),
  title: z.string().min(1),
  type: z.literal("ctaBand"),
});
export const EditorialHeroBlockOut = z.object({
  cta: z.union([CallToActionOut, z.null()]),
  eyebrow: z.union([z.string(), z.null()]),
  headline: z.string().min(1),
  secondaryCta: z.union([CallToActionOut, z.null()]),
  sub: z.string(),
  type: z.literal("editorialHero"),
});
export const VideoHeroBlockOut = z.object({
  cta: z.union([CallToActionOut, z.null()]),
  headline: z.string().min(1),
  meta: z.array(z.string()),
  poster: z.union([ImageRefOut, z.null()]),
  secondaryCta: z.union([CallToActionOut, z.null()]),
  sub: z.string(),
  type: z.literal("videoHero"),
  videoUrl: z.union([z.string(), z.null()]),
});
export const HairlineIndexItemOut = z.object({
  description: z.string(),
  href: z.string().min(1),
  label: z.string().min(1),
});
export const HairlineIndexBlockOut = z.object({
  heading: z.union([z.string(), z.null()]),
  items: z.array(HairlineIndexItemOut),
  lead: z.union([z.string(), z.null()]),
  numbered: z.boolean(),
  type: z.literal("hairlineIndex"),
});
export const FeaturedProductTeaserOut = z.object({
  href: z.string().min(1),
  img: z.union([z.string(), z.null()]),
  name: z.string().min(1),
  slug: z.string().min(1),
  tagline: z.string(),
});
export const FeaturedProductsBlockOut = z.object({
  heading: z.string().min(1),
  items: z.array(FeaturedProductTeaserOut),
  link: z.union([CallToActionOut, z.null()]),
  type: z.literal("featuredProducts"),
});
export const SplitFactOut = z.object({ text: z.string(), title: z.string().min(1) });
export const SplitImageTextBlockOut = z.object({
  body: z.string(),
  bullets: z.array(z.string()),
  cta: z.union([CallToActionOut, z.null()]),
  facts: z.array(SplitFactOut),
  heading: z.string().min(1),
  image: z.union([ImageRefOut, z.null()]),
  imageSide: z.enum(["left", "right"]),
  type: z.literal("splitImageText"),
});
export const StatItemOut = z.object({
  label: z.string().min(1),
  value: z.string().min(1),
});
export const StatsBandBlockOut = z.object({
  heading: z.union([z.string(), z.null()]),
  items: z.array(StatItemOut),
  type: z.literal("statsBand"),
  variant: z.enum(["dark", "light"]),
});
export const DecorativeImageRefOut = z.object({
  decorative: z.boolean(),
  url: z.string().min(1),
});
export const DarkCtaBandBlockOut = z.object({
  cta: z.union([CallToActionOut, z.null()]),
  headline: z.string().min(1),
  media: z.union([DecorativeImageRefOut, z.null()]),
  secondaryCta: z.union([CallToActionOut, z.null()]),
  text: z.string(),
  type: z.literal("darkCtaBand"),
});
export const MediaBandBlockOut = z.object({
  caption: z.union([z.string(), z.null()]),
  media: DecorativeImageRefOut,
  type: z.literal("mediaBand"),
});
export const SegmentCardOut = z.object({
  body: z.string(),
  image: ImageRefOut,
  title: z.string().min(1),
});
export const SegmentsBlockOut = z.object({
  heading: z.string().min(1),
  items: z.array(SegmentCardOut),
  type: z.literal("segments"),
});
export const ColorSwatchOut = z.object({
  color: z.string().min(1),
  name: z.string().min(1),
});
export const ColorSpectrumBlockOut = z.object({
  caption: z.string(),
  swatches: z.array(ColorSwatchOut),
  type: z.literal("colorSpectrum"),
});
export const StorySplitBlockOut = z.object({
  body: z.string(),
  image: z.union([ImageRefOut, z.null()]),
  imageSide: z.enum(["left", "right"]),
  quote: z.string().min(1),
  type: z.literal("storySplit"),
});
export const PageOut = z.object({
  blocks: z.array(
    z.discriminatedUnion("type", [
      HeroBlockOut,
      ValueRowsBlockOut,
      StepsBlockOut,
      CtaBandBlockOut,
      EditorialHeroBlockOut,
      VideoHeroBlockOut,
      HairlineIndexBlockOut,
      FeaturedProductsBlockOut,
      SplitImageTextBlockOut,
      StatsBandBlockOut,
      DarkCtaBandBlockOut,
      MediaBandBlockOut,
      SegmentsBlockOut,
      ColorSpectrumBlockOut,
      StorySplitBlockOut,
    ])
  ),
  key: z.enum(["home", "ueber-uns"]),
  seo: SeoMetaOut,
});
export const ApplicationStepOut = z.object({
  description: z.string(),
  title: z.string().min(1),
});
export const MaterialCompatibilityOut = z.object({
  avoid: z.array(z.string()),
  ok: z.array(z.string()),
});
export const ProductRefOut = z.object({
  name: z.string().min(1),
  slug: z.string().min(1),
});
export const ProductOut = z.object({
  anwendung: z.union([z.string(), z.null()]),
  applicationSteps: z.array(ApplicationStepOut),
  applications: z.array(z.string()),
  badges: z.array(z.string()),
  category: z.string().min(1),
  color: z.string().min(1),
  description: z.string(),
  dosierung: z.union([z.string(), z.null()]),
  eigenschaften: z.array(z.string()),
  img: z.union([z.string(), z.null()]),
  labelling: z.enum(["kennzeichnungsfrei", "kennzeichnungspflichtig"]),
  materialCompatibility: z.union([MaterialCompatibilityOut, z.null()]),
  materialien: z.array(z.string()),
  mixingRatio: z.union([z.string(), z.null()]),
  name: z.string().min(1),
  phTyp: z.enum(["Sauer", "Neutral", "Alkalisch"]),
  seo: SeoMetaOut,
  slug: z.string().min(1),
  tagline: z.string().min(1),
  typicalProblems: z.array(z.string()),
  usageArea: z.enum(["Sanitär", "Küche", "Werkstatt", "Maschine", "Fläche"]),
  useCases: z.array(z.string()),
  valueProposition: z.union([z.string(), z.null()]),
  zubehoer: z.array(ProductRefOut),
});
export const expect_sha = z.union([z.string().min(64).max(64), z.null()]).optional();
export const ComplianceManifestResponse = z
  .object({
    checksum: z.string(),
    code_constant_count: z.number().int(),
    envelope_count: z.number().int(),
    generated_at: z.string(),
    route_count: z.number().int(),
  })
  .passthrough();
export const DiscoveryReviewRequest = z.object({
  match_path: z.string().min(1),
  match_value: z.string(),
  use_case_id: z.string().min(1),
  value_path: z.string().min(1),
});
export const DiscoveryValue = z
  .object({
    count: z.union([z.number().int(), z.null()]),
    value: z.union([z.unknown(), z.null()]),
  })
  .partial()
  .passthrough();
export const DiscoveryReviewEnvelope = z
  .object({ values: z.array(DiscoveryValue) })
  .partial()
  .passthrough();
export const EvalReadRequest = z.object({
  config_kind: z.union([z.string(), z.null()]).optional(),
  consumer_id: z.union([z.string(), z.null()]).optional(),
  use_case_id: z.string().min(1),
  version: z.union([z.number().int().gte(1), z.null()]).optional(),
});
export const EvalReadEnvelope = z
  .object({
    config_versions: z.union([
      z.array(z.object({}).partial().passthrough()),
      z.null(),
    ]),
    eval: z.union([z.object({}).partial().passthrough(), z.null()]),
    use_case_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ConfigPromoteRequest = z.object({
  config_kind: z.string().min(1),
  consumer_id: z.string().min(1),
  version: z.number().int().gte(1),
});
export const LlmConfigVersionEnvelope = z
  .object({
    config_kind: z.union([z.string(), z.null()]),
    consumer_id: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    is_active: z.union([z.boolean(), z.null()]),
    proposed_at: z.union([z.string(), z.null()]),
    proposed_by: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    version: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const ConfigProposeRequest = z.object({
  config: z.object({}).partial().passthrough(),
  config_kind: z.string().min(1),
  consumer_id: z.string().min(1),
});
export const HygieneBrokenRefRow = z
  .object({
    broken_ref: z.string(),
    doc_id: z.string(),
    doc_title: z.union([z.string(), z.null()]).optional(),
    ref_kind: z.string(),
  })
  .passthrough();
export const HygieneChildlessDocRow = z
  .object({
    doc_id: z.string(),
    status: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const HygieneForkRow = z
  .object({
    count: z.number().int(),
    doc_ids: z.array(z.string()),
    title: z.string(),
    type: z.string(),
  })
  .passthrough();
export const HygieneOrphanChunkRow = z
  .object({ chunk_id: z.string(), document_id: z.string() })
  .passthrough();
export const HygieneStaleEmbeddingRow = z
  .object({
    chunk_created_at: z.union([z.string(), z.null()]).optional(),
    chunk_id: z.string(),
    doc_id: z.string(),
    doc_updated_at: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CrossStoreHygieneData = z
  .object({
    broken_refs: z.array(HygieneBrokenRefRow),
    childless_docs: z.array(HygieneChildlessDocRow),
    chunk_limit: z.number().int(),
    chunks_scanned: z.number().int(),
    docs_scanned: z.number().int(),
    forks: z.array(HygieneForkRow),
    limit: z.number().int(),
    orphan_chunks: z.array(HygieneOrphanChunkRow),
    stale_embeddings: z.array(HygieneStaleEmbeddingRow),
    summary: z.object({}).partial().passthrough(),
  })
  .passthrough();
export const CrossStoreHygieneEnvelope = z
  .object({ data: CrossStoreHygieneData, success: z.boolean() })
  .passthrough();
export const DocSweeperExpiredCadenceRow = z
  .object({
    cadence: z.union([z.string(), z.null()]).optional(),
    days_since_update: z.union([z.number().int(), z.null()]).optional(),
    id: z.string(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const DocSweeperStaleDraftRow = z
  .object({
    id: z.string(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
    updated_at: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const DocSweeperEnvelope = z
  .object({
    dry_run: z.boolean(),
    expired_cadence: z.array(DocSweeperExpiredCadenceRow),
    orphans: z.array(z.object({}).partial().passthrough()),
    stale_drafts: z.array(DocSweeperStaleDraftRow),
    summary: z.object({}).partial().passthrough(),
  })
  .passthrough();
export const EntityJourneyMeta = z
  .object({
    captures_populated: z.union([z.boolean(), z.null()]),
    directive: z.union([z.string(), z.null()]),
    generated_at: z.union([z.string(), z.null()]),
    spec: z.union([z.string(), z.null()]),
    view_version: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const EntityJourneyData = z
  .object({
    dispatches: z.array(z.unknown()).default([]),
    emitted_errors: z.array(z.unknown()).default([]),
    emitted_outcomes: z.array(z.unknown()).default([]),
    entity: z.union([z.unknown(), z.null()]),
    logs: z.array(z.unknown()).default([]),
    meta: z.union([EntityJourneyMeta, z.null()]),
    signals: z.array(z.unknown()).default([]),
    transitions: z.array(z.unknown()).default([]),
  })
  .partial()
  .passthrough();
export const EntityJourneyEnvelope = z
  .object({ data: EntityJourneyData, success: z.boolean() })
  .passthrough();
export const GoldenRunRequest = z.object({
  config_kind: z.union([z.string(), z.null()]).optional(),
  consumer_id: z.union([z.string(), z.null()]).optional(),
  use_case_id: z.string().min(1),
  version: z.union([z.number().int().gte(1), z.null()]).optional(),
});
export const GoldenRunEnvelope = z
  .object({
    run_id: z.union([z.number().int(), z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    use_case_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const EvalStatusEnvelope = z
  .object({
    passing: z.union([z.boolean(), z.null()]),
    status: z.union([z.string(), z.null()]),
    use_case_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const GdprAnonymizeResponse = z
  .object({
    anonymized_at: z.string(),
    tables_affected: z.array(z.object({}).partial().passthrough()),
    total_rows_anonymized: z.number().int(),
    user_id: z.string(),
  })
  .passthrough();
export const PiiTableExport = z
  .object({
    row_count: z.number().int(),
    rows: z.array(z.object({}).partial().passthrough()),
    table: z.string(),
  })
  .passthrough();
export const GdprExportResponse = z
  .object({
    exported_at: z.string(),
    tables: z.array(PiiTableExport),
    total_rows: z.number().int(),
    user_id: z.string(),
  })
  .passthrough();
export const GoldenAdmissionRequest = z.object({
  admitted_value: z.string().min(1),
  golden_case_id: z.union([z.string().min(1), z.null()]).optional(),
  reason: z.union([z.string().min(1), z.null()]).optional(),
  scored_field: z.string().min(1),
  source_eval_run_id: z.union([z.string().min(1), z.null()]).optional(),
  use_case_id: z.string().min(1),
});
export const GoldenAdmissionEnvelope = z
  .object({
    admitted_at: z.union([z.string(), z.null()]),
    admitted_by: z.union([z.string(), z.null()]),
    admitted_value: z.union([z.string(), z.null()]),
    golden_case_id: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    reason: z.union([z.string(), z.null()]),
    scored_field: z.union([z.string(), z.null()]),
    source_eval_run_id: z.union([z.string(), z.null()]),
    use_case_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ReconcilePauseAbandonEnvelope = z
  .object({
    detected: z.number().int(),
    dry_run: z.boolean(),
    orphan_ids: z.array(z.string()),
    released: z.number().int(),
    timeout_minutes: z.number().int(),
  })
  .passthrough();
export const StaleRefRow = z
  .object({
    doc_id: z.string(),
    doc_title: z.union([z.string(), z.null()]).optional(),
    ref_kind: z.string(),
    stale_ref: z.string(),
  })
  .passthrough();
export const StaleRefAuditData = z
  .object({
    docs_scanned: z.number().int(),
    limit: z.number().int(),
    stale_ref_count: z.number().int(),
    stale_refs: z.array(StaleRefRow),
  })
  .passthrough();
export const StaleRefAuditEnvelope = z
  .object({ data: StaleRefAuditData, success: z.boolean() })
  .passthrough();
export const RevokeSessionsRequest = z.object({ reason: z.string().min(1) });
export const RevokeSessionsResponse = z
  .object({
    reason: z.string(),
    revoked_at: z.string(),
    revoked_by: z.string(),
    user_id: z.string(),
  })
  .passthrough();
export const EmbodimentRef = z
  .object({
    branch: z.union([z.string(), z.null()]).optional(),
    embodiment_id: z.string(),
    external_session_id: z.union([z.string(), z.null()]).optional(),
    idle_seconds: z.union([z.number().int(), z.null()]).optional(),
    last_activity_at: z.union([z.string(), z.null()]).optional(),
    last_message: z.union([z.string(), z.null()]).optional(),
    location: z.union([z.string(), z.null()]).optional(),
    machine: z.union([z.string(), z.null()]).optional(),
    model: z.union([z.string(), z.null()]).optional(),
    replies: z.number().int().optional().default(0),
    repo: z.union([z.string(), z.null()]).optional(),
    shorthandle: z.union([z.string(), z.null()]).optional(),
    started_at: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    turns: z.number().int().optional().default(0),
    vendor: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const PersonaRow = z
  .object({
    agent_id: z.string(),
    display_name: z.union([z.string(), z.null()]).optional(),
    live_embodiments: z.array(EmbodimentRef).optional(),
    primary_embodiment: z.union([EmbodimentRef, z.null()]).optional(),
    repo: z.union([z.string(), z.null()]).optional(),
    shorthandle: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    vendor: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const AgentsRegistryEnvelope = z
  .object({ data: z.array(PersonaRow), total: z.number().int() })
  .passthrough();
export const AgentPinnedDocRow = z
  .object({
    created_at: z.string(),
    document_id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    gcs_path: z.union([z.string(), z.null()]).optional(),
    heading: z.union([z.string(), z.null()]).optional(),
    id: z.union([z.number().int(), z.string()]),
    namespace: z.union([z.string(), z.null()]).optional(),
    score: z.union([z.number(), z.null()]).optional(),
    snippet: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    title: z.string(),
    type: z.string(),
    updated_at: z.string(),
    version: z.number().int(),
  })
  .passthrough();
export const AgentDocsListEnvelope = z
  .object({ data: z.array(AgentPinnedDocRow), total: z.number().int() })
  .passthrough();
export const _PinBody = z.object({ doc_id: z.string().min(1) });
export const AgentDocPinEnvelope = z
  .object({
    already_pinned: z.boolean(),
    frontmatter_consumers: z.array(z.string()),
    success: z.boolean(),
  })
  .passthrough();
export const AgentDocUnpinEnvelope = z
  .object({
    already_unpinned: z.boolean(),
    frontmatter_consumers: z.array(z.string()),
    success: z.boolean(),
  })
  .passthrough();
export const IdentityDocSlot = z
  .object({
    doc_id: z.union([z.number().int(), z.string(), z.null()]),
    resolution: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
    version: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const SystemPromptStack = z
  .object({
    active_environment: z.union([z.unknown(), z.null()]),
    base: z.union([IdentityDocSlot, z.null()]),
    components: z.array(z.unknown()).default([]),
  })
  .partial()
  .passthrough();
export const AgentIdentityDocsEnvelope = z
  .object({
    bootstrap: z.union([IdentityDocSlot, z.null()]),
    system_prompt: z.union([SystemPromptStack, z.null()]),
    working_doc: z.union([IdentityDocSlot, z.null()]),
  })
  .partial()
  .passthrough();
export const MessageRequest = z.object({
  target_embodiment_id: z.union([z.string(), z.null()]).optional(),
  text: z.string().min(1),
});
export const MessageResponse = z
  .object({
    dispatched_via: z.string(),
    resolved_embodiment_id: z.string(),
    routing_override: z.boolean().optional().default(false),
    row_id: z.string(),
  })
  .passthrough();
export const app__api__v1__agents_models__MessageEnvelope = z
  .object({ data: MessageResponse, success: z.boolean() })
  .passthrough();
export const app__api__v1__agents_models__SpawnRequest = z
  .object({
    branch: z.union([z.string(), z.null()]),
    model: z.union([z.string(), z.null()]),
    repo: z.union([z.string(), z.null()]),
  })
  .partial();
export const app__api__v1__agents_models__SpawnResponse = z
  .object({ session_id: z.string(), status: z.string() })
  .passthrough();
export const SpawnEnvelope = z
  .object({
    data: app__api__v1__agents_models__SpawnResponse,
    success: z.boolean(),
  })
  .passthrough();
export const owner_email = z.union([z.string(), z.null()]).optional();
export const lead_id = z.union([z.string().uuid(), z.null()]).optional();
export const AppointmentRow = z
  .object({
    commitment: z.union([z.string(), z.null()]),
    contact_person_id: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    date_target: z.union([z.string(), z.null()]),
    ends_at: z.union([z.string(), z.null()]),
    id: z.union([z.string(), z.null()]),
    lead_id: z.union([z.string(), z.null()]),
    location_text: z.union([z.string(), z.null()]),
    notes: z.union([z.string(), z.null()]),
    org_id: z.union([z.string(), z.null()]),
    owner_email: z.union([z.string(), z.null()]),
    starts_at: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    time_label: z.union([z.string(), z.null()]),
    time_type: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const AppointmentListResponse = z
  .object({
    data: z.array(AppointmentRow),
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const AppointmentCreateRequest = z.object({
  commitment: z
    .string()
    .regex(/^(tentativ|zeitfenster|bestaetigt)$/)
    .optional()
    .default("tentativ"),
  contact_person_id: z.union([z.string(), z.null()]).optional(),
  date_target: z
    .union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/), z.null()])
    .optional(),
  ends_at: z.union([z.string(), z.null()]).optional(),
  lead_id: z.union([z.string(), z.null()]).optional(),
  location_text: z.union([z.string(), z.null()]).optional(),
  notes: z.union([z.string(), z.null()]).optional(),
  org_id: z.union([z.string(), z.null()]).optional(),
  owner_email: z.string(),
  starts_at: z.union([z.string(), z.null()]).optional(),
  status: z
    .string()
    .regex(/^(planned|completed|cancelled|rescheduled)$/)
    .optional()
    .default("planned"),
  time_label: z.union([z.string(), z.null()]).optional(),
  time_type: z
    .string()
    .regex(/^(precise|window|vague)$/)
    .optional()
    .default("precise"),
});
export const AppointmentRowResponse = z
  .object({
    data: AppointmentRow,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const AppointmentUpdateRequest = z
  .object({
    commitment: z.union([
      z.string().regex(/^(tentativ|zeitfenster|bestaetigt)$/),
      z.null(),
    ]),
    contact_person_id: z.union([z.string(), z.null()]),
    date_target: z.union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/), z.null()]),
    ends_at: z.union([z.string(), z.null()]),
    expected_updated_at: z.union([z.string(), z.null()]),
    lead_id: z.union([z.string(), z.null()]),
    location_text: z.union([z.string(), z.null()]),
    notes: z.union([z.string(), z.null()]),
    starts_at: z.union([z.string(), z.null()]),
    status: z.union([
      z.string().regex(/^(planned|completed|cancelled|rescheduled)$/),
      z.null(),
    ]),
    time_label: z.union([z.string(), z.null()]),
    time_type: z.union([
      z.string().regex(/^(precise|window|vague)$/),
      z.null(),
    ]),
  })
  .partial();
export const CookieHandoffBody = z
  .object({
    access_token: z.string().min(10),
    provider: z.union([z.string(), z.null()]).optional(),
    provider_access_token: z.union([z.string(), z.null()]).optional(),
    provider_expires_in: z.union([z.number().int(), z.null()]).optional(),
    provider_refresh_token: z.union([z.string(), z.null()]).optional(),
    refresh_token: z.string().min(10),
    user: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
  })
  .passthrough();
export const OnboardingOtpStartRequest = z.object({ phone: z.string().min(1) });
export const OnboardingOtpStartResponse = z
  .object({ challenge_id: z.string().min(1), expires_at: z.string().min(1) })
  .passthrough();
export const OnboardingOtpVerifyRequest = z.object({
  code: z.string().min(1),
  phone: z.string().min(1),
});
export const OnboardingOtpVerifyResponse = z
  .object({
    access_token: z.string().min(1),
    refresh_token: z.string().min(1),
    user_id: z.string().min(1),
  })
  .passthrough();
export const BatchJobResponse = z
  .object({
    data: z.object({}).partial().passthrough(),
    meta: z.object({}).partial().passthrough(),
    success: z.boolean(),
  })
  .passthrough();
export const BatchProcessingOptions = z
  .object({
    chunk_size: z.number().int().default(100),
    max_concurrency: z.number().int().default(8),
    priority: z.string().default("normal"),
    retry_attempts: z.number().int().default(2),
    retry_delay_sec: z.number().int().default(5),
    services: z.array(z.string()).default(["imprint"]),
    timeout_sec_per_company: z.number().int().default(45),
  })
  .partial()
  .passthrough();
export const BatchProcessingRequest = z.object({
  company_ids: z.array(z.string()),
  options: z.union([BatchProcessingOptions, z.null()]).optional(),
});
export const BatchJobStatus = z.enum([
  "queued",
  "processing",
  "completed",
  "failed",
  "paused",
  "cancelled",
]);
export const status = z.union([BatchJobStatus, z.null()]).optional();
export const BatchJobListResponse = z
  .object({
    data: z.array(z.object({}).partial().passthrough()),
    meta: z.object({}).partial().passthrough(),
    success: z.boolean(),
  })
  .passthrough();
export const BatchStatsResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const BulkDeleteRequest = z.object({
  entity_type: z.enum(["missions", "mission_leads"]),
  ids: z.array(z.string()).min(1).max(100),
});
export const BulkDeleteData = z
  .object({ affected: z.number().int(), delete_status: z.string() })
  .passthrough();
export const BulkDeleteEnvelope = z
  .object({ data: BulkDeleteData, success: z.boolean() })
  .passthrough();
export const BulkExportRequest = z.object({
  entity_type: z.enum(["missions", "mission_leads", "unified_lead_base"]),
  fields: z.union([z.array(z.string()), z.null()]).optional(),
  filters: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
  ids: z.union([z.array(z.string()).max(100), z.null()]).optional(),
});
export const BulkExportData = z
  .object({
    count: z.number().int(),
    fields: z.array(z.string()),
    rows: z.array(z.object({}).partial().passthrough()),
  })
  .passthrough();
export const BulkExportEnvelope = z
  .object({ data: BulkExportData, success: z.boolean() })
  .passthrough();
export const BulkStatusChangeRequest = z.object({
  entity_type: z.enum(["missions", "mission_leads"]),
  ids: z.array(z.string()).min(1).max(100),
  status: z.string().min(1).max(50),
});
export const BulkStatusData = z
  .object({ affected: z.number().int(), status: z.string() })
  .passthrough();
export const BulkStatusEnvelope = z
  .object({ data: BulkStatusData, success: z.boolean() })
  .passthrough();
export const CallQueueStatus = z.enum([
  "pending",
  "in_progress",
  "completed",
  "skipped",
  "callback",
]);
export const CallQueueRow = z
  .object({
    assigned_caller_id: z.union([z.string(), z.null()]),
    attempt_count: z.union([z.number().int(), z.null()]),
    available_at: z.union([z.string(), z.null()]),
    campaign_id: z.union([z.string(), z.null()]),
    company_name: z.union([z.string(), z.null()]),
    completed_at: z.union([z.string(), z.null()]),
    contact_name: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    detection_suggestion: z.union([
      z.object({}).partial().passthrough(),
      z.null(),
    ]),
    detection_suggestion_generated_at: z.union([z.string(), z.null()]),
    disqualified_at: z.union([z.string(), z.null()]),
    disqualified_by: z.union([z.string(), z.null()]),
    disqualified_reason: z.union([z.string(), z.null()]),
    id: z.union([z.string(), z.null()]),
    last_result_id: z.union([z.string(), z.null()]),
    lead_briefing: z.union([z.object({}).partial().passthrough(), z.null()]),
    max_attempts: z.union([z.number().int(), z.null()]),
    outcome: z.union([z.string(), z.null()]),
    parent_call_id: z.union([z.string(), z.null()]),
    phone: z.union([z.string(), z.null()]),
    priority: z.union([z.number().int(), z.null()]),
    scheduled_at: z.union([z.string(), z.null()]),
    session_id: z.union([z.string(), z.null()]),
    skipped_at: z.union([z.string(), z.null()]),
    skipped_by: z.union([z.string(), z.null()]),
    status: z.union([CallQueueStatus, z.null()]),
    suggested_demo_use_case: z.union([z.string(), z.null()]),
    unified_lead_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const CallbackRemoveResponse = z
  .object({
    data: CallQueueRow,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const CallingError = z
  .object({ code: z.string(), message: z.string() })
  .passthrough();
export const CallingErrorResponse = z.object({ error: CallingError }).passthrough();
export const CallbackQueuePatchRequest = z.object({
  action: z.enum(["complete", "reschedule"]),
  callback_at: z
    .union([z.string().datetime({ offset: true }), z.null()])
    .optional(),
});
export const CallResultRow = z
  .object({
    call_sid: z.union([z.string(), z.null()]),
    call_timestamp: z.union([z.string(), z.null()]),
    callback_time: z.union([z.string(), z.null()]),
    caller_id: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    follow_up_completed: z.union([z.boolean(), z.null()]),
    follow_up_completed_at: z.union([z.string(), z.null()]),
    follow_up_scheduled_at: z.union([z.string(), z.null()]),
    id: z.union([z.string(), z.null()]),
    outcome: z.union([z.string(), z.null()]),
    rep_id: z.union([z.string(), z.null()]),
    session_id: z.union([z.string(), z.null()]),
    unified_lead_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const CallbackQueuePatchData = z
  .object({
    action: z.enum(["complete", "reschedule"]),
    call_result: CallResultRow,
    call_result_id: z.string(),
    unified_lead_id: z.string(),
  })
  .passthrough();
export const CallbackQueuePatchResponse = z
  .object({
    data: CallbackQueuePatchData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const CallResultOutcome = z.enum([
  "qualified",
  "disqualified",
  "not_reached",
  "wrong_number",
  "closed",
  "blocked",
  "call_later",
  "reached",
  "Email_Pfad_Deflection",
]);
export const CallResultCreateRequest = z
  .object({
    call_sid: z.union([z.string(), z.null()]).optional(),
    callback_time: z.union([z.string(), z.null()]).optional(),
    outcome: CallResultOutcome,
    session_id: z.string(),
    unified_lead_id: z.string(),
  })
  .passthrough();
export const app__api__v1__calling_row_models__ContactPersonRow = z
  .object({
    full_name: z.union([z.string(), z.null()]),
    id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const CallResultCreateData = z
  .object({
    call_result: CallResultRow,
    contact_person: z
      .union([app__api__v1__calling_row_models__ContactPersonRow, z.null()])
      .optional(),
    queue_status: z.union([CallQueueStatus, z.null()]).optional(),
  })
  .passthrough();
export const CallResultCreateResponse = z
  .object({
    data: CallResultCreateData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const CallResultErrorCode = z.enum([
  "UNAUTHORIZED",
  "FORBIDDEN",
  "MISSING_IDENTITY",
  "SESSION_EXPIRED",
  "INVALID_SESSION_ID",
  "CALL_RESULT_CREATE_FAILED",
  "CALL_RESULT_CREATE_NO_ROW",
  "CALL_RESULT_UNEXPECTED_ERROR",
  "CONTACT_PERSON_DERIVE_FAILED",
]);
export const CallResultErrorDetailV1 = z
  .object({
    code: CallResultErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CallResultErrorEnvelopeV1 = z
  .object({ error: CallResultErrorDetailV1 })
  .passthrough();
export const CampaignRow = z
  .object({
    campaign_type: z.union([z.string(), z.null()]),
    config: z.union([z.object({}).partial().passthrough(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    created_by: z.union([z.string(), z.null()]),
    id: z.union([z.string(), z.null()]),
    session_config: z.union([z.object({}).partial().passthrough(), z.null()]),
    status: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const CampaignListResponse = z
  .object({
    data: z.array(CampaignRow),
    success: z.literal(true).optional().default(true),
    total: z.number().int(),
  })
  .passthrough();
export const CampaignDetailResponse = z
  .object({
    data: CampaignRow,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const CallingEventCreateRequest = z.object({
  caller_id: z.string(),
  event_id: z.string(),
  event_type: z.string(),
  metadata: z.object({}).partial().passthrough().optional(),
  session_id: z.union([z.string(), z.null()]).optional(),
  timestamp: z.string(),
});
export const CallingEventIngestResponse = z
  .object({
    event_id: z.string(),
    server_received_at: z.string(),
    status: z.enum(["inserted", "deduplicated"]),
  })
  .passthrough();
export const ClaimNextLeadRequest = z.object({
  p_caller_id: z.string(),
  p_campaign_id: z.union([z.string(), z.null()]).optional(),
  p_session_id: z.string(),
});
export const ClaimedLead = z
  .object({
    company_name: z.union([z.string(), z.null()]),
    contact_name: z.union([z.string(), z.null()]),
    detection_suggestion: z.union([
      z.object({}).partial().passthrough(),
      z.null(),
    ]),
    id: z.union([z.string(), z.null()]),
    lead_briefing: z.union([z.object({}).partial().passthrough(), z.null()]),
    phone: z.union([z.string(), z.null()]),
    priority: z.union([z.number().int(), z.null()]),
    unified_lead_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ClaimNextLeadResponse = z
  .object({
    lead: z.union([ClaimedLead, z.null()]),
    reason: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DisqualifyLeadRequest = z.object({
  queue_id: z.string(),
  reason: z.string().min(1),
  session_id: z.string(),
});
export const QueueActionResponse = z.object({
  queue_id: z.string(),
  queue_status: z.string(),
  success: z.boolean(),
});
export const CallingQueueCardData = z
  .object({
    detection_suggestion: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    lead_briefing: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    queue_row: CallQueueRow,
    suggested_demo_use_case: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CallingQueueNextResponse = z
  .object({
    data: z.union([CallingQueueCardData, z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const CallingQueueCardErrorCode = z.enum([
  "UNAUTHORIZED",
  "FORBIDDEN",
  "MISSING_IDENTITY",
  "SESSION_EXPIRED",
  "INVALID_SESSION_ID",
  "QUEUE_SESSION_LOOKUP_FAILED",
  "SESSION_NOT_FOUND",
  "SESSION_NOT_ACTIVE",
  "SESSION_MISSING_CAMPAIGN",
  "QUEUE_RPC_FAILED",
]);
export const CallingQueueCardErrorDetailV1 = z
  .object({
    code: CallingQueueCardErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CallingQueueCardErrorEnvelopeV1 = z
  .object({ error: CallingQueueCardErrorDetailV1 })
  .passthrough();
export const SkipLeadRequest = z.object({
  queue_id: z.string(),
  session_id: z.string(),
});
export const ClaimByIdRequest = z.object({
  p_caller_id: z.union([z.string(), z.null()]).optional(),
  p_session_id: z.string(),
});
export const ClaimByIdResponse = z
  .object({
    data: z.union([CallQueueRow, z.null()]),
    success: z.literal(true).default(true),
  })
  .partial()
  .passthrough();
export const LeadEditRequest = z
  .object({
    company_name: z.union([z.string(), z.null()]),
    contact_name: z.union([z.string(), z.null()]),
    phone: z.union([z.string(), z.null()]),
  })
  .partial();
export const LeadEditResponse = z
  .object({
    data: CallQueueRow,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const CallingSessionCreateRequest = z.object({
  campaign_id: z.string(),
  checklist_completed: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
  planned_duration_min: z.union([z.number().int().gte(1), z.null()]).optional(),
});
export const CallingSession = z
  .object({
    caller_id: z.string(),
    campaign_id: z.union([z.string(), z.null()]).optional(),
    checklist_completed: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    completed_at: z.union([z.string(), z.null()]).optional(),
    created_at: z.union([z.string(), z.null()]).optional(),
    duration_seconds: z.union([z.number().int(), z.null()]).optional(),
    id: z.string(),
    idle_timeout_seconds: z.union([z.number().int(), z.null()]).optional(),
    paused_at: z.union([z.string(), z.null()]).optional(),
    planned_duration_min: z.union([z.number().int(), z.null()]).optional(),
    resumed_at: z.union([z.string(), z.null()]).optional(),
    review_notes: z.union([z.string(), z.null()]).optional(),
    reviewed_at: z.union([z.string(), z.null()]).optional(),
    reviewed_by: z.union([z.string(), z.null()]).optional(),
    started_at: z.union([z.string(), z.null()]).optional(),
    status: z.string(),
    total_break_seconds: z.union([z.number().int(), z.null()]).optional(),
    total_calls: z.union([z.number().int(), z.null()]).optional(),
    total_reached: z.union([z.number().int(), z.null()]).optional(),
    updated_at: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CallingSessionResponse = z
  .object({
    data: z.union([CallingSession, z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const CallingSessionUpdateRequest = z.object({
  action: z.enum(["pause", "resume", "end"]),
  metadata: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
});
export const SalesCohortResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const SalesCohortRequest = z
  .object({
    exclude_municipalities: z.boolean().default(true),
    limit: z.number().int().default(100),
    sales_rep_user_id: z.union([z.string(), z.null()]),
    status: z.string().default("sale_confirmed"),
  })
  .partial();
export const VisitReportsCohortResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const VisitReportsCohortRequest = z
  .object({
    exclude_municipalities: z.boolean().default(true),
    limit: z.number().int().default(100),
    outcome: z.union([z.string(), z.null()]),
    rep_user_id: z.union([z.string(), z.null()]),
  })
  .partial();
export const AgentTriggerPatch = z.object({ active: z.boolean() });
export const AgentTriggerPatchEnvelope = z
  .object({ active: z.boolean(), id: z.string(), updated_at: z.string() })
  .passthrough();
export const AgentTriggerFireEnvelope = z
  .object({ fire_id: z.string(), fired_at: z.string(), trigger_id: z.string() })
  .passthrough();
export const DecisionRatifyBody = z.object({
  amendment: z.union([z.string().max(4000), z.null()]).optional(),
  reason: z.union([z.string().max(2000), z.null()]).optional(),
  response: z.enum(["yes", "no", "amend"]),
});
export const DecisionRatifyEnvelope = z
  .object({
    decided_at: z.union([z.string(), z.null()]).optional(),
    decision_id: z.string(),
    ratification_record: z
      .array(z.object({}).partial().passthrough())
      .optional()
      .default([]),
    status: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CommanderDocCreateEnvelope = z
  .object({
    action: z.union([z.string(), z.null()]),
    gcs_path: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    intake_outcome: z.union([z.string(), z.null()]),
    intake_status: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    type: z.union([z.string(), z.null()]),
    version: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DocResolveEnvelope = z
  .object({
    frontmatter: z.union([z.object({}).partial().passthrough(), z.null()]),
    gcs_path: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    resolution_kind: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    type: z.union([z.string(), z.null()]),
    version: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ReviewQueueRow = z
  .object({
    dropzone_at: z.union([z.string(), z.null()]).optional(),
    frontmatter_excerpt: z.object({}).partial().passthrough(),
    id: z.union([z.string(), z.null()]).optional(),
    intake_status: z.union([z.string(), z.null()]).optional(),
    proposed_by: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
    version: z.union([z.number().int(), z.null()]).optional(),
  })
  .passthrough();
export const ReviewQueueEnvelope = z
  .object({ data: z.array(ReviewQueueRow), total: z.number().int() })
  .passthrough();
export const CommanderDocSearchRow = z
  .object({
    document_id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    gcs_path: z.union([z.string(), z.null()]).optional(),
    heading: z.union([z.string(), z.null()]).optional(),
    id: z.union([z.number().int(), z.string()]),
    namespace: z.union([z.string(), z.null()]).optional(),
    score: z.union([z.number(), z.null()]).optional(),
    snippet: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CommanderDocsSearchEnvelope = z
  .object({ data: z.array(CommanderDocSearchRow), total: z.number().int() })
  .passthrough();
export const CommanderDocTagRow = z
  .object({
    count: z.union([z.number().int(), z.null()]),
    tag: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const CommanderDocTagsEnvelope = z
  .object({
    data: z.array(CommanderDocTagRow),
    total_docs_scanned: z.number().int(),
    total_unique_tags: z.number().int(),
  })
  .passthrough();
export const CommanderDocDeleteEnvelope = z
  .object({
    id: z.string(),
    previous_status: z.string(),
    status: z.string(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CommanderDocEnvelope = z
  .object({
    content: z.union([z.string(), z.null()]).optional(),
    frontmatter: z.union([z.unknown(), z.null()]).optional(),
    gcs_path: z.union([z.string(), z.null()]).optional(),
    id: z.union([z.number().int(), z.string()]),
    status: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
    version: z.union([z.number().int(), z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CommanderDocUpdateRequest = z
  .object({
    change_summary: z.union([z.string(), z.null()]).optional(),
    content: z.string(),
    expected_version: z.union([z.number().int(), z.null()]).optional(),
  })
  .passthrough();
export const CommanderDocUpdateEnvelope = z
  .object({
    action: z.union([z.string(), z.null()]),
    gcs_path: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    intake_outcome: z.union([z.string(), z.null()]),
    intake_status: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    type: z.union([z.string(), z.null()]),
    version: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DocApproveEnvelope = z
  .object({
    approved_at: z.union([z.string(), z.null()]).optional(),
    approved_by: z.union([z.string(), z.null()]).optional(),
    banner_status_stale: z.union([z.boolean(), z.null()]).optional(),
    banner_status_stale_heading: z.union([z.string(), z.null()]).optional(),
    id: z.union([z.number().int(), z.string()]),
    intake_status: z.union([z.string(), z.null()]).optional(),
    review_decision_reason: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
    version: z.union([z.number().int(), z.string(), z.null()]).optional(),
  })
  .passthrough();
export const DocBacklinkRow = z
  .object({
    edge_kind: z.union([z.string(), z.null()]),
    id: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    type: z.union([z.string(), z.null()]),
    version: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DocBacklinksEnvelope = z
  .object({
    data: z.array(DocBacklinkRow),
    target_id: z.string(),
    target_title: z.union([z.string(), z.null()]).optional(),
    target_type: z.union([z.string(), z.null()]).optional(),
    total: z.number().int(),
  })
  .passthrough();
export const DocBodySectionPatchRequest = z.object({
  anchor: z.string().min(1),
  expected_version: z.union([z.number().int().gte(1), z.null()]).optional(),
  replacement: z.string(),
});
export const DocBodySectionPatchEnvelope = z.object({
  action: z.string(),
  anchor: z.string(),
  content_sha256: z.string(),
  document_bytes_after: z.number().int(),
  document_bytes_before: z.number().int(),
  document_id: z.string(),
  heading: z.string(),
  heading_line_no: z.number().int(),
  previous_version: z.number().int(),
  remainder_verified: z.boolean(),
  section_bytes_after: z.number().int(),
  section_bytes_before: z.number().int(),
  title: z.string(),
  type: z.string(),
  version: z.number().int(),
});
export const DocBodyPatchErrorCode = z.enum([
  "UNAUTHORIZED",
  "FORBIDDEN",
  "DOC_NOT_FOUND",
  "BODY_PATCH_INVALID",
  "BODY_PATCH_NO_CHANGE",
  "ANCHOR_NOT_FOUND",
  "ANCHOR_AMBIGUOUS",
  "DOC_BODY_UNAVAILABLE",
  "CONFLICT_STALE_VERSION",
  "BODY_PATCH_WRITE_FAILED",
  "REPLACEMENT_RESTRUCTURES_DOCUMENT",
  "VERIFY_AFTER_WRITE_DOC_MUTATED",
]);
export const DocBodyPatchErrorDetailV1 = z
  .object({
    code: DocBodyPatchErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const DocBodyPatchErrorEnvelopeV1 = z
  .object({ error: DocBodyPatchErrorDetailV1 })
  .passthrough();
export const DocVersionSide = z
  .object({
    body: z.string(),
    frontmatter: z.object({}).partial().passthrough(),
    version: z.union([z.number().int(), z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CommanderDocDiffEnvelope = z
  .object({
    diff_size: z.number().int(),
    dropzone: DocVersionSide,
    prev: z.union([DocVersionSide, z.null()]).optional(),
    target_id: z.string(),
    target_title: z.union([z.string(), z.null()]).optional(),
    target_type: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const FrontmatterValue = z.union([
  z.string(),
  z.number().int(),
  z.boolean(),
  z.array(z.string()),
  z.array(z.record(z.string())),
  z.null(),
]);
export const DocFrontmatterPatchRequest = z.object({
  patch: z.record(FrontmatterValue),
});
export const DocFrontmatterPatchEnvelope = z
  .object({
    frontmatter: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    id: z.union([z.number().int(), z.string()]),
    status: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
    version: z.union([z.number().int(), z.string(), z.null()]).optional(),
  })
  .passthrough();
export const FrontmatterPatchErrorCode = z.enum([
  "UNAUTHORIZED",
  "FORBIDDEN",
  "DOC_NOT_FOUND",
  "FRONTMATTER_PATCH_INVALID",
  "FRONTMATTER_FIELD_LOCKED",
  "VERIFY_AFTER_WRITE_MISMATCH",
  "INTERNAL",
]);
export const FrontmatterPatchErrorDetailV1 = z
  .object({
    code: FrontmatterPatchErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const FrontmatterPatchErrorEnvelopeV1 = z
  .object({ error: FrontmatterPatchErrorDetailV1 })
  .passthrough();
export const DocHistoryVersionRow = z
  .object({
    change_summary: z.union([z.string(), z.null()]),
    content_hash: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    created_by: z.union([z.string(), z.null()]),
    gcs_path: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    version: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DocHistoryEnvelope = z
  .object({
    current_version: z
      .union([z.number().int(), z.string(), z.null()])
      .optional(),
    data: z.array(DocHistoryVersionRow),
    target_id: z.string(),
    target_title: z.union([z.string(), z.null()]).optional(),
    target_type: z.union([z.string(), z.null()]).optional(),
    total: z.number().int(),
  })
  .passthrough();
export const RatifyDocRequest = z.object({}).partial();
export const RatifyDocResponse = z
  .object({
    approved_at: z.union([z.string(), z.null()]),
    approved_by: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    intake_status: z.union([z.string(), z.null()]),
    review_decision_reason: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    type: z.union([z.string(), z.null()]),
    version: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const RatifyDocErrorCode = z.enum([
  "UNAUTHORIZED",
  "FORBIDDEN",
  "DOC_NOT_FOUND",
  "DOC_INTAKE_NOT_CLEARED",
  "DOC_NOT_DRAFT",
  "RATIFY_FAILED",
]);
export const RatifyDocErrorDetailV1 = z
  .object({
    code: RatifyDocErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const RatifyDocErrorEnvelopeV1 = z
  .object({ error: RatifyDocErrorDetailV1 })
  .passthrough();
export const CommanderDocRejectEnvelope = z
  .object({
    id: z.union([z.number().int(), z.string(), z.null()]),
    intake_status: z.union([z.string(), z.null()]),
    review_decision_reason: z.union([z.string(), z.null()]),
    reviewed_at: z.union([z.string(), z.null()]),
    reviewed_by: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    type: z.union([z.string(), z.null()]),
    version: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DocStatus = z.enum(["active", "draft", "superseded", "archived"]);
export const DocStampRequest = z.object({
  reason: z.union([z.string().max(1000), z.null()]).optional(),
  target_status: DocStatus,
});
export const DocStampEnvelope = z
  .object({
    approved_at: z.union([z.string(), z.null()]).optional(),
    approved_by: z.union([z.string(), z.null()]).optional(),
    frontmatter: z.union([z.unknown(), z.null()]).optional(),
    id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    intake_status: z.union([z.string(), z.null()]).optional(),
    review_decision_reason: z.union([z.string(), z.null()]).optional(),
    status: DocStatus,
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
    version: z.union([z.number().int(), z.string(), z.null()]).optional(),
  })
  .passthrough();
export const StampDocErrorCode = z.enum([
  "UNAUTHORIZED",
  "FORBIDDEN",
  "DOC_NOT_FOUND",
  "STAMP_INVALID_STATE_TRANSITION",
  "VERIFY_AFTER_WRITE_MISMATCH",
  "INTERNAL",
]);
export const StampDocErrorDetailV1 = z
  .object({
    code: StampDocErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const StampDocErrorEnvelopeV1 = z
  .object({ error: StampDocErrorDetailV1 })
  .passthrough();
export const EscalationItem = z
  .object({
    created_at: z.union([z.string(), z.null()]).optional(),
    halt_reason: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    manifest_id: z.union([z.string(), z.null()]).optional(),
    manifest_title: z.union([z.string(), z.null()]).optional(),
    name: z.union([z.string(), z.null()]).optional(),
    phase: z.union([z.string(), z.null()]).optional(),
    status: z.string(),
  })
  .passthrough();
export const EscalationActionBody = z.object({
  action: z.string().regex(/^(reset_to_gate|kill|replan)$/),
  reason: z.union([z.string(), z.null()]).optional(),
});
export const EscalationActionResponse = z
  .object({ id: z.string(), lifecycle_node: z.string(), status: z.string() })
  .passthrough();
export const app__api__v1__commander_inbox_iacp_send__InboxSendBody = z.object({
  body_text: z.string().min(1).max(8000),
  dedup_key: z.union([z.string().min(1).max(200), z.null()]).optional(),
  in_reply_to: z.union([z.string(), z.null()]).optional(),
  kind: z.enum(["stream", "reply", "decision", "escalation"]),
  requires_ack: z.union([z.boolean(), z.null()]).optional(),
  severity: z.union([z.string(), z.null()]).optional(),
  target_call_sign: z.union([z.string().min(1), z.null()]).optional(),
  target_embodiment_id: z.union([z.string(), z.null()]).optional(),
  target_persona: z.union([z.string().min(1), z.null()]).optional(),
  thread_root: z.union([z.string(), z.null()]).optional(),
});
export const InboxIacpSendData = z
  .object({
    deduplicated: z.union([z.boolean(), z.null()]).optional(),
    kind: z.enum(["stream", "reply", "decision", "escalation"]),
    original_signal_id: z
      .union([z.number().int(), z.string(), z.null()])
      .optional(),
    signal_id: z.union([z.number().int(), z.string()]),
    target_embodiment_id: z.union([z.string(), z.null()]).optional(),
    wa_dispatched_at: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const InboxIacpSendEnvelope = z
  .object({ data: InboxIacpSendData, success: z.boolean() })
  .passthrough();
export const app__api__v1__commander_inbox__InboxSendBody = z.object({
  attachments: z
    .union([z.array(z.object({}).partial().passthrough()), z.null()])
    .optional(),
  displayed_index: z.union([z.number().int(), z.null()]).optional(),
  from_work_item_id: z.union([z.string(), z.null()]).optional(),
  in_reply_to: z.union([z.string(), z.null()]).optional(),
  option_id: z.union([z.string(), z.null()]).optional(),
  target: z.string().min(1),
  target_embodiment_id: z.union([z.string(), z.null()]).optional(),
  text: z.string().min(1),
});
export const InboxSendResponse = z
  .object({
    dispatched_via: z.string(),
    resolved_embodiment_id: z.union([z.string(), z.null()]).optional(),
    signal_id: z.string(),
    status: z.string(),
    target: z.string(),
  })
  .passthrough();
export const InboxAckBody = z
  .object({ ack_note: z.union([z.string().max(500), z.null()]) })
  .partial();
export const InboxAckData = z
  .object({ acked_at: z.string(), acked_by: z.string(), signal_id: z.string() })
  .passthrough();
export const InboxAckEnvelope = z
  .object({ data: InboxAckData, success: z.boolean() })
  .passthrough();
export const is_blocked = z.union([z.boolean(), z.null()]).optional();
export const ManifestItem = z
  .object({
    blocked_by: z.union([z.array(z.string()), z.null()]).optional(),
    blocker_reason: z.union([z.string(), z.null()]).optional(),
    closeout_profile: z.union([z.string(), z.null()]).optional(),
    closure_reason: z.union([z.string(), z.null()]).optional(),
    commander_action: z.union([z.string(), z.null()]).optional(),
    commander_comment: z.union([z.string(), z.null()]).optional(),
    created_at: z.union([z.string(), z.null()]).optional(),
    description: z.union([z.string(), z.null()]).optional(),
    due_at: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    is_blocked: z.union([z.boolean(), z.null()]).optional(),
    lifecycle_node: z.union([z.string(), z.null()]).optional(),
    notes: z.union([z.string(), z.null()]).optional(),
    owner: z.union([z.string(), z.null()]).optional(),
    parent_id: z.union([z.string(), z.null()]).optional(),
    phase: z.union([z.string(), z.null()]).optional(),
    priority: z.union([z.string(), z.null()]).optional(),
    repo: z.union([z.string(), z.null()]).optional(),
    sorties_done: z.union([z.number().int(), z.null()]).optional(),
    sorties_total: z.union([z.number().int(), z.null()]).optional(),
    source_doc_id: z.union([z.string(), z.null()]).optional(),
    source_type: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    track: z.union([z.string(), z.null()]).optional(),
    updated_at: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const ManifestEntryCreate = z.object({
  assignee: z.union([z.string().max(100), z.null()]).optional(),
  blocker_reason: z.union([z.string(), z.null()]).optional(),
  ci_status: z.union([z.string().max(50), z.null()]).optional(),
  closure_reason: z
    .union([z.enum(["done", "cancelled", "deferred", "superseded"]), z.null()])
    .optional(),
  description: z.union([z.string(), z.null()]).optional(),
  entity_type: z.enum(["sf", "op", "mo", "sortie", "task", "bug", "fr"]),
  execution_mode: z
    .union([z.enum(["cloud", "local_daemon", "local_raw"]), z.null()])
    .optional(),
  execution_mode_inherited: z.union([z.boolean(), z.null()]).optional(),
  id: z.string().min(1).max(200),
  is_blocked: z.union([z.boolean(), z.null()]).optional(),
  last_session_note: z.union([z.string(), z.null()]).optional(),
  lifecycle_node: z
    .union([
      z.enum([
        "INTAKE",
        "ORIENT",
        "PLAN",
        "GATE",
        "EXECUTE",
        "VERIFY",
        "REVIEW",
        "CLOSE",
      ]),
      z.null(),
    ])
    .optional(),
  parent_id: z.union([z.string().max(200), z.null()]).optional(),
  phase: z.union([z.number().int().gte(1).lte(5), z.null()]).optional(),
  pipeline_entity_id: z.union([z.string().max(200), z.null()]).optional(),
  pr_number: z.union([z.number().int(), z.null()]).optional(),
  pr_url: z.union([z.string(), z.null()]).optional(),
  priority: z.union([z.enum(["P0", "P1", "P2", "P3"]), z.null()]).optional(),
  repo: z.union([z.string().max(100), z.null()]).optional(),
  session_purpose: z
    .union([z.enum(["debug", "plan", "hotfix", "author", "execute"]), z.null()])
    .optional(),
  sort_order: z.union([z.number().int(), z.null()]).optional(),
  source_doc_id: z.union([z.string(), z.null()]).optional(),
  tenant_id: z
    .union([z.string().max(100), z.null()])
    .optional()
    .default("appic"),
  title: z.string().min(1).max(500),
  track: z.union([z.string().max(100), z.null()]).optional(),
});
export const ManifestEntryRow = z
  .object({
    assignee: z.union([z.string(), z.null()]).optional(),
    created_at: z.union([z.string(), z.null()]).optional(),
    created_by: z.union([z.string(), z.null()]).optional(),
    entity_type: z.union([z.string(), z.null()]).optional(),
    id: z.union([z.string(), z.null()]).optional(),
    parent_id: z.union([z.string(), z.null()]).optional(),
    phase: z.union([z.string(), z.null()]).optional(),
    priority: z.union([z.number().int(), z.string(), z.null()]).optional(),
    session_purpose: z.union([z.string(), z.null()]).optional(),
    source_doc_id: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    tenant_id: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    updated_at: z.string(),
  })
  .passthrough();
export const ManifestEntryWriteEnvelope = z
  .object({ data: ManifestEntryRow, success: z.boolean() })
  .passthrough();
export const ManifestEntryDeleteData = z
  .object({ cascade_count: z.number().int(), deleted_ids: z.array(z.string()) })
  .passthrough();
export const ManifestEntryDeleteEnvelope = z
  .object({ data: ManifestEntryDeleteData, success: z.boolean() })
  .passthrough();
export const ManifestEntryPatch = z
  .object({
    assignee: z.union([z.string().max(100), z.null()]),
    blocker_reason: z.union([z.string(), z.null()]),
    ci_status: z.union([z.string().max(50), z.null()]),
    closure_reason: z.union([
      z.enum(["done", "cancelled", "deferred", "superseded"]),
      z.null(),
    ]),
    description: z.union([z.string(), z.null()]),
    execution_mode: z.union([
      z.enum(["cloud", "local_daemon", "local_raw"]),
      z.null(),
    ]),
    execution_mode_inherited: z.union([z.boolean(), z.null()]),
    is_blocked: z.union([z.boolean(), z.null()]),
    last_session_note: z.union([z.string(), z.null()]),
    lifecycle_node: z.union([
      z.enum([
        "INTAKE",
        "ORIENT",
        "PLAN",
        "GATE",
        "EXECUTE",
        "VERIFY",
        "REVIEW",
        "CLOSE",
      ]),
      z.null(),
    ]),
    parent_id: z.union([z.string().max(200), z.null()]),
    phase: z.union([z.number().int().gte(1).lte(5), z.null()]),
    pipeline_entity_id: z.union([z.string().max(200), z.null()]),
    pr_number: z.union([z.number().int(), z.null()]),
    pr_url: z.union([z.string(), z.null()]),
    priority: z.union([z.enum(["P0", "P1", "P2", "P3"]), z.null()]),
    repo: z.union([z.string().max(100), z.null()]),
    session_purpose: z.union([
      z.enum(["debug", "plan", "hotfix", "author", "execute"]),
      z.null(),
    ]),
    sort_order: z.union([z.number().int(), z.null()]),
    source_doc_id: z.union([z.string(), z.null()]),
    title: z.union([z.string().min(1).max(500), z.null()]),
    track: z.union([z.string().max(100), z.null()]),
  })
  .partial();
export const PhaseSummary = z
  .object({
    active: z.number().int(),
    done: z.number().int(),
    phase: z.string(),
    queued: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const ManifestPatchBody = z
  .object({
    blocker_reason: z.union([z.string(), z.null()]),
    closeout_profile: z.union([
      z.enum([
        "code_mo",
        "doc_mo",
        "db_migration",
        "investigation",
        "aircrew_wave",
        "subagent_wave",
      ]),
      z.null(),
    ]),
    closure_reason: z.union([z.string(), z.null()]),
    commander_action: z.union([
      z.string().regex(/^(halt|escalate|reprioritize|kill)$/),
      z.null(),
    ]),
    commander_comment: z.union([z.string(), z.null()]),
    due_at: z.union([z.string(), z.null()]),
    is_blocked: z.union([z.boolean(), z.null()]),
    lifecycle_node: z.union([z.string(), z.null()]),
    notes: z.union([z.string(), z.null()]),
    parent_id: z.union([z.string(), z.null()]),
    priority: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial();
export const app__api__v1__commander_manifest__CommentBody = z.object({
  parent_comment_id: z.union([z.string(), z.null()]).optional(),
  text: z.string().min(1),
});
export const ManifestCommentRow = z
  .object({
    activity_type: z.union([z.string(), z.null()]),
    author: z.union([z.string(), z.null()]),
    content: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    entry_id: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    metadata: z.union([z.unknown(), z.null()]),
  })
  .partial()
  .passthrough();
export const ManifestCommentEnvelope = z
  .object({ data: ManifestCommentRow, success: z.boolean() })
  .passthrough();
export const LifecyclePatchRequest = z
  .object({
    blocker_reason: z.union([z.string().max(2000), z.null()]),
    closure_reason: z.union([z.string().max(2000), z.null()]),
    is_blocked: z.union([z.boolean(), z.null()]),
    target_lifecycle_node: z.union([
      z.enum([
        "INTAKE",
        "ORIENT",
        "PLAN",
        "GATE",
        "EXECUTE",
        "VERIFY",
        "REVIEW",
        "CLOSE",
      ]),
      z.null(),
    ]),
  })
  .partial();
export const LifecycleResponse = z
  .object({
    blocker_reason: z.union([z.string(), z.null()]).optional(),
    closure_reason: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    is_blocked: z.boolean(),
    lifecycle_node: z.union([z.string(), z.null()]).optional(),
    updated_at: z.string(),
  })
  .passthrough();
export const ReDispatchRequest = z
  .object({ reason: z.union([z.string().max(500), z.null()]) })
  .partial();
export const ReDispatchResponse = z
  .object({
    id: z.string(),
    previous_assignee: z.union([z.string(), z.null()]).optional(),
    re_dispatched_at: z.string(),
    re_dispatched_by: z.union([z.string(), z.null()]).optional(),
    updated_at: z.string(),
  })
  .passthrough();
export const MigrationApproveRequest = z
  .object({
    force_signal_fallback: z.boolean().default(false),
    notes: z.union([z.string().max(2000), z.null()]),
  })
  .partial();
export const MigrationApproveEnvelope = z
  .object({
    applied_at: z.union([z.string(), z.null()]).optional(),
    apply_signal_id: z.union([z.string().uuid(), z.null()]).optional(),
    approved_at: z.union([z.string(), z.null()]).optional(),
    approved_by: z.union([z.string(), z.null()]).optional(),
    dry_run_status: z.union([z.string(), z.null()]).optional(),
    id: z.string().uuid(),
    migration_name: z.string(),
    proposed_at: z.string(),
    proposed_by: z.string(),
    rejected_at: z.union([z.string(), z.null()]).optional(),
    rejected_by: z.union([z.string(), z.null()]).optional(),
    rejection_reason: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const MigrationRejectRequest = z.object({
  rejection_reason: z.string().min(3).max(2000),
});
export const MigrationRejectEnvelope = z
  .object({
    applied_at: z.union([z.string(), z.null()]).optional(),
    apply_signal_id: z.union([z.string(), z.null()]).optional(),
    approved_at: z.union([z.string(), z.null()]).optional(),
    approved_by: z.union([z.string(), z.null()]).optional(),
    dry_run_status: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    migration_name: z.string(),
    proposed_at: z.string(),
    proposed_by: z.string(),
    rejected_at: z.union([z.string(), z.null()]).optional(),
    rejected_by: z.union([z.string(), z.null()]).optional(),
    rejection_reason: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const NotificationPrefsBody = z
  .object({
    ci_failure_push: z.boolean().default(false),
    daily_digest: z.boolean().default(true),
    escalation_push: z.boolean().default(true),
    inbox_push: z.boolean().default(true),
  })
  .partial();
export const NotificationPreferencesResponse = z
  .object({
    status: z.string(),
    user_id: z.union([z.number().int(), z.string()]),
  })
  .passthrough();
export const app__api__v1__commander_pat_spawn_models__SpawnRequest = z
  .object({
    machine: z.union([z.string().max(200), z.null()]),
    reason: z.union([z.string().max(500), z.null()]),
    vendor: z.union([z.string().max(80), z.null()]),
  })
  .partial();
export const app__api__v1__commander_pat_spawn_models__SpawnResponse = z
  .object({
    embodiment_id: z.string().uuid(),
    machine: z.union([z.string(), z.null()]).optional(),
    persona: z.string(),
    started_at: z.string(),
    status: z.string(),
  })
  .passthrough();
export const CommanderPrCISummary = z
  .object({
    failure: z.number().int(),
    pending: z.number().int(),
    skipped: z.number().int(),
    state: z.enum(["success", "failure", "pending", "error", "unknown"]),
    success: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const CommanderPrComments = z
  .object({
    issue_comments: z.number().int(),
    review_comments: z.number().int(),
    unresolved: z.number().int(),
  })
  .passthrough();
export const CommanderPrDiffSummary = z
  .object({
    additions: z.number().int(),
    changed_files: z.number().int(),
    deletions: z.number().int(),
  })
  .passthrough();
export const CommanderPrListRow = z
  .object({
    author: z.string(),
    author_kind: z.enum(["bot", "user"]),
    base_branch: z.string(),
    blocking_reasons: z.array(z.string()),
    branch_protection_blocking: z.boolean(),
    branch_rule_bypassable_by_admin: z.boolean(),
    ci_summary: CommanderPrCISummary,
    comments: CommanderPrComments,
    created_at: z.string(),
    diff_summary: CommanderPrDiffSummary,
    draft: z.boolean(),
    head_branch: z.string(),
    head_sha: z.string(),
    html_url: z.string(),
    labels: z.array(z.string()),
    mergeable: z.boolean(),
    mergeable_state: z.union([z.string(), z.null()]).optional(),
    number: z.number().int(),
    repo: z.string(),
    state: z.string(),
    target_branch: z.string(),
    title: z.string(),
    updated_at: z.string(),
  })
  .passthrough();
export const CommanderPrsListMeta = z
  .object({
    target_branch: z.union([z.array(z.string()), z.null()]).optional(),
    ttl_seconds: z.number().int(),
  })
  .passthrough();
export const CommanderPrsListEnvelope = z
  .object({
    data: z.array(CommanderPrListRow),
    meta: CommanderPrsListMeta,
    total: z.number().int(),
  })
  .passthrough();
export const BatchApproveItem = z
  .object({ number: z.number().int(), repo: z.string() })
  .passthrough();
export const PRBatchApproveResultItem = z
  .object({
    error: z.union([z.string(), z.null()]).optional(),
    method: z.union([z.enum(["merge", "squash"]), z.null()]).optional(),
    number: z.number().int(),
    repo: z.string(),
    status: z.string(),
  })
  .passthrough();
export const PRBatchApproveResponse = z
  .object({ results: z.array(PRBatchApproveResultItem) })
  .passthrough();
export const PRInfo = z
  .object({
    additions: z.number().int(),
    author: z.string(),
    base_branch: z.string(),
    changed_files: z.number().int(),
    ci_status: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    deletions: z.number().int(),
    head_branch: z.string(),
    manifest_id: z.union([z.string(), z.null()]).optional(),
    manifest_title: z.union([z.string(), z.null()]).optional(),
    number: z.number().int(),
    repo: z.string(),
    state: z.string(),
    title: z.string(),
    url: z.string(),
  })
  .passthrough();
export const PRGroup = z
  .object({
    progress: z.union([z.string(), z.null()]).optional(),
    prs: z.array(PRInfo),
    source_type: z.string(),
    title: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CommanderPrReadyRow = z
  .object({
    number: z.number().int(),
    repo: z.string(),
    target_branch: z.string(),
    title: z.string(),
  })
  .passthrough();
export const CommanderPrsNotificationsEnvelope = z
  .object({
    as_of: z.string(),
    ready_to_merge: z.array(CommanderPrReadyRow),
    total: z.number().int(),
  })
  .passthrough();
export const CommanderPrDetailCheck = z
  .object({
    completed_at: z.union([z.string(), z.null()]),
    conclusion: z.union([z.string(), z.null()]),
    html_url: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string()]),
    name: z.string(),
    run_id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    status: z.string(),
  })
  .passthrough();
export const CommanderPrDetailFile = z
  .object({
    additions: z.number().int(),
    deletions: z.number().int(),
    html_url: z.union([z.string(), z.null()]),
    patch: z.union([z.string(), z.null()]),
    path: z.string(),
    status: z.string(),
  })
  .passthrough();
export const CommanderPrIssueComment = z
  .object({
    author: z.union([z.string(), z.null()]),
    body: z.string(),
    created_at: z.string(),
    id: z.union([z.number().int(), z.string()]),
  })
  .passthrough();
export const CommanderPrDetailPr = z
  .object({
    author: z.union([z.string(), z.null()]),
    author_kind: z.union([z.string(), z.null()]),
    base_branch: z.union([z.string(), z.null()]),
    body: z.union([z.string(), z.null()]).optional(),
    branch_protection_blocking: z.boolean(),
    draft: z.union([z.boolean(), z.null()]).optional(),
    head_branch: z.union([z.string(), z.null()]),
    head_sha: z.union([z.string(), z.null()]).optional(),
    html_url: z.union([z.string(), z.null()]),
    mergeable_state: z.string(),
    number: z.number().int(),
    repo: z.string(),
    state: z.union([z.string(), z.null()]).optional(),
    title: z.string(),
  })
  .passthrough();
export const CommanderPrThreadComment = z
  .object({
    author: z.union([z.string(), z.null()]),
    body: z.string(),
    created_at: z.string(),
    id: z.union([z.number().int(), z.string()]),
  })
  .passthrough();
export const CommanderPrReviewThread = z
  .object({
    comments: z.array(CommanderPrThreadComment),
    file_path: z.string(),
    id: z.union([z.number().int(), z.string()]),
    line: z.union([z.number().int(), z.null()]),
    resolved: z.boolean(),
  })
  .passthrough();
export const CommanderPrReview = z
  .object({
    id: z.union([z.number().int(), z.string()]),
    reviewer: z.union([z.string(), z.null()]),
    state: z.string(),
    submitted_at: z.union([z.string(), z.null()]),
  })
  .passthrough();
export const CommanderPrDetail = z
  .object({
    actions: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    checks: z.array(CommanderPrDetailCheck),
    files_changed: z.array(CommanderPrDetailFile),
    issue_comments: z
      .union([z.array(CommanderPrIssueComment), z.null()])
      .optional(),
    pr: CommanderPrDetailPr,
    review_actions: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    review_threads: z.array(CommanderPrReviewThread),
    reviews: z.union([z.array(CommanderPrReview), z.null()]).optional(),
  })
  .passthrough();
export const PRApproveResponse = z
  .object({
    method: z.enum(["merge", "squash"]),
    number: z.number().int(),
    repo: z.string(),
    status: z.string(),
  })
  .passthrough();
export const _MergeBody = z
  .object({ skip_approve: z.boolean().default(false) })
  .partial()
  .passthrough();
export const merge_as_admin_v1_commander_prs__repo___number__merge_as_admin_post_Body =
  z.union([_MergeBody, z.null()]);
export const PRMergeAsAdminResponse = z
  .object({
    approval: z.enum(["approved", "self_author_skipped", "skipped_by_caller"]),
    merge_response: z.object({}).partial().passthrough(),
    merged_sha: z.string(),
    merged_via: z.literal("pat"),
    method: z.literal("merge"),
    number: z.number().int(),
    repo: z.string(),
    status: z.literal("merged"),
  })
  .passthrough();
export const PRMergePromoteResponse = z
  .object({
    approval: z.enum(["approved", "self_author_skipped", "skipped_by_caller"]),
    merge_response: z.object({}).partial().passthrough(),
    merged_sha: z.string(),
    merged_via: z.literal("pat"),
    method: z.literal("merge"),
    number: z.number().int(),
    promotion: z.boolean(),
    repo: z.string(),
    status: z.literal("merged"),
  })
  .passthrough();
export const PRRejectBody = z
  .object({ reason: z.union([z.string(), z.null()]) })
  .partial()
  .passthrough();
export const reject_pr_v1_commander_prs__repo___number__reject_post_Body = z.union([
  PRRejectBody,
  z.null(),
]);
export const PRRejectResponse = z
  .object({ number: z.number().int(), repo: z.string(), status: z.string() })
  .passthrough();
export const RegisterWorkRequest = z.object({
  entity_type: z.string().min(1),
  lifecycle: z.string().min(1),
  parent_id: z.union([z.string(), z.null()]).optional(),
  source_doc_id: z.union([z.string(), z.null()]).optional(),
  title: z.string().min(1),
});
export const RegisterWorkEnvelope = z
  .object({
    created_at: z.union([z.string(), z.null()]).optional(),
    created_by: z.union([z.string(), z.null()]).optional(),
    dispatchable: z.union([z.boolean(), z.null()]).optional(),
    entity_type: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    is_blocked: z.union([z.boolean(), z.null()]).optional(),
    lifecycle_node: z.union([z.string(), z.null()]).optional(),
    metadata: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    owner: z.union([z.string(), z.null()]).optional(),
    parent_id: z.union([z.string(), z.null()]).optional(),
    phase: z.union([z.string(), z.null()]).optional(),
    priority: z.union([z.string(), z.null()]).optional(),
    source_doc_id: z.union([z.string(), z.null()]).optional(),
    source_type: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    updated_at: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SessionCommandBody = z.object({
  agent_name: z.string().min(1),
  command: z.string().regex(/^(spawn|kill|restart)$/),
  params: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
});
export const SessionCommandResponse = z
  .object({ command: z.string(), command_id: z.string(), status: z.string() })
  .passthrough();
export const CommanderSkillFamilyRow = z
  .object({
    family: z.union([z.string(), z.null()]),
    skill_count: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const CommanderSkillFamiliesEnvelope = z
  .object({ data: z.array(CommanderSkillFamilyRow), total: z.number().int() })
  .passthrough();
export const StagingDelta = z
  .object({
    commits_ahead: z.number().int(),
    files_changed: z.number().int(),
    last_commit_date: z.union([z.string(), z.null()]).optional(),
    repo: z.string(),
  })
  .passthrough();
export const PromoteBody = z
  .object({ title: z.union([z.string(), z.null()]) })
  .partial()
  .passthrough();
export const promote_staging_v1_commander_staging__repo__promote_post_Body = z.union([
  PromoteBody,
  z.null(),
]);
export const StagingPromoteResponse = z
  .object({
    pr_number: z.union([z.number().int(), z.string()]),
    pr_url: z.string(),
    repo: z.string(),
  })
  .passthrough();
export const app__api__v1__commander_workright_grant_models__WorkrightGrantRequest =
  z.object({
    embodiment_id: z.string().uuid(),
    reason: z.union([z.string().max(500), z.null()]).optional(),
    workright_id: z.string().min(1),
  });
export const app__api__v1__commander_workright_grant_models__WorkrightGrantResponse = z
  .object({
    assigned_at: z.string(),
    embodiment_id: z.string().uuid(),
    label: z.string(),
    persona_id: z.string(),
    workright_id: z.string(),
  })
  .passthrough();
export const WorkrightGrantErrorCode = z.enum([
  "UNAUTHORIZED",
  "FORBIDDEN",
  "WORKRIGHT_NOT_FOUND",
  "WORKRIGHT_REVOKED",
  "WORKRIGHT_EXPIRED",
  "EMBODIMENT_NOT_FOUND",
  "EMBODIMENT_NOT_ACTIVE",
  "ALREADY_ASSIGNED",
  "VERIFY_MISMATCH",
  "GRANT_WRITE_FAILED",
]);
export const WorkrightGrantErrorDetailV1 = z
  .object({
    code: WorkrightGrantErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const WorkrightGrantErrorEnvelopeV1 = z
  .object({ error: WorkrightGrantErrorDetailV1 })
  .passthrough();
export const app__api__v1__commander_workrights_g2_models__WorkrightGrantRequest =
  z.object({
    agent_id: z.string().min(1).max(200),
    embodiment_id: z.union([z.string().uuid(), z.null()]).optional(),
    expires_at: z.union([z.string().max(64), z.null()]).optional(),
    granted_reason: z.string().min(3).max(2000),
    manifest_entry_id: z.union([z.string().uuid(), z.null()]).optional(),
    permanent_auto_renew: z.boolean().optional().default(false),
    scope_globs: z.array(z.string()).min(1).max(64),
    verify_token: z.union([z.string().max(64), z.null()]).optional(),
  });
export const app__api__v1__commander_workrights_g2_models__WorkrightGrantResponse = z
  .object({
    agent_id: z.string(),
    embodiment_id: z.union([z.string().uuid(), z.null()]).optional(),
    expires_at: z.union([z.string(), z.null()]).optional(),
    granted_at: z.string(),
    granted_by: z.string(),
    granted_reason: z.string(),
    id: z.string().uuid(),
    manifest_entry_id: z.union([z.string().uuid(), z.null()]).optional(),
    permanent_auto_renew: z.boolean(),
    scope_globs: z.array(z.string()),
  })
  .passthrough();
export const WorkrightEventsErrorCode = z.enum([
  "UNAUTHORIZED",
  "FORBIDDEN",
  "INVALID_SCOPE_FORMAT",
  "EMBODIMENT_NOT_FOUND",
  "EMBODIMENT_NOT_ACTIVE",
  "MANIFEST_ENTRY_NOT_FOUND",
  "GRANT_WRITE_FAILED",
  "GRANT_NOT_FOUND",
  "GRANT_ALREADY_REVOKED",
  "REVOKE_WRITE_FAILED",
  "IDENTITY_UNRESOLVED",
  "RATE_LIMIT_EXCEEDED",
  "SIGNAL_INSERT_FAILED",
  "VERIFY_MISMATCH",
]);
export const WorkrightEventsErrorDetailV1 = z
  .object({
    code: WorkrightEventsErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const WorkrightEventsErrorEnvelopeV1 = z
  .object({ error: WorkrightEventsErrorDetailV1 })
  .passthrough();
export const Urgency = z.enum(["blocking", "soon", "whenever"]);
export const WorkrightScopeRequestRequest = z.object({
  reason: z.string().min(3).max(2000),
  related_doc_ids: z.union([z.array(z.string().uuid()), z.null()]).optional(),
  requested_scope: z.enum([
    "mcp_tool",
    "workright",
    "skill_ack",
    "flight_right",
    "other",
  ]),
  target: z.string().min(1).max(200),
  urgency: Urgency.optional(),
});
export const WorkrightScopeRequestResponse = z
  .object({
    created_at: z.string(),
    signal_id: z.string().uuid(),
    target_personas: z.array(z.string()),
  })
  .passthrough();
export const WorkrightRevokeRequest = z.object({
  revoked_reason: z.string().min(3).max(2000),
});
export const WorkrightRevokeResponse = z
  .object({
    agent_id: z.string(),
    id: z.string().uuid(),
    revoked_at: z.string(),
    revoked_reason: z.string(),
  })
  .passthrough();
export const PayloadValidateRequest = z
  .object({
    actor_email: z.string().min(1).max(320),
    payload: z.object({}).partial().passthrough().optional(),
    payload_type: z.string().min(1).max(64),
  })
  .passthrough();
export const Verdict = z
  .object({
    reason: z.union([z.string(), z.null()]).optional(),
    verdict: z.string(),
    violations: z.array(z.string()).optional(),
  })
  .passthrough();
export const DiscoveryOptions = z
  .object({
    include_metadata: z.boolean().default(true),
    max_concurrency: z.number().int().default(5),
    max_results: z.number().int().default(10),
    priority: z.string().default("normal"),
    timeout_sec: z.number().int().default(30),
  })
  .partial()
  .passthrough();
export const CompanyDiscoveryRequest = z.object({
  company_name: z.string(),
  options: z.union([DiscoveryOptions, z.null()]).optional(),
  services: z.array(z.string()),
});
export const CompanyDiscoveryResponse = z
  .object({
    data: z.object({}).partial().passthrough(),
    meta: z.object({}).partial().passthrough(),
    success: z.boolean(),
  })
  .passthrough();
export const app__api__v1__company_discovery__ServiceHealthResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const CompanyWithSalesOrdersRow = z
  .object({
    address_line1: z.union([z.string(), z.null()]),
    city: z.union([z.string(), z.null()]),
    country: z.union([z.string(), z.null()]),
    email: z.union([z.string(), z.null()]),
    enrichment_attempts: z.union([z.number().int(), z.null()]),
    enrichment_error_reason: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    last_enriched_at: z.union([z.string(), z.null()]),
    last_order_date: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    phone_number: z.union([z.string(), z.null()]),
    postcode: z.union([z.string(), z.null()]),
    sales_orders_count: z.union([z.number().int(), z.null()]),
    stage: z.union([z.string(), z.null()]),
    total_revenue: z.union([z.number(), z.null()]),
    vat_number: z.union([z.string(), z.null()]),
    website: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const CompaniesWithSalesOrdersData = z
  .object({
    companies: z.array(CompanyWithSalesOrdersRow),
    total: z.number().int(),
  })
  .passthrough();
export const CompaniesWithSalesOrdersEnvelope = z
  .object({ data: CompaniesWithSalesOrdersData, success: z.boolean() })
  .passthrough();
export const CompanyRowV1 = z
  .object({
    address_line: z.union([z.string(), z.null()]).optional(),
    city: z.union([z.string(), z.null()]).optional(),
    country: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    email: z.union([z.string(), z.null()]).optional(),
    employees: z.union([z.number().int(), z.null()]).optional(),
    founded_year: z.union([z.number().int(), z.null()]).optional(),
    hrb: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    industry_code: z.union([z.string(), z.null()]).optional(),
    lat: z.union([z.number(), z.null()]).optional(),
    legal_form: z.union([z.string(), z.null()]).optional(),
    lng: z.union([z.number(), z.null()]).optional(),
    name: z.string(),
    orbis_id: z.union([z.string(), z.null()]).optional(),
    phone: z.union([z.string(), z.null()]).optional(),
    postal_code: z.union([z.string(), z.null()]).optional(),
    revenue_eur: z.union([z.number(), z.null()]).optional(),
    vat_id: z.union([z.string(), z.null()]).optional(),
    website: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CompanyByIdV1Envelope = z
  .object({ data: CompanyRowV1, success: z.boolean() })
  .passthrough();
export const CompanyErrorCode = z.enum([
  "UNAUTHORIZED",
  "FORBIDDEN",
  "COMPANY_NOT_FOUND",
  "COMPANY_LOOKUP_FAILED",
]);
export const CompanyErrorDetailV1 = z
  .object({
    code: CompanyErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const CompanyErrorEnvelopeV1 = z
  .object({ error: CompanyErrorDetailV1 })
  .passthrough();
export const Address = z
  .object({
    city: z.union([z.string(), z.null()]),
    country: z.union([z.string(), z.null()]),
    line1: z.union([z.string(), z.null()]),
    line2: z.union([z.string(), z.null()]),
    postal_code: z.union([z.string(), z.null()]),
    region: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const Company = z
  .object({
    address: z.union([Address, z.null()]),
    category: z.union([z.string(), z.null()]),
    country: z.union([z.string(), z.null()]),
    domain: z.union([z.string(), z.null()]),
    email: z.union([z.string(), z.null()]),
    employees: z.union([z.number().int(), z.null()]),
    expected_gp_eur: z.union([z.number(), z.null()]),
    has_historic_sales: z.union([z.boolean(), z.null()]),
    historical_revenue_eur: z.union([z.number(), z.null()]),
    id: z.union([z.string(), z.null()]),
    lead_type: z.union([z.string(), z.null()]),
    legal_name: z.union([z.string(), z.null()]),
    match_confidence: z.union([z.number(), z.null()]),
    metadata: z.object({}).partial().passthrough(),
    name: z.union([z.string(), z.null()]),
    payment_metrics: z.union([z.object({}).partial().passthrough(), z.null()]),
    phone: z.union([z.string(), z.null()]),
    products: z.union([z.array(z.string()), z.null()]),
    provenance: z.record(z.string()),
    registration_number: z.union([z.string(), z.null()]),
    score: z.union([z.number(), z.null()]),
    score_breakdown: z.union([z.object({}).partial().passthrough(), z.null()]),
    source: z.union([z.string(), z.null()]),
    source_system: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    vat_id: z.union([z.string(), z.null()]),
    website: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const CompanyAutocompleteData = z
  .object({ google_places: z.array(Company), unified_lead: z.array(Company) })
  .passthrough();
export const CompanyAutocompleteEnvelope = z
  .object({ data: CompanyAutocompleteData, success: z.boolean() })
  .passthrough();
export const CompanyLookupRequest = z
  .object({
    address: z.union([z.string(), z.null()]),
    bypass_cache: z.union([z.boolean(), z.null()]).default(false),
    country: z.union([z.string().min(2).max(2), z.null()]),
    domain: z.union([z.string(), z.null()]),
    name: z.union([z.string().min(1), z.null()]),
    source: z.union([z.string(), z.null()]),
    vat_id: z.union([z.string(), z.null()]),
    website: z.union([z.string(), z.null()]),
  })
  .partial();
export const WaterfallStep = z
  .object({
    details: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    step: z.string(),
    success: z.boolean(),
  })
  .passthrough();
export const CompanyLookupResponse = z
  .object({
    company: z.union([Company, z.null()]).optional(),
    confidence: z.record(z.number()).optional(),
    found: z.boolean(),
    provenance: z.record(z.string()).optional(),
    request_id: z.union([z.string(), z.null()]).optional(),
    steps: z.array(WaterfallStep).optional(),
  })
  .passthrough();
export const CompanyLookupEnvelope = z
  .object({ data: CompanyLookupResponse, success: z.boolean() })
  .passthrough();
export const CompanyByIdData = z
  .object({ id: z.union([z.number().int(), z.string()]) })
  .passthrough();
export const CompanyByIdEnvelope = z
  .object({ data: CompanyByIdData, success: z.boolean() })
  .passthrough();
export const app__api__v1__appointments_response_models__ContactPersonRow = z
  .object({
    created_at: z.union([z.string(), z.null()]),
    created_by: z.union([z.string(), z.null()]),
    email: z.union([z.string(), z.null()]),
    full_name: z.union([z.string(), z.null()]),
    id: z.union([z.string(), z.null()]),
    lead_id: z.union([z.string(), z.null()]),
    mobile: z.union([z.string(), z.null()]),
    notes: z.union([z.string(), z.null()]),
    org_id: z.union([z.string(), z.null()]),
    phone: z.union([z.string(), z.null()]),
    position: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ContactPersonListResponse = z
  .object({
    data: z.array(app__api__v1__appointments_response_models__ContactPersonRow),
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const ContactPersonCreateRequest = z.object({
  email: z.union([z.string(), z.null()]).optional(),
  full_name: z.string().min(1),
  lead_id: z.union([z.string(), z.null()]).optional(),
  mobile: z.union([z.string(), z.null()]).optional(),
  notes: z.union([z.string(), z.null()]).optional(),
  org_id: z.union([z.string(), z.null()]).optional(),
  phone: z.union([z.string(), z.null()]).optional(),
  position: z.union([z.string(), z.null()]).optional(),
});
export const ContactPersonRowResponse = z
  .object({
    data: app__api__v1__appointments_response_models__ContactPersonRow,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const ContactPersonUpdateRequest = z
  .object({
    email: z.union([z.string(), z.null()]),
    full_name: z.union([z.string(), z.null()]),
    lead_id: z.union([z.string(), z.null()]),
    mobile: z.union([z.string(), z.null()]),
    notes: z.union([z.string(), z.null()]),
    org_id: z.union([z.string(), z.null()]),
    phone: z.union([z.string(), z.null()]),
    position: z.union([z.string(), z.null()]),
  })
  .partial();
export const WebhookProcessCounts = z
  .object({
    errors: z.number().int(),
    no_match: z.number().int(),
    processed: z.number().int(),
    skipped: z.number().int(),
    total_pulled: z.number().int(),
    unresolved_embodiment: z.number().int(),
  })
  .passthrough();
export const WebhookProcessEnvelope = z
  .object({ data: WebhookProcessCounts, success: z.boolean() })
  .passthrough();
export const CustomerTypeRow = z
  .object({
    id: z.union([z.number().int(), z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    segment: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const CustomerTypesEnvelope = z
  .object({
    data: z.array(CustomerTypeRow),
    success: z.boolean(),
    total: z.number().int(),
  })
  .passthrough();
export const DocumentChunkRowEnvelope = z
  .object({
    chunk_index: z.union([z.number().int(), z.null()]),
    content: z.union([z.string(), z.null()]),
    content_preview: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    document_id: z.union([z.number().int(), z.string(), z.null()]),
    heading: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DocumentChunkListEnvelope = z.array(DocumentChunkRowEnvelope);
export const DocSearchHit = z
  .object({
    document_id: z.union([z.number().int(), z.string()]),
    gcs_path: z.union([z.string(), z.null()]).optional(),
    heading: z.union([z.string(), z.null()]).optional(),
    id: z.union([z.number().int(), z.string()]),
    score: z.union([z.number(), z.null()]).optional(),
    snippet: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const DocumentVersionRowEnvelope = z
  .object({
    change_summary: z.union([z.string(), z.null()]),
    content_hash: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    created_by: z.union([z.string(), z.null()]),
    document_id: z.union([z.number().int(), z.string(), z.null()]),
    gcs_path: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    version: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DocumentVersionListEnvelope = z.array(DocumentVersionRowEnvelope);
export const DocumentRowEnvelope = z
  .object({
    content_hash: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    created_by: z.union([z.string(), z.null()]),
    frontmatter: z.union([z.unknown(), z.null()]),
    gcs_path: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    parent_id: z.union([z.number().int(), z.string(), z.null()]),
    repo: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    type: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
    version: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DocumentListEnvelope = z.array(DocumentRowEnvelope);
export const DocumentIngestData = z
  .object({
    chunk_count: z.number().int(),
    content_hash: z.string(),
    document_id: z.string(),
    embed_count: z.number().int(),
    gcs_path: z.string(),
    gcs_uploaded: z.boolean(),
    is_update: z.boolean(),
    title: z.string(),
    type: z.string(),
    version: z.number().int(),
  })
  .passthrough();
export const DocumentIngestEnvelope = z
  .object({ data: DocumentIngestData, success: z.boolean() })
  .passthrough();
export const DataProxyRowEnvelope = z
  .object({ id: z.union([z.number().int(), z.string(), z.null()]) })
  .partial()
  .passthrough();
export const DataProxyListEnvelope = z.array(DataProxyRowEnvelope);
export const MetadataMergeRow = z
  .object({
    id: z.union([z.number().int(), z.string()]),
    metadata: z.object({}).partial().passthrough(),
  })
  .passthrough();
export const MetadataMergeEnvelope = z
  .object({ row: MetadataMergeRow, updated: z.boolean() })
  .passthrough();
export const DeliberationCreateRequest = z.object({
  budget_ceiling_tokens: z.union([z.number().int(), z.null()]).optional(),
  commander_intent: z.string(),
  config_overrides: z.object({}).partial().passthrough().optional(),
  intel_brief: z.string().optional().default(""),
  run_card: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
});
export const DeliberationCreateEnvelope = z
  .object({
    run_id: z.union([z.number().int(), z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DeliberationStatusEnvelope = z
  .object({
    run_id: z.union([z.number().int(), z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DeliberationEventsEnvelope = z
  .object({
    events: z.union([z.array(z.unknown()), z.null()]),
    run_id: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const GateDecisionRequest = z.object({
  comment: z.union([z.string(), z.null()]).optional(),
  decision: z.string(),
});
export const DeliberationGateEnvelope = z
  .object({
    run_id: z.union([z.number().int(), z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DeliberationTraceEnvelope = z
  .object({
    nodes: z.union([z.array(z.unknown()), z.null()]),
    run_id: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DeliberationVersionEnvelope = z
  .object({
    run_id: z.union([z.number().int(), z.string(), z.null()]),
    version: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DispatchCallerIdentity = z.object({
  embodiment_id: z.string().uuid(),
  persona: z.string().min(1),
  session_id: z.string().uuid(),
});
export const DispatchScopeIn = z
  .object({
    files: z.union([z.array(z.string()), z.null()]),
    repo: z.union([z.string(), z.null()]),
  })
  .partial();
export const DispatchContract = z
  .object({
    acceptance_criteria: z.union([z.array(z.string()), z.null()]),
    constraints: z.union([z.array(z.string()), z.null()]),
    mission: z.union([z.string(), z.null()]),
    operation_id: z.union([z.string(), z.null()]),
    review_findings: z.union([z.array(z.string()), z.null()]),
    scope_in: z.union([DispatchScopeIn, z.null()]),
    todos: z.union([z.array(z.string()), z.null()]),
  })
  .partial();
export const DispatchGatewayRequest = z.object({
  agent_mode: z.string().min(1),
  author_index: z.union([z.number().int().gte(0), z.null()]).optional(),
  base_branch: z.union([z.string(), z.null()]).optional(),
  branch: z.string().min(1),
  caller: DispatchCallerIdentity,
  contract: DispatchContract,
  model: z.string().min(1),
  repo_url: z.string().min(1),
  resume_sortie_id: z.union([z.string(), z.null()]).optional(),
  reviewer_id: z.union([z.string(), z.null()]).optional(),
  sortie_id: z.string().min(1),
  timeout_minutes: z.union([z.number().int().gte(1), z.null()]).optional(),
  vendor: z.string().min(1),
});
export const DispatchRouted = z.object({
  decision: z.literal("routed").optional().default("routed"),
  dispatch_id: z.string(),
  duration_ms: z.number().int().gte(0),
  error: z.union([z.string(), z.null()]).optional(),
  runtime_id: z.string(),
  sortie_id: z.string(),
  status: z.enum(["complete", "failed"]),
});
export const DispatchFallback = z.object({
  decision: z.literal("fallback").optional().default("fallback"),
  detail: z.string(),
  dispatch_id: z.string(),
  error: z
    .literal("no_runtime_available")
    .optional()
    .default("no_runtime_available"),
  permitted_scopes: z.array(z.string()),
  remedy: z.literal("use_subagents").optional().default("use_subagents"),
});
export const CommsProxyResponseEnvelope = z
  .object({ data: z.union([z.unknown(), z.null()]) })
  .partial()
  .passthrough();
export const EmbodimentCloseReason = z.enum([
  "manual",
  "crash",
  "mcp_provision_failed",
  "embodiment_register_failed",
  "identity_seal_fail",
  "kill_grace_exceeded",
  "resume_attempt_failed",
]);
export const EmbodimentStatus = z.enum([
  "created",
  "provisioning",
  "active",
  "closing",
  "closed",
]);
export const EmbodimentRow = z
  .object({
    call_sign: z.union([z.string(), z.null()]).optional(),
    close_reason: z.union([EmbodimentCloseReason, z.null()]).optional(),
    closed_at: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    current_embodiment_id: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    last_heartbeat_at: z.union([z.string(), z.null()]).optional(),
    machine: z.string(),
    metadata: z.object({}).partial().passthrough().optional(),
    model: z.string(),
    persona: z.string(),
    seal_envelope_id: z.union([z.string(), z.null()]).optional(),
    spawn_reason: z.union([z.string(), z.null()]).optional(),
    started_at: z.union([z.string(), z.null()]).optional(),
    status: EmbodimentStatus,
    vendor: z.string(),
  })
  .passthrough();
export const EmbodimentListResponse = z
  .object({
    data: z.array(EmbodimentRow),
    next_cursor: z.union([z.string(), z.null()]).optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const EmbodimentErrorCode = z.enum([
  "UNAUTHORIZED",
  "AUTHORITY_DENIED",
  "ATC_UNAVAILABLE",
  "EMBODIMENT_NOT_FOUND",
  "EMBODIMENT_LOOKUP_FAILED",
  "EMBODIMENT_CLOSED",
  "EMBODIMENT_PATCH_FAILED",
  "EMBODIMENT_PATCH_WRITE_VERIFICATION_FAILED",
  "EMBODIMENT_LIST_FAILED",
  "EMBODIMENT_SINGLETON",
  "EMBODIMENT_START_FAILED",
  "EMBODIMENT_START_WRITE_VERIFICATION_FAILED",
  "EMBODIMENT_KILL_RACE",
  "SEND_MESSAGE_FAILED",
  "SEND_MESSAGE_WRITE_VERIFICATION_FAILED",
]);
export const EmbodimentErrorDetailV1 = z
  .object({
    code: EmbodimentErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const EmbodimentErrorEnvelopeV1 = z
  .object({ error: EmbodimentErrorDetailV1 })
  .passthrough();
export const EmbodimentStartRequest = z.object({
  authority_policy: z.string(),
  call_sign: z.union([z.string(), z.null()]).optional(),
  metadata: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
  model: z.string().min(1),
  persona: z.string().min(1),
  spawn_reason: z.union([z.string(), z.null()]).optional(),
});
export const EmbodimentResponse = z.object({ data: EmbodimentRow }).passthrough();
export const EmbodimentKillRequest = z
  .object({ reason: z.union([z.string().min(1), z.null()]) })
  .partial();
export const EmbodimentSendMessageRequest = z.object({
  content: z.string().min(1),
  metadata: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
});
export const EmbodimentSendMessageResponse = z
  .object({
    created_at: z.string(),
    delivered_to_agent: z.boolean(),
    message_id: z.string(),
    session_id: z.string(),
  })
  .passthrough();
export const EmbodimentRebootRequest = z.object({
  authority_policy: z.string(),
  force_cold_start: z.union([z.boolean(), z.null()]).optional(),
  reason: z.union([z.string().min(1), z.null()]).optional(),
});
export const EmbodimentResumeRequest = z.object({
  authority_policy: z.string(),
  force_cold_start: z.union([z.boolean(), z.null()]).optional(),
});
export const DispatchRequest = z.object({
  agent_id: z.string().min(1),
  signal_type: z.string().optional().default("commander-fe"),
  target_embodiment_id: z.string(),
  text: z.string().min(1),
});
export const DispatchResponse = z
  .object({ dispatched_via: z.string(), row_id: z.string() })
  .passthrough();
export const LiveEmbodimentRow = z
  .object({
    agent_id: z.string(),
    display_name: z.union([z.string(), z.null()]).optional(),
    embodiment_id: z.string(),
    location: z.union([z.string(), z.null()]).optional(),
    machine: z.union([z.string(), z.null()]).optional(),
    shorthandle: z.union([z.string(), z.null()]).optional(),
    source: z.union([z.string(), z.null()]).optional(),
    vendor: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const TransitionRequest = z.object({
  metadata: z.object({}).partial().passthrough().optional(),
  to_node: z.string(),
});
export const TransitionResponse = z.object({
  entity_id: z.string(),
  event_id: z.string(),
  recorded_at: z.string(),
  status: z
    .literal("pending_daemon_advance")
    .optional()
    .default("pending_daemon_advance"),
  stored_from_node: z.union([z.string(), z.null()]),
  stored_to_node: z.string(),
});
export const ModuleEntitlements = z
  .object({ modules: z.array(z.string()) })
  .partial()
  .passthrough();
export const ModuleEntitlementsResponse = z
  .object({ data: ModuleEntitlements })
  .passthrough();
export const DirectionsLeg = z
  .object({
    distance_meters: z.union([z.number().int(), z.number(), z.null()]),
    duration_in_traffic_seconds: z.union([
      z.number().int(),
      z.number(),
      z.null(),
    ]),
    duration_seconds: z.union([z.number().int(), z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const DirectionsOverviewPolyline = z
  .object({ points: z.union([z.string(), z.null()]) })
  .partial()
  .passthrough();
export const DirectionsRoute = z
  .object({
    legs: z.array(DirectionsLeg).optional().default([]),
    overview_polyline: DirectionsOverviewPolyline,
  })
  .passthrough();
export const DirectionsResponse = z
  .object({
    routes: z.array(DirectionsRoute).default([]),
    status: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const language = z.union([z.string(), z.null()]).optional().default("de");
export const components = z
  .union([z.string(), z.null()])
  .optional()
  .default("country:DE");
export const GeocodeResponse = z
  .object({
    error_message: z.union([z.string(), z.null()]),
    results: z.array(z.object({}).partial().passthrough()).default([]),
    status: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const PlacesAutocompleteStructuredFormatting = z
  .object({
    main_text: z.union([z.string(), z.null()]),
    secondary_text: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const PlacesAutocompletePrediction = z
  .object({
    description: z.union([z.string(), z.null()]),
    place_id: z.union([z.string(), z.null()]),
    structured_formatting: z.union([
      PlacesAutocompleteStructuredFormatting,
      z.null(),
    ]),
  })
  .partial()
  .passthrough();
export const PlacesAutocompleteResponse = z
  .object({
    predictions: z.array(PlacesAutocompletePrediction),
    status: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const fields = z.union([z.string(), z.null()]).optional().default("all");
export const GooglePlaceDetailV1Response = z
  .object({ id: z.union([z.string(), z.null()]) })
  .partial()
  .passthrough();
export const PlacesDetailsGeometry = z
  .object({ location: z.union([z.unknown(), z.null()]) })
  .partial()
  .passthrough();
export const PlacesDetailsPhoto = z
  .object({
    height: z.union([z.number().int(), z.null()]),
    html_attributions: z.union([z.unknown(), z.null()]),
    photo_reference: z.union([z.string(), z.null()]),
    width: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const PlacesDetailsResult = z
  .object({
    address_components: z.array(z.unknown()),
    business_status: z.union([z.string(), z.null()]).optional(),
    formatted_address: z.union([z.string(), z.null()]).optional(),
    formatted_phone_number: z.union([z.string(), z.null()]).optional(),
    geometry: PlacesDetailsGeometry,
    international_phone_number: z.union([z.string(), z.null()]).optional(),
    name: z.union([z.string(), z.null()]).optional(),
    opening_hours: z.union([z.unknown(), z.null()]).optional(),
    photos: z.array(PlacesDetailsPhoto),
    types: z.array(z.unknown()),
    vicinity: z.union([z.string(), z.null()]).optional(),
    website: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const PlacesDetailsResponse = z
  .object({
    result: PlacesDetailsResult,
    status: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const PlacesSearchRequest = z
  .object({
    language: z.union([z.string(), z.null()]),
    location: z.union([z.string(), z.null()]),
    query: z.union([z.string(), z.null()]),
    radius: z.union([z.number().int(), z.null()]),
    type: z.union([z.string(), z.null()]),
  })
  .partial();
export const GooglePlacesV1SearchResponse = z
  .object({
    nextPageToken: z.union([z.string(), z.null()]),
    places: z.union([z.array(z.unknown()), z.null()]),
    results: z.union([z.array(z.unknown()), z.null()]),
    status: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const PlacesSearchAlongRouteRequest = z.object({
  languageCode: z.union([z.string(), z.null()]).optional(),
  maxResultCount: z.union([z.number().int(), z.null()]).optional(),
  rankPreference: z.union([z.string(), z.null()]).optional(),
  regionCode: z.union([z.string(), z.null()]).optional(),
  searchAlongRouteParameters: z.object({}).partial().passthrough(),
  textQuery: z.string(),
});
export const LatLng = z
  .object({ latitude: z.number(), longitude: z.number() })
  .passthrough();
export const PlacesSearchNearbyRequest = z.object({
  languageCode: z.union([z.string(), z.null()]).optional().default("de"),
  location: LatLng,
  maxResultCount: z
    .union([z.number().int().gte(1).lte(20), z.null()])
    .optional(),
  pageToken: z.union([z.string(), z.null()]).optional(),
  radiusMeters: z.number().int().gte(1).lte(50000),
  rankPreference: z.union([z.string(), z.null()]).optional(),
  regionCode: z.union([z.string(), z.null()]).optional().default("DE"),
  textQuery: z.string(),
});
export const PlacesSearchTextRequest = z.object({
  languageCode: z.union([z.string(), z.null()]).optional().default("de"),
  location: z.union([LatLng, z.null()]).optional(),
  maxResultCount: z
    .union([z.number().int().gte(1).lte(20), z.null()])
    .optional(),
  pageToken: z.union([z.string(), z.null()]).optional(),
  radiusMeters: z
    .union([z.number().int().gte(1000).lte(50000), z.null()])
    .optional(),
  regionCode: z.union([z.string(), z.null()]).optional().default("DE"),
  textQuery: z.string(),
});
export const RoutesRequest = z.object({
  destination: z.string(),
  mode: z.union([z.string(), z.null()]).optional().default("driving"),
  origin: z.string(),
});
export const RoutesResponse = z
  .object({
    error_message: z.union([z.string(), z.null()]),
    geocoded_waypoints: z.union([
      z.array(z.object({}).partial().passthrough()),
      z.null(),
    ]),
    routes: z.array(z.object({}).partial().passthrough()).default([]),
    status: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const RoutesCalculateRequest = z.object({
  destination: z.object({}).partial().passthrough(),
  languageCode: z.union([z.string(), z.null()]).optional(),
  origin: z.object({}).partial().passthrough(),
  routingPreference: z.union([z.string(), z.null()]).optional(),
  travelMode: z.union([z.string(), z.null()]).optional(),
  units: z.union([z.string(), z.null()]).optional(),
});
export const RoutesCalculatePolyline = z
  .object({ encodedPolyline: z.union([z.string(), z.null()]) })
  .partial()
  .passthrough();
export const RoutesCalculateRoute = z
  .object({
    distanceMeters: z.union([z.number().int(), z.number(), z.null()]),
    duration: z.union([z.string(), z.null()]),
    polyline: z.union([RoutesCalculatePolyline, z.null()]),
  })
  .partial()
  .passthrough();
export const RoutesCalculateResponse = z
  .object({ routes: z.union([z.array(RoutesCalculateRoute), z.null()]) })
  .partial()
  .passthrough();
export const GovernancePendingRow = z
  .object({
    id: z.union([z.string(), z.null()]),
    intake_status: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    type: z.union([z.string(), z.null()]),
    version: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const GovernancePendingEnvelope = z
  .object({ count: z.number().int(), items: z.array(GovernancePendingRow) })
  .passthrough();
export const GovernancePromoteEnvelope = z
  .object({
    doc_id: z.string(),
    intake_status: z.string(),
    ok: z.boolean(),
    promoted_at: z.string(),
    promoted_by: z.string(),
    status: z.string(),
  })
  .passthrough();
export const GovernanceRejectEnvelope = z
  .object({
    doc_id: z.string(),
    intake_status: z.string(),
    ok: z.boolean(),
    reason: z.string(),
    rejected_at: z.string(),
    rejected_by: z.string(),
  })
  .passthrough();
export const CircuitBreakerResponse = z
  .object({
    data: z.object({}).partial().passthrough(),
    meta: z.object({}).partial().passthrough(),
    success: z.boolean(),
  })
  .passthrough();
export const HealthResponse = z
  .object({
    data: z.object({}).partial().passthrough(),
    meta: z.object({}).partial().passthrough(),
    success: z.boolean(),
  })
  .passthrough();
export const app__api__v1__health_monitoring_models__ServiceHealthResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const services = z.union([z.array(z.string()), z.null()]).optional();
export const CaseLookupRequest = z.object({
  ticket_id: z
    .string()
    .min(1)
    .max(32)
    .regex(/^[0-9]{1,32}$/),
});
export const CaseLookupResponse = z
  .object({
    case_id: z.string(),
    lifecycle_node: z.union([z.string(), z.null()]).optional(),
    tenant_id: z.string(),
    ticket_active: z.union([z.boolean(), z.null()]).optional(),
    ticket_id: z.string(),
    ticket_mirrored: z.boolean(),
  })
  .passthrough();
export const HelpdeskDoorErrorCode = z.enum([
  "INVALID_REQUEST",
  "DOOR_MISMATCH",
  "UNMAPPED_DOOR_ERROR",
  "DOOR_UNREACHABLE",
  "DOOR_OUTCOME_UNKNOWN",
  "UNAUTHORIZED",
  "UNKNOWN_ACTION_CODE",
  "UNKNOWN_TAG_TOKEN",
  "UNKNOWN_CATEGORY",
  "UNKNOWN_CASE_CLASS",
  "UNKNOWN_TENANT",
  "UNKNOWN_REFERENCE",
  "NO_SUCH_CASE",
  "NO_SUCH_ACTION",
  "DOOR_PRIVILEGE_DENIED",
  "NONCE_REPLAYED",
  "UNKNOWN_DOOR",
  "UNKNOWN_DOOR_ARGUMENT",
  "AMBIGUOUS_DOOR",
  "NO_SUCH_OUTCOME",
  "INVALID_AUTH_TYPE",
  "INSUFFICIENT_PERMISSIONS",
  "MISSING_TOKEN",
]);
export const HelpdeskDoorRetryWith = z.enum([
  "fresh_signature",
  "same_signed_request",
]);
export const HelpdeskDoorErrorDetailV1 = z
  .object({
    code: z.union([HelpdeskDoorErrorCode, z.string()]),
    message: z.union([z.string(), z.null()]).optional(),
    request_id: z.union([z.string(), z.null()]).optional(),
    retry_with: z.union([HelpdeskDoorRetryWith, z.null()]).optional(),
    retryable: z.boolean().optional().default(false),
    sqlstate: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const HelpdeskDoorErrorEnvelopeV1 = z
  .object({ error: HelpdeskDoorErrorDetailV1 })
  .passthrough();
export const CaseMapRequest = z.object({}).partial();
export const CaseMapEntry = z
  .object({
    case_id: z
      .string()
      .regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/),
    lifecycle_node: z.union([z.string(), z.null()]).optional(),
    tenant_id: z.string(),
    ticket_active: z.union([z.boolean(), z.null()]).optional(),
    ticket_id: z.string().regex(/^[0-9]{1,32}$/),
    ticket_mirrored: z.boolean(),
  })
  .passthrough();
export const CaseMapResponse = z
  .object({
    active_undecodable_count: z.number().int(),
    mapped_count: z.number().int(),
    mappings: z.array(CaseMapEntry),
    ticket_count: z.number().int(),
    unmapped_count: z.number().int(),
    unmapped_ticket_ids: z.array(z.string().regex(/^[0-9]{1,32}$/)),
    unmirrored_count: z.number().int(),
  })
  .passthrough();
export const DoorName = z.enum([
  "classify_case",
  "record_case_tag",
  "promote_case_tag",
  "propose_tag",
  "resolve_case",
  "stage_case_action",
  "confirm_case_action",
  "execute_case_action",
  "advance_case",
]);
export const DoorCallResponse = z.object({
  door: DoorName,
  replayed: z.boolean(),
  result: z.unknown(),
});
export const call_helpdesk_door_v1_helpdesk_doors__door__post_Body = z.union([
  z.object({
    case_id: z.string().uuid(),
    door: z.literal("advance_case"),
    on_behalf_of: z.string().min(1).max(256),
    reason: z.union([z.string(), z.null()]).optional(),
    to_node: z.string(),
  }),
  z.object({
    case_class: z.union([z.string(), z.null()]),
    case_id: z.string().uuid(),
    category: z.union([z.string(), z.null()]),
    door: z.literal("classify_case"),
    engine_category: z.union([z.string(), z.null()]).optional(),
    engine_confidence: z
      .union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null(),
      ])
      .optional(),
    on_behalf_of: z.string().min(1).max(256),
    origin: z.union([z.string(), z.null()]).optional(),
    origin_evidence: z.union([z.string(), z.null()]).optional(),
    source: z.string(),
    tenant_id: z.string().uuid(),
  }),
  z.object({
    action_id: z.string().uuid(),
    door: z.literal("confirm_case_action"),
    on_behalf_of: z.string().min(1).max(256),
  }),
  z.object({
    action_id: z.string().uuid(),
    door: z.literal("execute_case_action"),
    on_behalf_of: z.string().min(1).max(256),
    outcome: z.string(),
    result: z.unknown().optional(),
  }),
  z.object({
    case_id: z.string().uuid(),
    door: z.literal("promote_case_tag"),
    on_behalf_of: z.string().min(1).max(256),
    source: z.string(),
    tag_token: z.string(),
  }),
  z.object({
    case_id: z.string().uuid(),
    door: z.literal("propose_tag"),
    forks_what: z.string(),
    on_behalf_of: z.string().min(1).max(256),
    proposed_token: z.string(),
    rationale: z.union([z.string(), z.null()]),
    tenant_id: z.string().uuid(),
  }),
  z.object({
    case_id: z.string().uuid(),
    confidence: z
      .union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
        z.null(),
      ])
      .optional(),
    door: z.literal("record_case_tag"),
    evidence: z.union([z.string(), z.null()]).optional(),
    on_behalf_of: z.string().min(1).max(256),
    source: z.string(),
    tag_token: z.string(),
    tenant_id: z.string().uuid(),
  }),
  z.object({
    case_id: z.string().uuid(),
    combination_key: z.union([z.string(), z.null()]).optional(),
    door: z.literal("resolve_case"),
    note: z.union([z.string(), z.null()]).optional(),
    on_behalf_of: z.string().min(1).max(256),
    outcome: z.string(),
    runbook_ref: z.union([z.string(), z.null()]).optional(),
    tenant_id: z.string().uuid(),
  }),
  z.object({
    action_code: z.string(),
    batch_id: z.string().uuid(),
    case_id: z.string().uuid(),
    depends_on: z.union([z.string().uuid(), z.null()]).optional(),
    door: z.literal("stage_case_action"),
    due_at: z
      .union([z.string().datetime({ offset: true }), z.null()])
      .optional(),
    maker_checker: z.boolean(),
    on_behalf_of: z.string().min(1).max(256),
    result: z.unknown().optional(),
    seq: z.number().int(),
    tenant_id: z.string().uuid(),
  }),
]);
export const IamRow = z
  .object({
    action: z.union([z.string(), z.null()]),
    app_id: z.union([z.string(), z.null()]),
    feature_id: z.union([z.string(), z.null()]),
    granted: z.union([z.boolean(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    label: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const IamRowsEnvelope = z
  .object({ data: z.array(IamRow), success: z.boolean() })
  .passthrough();
export const PermissionCheckRequest = z.object({
  action: z.string().optional().default("read"),
  app_id: z.string(),
  feature_id: z.union([z.string(), z.null()]).optional(),
  user_id: z.string(),
});
export const IamCheckEnvelope = z
  .object({ granted: z.boolean(), success: z.boolean() })
  .passthrough();
export const InvocationIncrementRequest = z.object({
  action: z.string().optional().default("execute"),
  app_id: z.string(),
  feature_id: z.union([z.string(), z.null()]).optional(),
  user_id: z.string(),
});
export const IamIncrementEnvelope = z
  .object({ allowed: z.boolean(), success: z.boolean() })
  .passthrough();
export const PermissionEntry = z
  .object({
    action: z.string(),
    app_id: z.string(),
    feature_id: z.union([z.string(), z.null()]).optional(),
    granted: z.boolean().optional().default(true),
    max_invocations: z.union([z.number().int(), z.null()]).optional(),
    rate_limit_per_hour: z.union([z.number().int(), z.null()]).optional(),
    reason: z.union([z.string(), z.null()]).optional(),
    valid_until: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SetUserPermissionsRequest = z.object({
  permissions: z.array(PermissionEntry),
  user_id: z.string().uuid(),
});
export const IamOkEnvelope = z.object({ success: z.boolean() }).passthrough();
export const RoleLevelEntry = z
  .object({ app_id: z.string(), level_key: z.string() })
  .passthrough();
export const SetRoleLevelsRequest = z.object({ levels: z.array(RoleLevelEntry) });
export const RolePermissionEntry = z
  .object({
    action: z.string(),
    app_id: z.string(),
    feature_id: z.union([z.string(), z.null()]).optional(),
    granted: z.boolean().optional().default(true),
  })
  .passthrough();
export const SetRolePermissionsRequest = z.object({
  entries: z.array(RolePermissionEntry),
});
export const IamRoleRow = z
  .object({
    id: z.union([z.string(), z.null()]),
    is_system: z.union([z.boolean(), z.null()]),
    label: z.union([z.string(), z.null()]),
    sort_order: z.union([z.number().int(), z.null()]),
    user_class: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const IamRolesListEnvelope = z
  .object({ data: z.array(IamRoleRow), success: z.boolean() })
  .passthrough();
export const app__api__v1__iam_models__RoleCreateRequest = z.object({
  id: z.string().min(1).max(100),
  label: z.string().min(1).max(100),
  user_class: z.string().optional().default("internal"),
});
export const IamRoleEnvelope = z
  .object({ data: IamRoleRow, success: z.boolean() })
  .passthrough();
export const IamMessageEnvelope = z
  .object({ message: z.string(), success: z.boolean() })
  .passthrough();
export const app__api__v1__iam_models__RoleUpdateRequest = z
  .object({
    label: z.union([z.string().min(1).max(100), z.null()]),
    user_class: z.union([z.string(), z.null()]),
  })
  .partial();
export const ImpersonationCandidateRow = z
  .object({
    email: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    is_active: z.union([z.boolean(), z.null()]),
    manager_id: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    role: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ImpersonationCandidatesEnvelope = z
  .object({
    count: z.number().int(),
    data: z.array(ImpersonationCandidateRow),
    success: z.boolean(),
  })
  .passthrough();
export const StartRequest = z.object({ target_email: z.string().min(3) });
export const TargetUser = z
  .object({
    email: z.string(),
    full_name: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    role: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const StartResponse = z
  .object({ expires_at: z.string(), target: TargetUser, ticket: z.string() })
  .passthrough();
export const StopRequest = z.object({ ticket: z.string().min(1) });
export const StopResponse = z.object({ success: z.boolean() }).passthrough();
export const IndustryRow = z
  .object({
    code: z.union([z.number().int(), z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    numeric_id: z.union([z.number().int(), z.null()]),
    segment: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const IndustriesEnvelope = z
  .object({
    data: z.array(IndustryRow),
    success: z.boolean(),
    total: z.number().int(),
  })
  .passthrough();
export const CallingCampaignConfigRefreshData = z
  .object({
    base_version: z.union([z.number().int(), z.string()]),
    campaigns: z.number().int(),
    duration_s: z.number(),
    ok: z.boolean(),
    rows_upserted: z.number().int(),
  })
  .passthrough();
export const CallingCampaignConfigRefreshEnvelope = z
  .object({ data: CallingCampaignConfigRefreshData, success: z.boolean() })
  .passthrough();
export const NightAutomergeProcessBody = z
  .object({ limit: z.number().int().gte(1).lte(100).default(10) })
  .partial()
  .passthrough();
export const process_night_automerge_queue_v1_internal_night_automerge_process_post_Body =
  z.union([NightAutomergeProcessBody, z.null()]);
export const NightAutomergeDetail = z
  .object({
    detail: z.union([z.string(), z.null()]).optional(),
    head_ref: z.union([z.string(), z.null()]).optional(),
    merge_sha: z.union([z.string(), z.null()]).optional(),
    pattern: z.union([z.string(), z.null()]).optional(),
    reason: z.union([z.string(), z.null()]).optional(),
    result: z.string(),
    signal_id: z.string(),
  })
  .passthrough();
export const NightAutomergeProcessEnvelope = z
  .object({
    details: z.array(NightAutomergeDetail),
    drained: z.number().int(),
    escalated: z.number().int(),
    merged: z.number().int(),
    skipped: z.number().int(),
  })
  .passthrough();
export const TelemetryAlert = z
  .object({
    evidence: z.object({}).partial().passthrough().optional(),
    rule: z.string(),
    severity: z.string(),
    summary: z.string(),
  })
  .passthrough();
export const TelemetryChannelOutcome = z
  .object({
    armed: z.boolean(),
    channel: z.string(),
    delivered: z.boolean(),
    detail: z.string(),
    receipt: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const TelemetryEmission = z
  .object({
    alert_count: z.number().int(),
    channels: z.array(TelemetryChannelOutcome),
  })
  .passthrough();
export const AggregateRunCounters = z
  .object({
    error_candidates: z.number().int(),
    errors_already_present: z.number().int(),
    errors_inserted: z.number().int(),
    lookback_days: z.number().int(),
    ran_at: z.string(),
    rollup_grains_written: z.number().int(),
    signature_drift: z.number().int(),
    source_rows_scanned: z.number().int(),
    window_from: z.string(),
    window_to: z.string(),
  })
  .passthrough();
export const TelemetrySweepData = z
  .object({
    alerts: z.array(TelemetryAlert),
    emission: TelemetryEmission,
    report: AggregateRunCounters,
    skipped_rules: z.array(z.string()),
  })
  .passthrough();
export const TelemetrySweepEnvelope = z
  .object({ data: TelemetrySweepData, success: z.boolean() })
  .passthrough();
export const SweepRequest = z
  .object({ lookback_days: z.number().int().gte(0).lte(90).default(2) })
  .partial();
export const post_scout_telemetry_aggregate_v1_internal_scout_telemetry_aggregate_post_Body =
  z.union([SweepRequest, z.null()]);
export const TopupRunRow = z
  .object({
    campaign_id: z.union([z.string(), z.null()]),
    config_key: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    error: z.union([z.string(), z.null()]),
    finished_at: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    leads_added: z.union([z.number().int(), z.null()]),
    leads_requested: z.union([z.number().int(), z.null()]),
    metadata: z.union([z.object({}).partial().passthrough(), z.null()]),
    started_at: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    triggered_by: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const TopupRunListEnvelope = z
  .object({
    count: z.number().int(),
    data: z.array(TopupRunRow),
    success: z.boolean(),
  })
  .passthrough();
export const TopupRunReport = z.object({
  campaign_id: z.union([z.string(), z.null()]).optional(),
  config_key: z.union([z.string(), z.null()]).optional(),
  error: z.union([z.string(), z.null()]).optional(),
  finished_at: z.union([z.string(), z.null()]).optional(),
  leads_added: z.number().int().gte(0).optional().default(0),
  leads_requested: z.union([z.number().int().gte(0), z.null()]).optional(),
  metadata: z.object({}).partial().passthrough().optional(),
  started_at: z.string(),
  status: z.string(),
  triggered_by: z.union([z.string(), z.null()]).optional(),
});
export const TopupRunRecordEnvelope = z
  .object({ data: TopupRunRow, success: z.boolean() })
  .passthrough();
export const LeadRow = z
  .object({
    created_at: z.union([z.string(), z.null()]),
    firma: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    land: z.union([z.string(), z.null()]),
    last_visited_at: z.union([z.string(), z.null()]),
    last_visited_by: z.union([z.string(), z.null()]),
    latitude: z.union([z.number(), z.null()]),
    lead_type: z.union([z.string(), z.null()]),
    longitude: z.union([z.number(), z.null()]),
    ort: z.union([z.string(), z.null()]),
    plz: z.union([z.string(), z.null()]),
    score: z.union([z.number().int(), z.null()]),
    status: z.union([z.string(), z.null()]),
    strasse: z.union([z.string(), z.null()]),
    telefon: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
    visit_count: z.union([z.number().int(), z.null()]),
    website: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const LeadsListMeta = z
  .object({
    limit: z.union([z.number().int(), z.null()]),
    offset: z.union([z.number().int(), z.null()]),
    source: z.union([z.string(), z.null()]),
    view: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const LeadsListEnvelope = z
  .object({
    data: z.array(LeadRow),
    meta: LeadsListMeta,
    total: z.number().int(),
  })
  .passthrough();
export const UnifiedLeadCreateRequest = z.object({
  adresse: z.union([z.string(), z.null()]).optional(),
  branche: z.union([z.string(), z.null()]).optional(),
  coordinates: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
  entfernung_km: z.union([z.number(), z.null()]).optional(),
  estimated_budget: z
    .union([z.string().regex(/^(low|medium|high)$/), z.null()])
    .optional(),
  firma: z.string().min(1),
  last_contact: z.union([z.string(), z.null()]).optional(),
  last_visited_at: z.union([z.string(), z.null()]).optional(),
  last_visited_by: z.union([z.string(), z.null()]).optional(),
  linked_mission_count: z
    .union([z.number().int().gte(0), z.null()])
    .optional()
    .default(0),
  odoo_customer_rank: z.union([z.number().int(), z.null()]).optional(),
  odoo_id: z.union([z.string(), z.null()]).optional(),
  ort: z.union([z.string(), z.null()]).optional(),
  plz: z.union([z.string(), z.null()]).optional(),
  produkt_potenzial: z.union([z.string(), z.null()]).optional(),
  produkte: z.union([z.array(z.string()), z.null()]).optional(),
  score: z.union([z.number().int().gte(0).lte(100), z.null()]).optional(),
  score_breakdown: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
  status: z
    .union([
      z.string().regex(/^(prospect|qualified|visited|customer|churned)$/),
      z.null(),
    ])
    .optional()
    .default("prospect"),
  telefon: z.union([z.string(), z.null()]).optional(),
  temperature: z
    .union([z.string().regex(/^(hot|warm|cold)$/), z.null()])
    .optional(),
  umsatz_eur: z.union([z.number(), z.null()]).optional(),
  visit_count: z
    .union([z.number().int().gte(0), z.null()])
    .optional()
    .default(0),
  website: z.union([z.string(), z.null()]).optional(),
});
export const LeadCreateEnvelope = z
  .object({ data: LeadRow, success: z.boolean() })
  .passthrough();
export const LeadBackfillGeocodeEnvelope = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const BatchLeadsRequest = z.object({
  lead_ids: z.array(z.string()).min(1).max(100),
});
export const LeadsBatchData = z
  .object({
    leads: z.array(LeadRow),
    requested_count: z.number().int(),
    returned_count: z.number().int(),
  })
  .passthrough();
export const LeadsBatchEnvelope = z
  .object({ data: LeadsBatchData, success: z.boolean() })
  .passthrough();
export const UnifiedLeadUpdateRequest = z
  .object({
    adresse: z.union([z.string(), z.null()]),
    branche: z.union([z.string(), z.null()]),
    coordinates: z.union([z.object({}).partial().passthrough(), z.null()]),
    entfernung_km: z.union([z.number(), z.null()]),
    estimated_budget: z.union([
      z.string().regex(/^(low|medium|high)$/),
      z.null(),
    ]),
    firma: z.union([z.string(), z.null()]),
    last_contact: z.union([z.string(), z.null()]),
    last_visited_at: z.union([z.string(), z.null()]),
    last_visited_by: z.union([z.string(), z.null()]),
    linked_mission_count: z.union([z.number().int().gte(0), z.null()]),
    odoo_customer_rank: z.union([z.number().int(), z.null()]),
    odoo_id: z.union([z.string(), z.null()]),
    ort: z.union([z.string(), z.null()]),
    plz: z.union([z.string(), z.null()]),
    produkt_potenzial: z.union([z.string(), z.null()]),
    produkte: z.union([z.array(z.string()), z.null()]),
    score: z.union([z.number().int().gte(0).lte(100), z.null()]),
    score_breakdown: z.union([z.object({}).partial().passthrough(), z.null()]),
    status: z.union([
      z.string().regex(/^(prospect|qualified|visited|customer|churned)$/),
      z.null(),
    ]),
    telefon: z.union([z.string(), z.null()]),
    temperature: z.union([z.string().regex(/^(hot|warm|cold)$/), z.null()]),
    umsatz_eur: z.union([z.number(), z.null()]),
    visit_count: z.union([z.number().int().gte(0), z.null()]),
    website: z.union([z.string(), z.null()]),
  })
  .partial();
export const LeadUpdateEnvelope = z
  .object({ data: LeadRow, success: z.boolean() })
  .passthrough();
export const LeadEnrichmentRequest = z
  .object({
    crawl_depth: z
      .string()
      .regex(/^(imprint_only|shallow|deep)$/)
      .default("imprint_only"),
    enable_pse: z.boolean().default(true),
  })
  .partial();
export const LeadEnrichmentResult = z
  .object({
    company_id: z.union([z.string(), z.null()]),
    cost_estimate_usd: z.union([z.number().int(), z.number(), z.null()]),
    errors: z.union([z.array(z.unknown()), z.null()]),
    imprint_data: z.union([z.object({}).partial().passthrough(), z.null()]),
    lead_id: z.union([z.string(), z.null()]),
    run_id: z.union([z.string(), z.null()]),
    stages: z.union([z.object({}).partial().passthrough(), z.null()]),
    success: z.union([z.boolean(), z.null()]),
    total_duration_ms: z.union([z.number().int(), z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const LeadEnrichData = z
  .object({ enrichment: LeadEnrichmentResult, lead_id: z.string() })
  .passthrough();
export const LeadEnrichEnvelope = z
  .object({ data: LeadEnrichData, success: z.boolean() })
  .passthrough();
export const LeadVisitRequest = z
  .object({
    notes: z.union([z.string(), z.null()]),
    visited_at: z.union([z.string(), z.null()]),
    visited_by: z.union([z.string(), z.null()]),
  })
  .partial();
export const LeadVisitEnvelope = z
  .object({ data: LeadRow, success: z.boolean() })
  .passthrough();
export const LeadVisitRow = z
  .object({
    id: z.union([z.number().int(), z.string(), z.null()]),
    state_reason: z.union([z.string(), z.null()]),
    visited_at: z.union([z.string(), z.null()]),
    visitor_email: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const LeadVisitHistoryData = z
  .object({
    days_since_last_visit: z.union([z.number().int(), z.null()]).optional(),
    last_visited_at: z.union([z.string(), z.null()]).optional(),
    visits: z.array(LeadVisitRow),
  })
  .passthrough();
export const LeadVisitHistoryEnvelope = z
  .object({ data: LeadVisitHistoryData, success: z.boolean() })
  .passthrough();
export const EllisIslandTouchpoint = z.enum([
  "observer",
  "structure",
  "duplicate",
  "quality",
  "antipattern",
]);
export const EllisIslandProcessRequest = z.object({
  budget_cents_cap: z.number().int().gte(1).lte(1000).optional().default(50),
  doc_id: z.string().uuid(),
  dry_run: z.boolean().optional().default(false),
  touchpoints: z.union([z.array(EllisIslandTouchpoint), z.null()]).optional(),
});
export const EllisIslandProcessResponse = z
  .object({
    anti_patterns_extracted: z.array(z.string()).optional(),
    cost_cents: z.number().int().gte(0),
    divergence_flags: z.array(z.string()).optional(),
    doc_id: z.string().uuid(),
    duration_ms: z.number().int().gte(0),
    quality_score: z.union([z.number().gte(0).lte(1), z.null()]).optional(),
    supersession_candidates: z.array(z.string().uuid()).optional(),
    touchpoints_run: z.array(EllisIslandTouchpoint),
    verified: z.boolean().optional().default(false),
  })
  .passthrough();
export const EllisIslandErrorCode = z.enum([
  "UNAUTHORIZED",
  "FORBIDDEN",
  "DOC_NOT_FOUND",
  "DOC_INTAKE_STATUS_INVALID",
  "BUDGET_EXCEEDED",
  "LLM_TIMEOUT",
  "LLM_API_ERROR",
  "ELLIS_ISLAND_VERIFY_FAILED",
  "DB_ERROR",
]);
export const EllisIslandErrorDetailV1 = z
  .object({
    code: EllisIslandErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const EllisIslandErrorEnvelopeV1 = z
  .object({ error: EllisIslandErrorDetailV1 })
  .passthrough();
export const ReconcileDocStoreRequest = z
  .object({
    dry_run: z.boolean().default(true),
    limit: z.number().int().gte(1).lte(1000).default(100),
  })
  .partial();
export const ReconcileDetailRow = z
  .object({
    action: z.enum([
      "would_insert",
      "inserted",
      "exists",
      "skipped_malformed",
      "skipped_no_id",
    ]),
    error: z.union([z.string(), z.null()]).optional(),
    gcs_path: z.string(),
    id: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const ReconcileDocStoreResponse = z
  .object({
    backfilled: z.number().int(),
    details: z.array(ReconcileDetailRow).optional(),
    missing_in_db: z.number().int(),
    scanned: z.number().int(),
    skipped_malformed: z.number().int(),
    skipped_no_id: z.number().int(),
  })
  .passthrough();
export const LibraryCardFrontmatterExcerpt = z
  .object({
    change_summary: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    tags: z.union([z.unknown(), z.null()]),
  })
  .partial()
  .passthrough();
export const LibraryCardInboxRow = z
  .object({
    dropzone_at: z.union([z.string(), z.null()]).optional(),
    frontmatter_excerpt: LibraryCardFrontmatterExcerpt,
    id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    intake_status: z.union([z.string(), z.null()]).optional(),
    proposed_by: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
    version: z.union([z.number().int(), z.string(), z.null()]).optional(),
  })
  .passthrough();
export const LibraryCardInboxEnvelope = z
  .object({ data: z.array(LibraryCardInboxRow), total: z.number().int() })
  .passthrough();
export const RunInput = z
  .object({
    bundle: z.union([z.object({}).partial().passthrough(), z.null()]),
    context: z.object({}).partial().passthrough(),
    user_message: z.string().default(""),
  })
  .partial()
  .passthrough();
export const RunCreateRequest = z.object({
  idempotency_key: z.union([z.string(), z.null()]).optional(),
  input: RunInput,
  policy_id: z.union([z.string(), z.null()]).optional(),
  run_type: z.string(),
});
export const RunResponse = z
  .object({
    cost_eur: z.union([z.number(), z.null()]).optional(),
    created_at: z.union([z.string(), z.null()]).optional(),
    output: z.union([z.unknown(), z.null()]).optional(),
    run_id: z.string(),
    status: z.string(),
    stop_reason: z.union([z.string(), z.null()]).optional(),
    total_tokens: z.union([z.number().int(), z.null()]).optional(),
    updated_at: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const VisionVerifyEnvelope = z.object({}).partial().passthrough();
export const ManifestControlsBody = z
  .object({
    close_out_via_cloud: z.union([z.boolean(), z.null()]),
    execution_mode: z.union([
      z.enum(["cloud", "local_daemon", "local_raw"]),
      z.null(),
    ]),
  })
  .partial();
export const ManifestControlsResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const MappingUnmatchedEntry = z
  .object({
    company: z.object({}).partial().passthrough(),
    suggestions: z.array(z.string()),
  })
  .passthrough();
export const MappingExportUnmatchedData = z
  .object({
    exported_at: z.string(),
    total: z.number().int(),
    unmatched_companies: z.array(MappingUnmatchedEntry),
  })
  .passthrough();
export const MappingExportUnmatchedEnvelope = z
  .object({ data: MappingExportUnmatchedData, success: z.boolean() })
  .passthrough();
export const MappedLinksResponse = z
  .object({
    crm_leads: z.array(z.object({}).partial().passthrough()),
    sales_orders: z.array(z.object({}).partial().passthrough()),
    total_leads: z.number().int(),
    total_orders: z.number().int(),
  })
  .passthrough();
export const MappingReviewData = z
  .object({
    candidates: z.array(z.object({}).partial().passthrough()),
    limit: z.number().int(),
    offset: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const MappingReviewEnvelope = z
  .object({ data: MappingReviewData, success: z.boolean() })
  .passthrough();
export const ReviewActionRequest = z.object({
  action: z.string(),
  reviewer: z.string(),
});
export const ReviewActionResponse = z
  .object({ message: z.string(), success: z.boolean() })
  .passthrough();
export const MappingRunRequest = z
  .object({
    include_municipalities: z.boolean().default(false),
    limit: z.number().int().default(10),
    second_pass: z.boolean().default(true),
    source: z.string().default("enriched"),
  })
  .partial();
export const MappingRunResponse = z
  .object({
    message: z.string(),
    results: z.object({}).partial().passthrough(),
    success: z.boolean(),
  })
  .passthrough();
export const MappingConfidenceBand = z
  .object({
    confidence_band: z.union([z.string(), z.null()]),
    count: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const MappingMunicipalityRate = z
  .object({
    municipalities: z.number().int(),
    rate: z.number(),
    total_companies: z.number().int(),
  })
  .passthrough();
export const MappingStatsData = z
  .object({
    confidence_bands: z.array(MappingConfidenceBand),
    municipality_rate: MappingMunicipalityRate,
    overall: z.object({}).partial().passthrough(),
  })
  .passthrough();
export const MappingStatsEnvelope = z
  .object({ data: MappingStatsData, success: z.boolean() })
  .passthrough();
export const McpJsonRpcError = z
  .object({
    code: z.union([z.number().int(), z.null()]),
    data: z.union([z.unknown(), z.null()]),
    message: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const McpJsonRpcEnvelope = z
  .object({
    error: z.union([McpJsonRpcError, z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    jsonrpc: z.union([z.string(), z.null()]),
    result: z.union([z.object({}).partial().passthrough(), z.null()]),
  })
  .partial()
  .passthrough();
export const MetricsTargetsData = z
  .object({
    leads_count: z.number().int(),
    leads_table: z.union([z.string(), z.null()]).optional(),
    orders_companies_count: z.number().int(),
    total_target: z.number().int(),
  })
  .passthrough();
export const MetricsTargetsEnvelope = z
  .object({ data: MetricsTargetsData, success: z.boolean() })
  .passthrough();
export const MissionRowV1 = z
  .object({
    assigned_date: z.union([z.string(), z.null()]).optional(),
    assigned_day: z.union([z.string(), z.null()]).optional(),
    created_at: z.union([z.string(), z.null()]).optional(),
    description: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    notes: z.union([z.string(), z.null()]).optional(),
    org_id: z.union([z.string(), z.null()]).optional(),
    owner_email: z.union([z.string(), z.null()]).optional(),
    owner_user_id: z.union([z.string(), z.null()]).optional(),
    region: z.union([z.string(), z.null()]).optional(),
    review_notes: z.union([z.string(), z.null()]).optional(),
    reviewed_at: z.union([z.string(), z.null()]).optional(),
    reviewed_by: z.union([z.string(), z.null()]).optional(),
    route_distance_km: z.union([z.number(), z.null()]).optional(),
    route_duration_min: z.union([z.number().int(), z.null()]).optional(),
    route_polyline: z.union([z.string(), z.null()]).optional(),
    route_provider: z.union([z.string(), z.null()]).optional(),
    route_version: z.union([z.string(), z.null()]).optional(),
    slot_index: z.union([z.number().int(), z.null()]).optional(),
    source: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    suggestion_id: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    updated_at: z.union([z.string(), z.null()]).optional(),
    user_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const MissionListResponse = z
  .object({
    data: z.array(MissionRowV1),
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionRowErrorCode = z.enum([
  "UNAUTHORIZED",
  "MISSION_NOT_FOUND",
  "LIST_FAILED",
  "UPDATE_FAILED",
  "CANCEL_FAILED",
  "FORBIDDEN_REVIEW_UPDATE",
  "FORBIDDEN_STATUS_UPDATE",
]);
export const MissionRowErrorDetailV1 = z
  .object({
    code: MissionRowErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const MissionRowErrorEnvelopeV1 = z
  .object({ error: MissionRowErrorDetailV1 })
  .passthrough();
export const MissionCreateRequest = z.object({
  assigned_date: z.string(),
  assigned_day: z.string(),
  description: z.union([z.string(), z.null()]).optional(),
  idempotency_key: z.union([z.string(), z.null()]).optional(),
  leads: z
    .union([z.array(z.object({}).partial().passthrough()), z.null()])
    .optional(),
  notes: z.union([z.string(), z.null()]).optional(),
  org_id: z.union([z.string(), z.null()]).optional(),
  owner_email: z.string(),
  region: z.string(),
  route_distance_km: z.union([z.number(), z.null()]).optional(),
  route_duration_min: z.union([z.number().int(), z.null()]).optional(),
  route_provider: z.union([z.string(), z.null()]).optional(),
  route_version: z.union([z.string(), z.null()]).optional(),
  slot_index: z.number().int(),
  source: z
    .string()
    .regex(/^(auto|manual)$/)
    .optional()
    .default("auto"),
  suggestion_id: z.union([z.string(), z.null()]).optional(),
  theme: z.union([z.string(), z.null()]).optional(),
  title: z.string().min(1),
  user_id: z.union([z.string(), z.null()]).optional(),
  week_start: z.union([z.string(), z.null()]).optional(),
});
export const MissionRowResponse = z
  .object({
    data: MissionRowV1,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionCreateErrorCode = z.enum([
  "UNAUTHORIZED",
  "CREATE_FAILED",
  "GENERATION_FAILED",
  "SCENARIOS_FAILED",
  "SERVICE_UNAVAILABLE",
]);
export const MissionCreateErrorDetailV1 = z
  .object({
    code: MissionCreateErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const MissionCreateErrorEnvelopeV1 = z
  .object({ error: MissionCreateErrorDetailV1 })
  .passthrough();
export const MissionCapacityCheckData = z.object({}).partial().passthrough();
export const MissionCapacityCheckResponse = z
  .object({
    data: MissionCapacityCheckData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionPrefsErrorCode = z.enum([
  "UNAUTHORIZED",
  "FORBIDDEN",
  "VALIDATION_ERROR",
  "PREFERENCES_FETCH_FAILED",
  "PREFERENCES_UPDATE_FAILED",
  "PREFERENCES_LIST_FAILED",
  "CAPACITY_CHECK_FAILED",
]);
export const MissionPrefsErrorDetailV1 = z
  .object({
    code: MissionPrefsErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const MissionPrefsErrorEnvelopeV1 = z
  .object({ error: MissionPrefsErrorDetailV1 })
  .passthrough();
export const MissionCapacityStatusData = z.object({}).partial().passthrough();
export const MissionCapacityStatusResponse = z
  .object({
    data: MissionCapacityStatusData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionComplianceDataV1 = z
  .object({
    all_submitted: z.union([z.boolean(), z.null()]),
    date: z.union([z.string(), z.null()]),
    locked_out: z.union([z.boolean(), z.null()]),
    locked_out_at: z.union([z.string(), z.null()]),
    open_reports: z.union([z.number().int(), z.null()]),
    submitted_reports: z.union([z.number().int(), z.null()]),
    user_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const MissionComplianceResponse = z
  .object({
    data: MissionComplianceDataV1,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionGenerationRequest = z.object({
  dry_run: z.union([z.boolean(), z.null()]).optional().default(false),
  exclude_lead_ids: z.union([z.array(z.string()), z.null()]).optional(),
  industry_codes: z.union([z.array(z.string()), z.null()]).optional(),
  keywords: z.union([z.array(z.string()), z.null()]).optional(),
  max_duration_hours: z.union([z.number().gte(0), z.null()]).optional(),
  max_leads: z.union([z.number().int().gte(1), z.null()]).optional(),
  max_route_km: z.union([z.number().gte(0), z.null()]).optional(),
  min_leads: z.union([z.number().int().gte(1), z.null()]).optional(),
  min_score: z.union([z.number().int().gte(0).lte(100), z.null()]).optional(),
  mission_count: z.union([z.number().int().gte(1), z.null()]).optional(),
  optimize_route: z.union([z.boolean(), z.null()]).optional().default(true),
  owner_id: z.string(),
  plz_prefix: z.string(),
  preferred_date: z.union([z.string(), z.null()]).optional(),
  product_families: z.union([z.array(z.string()), z.null()]).optional(),
  scenario: z.union([z.string(), z.null()]).optional(),
  scenario_params: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
});
export const MissionGenerateData = z.object({}).partial().passthrough();
export const MissionGenerateResponse = z
  .object({
    data: MissionGenerateData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionIdempotencyCleanupData = z.object({}).partial().passthrough();
export const MissionIdempotencyCleanupResponse = z
  .object({
    data: MissionIdempotencyCleanupData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionOpsErrorCode = z.enum([
  "UNAUTHORIZED",
  "STATS_FAILED",
  "CLEANUP_FAILED",
]);
export const MissionOpsErrorDetailV1 = z
  .object({
    code: MissionOpsErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const MissionOpsErrorEnvelopeV1 = z
  .object({ error: MissionOpsErrorDetailV1 })
  .passthrough();
export const MissionIdempotencyStatsData = z.object({}).partial().passthrough();
export const MissionIdempotencyStatsResponse = z
  .object({
    data: MissionIdempotencyStatsData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionPreferencesRowV1 = z
  .object({
    auto_generate: z.union([z.boolean(), z.null()]),
    daily_quota: z.union([z.number().int(), z.null()]),
    industry_codes: z.union([z.array(z.string()), z.null()]),
    keywords: z.union([z.array(z.string()), z.null()]),
    max_leads: z.union([z.number().int(), z.null()]),
    max_route_km: z.union([z.number(), z.null()]),
    min_leads: z.union([z.number().int(), z.null()]),
    owner_email: z.union([z.string(), z.null()]),
    plz_prefixes: z.union([z.array(z.string()), z.null()]),
    product_families: z.union([z.array(z.string()), z.null()]),
    tier: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const MissionPreferencesListResponse = z
  .object({
    data: z.array(MissionPreferencesRowV1),
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionPreferencesResponse = z
  .object({
    data: MissionPreferencesRowV1,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionPreferencesRequest = z
  .object({
    auto_generate: z.union([z.boolean(), z.null()]).default(false),
    daily_quota: z.union([z.number().int().gte(0), z.null()]),
    industry_codes: z.union([z.array(z.string()), z.null()]),
    keywords: z.union([z.array(z.string()), z.null()]),
    max_leads: z.union([z.number().int().gte(1), z.null()]),
    max_route_km: z.union([z.number().gt(0), z.null()]),
    min_leads: z.union([z.number().int().gte(1), z.null()]),
    plz_prefixes: z.union([z.array(z.string()), z.null()]),
    product_families: z.union([z.array(z.string()), z.null()]),
    tier: z.union([z.number().int().gte(1).lte(3), z.null()]),
  })
  .partial();
export const MissionScenariosData = z.object({}).partial().passthrough();
export const MissionScenariosResponse = z
  .object({
    data: MissionScenariosData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionScoringSnapshotData = z.object({}).partial().passthrough();
export const MissionScoringSnapshotResponse = z
  .object({
    data: MissionScoringSnapshotData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionLeadsErrorCode = z.enum([
  "UNAUTHORIZED",
  "MISSION_NOT_FOUND",
  "NOT_FOUND",
  "QUERY_FAILED",
  "BACKLOG_CHECK_FAILED",
  "ADD_LEADS_FAILED",
  "UPDATE_LEAD_FAILED",
  "VISIT_FAILED",
  "SKIP_FAILED",
]);
export const MissionLeadsErrorDetailV1 = z
  .object({
    code: MissionLeadsErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const MissionLeadsErrorEnvelopeV1 = z
  .object({ error: MissionLeadsErrorDetailV1 })
  .passthrough();
export const StopTransitionRequest = z.object({
  accuracy: z.union([z.number(), z.null()]).optional(),
  engagement_id: z.string(),
  event: z.enum([
    "anfahren",
    "besuch_starten",
    "besuch_beenden",
    "submit",
    "skip",
  ]),
  lat: z.union([z.number(), z.null()]).optional(),
  lng: z.union([z.number(), z.null()]).optional(),
  occurred_at: z.union([z.string(), z.null()]).optional(),
  onsite: z.union([z.boolean(), z.null()]).optional(),
});
export const StopTransitionData = z
  .object({
    engagement_id: z.string(),
    event: z.enum([
      "anfahren",
      "besuch_starten",
      "besuch_beenden",
      "submit",
      "skip",
    ]),
    lifecycle_node: z.string(),
    occurred_at: z.string(),
  })
  .passthrough();
export const StopTransitionResponse = z
  .object({
    data: StopTransitionData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const AnchorEventRequest = z.object({
  event_type: z.string().regex(/^(promoted|demoted)$/),
  reason: z.union([z.string(), z.null()]).optional(),
});
export const MissionAnchorEventV1 = z
  .object({
    actor_email: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    event_type: z.union([z.string(), z.null()]),
    id: z.union([z.string(), z.null()]),
    mission_lead_id: z.union([z.string(), z.null()]),
    reason: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const MissionAnchorEventResponse = z
  .object({
    data: MissionAnchorEventV1,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionStopsErrorCode = z.enum([
  "UNAUTHORIZED",
  "MISSION_NOT_FOUND",
  "NOT_FOUND",
  "QUERY_FAILED",
  "UPSTREAM_ERROR",
  "UPDATE_STOP_FAILED",
  "EVENT_FAILED",
  "REORDER_ATOMIC_FAILED",
  "REORDER_ATOMIC_NO_RESULT",
  "INVALID_JOKER_SOURCE",
  "MISSION_LOOKUP_FAILED",
  "JOKERS_DISABLED",
  "JOKER_QUOTA_EXCEEDED",
  "JOKER_CREATE_FAILED",
  "LIST_JOKERS_FAILED",
]);
export const MissionStopsErrorDetailV1 = z
  .object({
    code: MissionStopsErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const MissionStopsErrorEnvelopeV1 = z
  .object({ error: MissionStopsErrorDetailV1 })
  .passthrough();
export const VisitReportAccessResult = z.enum([
  "no_access",
  "no_decision_maker",
  "decision_maker_reached",
]);
export const VisitReportConversationResult = z.enum([
  "sale",
  "demo",
  "conversation",
  "rejected",
]);
export const VisitReportTypeCorrect = z.enum(["yes", "wrong"]);
export const VisitReportSubmitRequest = z.object({
  access_result: z.union([VisitReportAccessResult, z.null()]).optional(),
  anchor_reason: z.union([z.string(), z.null()]).optional(),
  anchor_recommendation: z
    .union([z.string().regex(/^(promote|demote|keep)$/), z.null()])
    .optional(),
  answers: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
  contact_card_photo: z.union([z.string(), z.null()]).optional(),
  contact_first_name: z.union([z.string(), z.null()]).optional(),
  contact_is_decision_maker: z.union([z.boolean(), z.null()]).optional(),
  contact_last_name: z.union([z.string(), z.null()]).optional(),
  contact_role: z.union([z.string(), z.null()]).optional(),
  conversation_result: z
    .union([VisitReportConversationResult, z.null()])
    .optional(),
  defer_count: z.union([z.number().int(), z.null()]).optional(),
  demo_given: z.union([z.boolean(), z.null()]).optional(),
  dynamic_context: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
  follow_up_date: z
    .union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/), z.null()])
    .optional(),
  follow_up_scheduled: z.union([z.boolean(), z.null()]).optional(),
  mission_id: z.string(),
  mission_lead_id: z.string(),
  next_steps: z
    .union([
      z.string().regex(/^(send_offer|deliver_test|schedule_followup|none)$/),
      z.null(),
    ])
    .optional(),
  no_access_detail: z.union([z.string(), z.null()]).optional(),
  no_access_reason: z
    .union([
      z
        .string()
        .regex(
          /^(business_closed|wrong_address|outside_hours|security_clearance|other)$/
        ),
      z.null(),
    ])
    .optional(),
  no_dm_detail: z.union([z.string(), z.null()]).optional(),
  no_dm_reason: z
    .union([
      z
        .string()
        .regex(
          /^(gatekeeper_rejected|dm_unavailable|referred_callback|other)$/
        ),
      z.null(),
    ])
    .optional(),
  notes: z.union([z.string(), z.null()]).optional(),
  products_interested: z.union([z.array(z.string()), z.null()]).optional(),
  products_presented: z.union([z.array(z.string()), z.null()]).optional(),
  products_sold: z.union([z.array(z.string()), z.null()]).optional(),
  questionnaire_version: z.union([z.string(), z.null()]).optional(),
  rejection_detail: z.union([z.string(), z.null()]).optional(),
  rejection_reason: z
    .union([
      z
        .string()
        .regex(
          /^(has_our_product|has_competitor_product|too_expensive|no_purchasing_authority|no_conversation|dm_not_present|business_closed|no_cleaning_need|other)$/
        ),
      z.null(),
    ])
    .optional(),
  rep_customer_status: z
    .union([z.enum(["neukunde", "bekannt"]), z.null()])
    .optional(),
  sale_amount_estimated: z.union([z.number(), z.null()]).optional(),
  submitted_at: z.union([z.string(), z.null()]).optional(),
  type_correct: z.union([VisitReportTypeCorrect, z.null()]).optional(),
  type_override: z.union([z.string(), z.null()]).optional(),
  unified_lead_id: z.string(),
  use_cases_confirmed: z.union([z.array(z.string()), z.null()]).optional(),
  visit_ended_at: z.union([z.string(), z.null()]).optional(),
  visit_started_at: z.union([z.string(), z.null()]).optional(),
  visit_type: z
    .union([z.string().regex(/^(termin|kaltbesuch)$/), z.null()])
    .optional(),
});
export const MissionVisitReportData = z.object({}).partial().passthrough();
export const MissionVisitReportResponse = z
  .object({
    data: MissionVisitReportData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionRejectErrorCode = z.enum([
  "UNAUTHORIZED",
  "MISSION_NOT_FOUND",
  "NOT_FOUND",
  "REJECT_FAILED",
  "SNOOZE_DATE_REQUIRED",
  "REJECTION_DETAIL_REQUIRED",
  "REASON_REQUIRED",
  "RESULT_REQUIRED",
  "OVERRIDE_REQUIRED",
  "REPORT_ATOMIC_FAILED",
  "REPORT_ATOMIC_NO_RESULT",
  "VISIT_ANSWER_UNKNOWN_KEY",
  "VISIT_ANSWER_VALUE_NOT_IN_CONFIG",
  "VISIT_ANSWER_DEFER_NOT_ALLOWED",
  "VISIT_ANSWER_SHAPE_INVALID",
  "VISIT_QUESTIONNAIRE_CONFIG_UNAVAILABLE",
  "VISIT_QUESTIONNAIRE_CONFIG_AMBIGUOUS",
  "VISIT_QUESTIONNAIRE_CONFIG_MALFORMED",
]);
export const MissionRejectErrorDetailV1 = z
  .object({
    code: MissionRejectErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const MissionRejectErrorEnvelopeV1 = z
  .object({ error: MissionRejectErrorDetailV1 })
  .passthrough();
export const VisitReportV2JahresbedarfItem = z.object({
  liter_jahr: z.number().gte(0),
  product: z.string(),
});
export const VisitReportV2SubmitRequest = z.object({
  account_ref: z.union([z.string(), z.null()]).optional(),
  ap_reached: z.union([z.boolean(), z.null()]).optional(),
  ap_rolle: z
    .union([
      z.enum([
        "geschaeftsfuehrung",
        "inhaber",
        "prokurist",
        "betriebsleiter",
        "einkauf",
        "hausmeister_haustechnik",
        "fachkraft_mitarbeiter",
        "sonstiges",
      ]),
      z.null(),
    ])
    .optional(),
  ap_rolle_sonstiges: z.union([z.string(), z.null()]).optional(),
  branche_correct: z
    .union([z.enum(["ja", "nein", "unbekannt"]), z.null()])
    .optional(),
  branche_correction: z.union([z.string(), z.null()]).optional(),
  contamination_confirmed: z.union([z.array(z.string()), z.null()]).optional(),
  demo_done: z.union([z.boolean(), z.null()]).optional(),
  demo_object: z.union([z.string(), z.null()]).optional(),
  dm_info_correct: z
    .union([z.enum(["ja", "nein", "unbekannt"]), z.null()])
    .optional(),
  dm_info_correction: z.union([z.string(), z.null()]).optional(),
  einschaetzung_fehler: z
    .union([
      z.enum([
        "falsche_branche",
        "kein_clanda_fit",
        "falsche_firma_adresse",
        "falsche_oeffnungszeiten",
        "firma_geschlossen_dauerhaft",
        "falsches_produkt_anwendung",
        "sonstiges",
      ]),
      z.null(),
    ])
    .optional(),
  einschaetzung_fehler_sonstiges: z.union([z.string(), z.null()]).optional(),
  entered: z.union([z.boolean(), z.null()]).optional(),
  erstbesuch: z.union([z.boolean(), z.null()]).optional(),
  gatekeeper_passed: z
    .union([z.enum(["durch", "blockiert", "keiner"]), z.null()])
    .optional(),
  jahresbedarf: z
    .union([z.array(VisitReportV2JahresbedarfItem), z.null()])
    .optional(),
  kunde_status: z.union([z.enum(["neukunde", "bestand"]), z.null()]).optional(),
  lead_invalid_reason: z
    .union([
      z.enum([
        "privathaus_kein_fit",
        "dauerhaft_geschlossen",
        "falsche_firma_adresse",
        "nicht_icp",
      ]),
      z.null(),
    ])
    .optional(),
  lead_valid: z
    .union([z.enum(["ja", "nein", "unbekannt"]), z.null()])
    .optional(),
  mischungsverhaeltnis_sonstiges: z.union([z.string(), z.null()]).optional(),
  mission_id: z.string(),
  mission_lead_id: z.string(),
  next_action: z
    .union([
      z.array(
        z.enum([
          "folgetermin",
          "angebot",
          "muster",
          "rueckruf",
          "wiedervorlage",
          "nichts",
        ])
      ),
      z.null(),
    ])
    .optional(),
  next_when_date: z
    .union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/), z.null()])
    .optional(),
  next_when_kind: z
    .union([z.enum(["datum", "kw", "monat", "zeitraum", "offen"]), z.null()])
    .optional(),
  next_when_label: z.union([z.string(), z.null()]).optional(),
  no_ap_reason: z
    .union([
      z.enum([
        "ap_nicht_da",
        "abgewimmelt",
        "kein_termin",
        "folgetermin",
        "sonstiges",
      ]),
      z.null(),
    ])
    .optional(),
  no_ap_reason_sonstiges: z.union([z.string(), z.null()]).optional(),
  no_entry_reason: z
    .union([
      z.enum([
        "firma_geschlossen_dauerhaft",
        "falsche_oeffnungszeiten",
        "kein_zutritt",
        "falsche_firma_adresse",
        "nicht_icp",
        "sonstiges",
      ]),
      z.null(),
    ])
    .optional(),
  no_entry_reason_sonstiges: z.union([z.string(), z.null()]).optional(),
  no_sale_reason: z
    .union([
      z.enum([
        "kein_bedarf",
        "bestandslieferant",
        "preis_budget",
        "bedenkzeit",
        "kein_interesse",
        "sonstiges",
      ]),
      z.null(),
    ])
    .optional(),
  no_sale_reason_sonstiges: z.union([z.string(), z.null()]).optional(),
  notizen: z.union([z.string(), z.null()]).optional(),
  objects_confirmed: z.union([z.array(z.string()), z.null()]).optional(),
  product_correct: z
    .union([z.enum(["ja", "nein", "unbekannt"]), z.null()])
    .optional(),
  questionnaire_version: z.union([z.string().min(1), z.null()]).optional(),
  relevante_produkte: z.union([z.array(z.string()), z.null()]).optional(),
  schon_mal_verkauft: z.union([z.boolean(), z.null()]).optional(),
  sold: z.boolean(),
  source_event_id: z.string(),
  spin_correct: z
    .union([z.enum(["ja", "nein", "unbekannt"]), z.null()])
    .optional(),
  stop_type: z.enum(["planned", "joker"]).optional().default("planned"),
  unified_lead_id: z.string(),
  visited_at: z.union([z.string(), z.null()]).optional(),
  wettbewerb: z.union([z.string(), z.null()]).optional(),
  zeichnungsberechtigt_info: z.union([z.string(), z.null()]).optional(),
  zeichnungsberechtigt_wer: z
    .union([
      z.enum([
        "ansprechpartner_selbst",
        "geschaeftsfuehrung",
        "einkauf",
        "gremium",
        "unbekannt",
      ]),
      z.null(),
    ])
    .optional(),
});
export const VisitReportV2Engagement = z.object({
  disposition: z
    .union([
      z.enum(["invalid_lead", "sold", "no_sale", "no_dm", "no_access"]),
      z.null(),
    ])
    .optional(),
  engagement_id: z.string(),
});
export const VisitReportDeadLetter = z.object({
  reason_code: z.literal("lead_unresolvable"),
  source_event_id: z.string().min(1),
});
export const VisitReportV2SubmitResponse = z
  .object({
    data: z.union([VisitReportV2Engagement, z.null()]),
    dead_letter: z.union([VisitReportDeadLetter, z.null()]),
    success: z.literal(true).default(true),
  })
  .partial();
export const VisitReportV8Bedarf = z.object({
  jahresbedarf_liter: z.number().gte(0),
  mischungsverhaeltnis: z.union([z.string(), z.null()]).optional(),
  mischungsverhaeltnis_seed: z.union([z.string(), z.null()]).optional(),
  mischungsverhaeltnis_seed_source: z.string().min(1),
  mischungsverhaeltnis_sonstiges: z.union([z.string(), z.null()]).optional(),
  product: z.string().min(1),
});
export const VisitReportV8Paar = z.object({
  dictionary_pair_id: z.union([z.string().uuid(), z.null()]).optional(),
  objekt: z.string().min(1),
  seed_present: z.boolean(),
  seed_source: z.union([z.string(), z.null()]).optional(),
  source: z.enum(["deterministic", "llm", "rep", "mechanical"]),
  verdict: z.enum(["confirm", "refute", "discover"]),
  verschmutzung: z.string().min(1),
});
export const VisitReportV8ProduktZuweisung = z.object({
  objekt: z.string().min(1),
  produkt: z.string().min(1),
  recommended: z.boolean(),
  seed_present: z.boolean(),
  seed_source: z.union([z.string(), z.null()]).optional(),
  source: z.enum(["deterministic", "llm", "rep", "mechanical"]),
  verdict: z.enum(["confirm", "refute", "discover"]),
  verschmutzung: z.string().min(1),
});
export const VisitReportV8Upsell = z.object({
  menge_liter: z.union([z.number().gte(0), z.null()]).optional(),
  produkt: z.string().min(1),
  relevant: z.boolean(),
  wann: z.union([z.string(), z.null()]).optional(),
});
export const VisitReportV8SubmitRequest = z.object({
  account_ref: z.union([z.string(), z.null()]).optional(),
  bedarf: z.union([z.array(VisitReportV8Bedarf), z.null()]).optional(),
  branche: z.union([z.string(), z.null()]).optional(),
  branche_seed_source: z.union([z.string(), z.null()]).optional(),
  branche_seed_value: z.union([z.string(), z.null()]).optional(),
  cleared: z.union([z.array(z.string()), z.null()]).optional(),
  einweisung_noetig: z.union([z.boolean(), z.null()]).optional(),
  firma_bekannt: z.union([z.boolean(), z.null()]).optional(),
  kauft_ueber_liste: z.union([z.string(), z.null()]).optional(),
  kunde_status_seed_source: z.union([z.string(), z.null()]).optional(),
  kunde_status_seed_value: z.union([z.string(), z.null()]).optional(),
  listung_realistisch: z.union([z.string(), z.null()]).optional(),
  max_rabatt_gefordert: z.union([z.string(), z.null()]).optional(),
  mehrstandort: z.union([z.string(), z.null()]).optional(),
  mehrstandort_details: z.union([z.string(), z.null()]).optional(),
  mission_id: z.string(),
  mission_lead_id: z.string().uuid(),
  next_when_bis: z.union([z.string(), z.null()]).optional(),
  next_when_kw: z.union([z.number().int(), z.null()]).optional(),
  next_when_kw_jahr: z.union([z.number().int(), z.null()]).optional(),
  next_when_monat: z.union([z.string(), z.null()]).optional(),
  next_when_typ: z.union([z.string(), z.null()]).optional(),
  next_when_von: z.union([z.string(), z.null()]).optional(),
  next_when_zeitpunkt: z
    .union([z.string().datetime({ offset: true }), z.null()])
    .optional(),
  paare: z.union([z.array(VisitReportV8Paar), z.null()]).optional(),
  paare_seed_shown: z.union([z.number().int().gte(0), z.null()]).optional(),
  person_getroffen: z.union([z.string(), z.null()]).optional(),
  person_getroffen_seed_source: z.union([z.string(), z.null()]).optional(),
  person_getroffen_seed_value: z.union([z.string(), z.null()]).optional(),
  person_korrektur_name: z.union([z.string(), z.null()]).optional(),
  person_korrektur_rolle: z.union([z.string(), z.null()]).optional(),
  produkt_zuweisung: z
    .union([z.array(VisitReportV8ProduktZuweisung), z.null()])
    .optional(),
  produkt_zuweisung_seed_shown: z
    .union([z.number().int().gte(0), z.null()])
    .optional(),
  questionnaire_version: z.string().min(1),
  rueckruf_uhrzeit: z.union([z.string(), z.null()]).optional(),
  scan_order_id: z.union([z.string().uuid(), z.null()]).optional(),
  scan_status: z.union([z.enum(["gescannt", "deferred"]), z.null()]).optional(),
  source_event_id: z.string().uuid(),
  termin: z.union([z.string(), z.null()]).optional(),
  unified_lead_id: z.string().uuid(),
  upsell: z.union([z.array(VisitReportV8Upsell), z.null()]).optional(),
  visitenkarte_email: z.union([z.string(), z.null()]).optional(),
  visitenkarte_erfassung: z
    .union([z.enum(["scan", "manuell"]), z.null()])
    .optional(),
  visitenkarte_funktion: z.union([z.string(), z.null()]).optional(),
  visitenkarte_name: z.union([z.string(), z.null()]).optional(),
  visitenkarte_telefon: z.union([z.string(), z.null()]).optional(),
  weitere_anwender: z.union([z.boolean(), z.null()]).optional(),
  wendet_selbst_an: z.union([z.boolean(), z.null()]).optional(),
  wettbewerb_seed_source: z.union([z.string(), z.null()]).optional(),
  wettbewerb_seed_value: z.union([z.string(), z.null()]).optional(),
  zeichnungsberechtigt: z.union([z.string(), z.null()]).optional(),
  zeichnungslimit: z.union([z.string(), z.null()]).optional(),
  zentrale_entscheidet: z.union([z.string(), z.null()]).optional(),
});
export const VisitReportV8Result = z.object({
  account_ref: z.string().min(1),
  answers_replay_noop: z.boolean(),
  engagement_id: z.string().min(1),
  jahresbedarf: z.number().int().gte(0),
  pairs: z.number().int().gte(0),
  revision: z.number().int().gte(1),
  stored_account_ref: z.string().min(1),
  stored_bedarf_mix_seed_sources: z.number().int().gte(0),
  stored_business_card: z.number().int().gte(0),
  stored_field_provenance: z.number().int().gte(0),
  stored_jahresbedarf: z.number().int().gte(0),
  stored_mission_lead_id: z.string().min(1),
  stored_paare_seed_shown: z.union([z.number().int().gte(0), z.null()]),
  stored_paare_seed_sources: z.number().int().gte(0),
  stored_pairs: z.number().int().gte(0),
  stored_produkt_zuweisung_seed_shown: z.union([
    z.number().int().gte(0),
    z.null(),
  ]),
  stored_produkt_zuweisung_verdicts: z.number().int().gte(0),
  stored_questionnaire_config_id: z.string().min(1),
  stored_questionnaire_version: z.string().min(1),
  stored_triples: z.number().int().gte(0),
  stored_upsell: z.number().int().gte(0),
  stored_v8_scalars_answered: z.number().int().gte(0),
  submitted_at: z.string().min(1),
  triples: z.number().int().gte(0),
  upsell: z.number().int().gte(0),
});
export const VisitReportV8DeadLetter = z.object({
  answers_dead_letter_submits: z.number().int().gte(1),
  answers_dead_lettered: z.literal(true),
  answers_projection: z.string().min(1),
  dead_lettered: z.literal(true),
  engagement_id: z.null(),
  reason_code: z.string().min(1),
  source_event_id: z.string().min(1),
});
export const VisitReportV8SubmitResponse = z.object({
  data: z.union([VisitReportV8Result, VisitReportV8DeadLetter]),
  success: z.literal(true).optional().default(true),
});
export const MissionUpdateRequest = z
  .object({
    assigned_date: z.union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/), z.null()]),
    assigned_day: z.union([z.string(), z.null()]),
    date: z.union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/), z.null()]),
    description: z.union([z.string(), z.null()]),
    expected_updated_at: z.union([z.string(), z.null()]),
    notes: z.union([z.string(), z.null()]),
    owner_email: z.union([z.string(), z.null()]),
    region_id: z.union([z.string(), z.null()]),
    review_notes: z.union([z.string(), z.null()]),
    reviewed_at: z.union([z.string(), z.null()]),
    reviewed_by: z.union([z.string(), z.null()]),
    route_distance_km: z.union([z.number(), z.null()]),
    route_duration_min: z.union([z.number().int(), z.null()]),
    route_polyline: z.union([z.string(), z.null()]),
    slot_index: z.union([z.number().int(), z.null()]),
    status: z.union([
      z
        .string()
        .regex(
          /^(generated|planned|in_progress|review_requested|reviewed|active|completed|closed|cancelled)$/
        ),
      z.null(),
    ]),
    title: z.union([z.string(), z.null()]),
  })
  .partial();
export const PendingLeadRow = z.object({}).partial().passthrough();
export const MissionBacklogDataV1 = z
  .object({
    is_blocked: z.union([z.boolean(), z.null()]),
    max_allowed: z.union([z.number().int(), z.null()]),
    pending_leads: z.union([z.array(PendingLeadRow), z.null()]),
    pending_reports: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const MissionBacklogResponse = z
  .object({
    data: MissionBacklogDataV1,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionJokerGoogleAutocompleteV1 = z
  .object({
    address: z.union([z.string(), z.null()]).optional(),
    city: z.union([z.string(), z.null()]).optional(),
    country: z.string().optional().default("DE"),
    lat: z.union([z.number(), z.null()]).optional(),
    lng: z.union([z.number(), z.null()]).optional(),
    name: z.string().min(1),
    phone: z.union([z.string(), z.null()]).optional(),
    place_id: z.string().min(1),
    plz: z.union([z.string(), z.null()]).optional(),
    website: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const MissionJokerManualEntryV1 = z
  .object({
    address: z.union([z.string(), z.null()]).optional(),
    city: z.union([z.string(), z.null()]).optional(),
    country: z.string().optional().default("DE"),
    name: z.string().min(1),
    phone: z.union([z.string(), z.null()]).optional(),
    plz: z.union([z.string(), z.null()]).optional(),
    website: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const JokerCreateRequest = z.object({
  discovered_company_id: z.union([z.string(), z.null()]).optional(),
  google_autocomplete: z
    .union([MissionJokerGoogleAutocompleteV1, z.null()])
    .optional(),
  lead_id: z.union([z.string(), z.null()]).optional(),
  manual_entry: z.union([MissionJokerManualEntryV1, z.null()]).optional(),
  order_index: z.union([z.number().int(), z.null()]).optional(),
  reason: z.string().min(1),
});
export const MissionJokerQuotaV1 = z
  .object({
    max_per_day: z.number().int().default(0),
    remaining: z.number().int().default(0),
    used_today: z.number().int().default(0),
  })
  .partial()
  .passthrough();
export const MissionStopV1 = z
  .object({
    anchor_source: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    discovered_company_id: z.union([z.string(), z.null()]),
    id: z.union([z.string(), z.null()]),
    is_anchor: z.union([z.boolean(), z.null()]),
    joker_reason: z.union([z.string(), z.null()]),
    joker_source: z.union([z.string(), z.null()]),
    mission_id: z.union([z.string(), z.null()]),
    order_index: z.union([z.number().int(), z.null()]),
    planned_time: z.union([z.string(), z.null()]),
    preferred_time: z.union([z.string(), z.null()]),
    state: z.union([z.string(), z.null()]),
    state_reason: z.union([z.string(), z.null()]),
    stop_type: z.union([z.string(), z.null()]),
    unified_lead_id: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
    visited_at: z.union([z.string(), z.null()]),
    visited_by: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const MissionJokerCreateDataV1 = z
  .object({ quota: MissionJokerQuotaV1, stop: MissionStopV1 })
  .passthrough();
export const MissionJokerResponse = z
  .object({
    data: MissionJokerCreateDataV1,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionJokerListResponse = z
  .object({
    data: z.array(MissionStopV1),
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const JokerDeleteResponse = z
  .object({ deleted: z.boolean(), mission_id: z.string(), stop_id: z.string() })
  .passthrough();
export const MissionLeadAssignment = z.object({
  order_index: z.number().int(),
  unified_lead_id: z.string(),
});
export const MissionAddLeadsInputV1 = z.array(MissionLeadAssignment);
export const AddedLeadRow = z.object({}).partial().passthrough();
export const MissionAddLeadsDataV1 = z
  .object({
    added_leads: z.union([z.array(AddedLeadRow), z.null()]),
    mission_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const MissionAddLeadsResponse = z
  .object({
    data: MissionAddLeadsDataV1,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionLeadStateName = z.enum([
  "queued",
  "visited",
  "skipped",
  "bounced",
]);
export const MissionLeadStateReason = z.enum([
  "not_found",
  "wrong_site",
  "not_at_address",
  "address_not_exists",
  "store_closed",
  "company_dissolved",
  "recently_visited",
  "appointment_declined",
  "duplicate",
  "out_of_territory",
  "other",
  "closed_permanently",
  "wrong_address",
  "refused_meeting",
]);
export const MissionLeadUpdateRequest = z
  .object({
    expected_updated_at: z.union([z.string(), z.null()]),
    is_anchor: z.union([z.boolean(), z.null()]),
    planned_time: z.union([z.string(), z.null()]),
    preferred_time: z.union([z.string(), z.null()]),
    state: z.union([MissionLeadStateName, z.null()]),
    state_reason: z.union([MissionLeadStateReason, z.null()]),
    visited_at: z.union([z.string(), z.null()]),
    visited_by: z.union([z.string(), z.null()]),
  })
  .partial();
export const MissionLeadStateData = z.object({}).partial().passthrough();
export const MissionLeadStateResponse = z
  .object({
    data: MissionLeadStateData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionAnchorEventListResponse = z
  .object({
    data: z.array(MissionAnchorEventV1),
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionLeadRejectionReason = z.enum([
  "wrong_location",
  "address_not_found",
  "address_invalid",
  "business_closed",
  "business_dissolved",
  "existing_customer",
  "recently_visited",
  "duplicate",
  "appointment_rejected",
  "visit_later",
  "dm_not_available",
  "out_of_territory",
  "other",
]);
export const MissionLeadRejectRequest = z.object({
  rejection_detail: z.union([z.string(), z.null()]).optional(),
  rejection_reason: MissionLeadRejectionReason,
  snooze_until: z.union([z.string(), z.null()]).optional(),
});
export const MissionLeadRejectData = z.object({}).partial().passthrough();
export const MissionLeadRejectResponse = z
  .object({
    data: MissionLeadRejectData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionLeadSkipRequest = z.object({
  state_reason: MissionLeadStateReason,
});
export const MissionLeadSkipData = z.object({}).partial().passthrough();
export const MissionLeadSkipResponse = z
  .object({
    data: MissionLeadSkipData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionLeadVisitRequest = z
  .object({
    state_reason: z.union([z.string(), z.null()]),
    visited_at: z.union([z.string(), z.null()]),
  })
  .partial();
export const MissionLeadVisitData = z.object({}).partial().passthrough();
export const MissionLeadVisitResponse = z
  .object({
    data: MissionLeadVisitData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionRejectRequest = z.object({
  rejection_notes: z.union([z.string(), z.null()]).optional(),
  rejection_reason: z.string(),
});
export const MissionRejectResponse = z
  .object({
    data: MissionRowV1,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionResumeRequest = z.object({ target_mission_id: z.string() });
export const MissionResumeDataV1 = z
  .object({
    carried_over_count: z.number().int().default(0),
    lead_ids: z.array(z.string()).default([]),
  })
  .partial()
  .passthrough();
export const MissionResumeResponse = z
  .object({
    data: MissionResumeDataV1,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionLifecycleErrorCode = z.enum([
  "UNAUTHORIZED",
  "MISSION_NOT_FOUND",
  "INVALID_TRANSITION",
  "MISSING_OWNER_EMAIL",
  "ACTIVE_MISSION_EXISTS",
]);
export const MissionLifecycleErrorDetailV1 = z
  .object({
    code: MissionLifecycleErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const MissionLifecycleErrorEnvelopeV1 = z
  .object({ error: MissionLifecycleErrorDetailV1 })
  .passthrough();
export const MissionStopListResponse = z.array(MissionStopV1);
export const StopReorderRequest = z.object({
  mission_lead_id: z.string(),
  new_index: z.number().int().gte(0),
});
export const MissionStopReorderResponse = z
  .object({
    data: z.array(MissionStopV1),
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const MissionStopRowResponse = z
  .object({
    data: MissionStopV1,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const StopUpdateRequest = z
  .object({
    anchor_source: z.union([
      z.string().regex(/^(suggested|manual)$/),
      z.null(),
    ]),
    expected_updated_at: z.union([z.string(), z.null()]),
    is_anchor: z.union([z.boolean(), z.null()]),
    order_index: z.union([z.number().int().gte(0), z.null()]),
    planned_time: z.union([z.string(), z.null()]),
    preferred_time: z.union([z.string(), z.null()]),
    state: z.union([MissionLeadStateName, z.null()]),
    state_reason: z.union([MissionLeadStateReason, z.null()]),
    visited_at: z.union([z.string(), z.null()]),
    visited_by: z.union([z.string(), z.null()]),
  })
  .partial();
export const MissionTransitionNode = z.enum([
  "INTAKE",
  "ORIENT",
  "PLAN",
  "GATE",
  "EXECUTE",
  "VERIFY",
  "REVIEW",
  "CLOSE",
]);
export const MissionTransitionRequest = z.object({
  target_node: MissionTransitionNode,
});
export const MeetingPoint = z
  .object({
    address: z.union([z.string(), z.null()]),
    lat: z.union([z.number(), z.null()]),
    lon: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const MissionBuildOverrides = z
  .object({
    accept_long_route: z.boolean().default(false),
    focus_plz: z.union([z.array(z.number().int()), z.null()]),
    lookback_days: z.union([z.number().int(), z.null()]),
    max_employees: z.union([z.number().int(), z.null()]),
    meeting_point: z.union([MeetingPoint, z.null()]),
  })
  .partial()
  .passthrough();
export const MissionBuildRequest = z.object({
  mission_date: z.string(),
  overrides: z.union([MissionBuildOverrides, z.null()]).optional(),
  rep_email: z.union([z.string(), z.null()]).optional(),
  rep_id: z.union([z.string().uuid(), z.null()]).optional(),
});
export const MissionBuildMetadata = z
  .object({
    generated_by: z.union([z.string(), z.null()]).optional(),
    source: z.union([z.string(), z.null()]).optional(),
    status: z.enum(["active", "review_required"]),
  })
  .passthrough();
export const MissionBuildResponseEnvelope = z
  .object({
    build_metadata: MissionBuildMetadata,
    mission_id: z.string(),
    replaced_mission_ids: z.array(z.string()).optional(),
    route_km: z.union([z.number(), z.null()]).optional(),
    stops: z.array(z.unknown()).optional(),
    summary: z.object({}).partial().passthrough().optional(),
    warnings: z.array(z.unknown()).optional(),
  })
  .passthrough();
export const HealthCheckResponse = z
  .object({
    data: z.object({}).partial().passthrough(),
    meta: z.object({}).partial().passthrough(),
    success: z.boolean(),
  })
  .passthrough();
export const MetricsResponse = z
  .object({
    data: z.object({}).partial().passthrough(),
    meta: z.object({}).partial().passthrough(),
    success: z.boolean(),
  })
  .passthrough();
export const NoteIn = z.object({ content: z.string(), lead_id: z.string() });
export const NoteLogData = z.object({ lead_id: z.string() }).passthrough();
export const NoteLogEnvelope = z
  .object({ data: NoteLogData, success: z.boolean() })
  .passthrough();
export const NotificationRow = z
  .object({
    body: z.union([z.string(), z.null()]),
    category: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    dismissed: z.union([z.boolean(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    read: z.union([z.boolean(), z.null()]),
    title: z.union([z.string(), z.null()]),
    user_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const NotificationsListEnvelope = z
  .object({ data: z.array(NotificationRow), success: z.boolean() })
  .passthrough();
export const NotificationsMarkAllReadData = z
  .object({ updated_count: z.number().int() })
  .passthrough();
export const NotificationsMarkAllReadEnvelope = z
  .object({ data: NotificationsMarkAllReadData, success: z.boolean() })
  .passthrough();
export const NotificationPreferencesRow = z
  .object({
    auto_start_daemon: z.boolean().nullable(),
    badge_count_mode: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    id: z.string().uuid().nullable(),
    notify_ci_failures: z.boolean().nullable(),
    notify_deploy_complete: z.boolean().nullable(),
    notify_escalations: z.boolean().nullable(),
    notify_inbox_messages: z.boolean().nullable(),
    notify_p0_signals: z.boolean().nullable(),
    notify_permission_prompts: z.boolean().nullable(),
    push_subscription: z.object({}).partial().passthrough().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    user_email: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const NotificationPreferencesEnvelope = z
  .object({
    data: z.array(NotificationPreferencesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const NotificationPreferencesUpdate = z
  .object({
    call_later_reminder: z.union([z.boolean(), z.null()]),
    day_summary: z.union([z.boolean(), z.null()]),
    mission_review: z.union([z.boolean(), z.null()]),
    push_enabled: z.union([z.boolean(), z.null()]),
    report_overdue: z.union([z.boolean(), z.null()]),
    session_stuck: z.union([z.boolean(), z.null()]),
    timesheet_reminder: z.union([z.boolean(), z.null()]),
  })
  .partial();
export const NotificationsUnreadCountData = z
  .object({ count: z.number().int() })
  .passthrough();
export const NotificationsUnreadCountEnvelope = z
  .object({ data: NotificationsUnreadCountData, success: z.boolean() })
  .passthrough();
export const NotificationUpdate = z
  .object({
    dismissed: z.union([z.boolean(), z.null()]),
    read: z.union([z.boolean(), z.null()]),
  })
  .partial();
export const NotificationUpdateEnvelope = z
  .object({ data: NotificationRow, success: z.boolean() })
  .passthrough();
export const OdooSalesAnalyticsData = z
  .object({
    active_days: z.union([z.number().int(), z.null()]),
    avg_order_value: z.union([z.number(), z.null()]),
    end_date: z.union([z.string(), z.null()]),
    period: z.union([z.string(), z.null()]),
    start_date: z.union([z.string(), z.null()]),
    total_orders: z.union([z.number().int(), z.null()]),
    total_revenue: z.union([z.number(), z.null()]),
    unique_customers: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const OdooSalesAnalyticsEnvelope = z
  .object({ data: OdooSalesAnalyticsData, success: z.boolean() })
  .passthrough();
export const BatchUpdateRequest = z.object({
  companies: z.array(z.object({}).partial().passthrough()),
  update_type: z.string(),
});
export const OdooBatchUpdateData = z
  .object({
    total_companies: z.number().int(),
    update_type: z.string(),
    updated_count: z.number().int(),
  })
  .passthrough();
export const OdooBatchUpdateEnvelope = z
  .object({ data: OdooBatchUpdateData, success: z.boolean() })
  .passthrough();
export const OdooSalesCompanyRow = z
  .object({
    address_line1: z.union([z.string(), z.null()]),
    city: z.union([z.string(), z.null()]),
    country: z.union([z.string(), z.null()]),
    email: z.union([z.string(), z.null()]),
    enrichment_attempts: z.union([z.number().int(), z.null()]),
    enrichment_error_reason: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    last_enriched_at: z.union([z.string(), z.null()]),
    last_order_date: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    phone_number: z.union([z.string(), z.null()]),
    postcode: z.union([z.string(), z.null()]),
    sales_orders_count: z.union([z.number().int(), z.null()]),
    stage: z.union([z.string(), z.null()]),
    total_revenue: z.union([z.number(), z.null()]),
    vat_number: z.union([z.string(), z.null()]),
    website: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const OdooSalesCompaniesData = z
  .object({
    companies: z.array(OdooSalesCompanyRow),
    limit: z.number().int(),
    offset: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const OdooSalesCompaniesEnvelope = z
  .object({
    data: OdooSalesCompaniesData,
    meta: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const OdooAddressRow = z
  .object({
    address_id: z.union([z.number().int(), z.string(), z.null()]),
    address_type: z.union([z.string(), z.null()]),
    city: z.union([z.string(), z.null()]),
    country: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    is_default: z.union([z.boolean(), z.null()]),
    state: z.union([z.string(), z.null()]),
    street: z.union([z.string(), z.null()]),
    street2: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
    zip: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const OdooAddressesData = z
  .object({
    addresses: z.array(OdooAddressRow),
    company_id: z.string(),
    total: z.number().int(),
  })
  .passthrough();
export const OdooAddressesEnvelope = z
  .object({ data: OdooAddressesData, success: z.boolean() })
  .passthrough();
export const year = z.union([z.number().int(), z.null()]).optional();
export const OdooBesuchsberichtRow = z
  .object({
    created_at: z.union([z.string(), z.null()]),
    follow_up_date: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    notes: z.union([z.string(), z.null()]),
    outcome: z.union([z.string(), z.null()]),
    salesperson: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
    visit_date: z.union([z.string(), z.null()]),
    visit_type: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const OdooBesuchsberichteData = z
  .object({
    besuchsberichte: z.array(OdooBesuchsberichtRow),
    company_id: z.string(),
    limit: z.number().int(),
    offset: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const OdooBesuchsberichteEnvelope = z
  .object({
    data: OdooBesuchsberichteData,
    meta: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const OdooContactRow = z
  .object({
    contact_id: z.union([z.number().int(), z.string(), z.null()]),
    contact_type: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    email: z.union([z.string(), z.null()]),
    first_name: z.union([z.string(), z.null()]),
    is_primary: z.union([z.boolean(), z.null()]),
    last_name: z.union([z.string(), z.null()]),
    mobile: z.union([z.string(), z.null()]),
    phone: z.union([z.string(), z.null()]),
    role: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const OdooContactsData = z
  .object({
    company_id: z.string(),
    contacts: z.array(OdooContactRow),
    total: z.number().int(),
  })
  .passthrough();
export const OdooContactsEnvelope = z
  .object({ data: OdooContactsData, success: z.boolean() })
  .passthrough();
export const OdooEnrichmentUpdateData = z
  .object({ company_id: z.string(), updated: z.boolean() })
  .passthrough();
export const OdooEnrichmentUpdateEnvelope = z
  .object({ data: OdooEnrichmentUpdateData, success: z.boolean() })
  .passthrough();
export const OdooFinancialRow = z
  .object({
    assets: z.union([z.number(), z.null()]),
    company_id: z.union([z.number().int(), z.string(), z.null()]),
    company_name: z.union([z.string(), z.null()]),
    currency: z.union([z.string(), z.null()]),
    employees: z.union([z.number().int(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    last_updated: z.union([z.string(), z.null()]),
    profit_margin: z.union([z.number(), z.null()]),
    revenue: z.union([z.number(), z.null()]),
    source: z.union([z.string(), z.null()]),
    year: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const OdooFinancialsData = z
  .object({
    company_id: z.string(),
    financials: z.array(OdooFinancialRow),
    total: z.number().int(),
  })
  .passthrough();
export const OdooFinancialsEnvelope = z
  .object({
    data: OdooFinancialsData,
    meta: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const OdooInvoiceRow = z
  .object({
    amount_tax: z.union([z.number(), z.null()]),
    amount_total: z.union([z.number(), z.null()]),
    amount_untaxed: z.union([z.number(), z.null()]),
    currency: z.union([z.string(), z.null()]),
    customer_name: z.union([z.string(), z.null()]),
    due_date: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    invoice_date: z.union([z.string(), z.null()]),
    invoice_number: z.union([z.string(), z.null()]),
    payment_reference: z.union([z.string(), z.null()]),
    state: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const OdooInvoicesData = z
  .object({
    company_id: z.string(),
    invoices: z.array(OdooInvoiceRow),
    limit: z.number().int(),
    offset: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const OdooInvoicesEnvelope = z
  .object({
    data: OdooInvoicesData,
    meta: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const OdooProductRow = z
  .object({
    active: z.union([z.boolean(), z.null()]),
    category: z.union([z.string(), z.null()]),
    currency_id: z.union([z.number().int(), z.string(), z.null()]),
    description: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    list_price: z.union([z.number(), z.null()]),
    product_code: z.union([z.string(), z.null()]),
    product_name: z.union([z.string(), z.null()]),
    standard_price: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const OdooProductsData = z
  .object({
    company_id: z.string(),
    limit: z.number().int(),
    offset: z.number().int(),
    products: z.array(OdooProductRow),
    total: z.number().int(),
  })
  .passthrough();
export const OdooProductsEnvelope = z
  .object({
    data: OdooProductsData,
    meta: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const PipelineConfigUpsertRequest = z.object({
  description: z.union([z.string().max(500), z.null()]).optional(),
  key: z.string().min(1).max(200),
  value: z.string().max(10000),
});
export const PipelineConfigRow = z
  .object({
    created_at: z.union([z.string(), z.null()]).optional(),
    description: z.union([z.string(), z.null()]).optional(),
    id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    key: z.string(),
    updated_at: z.union([z.string(), z.null()]).optional(),
    updated_by: z.union([z.string(), z.null()]).optional(),
    value: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const PipelineConfigUpsertEnvelope = z
  .object({ data: PipelineConfigRow, success: z.boolean() })
  .passthrough();
export const AddLabelRequest = z.object({
  label: z.string(),
  pr_number: z.number().int(),
});
export const POActionResult = z
  .object({
    error: z.union([z.string(), z.null()]).optional(),
    message: z.union([z.string(), z.null()]).optional(),
    result: z.union([z.unknown(), z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const AnswerQuestionRequest = z.object({
  answer: z.string().optional().default(""),
  pr_number: z.number().int(),
  question_id: z.string(),
});
export const ApproveSprintRequest = z.object({ pr_number: z.number().int() });
export const PauseSprintRequest = z.object({
  pr_number: z.number().int(),
  reason: z.string().optional().default(""),
});
export const PostCommentRequest = z.object({
  body: z.string(),
  pr_number: z.number().int(),
});
export const RejectSprintRequest = z.object({
  pr_number: z.number().int(),
  reason: z.string().optional().default(""),
});
export const RemoveLabelRequest = z.object({
  label: z.string(),
  pr_number: z.number().int(),
});
export const RequestChangesRequest = z.object({
  pr_number: z.number().int(),
  reason: z.string().optional().default(""),
});
export const RerunWorkflowRequest = z.object({ run_id: z.string() });
export const ResumeSprintRequest = z.object({ pr_number: z.number().int() });
export const StartPlanningRequest = z.object({
  branch_suffix: z.union([z.string(), z.null()]).optional(),
  dispatch_backend: z.union([z.string(), z.null()]).optional(),
  dispatch_id: z.union([z.string(), z.null()]).optional(),
  force_new_branch: z.boolean().optional().default(false),
  prd_content: z.union([z.string(), z.null()]).optional(),
  reuse_planning: z.boolean().optional().default(false),
  source_sprint_branch: z.union([z.string(), z.null()]).optional(),
  sprint_id: z.string(),
  sprint_name: z.union([z.string(), z.null()]).optional(),
});
export const POStartPlanningEnvelope = z
  .object({
    error: z.union([z.unknown(), z.null()]),
    pr_number: z.union([z.number().int(), z.null()]),
    sprint_id: z.union([z.string(), z.null()]),
    success: z.union([z.boolean(), z.null()]),
  })
  .partial()
  .passthrough();
export const TriggerWorkflowRequest = z.object({
  inputs: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
  ref: z.string().optional().default("main"),
  workflow_id: z.string(),
});
export const POArtifactsData = z
  .object({
    backlog: z.union([z.object({}).partial().passthrough(), z.null()]),
    briefings: z.union([z.array(z.unknown()), z.null()]),
    closeoutReport: z.union([z.string(), z.null()]),
    contract: z.union([z.object({}).partial().passthrough(), z.null()]),
    manifest: z.union([z.object({}).partial().passthrough(), z.null()]),
    prd: z.union([z.string(), z.null()]),
    questions: z.union([z.string(), z.null()]),
    state: z.union([z.object({}).partial().passthrough(), z.null()]),
  })
  .partial()
  .passthrough();
export const POArtifactsEnvelope = z
  .object({
    data: z.union([POArtifactsData, z.null()]).optional(),
    error: z.union([z.string(), z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const POBudgetTotals = z
  .object({
    cost: z.union([z.number().int(), z.number(), z.null()]),
    minutes: z.union([z.number().int(), z.number(), z.null()]),
    points: z.union([z.number().int(), z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const POBudget = z
  .object({
    maxActionsMinutes: z.union([z.number().int(), z.number(), z.null()]),
    maxTokens: z.union([z.number().int(), z.number(), z.null()]),
    tickets: z.union([z.array(z.unknown()), z.null()]),
    totals: z.union([POBudgetTotals, z.null()]),
  })
  .partial()
  .passthrough();
export const POBudgetEnvelope = z
  .object({
    budget: z.union([POBudget, z.null()]).optional(),
    error: z.union([z.string(), z.null()]).optional(),
    message: z.union([z.string(), z.null()]).optional(),
    metadata: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    success: z.boolean(),
    warning: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const POCurrentSprintEnvelope = z
  .object({
    error: z.union([z.string(), z.null()]).optional(),
    metrics: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    pr_number: z.union([z.number().int(), z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const POGithubActivityEnvelope = z
  .object({
    actionsMinutes: z.union([z.number(), z.null()]).optional(),
    actionsStats: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    commits: z.union([z.array(z.unknown()), z.null()]).optional(),
    error: z.union([z.string(), z.null()]).optional(),
    lastUpdated: z.union([z.string(), z.null()]).optional(),
    message: z.union([z.string(), z.null()]).optional(),
    metadata: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    pr: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
    success: z.boolean(),
    warning: z.union([z.string(), z.null()]).optional(),
    workflowRuns: z.union([z.array(z.unknown()), z.null()]).optional(),
  })
  .passthrough();
export const POPrDetailsEnvelope = z
  .object({
    error: z.union([z.string(), z.null()]).optional(),
    message: z.union([z.string(), z.null()]).optional(),
    metadata: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    pr: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
    success: z.boolean(),
    warning: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const POQaEnvelope = z
  .object({
    answered: z.union([z.boolean(), z.null()]).optional(),
    error: z.union([z.string(), z.null()]).optional(),
    issueUrl: z.union([z.string(), z.null()]).optional(),
    message: z.union([z.string(), z.null()]).optional(),
    metadata: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    questions: z.union([z.array(z.unknown()), z.null()]).optional(),
    rawContent: z.union([z.string(), z.null()]).optional(),
    success: z.boolean(),
    warning: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const POWavesEnvelope = z
  .object({
    error: z.union([z.string(), z.null()]).optional(),
    manifestGeneratedAt: z.union([z.string(), z.null()]).optional(),
    sprintId: z.union([z.string(), z.null()]).optional(),
    success: z.boolean(),
    totalBatches: z.union([z.number().int(), z.null()]).optional(),
    waves: z.union([z.object({}).partial().passthrough(), z.null()]).optional(),
  })
  .passthrough();
export const POWorkflowRunsEnvelope = z
  .object({
    error: z.union([z.string(), z.null()]).optional(),
    runs: z.union([z.array(z.unknown()), z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const POSprintListItem = z
  .object({
    actual_tokens_usd: z.union([z.number(), z.null()]),
    completed_tickets: z.union([z.number().int(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    created_by: z.union([z.string(), z.null()]),
    duration_minutes: z.union([z.number(), z.null()]),
    estimated_tokens_usd: z.union([z.number(), z.null()]),
    execution_completed_at: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    labels: z.union([z.array(z.unknown()), z.null()]),
    name: z.union([z.string(), z.null()]),
    phase: z.union([z.string(), z.null()]),
    pr_number: z.union([z.number().int(), z.null()]),
    progress_percent: z.union([z.number().int(), z.null()]),
    status: z.union([z.string(), z.null()]),
    total_tickets: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const POSprintListEnvelope = z
  .object({
    items: z.array(POSprintListItem),
    limit: z.number().int(),
    offset: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const POSprintDetailEnvelope = z
  .object({
    backlog: z.union([z.unknown(), z.null()]),
    completed_tickets: z.union([z.number().int(), z.null()]),
    contract: z.union([z.object({}).partial().passthrough(), z.null()]),
    estimated_minutes: z.union([z.number(), z.null()]),
    estimated_tokens_usd: z.union([z.number(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    metrics: z.union([z.object({}).partial().passthrough(), z.null()]),
    name: z.union([z.string(), z.null()]),
    phase_transitions: z.union([z.unknown(), z.null()]),
    pr_number: z.union([z.number().int(), z.null()]),
    recentWorkflows: z.union([z.array(z.unknown()), z.null()]),
    state: z.union([z.object({}).partial().passthrough(), z.null()]),
    status: z.union([z.string(), z.null()]),
    total_tickets: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const PrequalSessionEventCreateRequest = z.object({
  event_id: z.string().min(1),
  event_type: z.string().min(1),
  metadata: z.object({}).partial().passthrough().optional(),
  timestamp: z.string().min(1),
});
export const Item = z
  .object({ artikel: z.string(), quantity: z.number().gt(0) })
  .passthrough();
export const LaEstimateRequest = z.object({
  destination: z.string().regex(/^(DE|AT)$/),
  items: z.array(Item),
});
export const LaEstimateEnvelope = z
  .object({
    breakdown: z.union([z.unknown(), z.null()]),
    carrier: z.union([z.string(), z.null()]),
    currency: z.union([z.string(), z.null()]),
    destination: z.union([z.string(), z.null()]),
    total: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const ProductRow = z
  .object({
    category: z.union([z.string(), z.null()]),
    family: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ProductListEnvelope = z
  .object({
    data: z.array(ProductRow),
    success: z.boolean(),
    total: z.number().int(),
  })
  .passthrough();
export const ProductCategoryRow = z
  .object({
    id: z.union([z.number().int(), z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ProductCategoryListEnvelope = z
  .object({
    data: z.array(ProductCategoryRow),
    success: z.boolean(),
    total: z.number().int(),
  })
  .passthrough();
export const PseCompanyDetailsRequest = z.object({
  company_name: z.string(),
  country: z.string(),
  fields: z.array(z.string()),
  zip_code: z.string(),
});
export const PseCompanyDetailsResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const PseRawRequest = z.object({
  engine: z.string().optional().default("de"),
  num: z.number().int().gte(1).lte(10).optional().default(10),
  query: z.string(),
});
export const PseRawResponse = z
  .object({
    data: z.object({}).partial().passthrough(),
    metadata: z.object({}).partial().passthrough(),
    success: z.boolean(),
  })
  .passthrough();
export const PseStatusResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const PushNotificationRequest = z.object({
  body: z.string().min(1).max(500),
  tag: z.union([z.string(), z.null()]).optional(),
  title: z.string().min(1).max(200),
  url: z.union([z.string(), z.null()]).optional(),
  user_ids: z.union([z.array(z.string()), z.null()]).optional(),
});
export const PushSendData = z
  .object({
    failed: z.union([z.number().int(), z.null()]).optional(),
    message: z.union([z.string(), z.null()]).optional(),
    sent: z.number().int(),
    total_subscriptions: z.union([z.number().int(), z.null()]).optional(),
  })
  .passthrough();
export const PushSendEnvelope = z
  .object({ data: PushSendData, success: z.boolean() })
  .passthrough();
export const PushSubscription = z.object({
  endpoint: z.string().min(1),
  keys: z.record(z.string()),
});
export const PushSubscribeData = z.object({ subscribed: z.boolean() }).passthrough();
export const PushSubscribeEnvelope = z
  .object({ data: PushSubscribeData, success: z.boolean() })
  .passthrough();
export const PushUnsubscribeData = z
  .object({ unsubscribed: z.boolean() })
  .passthrough();
export const PushUnsubscribeEnvelope = z
  .object({ data: PushUnsubscribeData, success: z.boolean() })
  .passthrough();
export const VapidPublicKeyResponse = z
  .object({
    data: z.object({}).partial().passthrough(),
    success: z.boolean().optional().default(true),
  })
  .passthrough();
export const CompaniesSampleResponse = z
  .object({
    data: z.object({}).partial().passthrough(),
    meta: z.object({}).partial().passthrough(),
    success: z.boolean(),
  })
  .passthrough();
export const CompanyGT = z
  .object({
    address_city: z.union([z.string(), z.null()]).optional(),
    address_street: z.union([z.string(), z.null()]).optional(),
    address_zip: z.union([z.string(), z.null()]).optional(),
    contact_email: z.union([z.string(), z.null()]).optional(),
    contact_phone: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    is_municipality: z.boolean().optional().default(false),
    last_verified_at: z.union([z.string(), z.null()]).optional(),
    legal_name: z.string(),
    register_court: z.union([z.string(), z.null()]).optional(),
    register_type: z.union([z.string(), z.null()]).optional(),
    registration_number: z.union([z.string(), z.null()]).optional(),
    source: z.union([z.string(), z.null()]).optional(),
    vat_id: z.union([z.string(), z.null()]).optional(),
    website: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const EvalItem = z
  .object({ fields: z.object({}).partial().passthrough(), id: z.string() })
  .passthrough();
export const ImprintEvalRequest = z.object({
  fields: z.union([z.array(z.string()), z.null()]).optional(),
  ground_truth: z.array(CompanyGT),
  predictions: z.array(EvalItem),
  strict: z.boolean().optional().default(true),
});
export const ImprintEvalMismatch = z
  .object({
    actual: z.unknown().optional(),
    expected: z.unknown().optional(),
    field: z.string(),
    id: z.union([z.number().int(), z.string()]),
  })
  .passthrough();
export const ImprintEvalData = z
  .object({
    mismatches: z.array(ImprintEvalMismatch),
    overall_accuracy_pct: z.number(),
    per_field_accuracy_pct: z.record(z.number()),
  })
  .passthrough();
export const ImprintEvalMeta = z
  .object({ request_id: z.union([z.string(), z.null()]) })
  .partial()
  .passthrough();
export const ImprintEvalResponse = z
  .object({
    data: ImprintEvalData,
    meta: ImprintEvalMeta,
    success: z.boolean(),
  })
  .passthrough();
export const ImprintInputCompany = z
  .object({
    id: z.string(),
    legal_name: z.string(),
    website: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const ImprintOptions = z
  .object({
    max_concurrency: z.number().int().default(8),
    timeout_sec_per_company: z.number().int().default(45),
  })
  .partial()
  .passthrough();
export const ImprintExtractRequest = z.object({
  companies: z.array(ImprintInputCompany),
  options: z.union([ImprintOptions, z.null()]).optional(),
});
export const ImprintExtractExtractor = z
  .object({
    confidence: z.number(),
    duration_ms: z.number().int(),
    fields: z.object({}).partial().passthrough(),
    method: z.string(),
    source_url: z.string(),
  })
  .passthrough();
export const ImprintExtractInput = z
  .object({
    name: z.union([z.string(), z.null()]),
    website: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ImprintExtractResult = z
  .object({
    error_codes: z.union([z.array(z.string()), z.null()]).optional(),
    errors: z.union([z.array(z.string()), z.null()]).optional(),
    extractor: ImprintExtractExtractor,
    id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    input: ImprintExtractInput,
    request_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const ImprintExtractData = z
  .object({ results: z.array(ImprintExtractResult) })
  .passthrough();
export const ImprintExtractMeta = z
  .object({
    failed: z.number().int(),
    request_id: z.union([z.string(), z.null()]).optional(),
    succeeded: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const ImprintExtractResponse = z
  .object({
    data: ImprintExtractData,
    meta: ImprintExtractMeta,
    success: z.boolean(),
  })
  .passthrough();
export const SchemaCompaniesData = z
  .object({
    columns: z.array(z.string()),
    message: z.union([z.string(), z.null()]).optional(),
    sample_record: z.object({}).partial().passthrough(),
    table_name: z.string(),
    total_columns: z.number().int(),
  })
  .passthrough();
export const SchemaCompaniesMeta = z
  .object({ discovered_at: z.number(), source: z.string() })
  .passthrough();
export const SchemaCompaniesResponse = z
  .object({
    data: SchemaCompaniesData,
    meta: SchemaCompaniesMeta,
    success: z.boolean(),
  })
  .passthrough();
export const ImprintUpsertItem = z
  .object({
    company_id: z.string(),
    confidence: z.number().gte(0).lte(1),
    extracted_data: z.object({}).partial().passthrough(),
    extraction_method: z
      .union([z.string(), z.null()])
      .optional()
      .default("raider-intel"),
    imprint_url: z.string(),
  })
  .passthrough();
export const ImprintUpsertRequest = z.object({
  imprints: z.array(ImprintUpsertItem).min(1).max(100),
});
export const ImprintUpsertResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const MissionQueryFilters = z
  .object({
    cities: z.union([z.array(z.string()), z.null()]),
    countries: z.union([z.array(z.string()), z.null()]),
    date_from: z.union([z.string(), z.null()]),
    date_to: z.union([z.string(), z.null()]),
    enrichment_stage: z.union([z.string(), z.null()]),
    has_email: z.union([z.boolean(), z.null()]),
    has_phone: z.union([z.boolean(), z.null()]),
    has_website: z.union([z.boolean(), z.null()]),
    max_employees: z.union([z.number().int().gte(0), z.null()]),
    max_revenue_eur: z.union([z.number().gte(0), z.null()]),
    max_score: z.union([z.number().gte(0).lte(1), z.null()]),
    min_employees: z.union([z.number().int().gte(0), z.null()]),
    min_revenue_eur: z.union([z.number().gte(0), z.null()]),
    min_score: z.union([z.number().gte(0).lte(1), z.null()]),
    postcode_pattern: z.union([z.string(), z.null()]),
    score_type: z.union([z.string(), z.null()]).default("clanda"),
  })
  .partial()
  .passthrough();
export const MissionQueryPagination = z
  .object({
    limit: z.number().int().gte(1).lte(1000).default(100),
    offset: z.number().int().gte(0).default(0),
  })
  .partial()
  .passthrough();
export const MissionQuerySort = z
  .object({
    field: z.string().default("score"),
    order: z.string().default("desc"),
  })
  .partial()
  .passthrough();
export const MissionQueryRequest = z
  .object({
    filters: MissionQueryFilters,
    pagination: MissionQueryPagination,
    sort: MissionQuerySort,
  })
  .partial();
export const MissionQueryResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const CrawlWebsiteRequest = z.object({ url: z.string().min(1) });
export const RaiderResponse = z
  .object({
    data: z.object({}).partial().passthrough(),
    status: z.number().int(),
    success: z.boolean(),
  })
  .passthrough();
export const ExtractImprintRequest = z
  .object({
    html: z.union([z.string(), z.null()]),
    url: z.union([z.string(), z.null()]),
  })
  .partial();
export const UrParseRequest = z.object({ text: z.string().min(1) });
export const RepPreferencesWeightsUpdate = z
  .object({
    industry_weights: z.record(
      z.enum(["overweight", "underweight", "neutral"])
    ),
    product_weights: z.record(z.enum(["overweight", "underweight", "neutral"])),
  })
  .partial();
export const RepPreferencesWeightsRow = z
  .object({
    industry_weights: z.record(z.string()).default({}),
    product_weights: z.record(z.string()).default({}),
    updated_at: z.union([z.string(), z.null()]),
    updated_by: z.union([z.string(), z.null()]),
    user_email: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const RepPreferencesWeightsEnvelope = z
  .object({ data: RepPreferencesWeightsRow, success: z.boolean() })
  .passthrough();
export const RepPreferencesRow = z
  .object({
    excluded_industries: z.array(z.string()).nullable(),
    excluded_products: z.array(z.string()).nullable(),
    focus_industries: z.array(z.string()).nullable(),
    focus_plz: z.array(z.string()).nullable(),
    focus_products: z.array(z.string()).nullable(),
    global_business_focus: z.object({}).partial().passthrough().nullable(),
    id: z.string().uuid().nullable(),
    industry_weights: z.object({}).partial().passthrough().nullable(),
    joker_max_per_day: z.number().int().nullable(),
    max_jokers_per_day: z.number().int().nullable(),
    notes: z.string().nullable(),
    product_weights: z.object({}).partial().passthrough().nullable(),
    selected_bestandskunden: z.object({}).partial().passthrough().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    updated_by: z.string().nullable(),
    user_email: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const RepPreferencesEnvelope = z
  .object({
    data: z.array(RepPreferencesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const RepPreferencesUpdate = z
  .object({
    focus_industries: z.union([z.array(z.string()), z.null()]),
    focus_plz: z.union([z.array(z.string()), z.null()]),
    focus_products: z.union([z.array(z.string()), z.null()]),
    global_business_focus: z.union([
      z.object({}).partial().passthrough(),
      z.null(),
    ]),
    joker_max_per_day: z.union([z.number().int().gte(0), z.null()]),
    selected_bestandskunden: z.union([
      z.object({}).partial().passthrough(),
      z.null(),
    ]),
  })
  .partial();
export const RoleRow = z
  .object({
    created_at: z.union([z.string(), z.null()]),
    description: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    permissions: z.union([z.array(z.string()), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
    user_count: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const RolesListEnvelope = z
  .object({ data: z.array(RoleRow), success: z.boolean() })
  .passthrough();
export const app__api__v1__roles__RoleCreateRequest = z.object({
  description: z.string().optional().default(""),
  name: z.string().min(1).max(100),
  permissions: z.array(z.string()).optional(),
});
export const RoleMutationEnvelope = z
  .object({ data: RoleRow, success: z.boolean() })
  .passthrough();
export const RoleDeleteEnvelope = z
  .object({ message: z.string(), success: z.boolean() })
  .passthrough();
export const app__api__v1__roles__RoleUpdateRequest = z
  .object({
    description: z.union([z.string(), z.null()]),
    name: z.union([z.string().min(1).max(100), z.null()]),
    permissions: z.union([z.array(z.string()), z.null()]),
  })
  .partial();
export const RouteComputeData = z
  .object({
    mission_id: z.string(),
    reason: z.union([z.string(), z.null()]).optional(),
    route_distance_km: z.union([z.number(), z.null()]).optional(),
    route_duration_min: z.union([z.number(), z.null()]).optional(),
    route_polyline: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const RouteComputeEnvelope = z
  .object({ data: RouteComputeData, success: z.boolean() })
  .passthrough();
export const RouteOptimizeRequest = z
  .object({ traffic_aware: z.boolean().default(false) })
  .partial();
export const RouteOptimizeData = z
  .object({
    mission_id: z.string(),
    optimized: z.boolean(),
    reason: z.union([z.string(), z.null()]).optional(),
    route_distance_km: z.union([z.number(), z.null()]).optional(),
    route_duration_min: z.union([z.number(), z.null()]).optional(),
    route_polyline: z.union([z.string(), z.null()]).optional(),
    traffic_aware: z.union([z.boolean(), z.null()]).optional(),
    warnings: z.union([z.array(z.string()), z.null()]).optional(),
  })
  .passthrough();
export const RouteOptimizeEnvelope = z
  .object({ data: RouteOptimizeData, success: z.boolean() })
  .passthrough();
export const RouteStop = z.object({ lat: z.number(), lng: z.number() }).passthrough();
export const RoutePreviewRequest = z.object({ stops: z.array(RouteStop).min(2) });
export const RoutePreviewData = z
  .object({
    fallback: z.boolean(),
    route_distance_km: z.union([z.number(), z.null()]).optional(),
    route_duration_min: z.union([z.number(), z.null()]).optional(),
    route_polyline: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const RoutePreviewEnvelope = z
  .object({ data: RoutePreviewData, success: z.boolean() })
  .passthrough();
export const ApplyVariantRequest = z.object({ variant: z.string() });
export const RouteApplyVariantData = z
  .object({
    applied_variant: z.string(),
    mission_id: z.string(),
    route_distance_km: z.union([z.number(), z.null()]).optional(),
    route_duration_min: z.union([z.number(), z.null()]).optional(),
    route_polyline: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const RouteApplyVariantEnvelope = z
  .object({ data: RouteApplyVariantData, success: z.boolean() })
  .passthrough();
export const RouteVariantRow = z
  .object({
    distance_km: z.union([z.number(), z.null()]),
    duration_min: z.union([z.number(), z.null()]),
    polyline: z.union([z.string(), z.null()]),
    stop_order: z.union([z.array(z.number().int()), z.null()]),
    variant: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const RouteVariantsData = z
  .object({ mission_id: z.string(), variants: z.array(RouteVariantRow) })
  .passthrough();
export const RouteVariantsEnvelope = z
  .object({ data: RouteVariantsData, success: z.boolean() })
  .passthrough();
export const ScanOrderRow = z
  .object({
    confidence_overall: z.union([z.number(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    customer_external_id: z.union([z.string(), z.null()]),
    customer_name: z.union([z.string(), z.null()]),
    extracted_data: z.union([z.unknown(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    rep_user_id: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    visit_report_id: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ScanOrdersListMeta = z
  .object({
    limit: z.union([z.number().int(), z.null()]),
    offset: z.union([z.number().int(), z.null()]),
    source: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    view: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ScanOrdersListEnvelope = z
  .object({
    data: z.array(ScanOrderRow),
    meta: ScanOrdersListMeta,
    total: z.number().int(),
  })
  .passthrough();
export const Body_upload_scan_v1_scan_orders_post = z
  .object({
    file: z.string(),
    visit_report_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const ScanOrderResultEnvelope = z
  .object({
    confidence_overall: z.union([z.number().int(), z.number()]),
    extracted_data: z.object({}).partial().passthrough(),
    rejection_reason: z.union([z.string(), z.null()]).optional(),
    scan_id: z.string(),
    status: z.string(),
  })
  .passthrough();
export const ScanOrderExtractRequest = z.object({
  filename: z.string().optional().default("scan.jpg"),
  image: z.string(),
  mime_type: z.string().optional().default("image/jpeg"),
  visit_report_id: z.union([z.string(), z.null()]).optional(),
});
export const ResolveContextData = z
  .object({
    company_external_id: z.union([z.string(), z.null()]).optional(),
    company_name: z.union([z.string(), z.null()]).optional(),
    contact_external_id: z.union([z.string(), z.null()]).optional(),
    mission_id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    reason: z.union([z.string(), z.null()]).optional(),
    rep_name: z.union([z.string(), z.null()]).optional(),
    rep_odoo_user_id: z.union([z.number().int(), z.null()]).optional(),
    rep_user_id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    resolved: z.boolean(),
    source: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const ResolveContextEnvelope = z
  .object({ data: ResolveContextData })
  .passthrough();
export const BestellerContact = z.object({ email: z.string(), name: z.string() });
export const ResolveOrCreateBillingRequest = z.object({
  besteller: z.union([BestellerContact, z.null()]).optional(),
  firma: z.string(),
  land: z.string().optional().default("DE"),
  ort: z.string(),
  plz: z.string(),
  strasse: z.string(),
});
export const ResolveOrCreateBillingResponse = z.object({
  created: z.boolean(),
  customer_ref: z.string(),
});
export const ScanOrderDetailMeta = z
  .object({
    source: z.union([z.string(), z.null()]),
    view: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ScanOrderDetailEnvelope = z
  .object({ data: ScanOrderRow, meta: ScanOrderDetailMeta })
  .passthrough();
export const Besteller = z.object({
  email: z.string(),
  funktion: z.union([z.string(), z.null()]).optional(),
  name: z.string(),
  telefon: z.union([z.string(), z.null()]).optional(),
});
export const CommsDoc = z.enum([
  "ab",
  "ls",
  "sdb",
  "rechnung",
  "mahnung",
  "allgemein",
]);
export const CommsRecipient = z.object({
  docs: z.array(CommsDoc).min(1),
  email: z.string(),
});
export const CommsRouting = z.object({ recipients: z.array(CommsRecipient).min(1) });
export const ContractPartner = z.object({
  customer_external_id: z.string().optional().default(""),
  firma: z.string(),
  ort: z.string(),
  plz: z.string(),
  strasse: z.string(),
});
export const DeliveryAddress = z
  .object({
    firma: z.union([z.string(), z.null()]),
    ort: z.union([z.string(), z.null()]),
    plz: z.union([z.string(), z.null()]),
    same_as_billing: z.boolean().default(false),
    strasse: z.union([z.string(), z.null()]),
  })
  .partial();
export const OrderPosition = z.object({
  anzahl: z.number(),
  einheit: z.string(),
  einzelpreis: z.number(),
  gebindegroesse: z.union([z.number(), z.null()]).optional(),
  name: z.union([z.string(), z.null()]).optional(),
  product_external_id: z.number().int(),
});
export const OrderTerms = z
  .object({
    datum: z.union([z.string(), z.null()]),
    kunden_auftrags_nr: z.union([z.string(), z.null()]),
    liefertermin: z.union([z.string(), z.null()]),
    verkaeufer: z.union([z.string(), z.null()]),
    zahlungsbedingungen: z.union([z.string(), z.null()]),
  })
  .partial();
export const ScanOrderConfirmRequest = z.object({
  besteller: Besteller,
  comms_routing: CommsRouting,
  contract_partner: ContractPartner,
  delivery: DeliveryAddress,
  marketing_consent: z.boolean().optional().default(false),
  note: z.union([z.string(), z.null()]).optional(),
  positionen: z.array(OrderPosition).min(1),
  rep_odoo_user_id: z.union([z.number().int(), z.null()]).optional(),
  terms: z.union([OrderTerms, z.null()]).optional(),
  visit_report_id: z.union([z.string(), z.null()]).optional(),
});
export const EmailVerificationNotice = z
  .object({
    email: z.string(),
    field: z.string(),
    reason: z.string(),
    state: z.string(),
  })
  .passthrough();
export const ScanOrderConfirmEnvelope = z
  .object({
    corrections: z.number().int(),
    email_verification: z
      .union([z.array(EmailVerificationNotice), z.null()])
      .optional(),
    freigabe: z.union([z.string(), z.null()]).optional(),
    odoo_order_id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    odoo_order_name: z.union([z.string(), z.null()]).optional(),
    scan_id: z.string(),
    status: z.string(),
  })
  .passthrough();
export const ScanOrderRejectRequest = z
  .object({ reason: z.union([z.string(), z.null()]) })
  .partial();
export const ScanOrderRejectEnvelope = z
  .object({ scan_id: z.string(), status: z.string() })
  .passthrough();
export const ScanReviewEnvelope = z
  .object({ data: ScanOrderRow, meta: ScanOrderDetailMeta })
  .passthrough();
export const ScanReviewLinkData = z
  .object({
    expires_at: z.union([z.string(), z.null()]).optional(),
    token: z.string(),
    url: z.string(),
  })
  .passthrough();
export const ScanReviewLinkEnvelope = z
  .object({ data: ScanReviewLinkData, success: z.boolean() })
  .passthrough();
export const RequestedScope = z.enum([
  "mcp_tool",
  "workright",
  "skill_ack",
  "flight_right",
  "other",
]);
export const ScopeRequestUrgency = z.enum(["blocking", "soon", "whenever"]);
export const ScopeRequestRequest = z.object({
  reason: z.string().min(3).max(2000),
  related_doc_ids: z.union([z.array(z.string().uuid()), z.null()]).optional(),
  requested_scope: RequestedScope,
  target: z.string().min(1).max(200),
  urgency: ScopeRequestUrgency.optional(),
});
export const ScopeRequestResponse = z
  .object({
    created_at: z.string(),
    signal_id: z.string().uuid(),
    target_personas: z.array(z.string()),
  })
  .passthrough();
export const ScopeRequestErrorCode = z.enum([
  "UNAUTHORIZED",
  "IDENTITY_UNRESOLVED",
  "RATE_LIMIT_EXCEEDED",
  "VERIFY_MISMATCH",
  "SIGNAL_INSERT_FAILED",
]);
export const ScopeRequestErrorDetailV1 = z
  .object({
    code: ScopeRequestErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const ScopeRequestErrorEnvelopeV1 = z
  .object({ error: ScopeRequestErrorDetailV1 })
  .passthrough();
export const ActivityRow = z
  .object({
    auftraege: z.number().int().optional().default(0),
    besuche: z.number().int().optional().default(0),
    demos: z.number().int().optional().default(0),
    gebinde10l: z.number().int().optional().default(0),
    gebinde25l: z.number().int().optional().default(0),
    gebinde60l: z.number().int().optional().default(0),
    nettoumsatzEurCents: z.number().int().optional().default(0),
    period: z.string(),
    periodLabel: z.string(),
    periodType: z.string().regex(/^(day|week|month|year)$/),
  })
  .passthrough();
export const ActivityTotals = z
  .object({
    auftraege: z.number().int().default(0),
    besuche: z.number().int().default(0),
    demos: z.number().int().default(0),
    gebinde10l: z.number().int().default(0),
    gebinde25l: z.number().int().default(0),
    gebinde60l: z.number().int().default(0),
    nettoumsatzEurCents: z.number().int().default(0),
  })
  .partial()
  .passthrough();
export const ActivityTableResponse = z
  .object({
    exportUrls: z.record(z.string()).optional(),
    filters: z.object({}).partial().passthrough().optional(),
    rows: z.array(ActivityRow),
    totals: ActivityTotals,
  })
  .passthrough();
export const HeatmapBreakdown = z
  .object({
    bestandskunden: z.number().int().default(0),
    neukunden: z.number().int().default(0),
  })
  .partial()
  .passthrough();
export const HeatmapRegion = z
  .object({
    breakdown: z.union([HeatmapBreakdown, z.null()]).optional(),
    intensity: z.number().optional().default(0),
    label: z.string(),
    plz2: z.string(),
    value: z.number().int().optional().default(0),
  })
  .passthrough();
export const HeatmapScale = z
  .object({
    max: z.number().int().default(0),
    min: z.number().int().default(0),
    unit: z.string().default("count"),
  })
  .partial()
  .passthrough();
export const HeatmapResponse = z
  .object({
    filters: z.object({}).partial().passthrough().optional(),
    metric: z.string(),
    period: z.string(),
    regions: z.array(HeatmapRegion),
    scale: HeatmapScale,
  })
  .passthrough();
export const PeriodInfo = z
  .object({
    elapsedDays: z.number().int().optional().default(0),
    end: z.string(),
    start: z.string(),
    totalDays: z.number().int().optional().default(0),
    type: z.string().regex(/^(day|week|month|year)$/),
  })
  .passthrough();
export const KpiTile = z
  .object({
    forecast: z.number().int().optional().default(0),
    gapToGo: z.number().int().optional().default(0),
    ist: z.number().int().optional().default(0),
    kpi: z.string(),
    label: z.string(),
    soll: z.number().int().optional().default(0),
    status: z.string().regex(/^(on_track|behind)$/),
    unit: z.string().regex(/^(count|eur_cents)$/),
  })
  .passthrough();
export const KpisResponse = z
  .object({ period: PeriodInfo, tiles: z.array(KpiTile) })
  .passthrough();
export const AnnualTargets = z
  .object({
    auftraege: z.union([z.number().int(), z.null()]),
    besuche: z.union([z.number().int(), z.null()]),
    demos: z.union([z.number().int(), z.null()]),
    nettoumsatzEurCents: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const SeasonBlock = z
  .object({
    besuchePerMonth: z.union([z.number().int(), z.null()]),
    months: z.array(z.string()),
  })
  .partial()
  .passthrough();
export const DerivedTargets = z
  .object({
    dailyBesuche: z.union([z.number().int(), z.null()]),
    seasonBlocks: z.union([z.record(SeasonBlock), z.null()]),
    weeklyBesuche: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const MonthlyOverride = z
  .object({
    besuche: z.union([z.number().int(), z.null()]),
    reason: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const TargetsResponse = z
  .object({
    annual: AnnualTargets,
    derived: DerivedTargets.optional(),
    monthlyOverrides: z.record(MonthlyOverride).optional(),
    repId: z.string(),
    year: z.number().int(),
  })
  .passthrough();
export const PutTargetsBody = z.object({
  annual: z.union([z.record(z.number().int()), z.null()]).optional(),
  monthlyOverrides: z
    .union([z.record(z.object({}).partial().passthrough()), z.null()])
    .optional(),
  repId: z.string(),
  year: z.number().int(),
});
export const TopBrancheRow = z
  .object({
    auftraege: z.number().int().optional().default(0),
    branche: z.string(),
    gebindeMenge: z.number().int().optional().default(0),
    nettoumsatzEurCents: z.number().int().optional().default(0),
  })
  .passthrough();
export const TopBranchenResponse = z
  .object({
    availablePeriods: z.array(z.string()).optional(),
    branchen: z.array(TopBrancheRow),
  })
  .passthrough();
export const TopProduktRow = z
  .object({
    absatzMenge: z.number().int().optional().default(0),
    kundenAnzahl: z.number().int().optional().default(0),
    nettoumsatzEurCents: z.number().int().optional().default(0),
    produktName: z.string(),
  })
  .passthrough();
export const TopProdukteResponse = z
  .object({ produkte: z.array(TopProduktRow) })
  .passthrough();
export const ScoutActivityEvent = z.object({
  event: z.string().min(1).max(200),
  payload: z.object({}).partial().passthrough().optional(),
  route: z.union([z.string().max(500), z.null()]).optional(),
  session_id: z.union([z.string().max(100), z.null()]).optional(),
});
export const DemoRateBlock = z
  .object({
    besuche: z.number().int().default(0),
    demos: z.number().int().default(0),
    target: z.union([z.number(), z.null()]),
    teamAverage: z.union([z.number(), z.null()]),
    value: z.number().default(0),
  })
  .partial()
  .passthrough();
export const RepeatVisitFlag = z
  .object({
    firma: z.string(),
    hasDemoOrConversion: z.boolean().optional().default(false),
    lastVisit: z.string().optional().default(""),
    leadId: z.string(),
    visitCount: z.number().int().optional().default(0),
  })
  .passthrough();
export const SystemVsManualDelta = z
  .object({
    deltaPercent: z.number().default(0),
    manualConversionRate: z.number().default(0),
    systemConversionRate: z.number().default(0),
    systemFollowRate: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const TerritorySaturationItem = z
  .object({
    lastActivityDate: z.union([z.string(), z.null()]).optional(),
    plz2: z.string(),
    saturationPercent: z.number().optional().default(0),
    totalLeads: z.number().int().optional().default(0),
    visitedLeads: z.number().int().optional().default(0),
  })
  .passthrough();
export const VisitDepthScore = z
  .object({
    averageVisitsBeforeConversion: z.number().default(0),
    flag: z.union([z.string(), z.null()]),
    teamAverage: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const RepDiagnosticsResponse = z
  .object({
    demoRate: DemoRateBlock,
    period: z.string(),
    repId: z.string(),
    repName: z.string(),
    repeatVisitFlags: z.array(RepeatVisitFlag).optional(),
    systemVsManualDelta: SystemVsManualDelta,
    territorySaturation: z.array(TerritorySaturationItem).optional(),
    visitDepthScore: VisitDepthScore,
  })
  .passthrough();
export const TeamRepSummary = z
  .object({
    demoRate: z.number().optional().default(0),
    repId: z.string(),
    repName: z.string(),
    repeatVisitFlags: z.number().int().optional().default(0),
    saturationAvg: z.number().optional().default(0),
    systemDelta: z.number().optional().default(0),
  })
  .passthrough();
export const TeamAverages = z
  .object({
    demoRate: z.number().default(0),
    systemDelta: z.number().default(0),
    visitDepth: z.number().default(0),
  })
  .partial()
  .passthrough();
export const TeamDiagnosticsResponse = z
  .object({
    period: z.string(),
    reps: z.array(TeamRepSummary),
    teamAverages: TeamAverages,
    teamId: z.string(),
  })
  .passthrough();
export const UseCaseProduct = z
  .object({
    dosierung: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    name: z.string(),
  })
  .passthrough();
export const UseCaseItem = z
  .object({
    betroffeneObjekte: z.array(z.string()).optional(),
    confidence: z.number().int().gte(0).lte(100),
    crossSellProdukt: z.union([UseCaseProduct, z.null()]).optional(),
    demoTip: z.union([z.string(), z.null()]).optional(),
    gpDriver: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    name: z.string(),
    primaerprodukt: z.union([UseCaseProduct, z.null()]).optional(),
    problemformulierung: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const LeadUseCasesResponse = z
  .object({
    leadId: z.string(),
    matchingSignals: z.array(z.string()).optional(),
    topUseCases: z.array(UseCaseItem),
    totalUseCases: z.number().int().optional().default(0),
  })
  .passthrough();
export const MissionTargets = z
  .object({
    auftraege: z.number().int().default(0),
    besuche: z.number().int().default(0),
    demos: z.number().int().default(0),
    umsatzEurCents: z.number().int().default(0),
  })
  .partial()
  .passthrough();
export const MissionConfigBlock = z
  .object({
    maxDailyKm: z.union([z.number().int(), z.null()]),
    maxLeadsPerMission: z.union([z.number().int(), z.null()]),
    maxRouteKm: z.union([z.number().int(), z.null()]),
    minLeadsPerMission: z.union([z.number().int(), z.null()]),
    missionsPerDay: z.union([z.number().int(), z.null()]),
    targets: z.union([MissionTargets, z.null()]),
    updatedAt: z.union([z.string(), z.null()]),
    updatedBy: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const MissionConfigResponse = z
  .object({
    effective: MissionConfigBlock,
    global: MissionConfigBlock,
    repOverride: z.union([MissionConfigBlock, z.null()]).optional(),
  })
  .passthrough();
export const MissionConfigPatchBody = z.object({
  repId: z.union([z.string(), z.null()]).optional(),
  scope: z.string().regex(/^(global|rep)$/),
  updates: z.object({}).partial().passthrough().optional(),
});
export const DayStateUpsertRequest = z.object({
  dayDate: z.string(),
  finishedAt: z
    .union([z.string().datetime({ offset: true }), z.null()])
    .optional(),
  homeReturnAt: z
    .union([z.string().datetime({ offset: true }), z.null()])
    .optional(),
  startedAt: z
    .union([z.string().datetime({ offset: true }), z.null()])
    .optional(),
});
export const DayStateResponse = z
  .object({
    createdAt: z.union([z.string(), z.null()]).optional(),
    dayDate: z.string(),
    dayStateId: z.string(),
    finishedAt: z.union([z.string(), z.null()]).optional(),
    homeReturnAt: z.union([z.string(), z.null()]).optional(),
    missionId: z.string(),
    startedAt: z.union([z.string(), z.null()]).optional(),
    userEmail: z.string(),
    warning: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const NextLeadSuggestionRequest = z.object({
  completedLeadIds: z.array(z.string()).optional(),
  currentLat: z.number(),
  currentLng: z.number(),
  missionId: z.string(),
  remainingDailyKmBudget: z.number().gte(0),
  repId: z.string(),
  timestamp: z.string(),
});
export const AlternativeLead = z
  .object({
    distanceKm: z.union([z.number(), z.null()]).optional(),
    firma: z.string(),
    id: z.string(),
    score: z.union([z.number(), z.null()]).optional(),
  })
  .passthrough();
export const KmWarning = z
  .object({
    level: z.string().regex(/^(warning|critical)$/),
    message: z.string(),
    remainingKm: z.number(),
  })
  .passthrough();
export const ScoreBreakdown = z
  .object({
    expectedMargin: z.number(),
    proximity: z.number(),
    recency: z.number(),
  })
  .passthrough();
export const SuggestedLead = z
  .object({
    ansprechpartner: z.union([z.string(), z.null()]).optional(),
    distanceKm: z.union([z.number(), z.null()]).optional(),
    estimatedDriveMinutes: z.union([z.number().int(), z.null()]).optional(),
    expectedMargin: z.union([z.number().int(), z.null()]).optional(),
    firma: z.string(),
    googleMapsUrl: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    lat: z.union([z.number(), z.null()]).optional(),
    lng: z.union([z.number(), z.null()]).optional(),
    ort: z.union([z.string(), z.null()]).optional(),
    plz: z.union([z.string(), z.null()]).optional(),
    score: z.union([z.number(), z.null()]).optional(),
    scoreBreakdown: z.union([ScoreBreakdown, z.null()]).optional(),
    strasse: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const NextLeadSuggestionResponse = z
  .object({
    alternatives: z.array(AlternativeLead).optional(),
    dailyKmBudget: z.number().optional().default(0),
    dailyKmUsed: z.number().optional().default(0),
    kmWarning: z.union([KmWarning, z.null()]).optional(),
    suggestedLead: SuggestedLead,
  })
  .passthrough();
export const ScoutCallQueueRow = z
  .object({ id: z.string(), priority: z.number().int() })
  .passthrough();
export const ScoutCompanyRow = z.object({ id: z.string() }).passthrough();
export const ScoutOutcomeRow = z.object({}).partial().passthrough();
export const ScoutScriptRow = z.object({}).partial().passthrough();
export const ScoutPrequalStats = z.object({}).partial().passthrough();
export const PrequalContextData = z
  .object({
    call_queue: z.array(ScoutCallQueueRow),
    companies: z.array(ScoutCompanyRow),
    outcomes: z.array(ScoutOutcomeRow),
    scripts: z.array(ScoutScriptRow),
    stats: z.union([ScoutPrequalStats, z.null()]).optional(),
  })
  .passthrough();
export const PrequalContextResponse = z
  .object({ data: PrequalContextData })
  .passthrough();
export const GreyZoneItem = z
  .object({
    approvalMode: z.string().regex(/^(auto_approved|requires_approval)$/),
    assignedAt: z.string(),
    assignedBy: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    plzPrefix: z.string(),
  })
  .passthrough();
export const GreyZonesResponse = z
  .object({ zones: z.array(GreyZoneItem) })
  .passthrough();
export const GreyZoneUpdateBody = z.object({
  approvalMode: z.string().regex(/^(auto_approved|requires_approval)$/),
});
export const ScoutLeadRow = z
  .object({
    accepted_at: z.union([z.string().datetime({ offset: true }), z.null()]),
    anchor_source: z.union([z.string(), z.null()]),
    briefing_generated_at: z.union([
      z.string().datetime({ offset: true }),
      z.null(),
    ]),
    company_name: z.union([z.string(), z.null()]),
    created_at: z.union([z.string().datetime({ offset: true }), z.null()]),
    discovered_company_id: z.union([z.string(), z.null()]),
    expected_arrival_at: z.union([
      z.string().datetime({ offset: true }),
      z.null(),
    ]),
    id: z.union([z.string(), z.null()]),
    is_anchor: z.union([z.boolean(), z.null()]),
    joker_reason: z.union([z.string(), z.null()]),
    joker_source: z.union([z.string(), z.null()]),
    lead_briefing: z.union([z.unknown(), z.null()]),
    lead_id: z.union([z.string(), z.null()]),
    lifecycle_node: z.union([z.string(), z.null()]),
    mission_id: z.union([z.string(), z.null()]),
    order_index: z.union([z.number().int(), z.null()]),
    pinned: z.union([z.boolean(), z.null()]),
    planned_time: z.union([z.string(), z.null()]),
    preferred_time: z.union([z.string(), z.null()]),
    rejection_date: z.union([z.string().datetime({ offset: true }), z.null()]),
    rejection_detail: z.union([z.string(), z.null()]),
    rejection_reason: z.union([z.string(), z.null()]),
    snooze_until: z.union([z.string(), z.null()]),
    state: z.union([z.string(), z.null()]),
    state_reason: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    stop_lifecycle_node: z.union([z.string(), z.null()]),
    stop_origin: z.union([z.enum(["planned", "joker"]), z.null()]),
    stop_type: z.union([z.string(), z.null()]),
    suggested_demo_use_case: z.union([z.string(), z.null()]),
    unified_lead_id: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string().datetime({ offset: true }), z.null()]),
    visited_at: z.union([z.string().datetime({ offset: true }), z.null()]),
    visited_by: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ScoutMissionRow = z
  .object({
    approval_status: z.union([z.string(), z.null()]),
    approved_at: z.union([z.string().datetime({ offset: true }), z.null()]),
    approved_by: z.union([z.string(), z.null()]),
    archived: z.union([z.boolean(), z.null()]),
    assigned_date: z.union([z.string(), z.null()]),
    assigned_day: z.union([z.string(), z.null()]),
    created_at: z.union([z.string().datetime({ offset: true }), z.null()]),
    date: z.union([z.string(), z.null()]),
    description: z.union([z.string(), z.null()]),
    generated_by: z.union([z.string(), z.null()]),
    id: z.union([z.string(), z.null()]),
    is_out_of_territory: z.union([z.boolean(), z.null()]),
    lifecycle_node: z.union([z.string(), z.null()]),
    mission_type: z.union([z.string(), z.null()]),
    notes: z.union([z.string(), z.null()]),
    owner_email: z.union([z.string(), z.null()]),
    rating_decision_maker: z.union([z.boolean(), z.null()]),
    rating_demo_performed: z.union([z.boolean(), z.null()]),
    rating_won_amount_eur: z.union([z.number(), z.null()]),
    region: z.union([z.string(), z.null()]),
    region_id: z.union([z.string(), z.null()]),
    requires_approval: z.union([z.boolean(), z.null()]),
    route_distance_km: z.union([z.number(), z.null()]),
    route_duration_min: z.union([z.number().int(), z.null()]),
    route_polyline: z.union([z.string(), z.null()]),
    route_provider: z.union([z.string(), z.null()]),
    route_variants: z.union([z.unknown(), z.null()]),
    route_version: z.union([z.string(), z.null()]),
    slot_index: z.union([z.number().int(), z.null()]),
    source: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    suggestion_id: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string().datetime({ offset: true }), z.null()]),
    user_id: z.union([z.string(), z.null()]),
    utility_breakdown: z.union([z.unknown(), z.null()]),
    utility_score: z.union([z.number(), z.null()]),
    week_start: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ScoutRepPreferences = z.object({}).partial().passthrough();
export const ScoutRepTargets = z.object({}).partial().passthrough();
export const TagesplanungContextData = z
  .object({
    home_address: z.string().optional().default(""),
    leads: z.array(ScoutLeadRow),
    missions: z.array(ScoutMissionRow),
    rep_preferences: z.union([ScoutRepPreferences, z.null()]).optional(),
    rep_targets: z.union([ScoutRepTargets, z.null()]).optional(),
  })
  .passthrough();
export const TagesplanungContextResponse = z
  .object({ data: TagesplanungContextData })
  .passthrough();
export const ScoutAppointmentRow = z.object({}).partial().passthrough();
export const ScoutRegionRow = z.object({}).partial().passthrough();
export const ScoutRepSettings = z.object({}).partial().passthrough();
export const WochenplanungContextData = z
  .object({
    appointments: z.array(ScoutAppointmentRow),
    leads: z.array(ScoutLeadRow),
    missions: z.array(ScoutMissionRow),
    regions: z.array(ScoutRegionRow),
    rep_settings: z.union([ScoutRepSettings, z.null()]).optional(),
  })
  .passthrough();
export const WochenplanungContextResponse = z
  .object({ data: WochenplanungContextData })
  .passthrough();
export const ZoneApprovalListItem = z
  .object({
    approvalId: z.union([z.string(), z.null()]),
    createdAt: z.union([z.string(), z.null()]),
    missionId: z.union([z.string(), z.null()]),
    plzPrefix: z.union([z.string(), z.null()]),
    reason: z.union([z.string(), z.null()]),
    repId: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ZoneApprovalRequest = z.object({
  missionId: z.string(),
  plzPrefix: z.string(),
  reason: z.union([z.string(), z.null()]).optional(),
  repId: z.string(),
});
export const ZoneApprovalResponse = z
  .object({
    approvalId: z.string(),
    createdAt: z.string(),
    status: z.string().regex(/^(pending|approved|rejected)$/),
  })
  .passthrough();
export const ZoneApprovalPatchBody = z.object({
  note: z.union([z.string(), z.null()]).optional(),
  status: z.string().regex(/^(approved|rejected)$/),
});
export const SearchData = z
  .object({
    contacts: z.array(z.unknown()),
    leads: z.array(z.unknown()),
    total_contacts: z.number().int(),
    total_leads: z.number().int(),
  })
  .passthrough();
export const SearchEnvelope = z
  .object({ data: SearchData, query: z.string(), success: z.boolean() })
  .passthrough();
export const SessionChatIdentity = z
  .object({
    embodiment_id: z.string(),
    model: z.string(),
    persona: z.string(),
    seal_envelope_id: z.union([z.string(), z.null()]).optional(),
    tool_use_id: z.union([z.string(), z.null()]).optional(),
    vendor: z.string(),
  })
  .passthrough();
export const SessionChatRole = z.enum(["user", "assistant", "system", "tool"]);
export const SessionChatMessageRow = z
  .object({
    content: z.string(),
    created_at: z.string(),
    delivered_to_agent: z.boolean(),
    id: z.string(),
    identity: SessionChatIdentity,
    metadata: z.object({}).partial().passthrough().optional(),
    role: SessionChatRole,
    session_id: z.string(),
    tool_name: z.union([z.string(), z.null()]).optional(),
    tool_use_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SessionChatListResponse = z
  .object({
    data: z.array(SessionChatMessageRow),
    next_cursor: z.union([z.string(), z.null()]).optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const SessionChatErrorCode = z.enum([
  "UNAUTHORIZED",
  "AUTHORITY_DENIED",
  "ATC_UNAVAILABLE",
  "EMBODIMENT_NOT_FOUND",
  "EMBODIMENT_LOOKUP_FAILED",
  "EMBODIMENT_CLOSED",
  "SESSION_CHAT_SEND_FAILED",
  "SESSION_CHAT_SEND_WRITE_VERIFICATION_FAILED",
  "SESSION_CHAT_CURSOR_LOOKUP_FAILED",
  "SESSION_CHAT_LIST_FAILED",
]);
export const SessionChatErrorDetailV1 = z
  .object({
    code: SessionChatErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SessionChatErrorEnvelopeV1 = z
  .object({ error: SessionChatErrorDetailV1 })
  .passthrough();
export const SessionChatSendRequest = z.object({
  content: z.string().min(1),
  metadata: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
});
export const SessionChatSendResponse = z
  .object({
    created_at: z.string(),
    delivered_to_agent: z.boolean(),
    message_id: z.string(),
    session_id: z.string(),
  })
  .passthrough();
export const SettingsEnvelope = z
  .object({
    data: z.record(z.object({}).partial().passthrough()),
    success: z.boolean(),
  })
  .passthrough();
export const SettingsUpdateRequest = z
  .object({
    configuration: z.union([z.object({}).partial().passthrough(), z.null()]),
    feature_toggles: z.union([z.object({}).partial().passthrough(), z.null()]),
  })
  .partial();
export const SettingsUpdateEnvelope = z
  .object({
    message: z.string(),
    success: z.boolean(),
    updated_keys: z.array(z.string()),
  })
  .passthrough();
export const ObjectionRow = z
  .object({ id: z.union([z.number().int(), z.string()]) })
  .passthrough();
export const ObjectionListResponse = z
  .object({ count: z.number().int(), objections: z.array(ObjectionRow) })
  .passthrough();
export const ScriptRow = z
  .object({ id: z.union([z.number().int(), z.string()]) })
  .passthrough();
export const ScriptListResponse = z
  .object({ count: z.number().int(), sections: z.array(ScriptRow) })
  .passthrough();
export const TemplateListSummary = z
  .object({
    full: z.number().int(),
    partial: z.number().int(),
    thin: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const TemplateCompleteness = z
  .object({ max: z.number().int(), score: z.number().int(), tier: z.string() })
  .passthrough();
export const TemplateRow = z
  .object({
    completeness: TemplateCompleteness,
    id: z.union([z.number().int(), z.string()]),
  })
  .passthrough();
export const TemplateListResponse = z
  .object({ summary: TemplateListSummary, templates: z.array(TemplateRow) })
  .passthrough();
export const SprintResponse = z
  .object({
    completed_tickets: z.number().int().optional().default(0),
    created_at: z.string().datetime({ offset: true }),
    created_by: z.union([z.string(), z.null()]).optional(),
    estimated_cost: z.number().optional().default(0),
    estimated_hours: z.number().int().optional().default(0),
    estimated_points: z.number().int().optional().default(0),
    failed_tickets: z.number().int().optional().default(0),
    has_backlog: z.boolean().optional().default(false),
    has_contract: z.boolean().optional().default(false),
    has_state: z.boolean().optional().default(false),
    id: z.string(),
    in_progress_tickets: z.number().int().optional().default(0),
    intent_doc_path: z.union([z.string(), z.null()]).optional(),
    intent_doc_sha: z.union([z.string(), z.null()]).optional(),
    labels: z.union([z.array(z.string()), z.null()]).optional(),
    name: z.string(),
    phase: z.string(),
    pr_number: z.union([z.number().int(), z.null()]).optional(),
    prd_content: z.string(),
    prd_hash: z.union([z.string(), z.null()]).optional(),
    sprint_branch: z.union([z.string(), z.null()]).optional(),
    status: z.string(),
    total_tickets: z.number().int().optional().default(0),
    updated_at: z.string().datetime({ offset: true }),
  })
  .passthrough();
export const SprintListResponse = z
  .object({
    items: z.array(SprintResponse),
    limit: z.number().int(),
    offset: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const SprintCreateRequest = z
  .object({
    created_by: z.union([z.string(), z.null()]).optional(),
    id: z.union([z.string().regex(/^SP-\d{3,}$/), z.null()]).optional(),
    intent_doc_path: z.union([z.string(), z.null()]).optional(),
    intent_doc_sha: z.union([z.string(), z.null()]).optional(),
    labels: z.union([z.array(z.string()), z.null()]).optional(),
    name: z.string().min(1),
    phase: z.string().optional().default("planning"),
    pr_number: z.union([z.number().int().gte(1), z.null()]).optional(),
    prd_content: z.string().min(1),
    prd_hash: z.union([z.string(), z.null()]).optional(),
    sprint_branch: z.union([z.string(), z.null()]).optional(),
    status: z
      .string()
      .regex(
        /^(planning|qa_pending|approved|executing|qa_final|completed|cancelled|failed)$/
      )
      .optional()
      .default("planning"),
  })
  .passthrough();
export const SuccessResponse = z
  .object({
    message: z.union([z.string(), z.null()]),
    success: z.boolean().default(true),
  })
  .partial()
  .passthrough();
export const SprintUpdateRequest = z
  .object({
    completed_tickets: z.union([z.number().int().gte(0), z.null()]),
    created_by: z.union([z.string(), z.null()]),
    estimated_cost: z.union([z.number().gte(0), z.null()]),
    estimated_hours: z.union([z.number().int().gte(0), z.null()]),
    estimated_points: z.union([z.number().int().gte(0), z.null()]),
    expected_updated_at: z.union([z.string(), z.null()]),
    failed_tickets: z.union([z.number().int().gte(0), z.null()]),
    has_backlog: z.union([z.boolean(), z.null()]),
    has_contract: z.union([z.boolean(), z.null()]),
    has_state: z.union([z.boolean(), z.null()]),
    in_progress_tickets: z.union([z.number().int().gte(0), z.null()]),
    intent_doc_path: z.union([z.string(), z.null()]),
    intent_doc_sha: z.union([z.string(), z.null()]),
    labels: z.union([z.array(z.string()), z.null()]),
    name: z.union([z.string().min(1), z.null()]),
    phase: z.union([z.string(), z.null()]),
    pr_number: z.union([z.number().int().gte(1), z.null()]),
    prd_content: z.union([z.string().min(1), z.null()]),
    prd_hash: z.union([z.string(), z.null()]),
    sprint_branch: z.union([z.string(), z.null()]),
    status: z.union([
      z
        .string()
        .regex(
          /^(planning|qa_pending|approved|executing|qa_final|completed|cancelled|failed)$/
        ),
      z.null(),
    ]),
    total_tickets: z.union([z.number().int().gte(0), z.null()]),
  })
  .partial();
export const SprintArtifactResponse = z
  .object({
    artifact_content: z.string(),
    artifact_name: z.string(),
    artifact_type: z.string(),
    artifact_url: z.union([z.string(), z.null()]).optional(),
    created_at: z.string().datetime({ offset: true }),
    id: z.string(),
    sprint_id: z.string(),
  })
  .passthrough();
export const SprintArtifactListResponse = z
  .object({
    artifacts: z.array(SprintArtifactResponse),
    total: z.number().int(),
  })
  .passthrough();
export const SprintArtifactCreateRequest = z.object({
  artifact_type: z
    .string()
    .regex(
      /^(prd|contract|backlog|qa|briefing|context_brief|flightplan|session|workspace_snapshot)$/
    ),
  content: z.string(),
  metadata: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
});
export const SprintEventResponse = z
  .object({
    created_at: z.string().datetime({ offset: true }),
    created_by: z.union([z.string(), z.null()]).optional(),
    event_data: z.object({}).partial().passthrough(),
    event_type: z.string(),
    id: z.string(),
    sprint_id: z.string(),
  })
  .passthrough();
export const SprintEventListResponse = z
  .object({ events: z.array(SprintEventResponse), total: z.number().int() })
  .passthrough();
export const SprintEventCreateRequest = z.object({
  event_data: z.object({}).partial().passthrough(),
  event_type: z.string(),
});
export const WorkflowRunResponse = z
  .object({
    completed_at: z
      .union([z.string().datetime({ offset: true }), z.null()])
      .optional(),
    conclusion: z.union([z.string(), z.null()]).optional(),
    created_at: z.string().datetime({ offset: true }),
    github_run_id: z.number().int(),
    head_branch: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    name: z.string(),
    sprint_id: z.string(),
    started_at: z
      .union([z.string().datetime({ offset: true }), z.null()])
      .optional(),
    status: z.string(),
    updated_at: z.string().datetime({ offset: true }),
    url: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const WorkflowRunListResponse = z
  .object({ runs: z.array(WorkflowRunResponse), total: z.number().int() })
  .passthrough();
export const CreateRunRequest = z.object({
  cohort_params: z.object({}).partial().passthrough(),
  notes: z.union([z.string(), z.null()]).optional(),
});
export const CreateRunResponse = z
  .object({
    run_id: z.string(),
    status: z.string().optional().default("running"),
  })
  .passthrough();
export const CompleteRunRequest = z.object({
  finished_at: z.union([z.string(), z.null()]).optional(),
  gs_manifest_uri: z.union([z.string(), z.null()]).optional(),
  kpis_json: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
  status: z.string(),
});
export const StagingCompleteEnvelope = z
  .object({ run_id: z.string(), status: z.string() })
  .passthrough();
export const AppendErrorRequest = z.object({
  company_id: z.union([z.string(), z.null()]).optional(),
  debug_ctx_json: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
  error_code: z.string(),
  error_message: z.union([z.string(), z.null()]).optional(),
  stage: z.string(),
});
export const StagingAckEnvelope = z.object({ success: z.boolean() }).passthrough();
export const AppendResultRequest = z.object({
  company_id: z.string(),
  confidence: z.union([z.number().gte(0).lte(1), z.null()]).optional(),
  duration_ms: z.number().int(),
  error_code: z.union([z.string(), z.null()]).optional(),
  fields_json: z.object({}).partial().passthrough(),
  impressum_url: z.union([z.string(), z.null()]).optional(),
  method: z.string(),
  source_domain: z.union([z.string(), z.null()]).optional(),
  status: z.string(),
});
export const StagingMetaTablesEnvelope = z
  .object({ tables: z.array(z.union([z.string(), z.null()])) })
  .passthrough();
export const StagingTableColumn = z
  .object({
    column_name: z.union([z.string(), z.null()]),
    data_type: z.union([z.string(), z.null()]),
    is_nullable: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const StagingTableConstraint = z
  .object({
    column_name: z.union([z.string(), z.null()]),
    constraint_type: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const StagingMetaTableEnvelope = z
  .object({
    columns: z.array(StagingTableColumn),
    constraints: z.array(StagingTableConstraint),
    table: z.string(),
  })
  .passthrough();
export const SupabaseCompanyWithSalesOrdersRow = z
  .object({
    address_line1: z.union([z.string(), z.null()]),
    city: z.union([z.string(), z.null()]),
    country: z.union([z.string(), z.null()]),
    email: z.union([z.string(), z.null()]),
    enrichment_attempts: z.union([z.number().int(), z.null()]),
    enrichment_error_reason: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    last_enriched_at: z.union([z.string(), z.null()]),
    last_order_date: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    phone_number: z.union([z.string(), z.null()]),
    postcode: z.union([z.string(), z.null()]),
    sales_orders_count: z.union([z.number().int(), z.null()]),
    stage: z.union([z.string(), z.null()]),
    total_revenue: z.union([z.number(), z.null()]),
    website: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const SupabaseCompaniesWithSalesOrdersData = z
  .object({
    companies: z.array(SupabaseCompanyWithSalesOrdersRow),
    total: z.number().int(),
  })
  .passthrough();
export const SupabaseCompaniesWithSalesOrdersEnvelope = z
  .object({ data: SupabaseCompaniesWithSalesOrdersData, success: z.boolean() })
  .passthrough();
export const SupabaseQueryRequest = z.object({
  limit: z.union([z.number().int(), z.null()]).optional(),
  offset: z.union([z.number().int(), z.null()]).optional(),
  params: z.union([z.array(z.unknown()), z.null()]).optional(),
  query: z.string(),
});
export const SupabaseQueryRow = z.object({}).partial().passthrough();
export const SupabaseQueryEnvelope = z
  .object({
    data: z.array(SupabaseQueryRow),
    query_id: z.string(),
    success: z.boolean(),
    total: z.number().int(),
  })
  .passthrough();
export const SupabaseSchemaData = z
  .object({
    access_mode: z.string(),
    actor: z.union([z.string(), z.null()]).optional(),
    allowed_tables: z.array(z.string()),
    forbidden_keywords: z.array(z.string()),
    table_schemas: z.object({}).partial().passthrough(),
    unrestricted_access: z.boolean(),
  })
  .passthrough();
export const SupabaseSchemaEnvelope = z
  .object({ data: SupabaseSchemaData, success: z.boolean() })
  .passthrough();
export const SupplierDocumentEnvelope = z
  .object({ success: z.boolean() })
  .passthrough();
export const TaskRow = z
  .object({
    assigned_at: z.union([z.string(), z.null()]).optional(),
    assigned_call_sign: z.union([z.string(), z.null()]).optional(),
    assigned_embodiment_id: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    finished_at: z.union([z.string(), z.null()]).optional(),
    id: z.string(),
    kind: z.string(),
    manifest_ref: z.union([z.string(), z.null()]).optional(),
    metadata: z.object({}).partial().passthrough(),
    payload: z.object({}).partial().passthrough(),
    priority: z.number().int(),
    started_at: z.union([z.string(), z.null()]).optional(),
    status: z.enum([
      "queued",
      "assigned",
      "in_progress",
      "review",
      "done",
      "rejected",
    ]),
    target_call_sign: z.union([z.string(), z.null()]).optional(),
    target_persona: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const TasksEnvelope = z
  .object({ data: z.array(TaskRow), total: z.number().int() })
  .passthrough();
export const TeamMember = z
  .object({
    color: z.union([z.string(), z.null()]).optional(),
    email: z.string(),
    id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    initials: z.union([z.string(), z.null()]).optional(),
    is_active: z.boolean(),
    name: z.string(),
    phone: z.union([z.string(), z.null()]).optional(),
    plz_areas: z.array(z.string()),
    role: z.string(),
    team_id: z.string(),
    team_name: z.string(),
  })
  .passthrough();
export const TeamMembersListEnvelope = z
  .object({ data: z.array(TeamMember), success: z.boolean() })
  .passthrough();
export const TeamRow = z
  .object({
    created_at: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const TeamsListEnvelope = z
  .object({ data: z.array(TeamRow), success: z.boolean() })
  .passthrough();
export const TeamMemberEnvelope = z
  .object({ data: TeamMember, success: z.boolean() })
  .passthrough();
export const TenantBranding = z
  .object({
    logo_url: z.union([z.string(), z.null()]),
    primary_color: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const TenantData = z
  .object({
    branding: TenantBranding,
    defaults: z.object({}).partial().passthrough(),
    domain: z.string(),
    features: z.object({}).partial().passthrough(),
    locale: z.object({}).partial().passthrough(),
    name: z.string(),
    tenant_id: z.string(),
  })
  .passthrough();
export const TenantResolveEnvelope = z
  .object({ data: TenantData, success: z.boolean() })
  .passthrough();
export const TimeEntryRow = z
  .object({
    approved_by: z.union([z.string(), z.null()]),
    billable: z.union([z.boolean(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    description: z.union([z.string(), z.null()]),
    duration_seconds: z.union([z.number().int(), z.null()]),
    ended_at: z.union([z.string(), z.null()]),
    entry_type: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    session_id: z.union([z.string(), z.null()]),
    session_type: z.union([z.string(), z.null()]),
    started_at: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
    worker_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const TimeEntryListEnvelope = z
  .object({ data: z.array(TimeEntryRow), success: z.boolean() })
  .passthrough();
export const TimeEntryCreate = z.object({
  billable: z.boolean().optional().default(true),
  description: z.union([z.string(), z.null()]).optional(),
  ended_at: z.union([z.string(), z.null()]).optional(),
  entry_type: z.string().regex(/^(session|manual)$/),
  session_id: z.union([z.string(), z.null()]).optional(),
  session_type: z.union([z.string(), z.null()]).optional(),
  started_at: z.string(),
});
export const TimeEntryEnvelope = z
  .object({ data: TimeEntryRow, success: z.boolean() })
  .passthrough();
export const TimeEntryUpdate = z
  .object({
    description: z.union([z.string(), z.null()]),
    ended_at: z.union([z.string(), z.null()]),
    status: z.union([
      z.string().regex(/^(tracking|submitted|approved|rejected)$/),
      z.null(),
    ]),
  })
  .partial();
export const TimesheetRow = z
  .object({
    created_at: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    period_end: z.union([z.string(), z.null()]),
    period_start: z.union([z.string(), z.null()]),
    status: z.union([z.string(), z.null()]),
    total_billable_seconds: z.union([z.number().int(), z.null()]),
    total_entries: z.union([z.number().int(), z.null()]),
    total_seconds: z.union([z.number().int(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
    worker_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const TimesheetListEnvelope = z
  .object({ data: z.array(TimesheetRow), success: z.boolean() })
  .passthrough();
export const TimesheetSubmit = z.object({
  period_end: z.string(),
  period_start: z.string(),
  worker_id: z.string(),
});
export const TimesheetEnvelope = z
  .object({ data: TimesheetRow, success: z.boolean() })
  .passthrough();
export const since = z
  .union([z.string().datetime({ offset: true }), z.null()])
  .optional();
export const TriggerFireRow = z
  .object({
    fired_at: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    payload: z.union([z.object({}).partial().passthrough(), z.null()]),
    responded: z.union([z.boolean(), z.null()]),
    responded_at: z.union([z.string(), z.null()]),
    trigger_id: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const TriggerFiresListEnvelope = z
  .object({
    data: z.array(TriggerFireRow),
    meta: z.object({}).partial().passthrough(),
    total: z.number().int(),
  })
  .passthrough();
export const TriggerRespondEnvelope = z
  .object({ responded_at: z.string() })
  .passthrough();
export const TriggerRow = z
  .object({
    active: z.union([z.boolean(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    escalation_policy: z.union([
      z.object({}).partial().passthrough(),
      z.null(),
    ]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    notes: z.union([z.string(), z.null()]),
    owner: z.union([z.string(), z.null()]),
    payload_metadata: z.union([z.object({}).partial().passthrough(), z.null()]),
    payload_text: z.union([z.string(), z.null()]),
    target_kind: z.union([z.string(), z.null()]),
    target_value: z.union([z.string(), z.null()]),
    trigger_config: z.union([z.object({}).partial().passthrough(), z.null()]),
    trigger_type: z.union([z.string(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const TriggerListEnvelope = z
  .object({
    data: z.array(TriggerRow),
    meta: z.object({}).partial().passthrough(),
    total: z.number().int(),
  })
  .passthrough();
export const TriggerCreateRequest = z.object({
  escalation_policy: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
  name: z.string().min(1),
  notes: z.union([z.string(), z.null()]).optional(),
  owner: z.union([z.string(), z.null()]).optional(),
  payload_metadata: z
    .union([z.object({}).partial().passthrough(), z.null()])
    .optional(),
  payload_text: z.string().min(1),
  target_kind: z.string().min(1),
  target_value: z.string().min(1),
  trigger_config: z.object({}).partial().passthrough().optional(),
  trigger_type: z.string().min(1),
});
export const TriggerDispatchResult = z
  .object({
    result: z.object({}).partial().passthrough(),
    trigger_name: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const TriggerDispatchEnvelope = z
  .object({
    data: z.array(TriggerDispatchResult),
    meta: z.object({}).partial().passthrough(),
    total: z.number().int(),
  })
  .passthrough();
export const TriggerPatchRequest = z
  .object({
    active: z.union([z.boolean(), z.null()]),
    escalation_policy: z.union([
      z.object({}).partial().passthrough(),
      z.null(),
    ]),
    notes: z.union([z.string(), z.null()]),
    owner: z.union([z.string(), z.null()]),
    payload_metadata: z.union([z.object({}).partial().passthrough(), z.null()]),
    payload_text: z.union([z.string(), z.null()]),
    target_kind: z.union([z.string(), z.null()]),
    target_value: z.union([z.string(), z.null()]),
    trigger_config: z.union([z.object({}).partial().passthrough(), z.null()]),
    trigger_type: z.union([z.string(), z.null()]),
  })
  .partial();
export const TriggerFireRequest = z
  .object({
    override_payload: z.union([z.object({}).partial().passthrough(), z.null()]),
  })
  .partial();
export const TriggerFireResultEnvelope = z.object({}).partial().passthrough();
export const TwinControlRestartRequest = z.object({ session_id: z.string().min(1) });
export const TwinStatus = z.enum([
  "created",
  "provisioning",
  "active",
  "closing",
  "closed",
]);
export const TwinControlRow = z
  .object({
    branch: z.string(),
    id: z.string(),
    model: z.string(),
    operator_id: z.string(),
    persona: z.string(),
    repo: z.string(),
    status: TwinStatus,
  })
  .passthrough();
export const TwinControlErrorCode = z.enum([
  "FORBIDDEN",
  "ATC_UNAVAILABLE",
  "SESSION_NOT_FOUND",
  "TWIN_CONTROL_WRITE_FAILED",
  "VERIFY_AFTER_WRITE_MISMATCH",
  "TWIN_CONTROL_CONFLICT",
]);
export const TwinControlError = z
  .object({ code: TwinControlErrorCode, message: z.string() })
  .passthrough();
export const TwinControlEnvelope = z
  .object({
    data: z.union([TwinControlRow, z.null()]).optional(),
    error: z.union([TwinControlError, z.null()]).optional(),
    ok: z.boolean(),
  })
  .passthrough();
export const TwinControlResumeRequest = z.object({ session_id: z.string().min(1) });
export const TwinControlStartRequest = z.object({
  branch: z.string().min(1),
  model: z.union([z.string().min(1), z.null()]).optional(),
  operator_id: z.string().min(1),
  persona: z.string().min(1),
  repo: z.string().min(1),
});
export const TwinControlStopRequest = z.object({ session_id: z.string().min(1) });
export const min_score = z
  .union([z.number().int().gte(0).lte(100), z.null()])
  .optional()
  .default(55);
export const min_gp_eur = z
  .union([z.number().gte(0), z.null()])
  .optional()
  .default(1000);
export const min_employees = z
  .union([z.number().int().gte(0), z.null()])
  .optional()
  .default(10);
export const max_employees = z.union([z.number().int().gte(0), z.null()]).optional();
export const UnifiedLeadRow = z
  .object({
    adresse: z.union([z.string(), z.null()]).optional(),
    coordinates: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    employees: z.union([z.number().int(), z.null()]).optional(),
    expected_gp_eur: z.union([z.number(), z.null()]).optional(),
    firma: z.string(),
    id: z.string(),
    ort: z.union([z.string(), z.null()]).optional(),
    plz: z.union([z.string(), z.null()]).optional(),
    produkte: z.union([z.array(z.string()), z.null()]).optional(),
    score: z.union([z.number().int().gte(0).lte(100), z.null()]).optional(),
    score_breakdown: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    source_system: z.union([z.string(), z.null()]).optional(),
    status: z.union([z.string(), z.null()]).optional(),
    telefon: z.union([z.string(), z.null()]).optional(),
    temperature: z.union([z.string(), z.null()]).optional(),
    website: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const UnifiedLeadsData = z
  .object({
    leads: z.array(UnifiedLeadRow),
    limit: z.number().int(),
    offset: z.number().int(),
    total: z.number().int(),
  })
  .passthrough();
export const UnifiedLeadsEnvelope = z
  .object({ data: UnifiedLeadsData, success: z.boolean() })
  .passthrough();
export const UnifiedLeadsQueryRequest = z
  .object({
    city_in: z.union([z.string(), z.null()]),
    filters: z.union([z.object({}).partial().passthrough(), z.null()]),
    has_gp_data: z.union([z.boolean(), z.null()]),
    limit: z.number().int().gte(1).lte(1000).default(100),
    max_employees: z.union([z.number().int().gte(0), z.null()]),
    min_employees: z.union([z.number().int().gte(0), z.null()]).default(10),
    min_gp_eur: z.union([z.number().gte(0), z.null()]).default(1000),
    min_score: z
      .union([z.number().int().gte(0).lte(100), z.null()])
      .default(55),
    offset: z.number().int().gte(0).default(0),
    plz_prefix: z.union([z.string(), z.null()]),
    product_exact: z.union([z.string(), z.null()]),
    product_family: z.union([z.string(), z.null()]),
    sort_field: z.string().default("score"),
    sort_order: z.string().default("desc"),
    source: z.union([z.string(), z.null()]),
  })
  .partial();
export const UserRow = z
  .object({
    created_at: z.union([z.string(), z.null()]),
    email: z.union([z.string(), z.null()]),
    full_name: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    initials: z.union([z.string(), z.null()]),
    is_active: z.union([z.boolean(), z.null()]),
    last_sign_in_at: z.union([z.string(), z.null()]),
    role: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const UsersListEnvelope = z
  .object({
    count: z.number().int(),
    data: z.array(UserRow),
    success: z.boolean(),
  })
  .passthrough();
export const UserCreateRequest = z.object({
  allowed_countries: z.union([z.array(z.string()), z.null()]).optional(),
  color: z.union([z.string().regex(/^#[0-9A-Fa-f]{6}$/), z.null()]).optional(),
  company_email: z.union([z.string(), z.null()]).optional(),
  company_name: z.union([z.string(), z.null()]).optional(),
  company_phone: z.union([z.string(), z.null()]).optional(),
  department: z.union([z.string(), z.null()]).optional(),
  email: z.string().min(1),
  employee_number: z.union([z.string(), z.null()]).optional(),
  employment_type: z
    .string()
    .regex(/^(employed|self_employed|contractor)$/)
    .optional()
    .default("employed"),
  external_domain: z.union([z.string(), z.null()]).optional(),
  full_name: z.union([z.string(), z.null()]).optional(),
  hire_date: z.union([z.string(), z.null()]).optional(),
  home_address: z.union([z.string(), z.null()]).optional(),
  home_address_line1: z.union([z.string(), z.null()]).optional(),
  home_address_line2: z.union([z.string(), z.null()]).optional(),
  home_city: z.union([z.string(), z.null()]).optional(),
  home_country: z
    .union([z.string().regex(/^[A-Z]{2}$/), z.null()])
    .optional()
    .default("DE"),
  home_lat: z.union([z.number(), z.null()]).optional(),
  home_lng: z.union([z.number(), z.null()]).optional(),
  home_postcode: z.union([z.string(), z.null()]).optional(),
  home_region: z.union([z.string(), z.null()]).optional(),
  initials: z.union([z.string().min(1).max(2), z.null()]).optional(),
  is_active: z.boolean().optional().default(true),
  is_internal: z.boolean().optional().default(true),
  manager_id: z.union([z.string(), z.null()]).optional(),
  odoo_user_id: z.union([z.string(), z.null()]).optional(),
  personal_email: z.union([z.string(), z.null()]).optional(),
  personal_phone: z.union([z.string(), z.null()]).optional(),
  phone: z.union([z.string(), z.null()]).optional(),
  plz_areas: z.union([z.array(z.string()), z.null()]).optional(),
  position: z.union([z.string(), z.null()]).optional(),
  preferred_language: z
    .string()
    .regex(/^(de|en)$/)
    .optional()
    .default("de"),
  preferred_theme: z
    .string()
    .regex(/^(dark|light|system)$/)
    .optional()
    .default("dark"),
  role: z
    .string()
    .regex(/^(superadmin|sales_manager|field_sales|handelsvertreter)$/)
    .optional()
    .default("field_sales"),
  tax_id: z.union([z.string(), z.null()]).optional(),
  vat_id: z.union([z.string(), z.null()]).optional(),
});
export const UserMutationEnvelope = z
  .object({ data: UserRow, success: z.boolean() })
  .passthrough();
export const UserSelfUpdateRequest = z
  .object({
    color: z.union([z.string().regex(/^#[0-9A-Fa-f]{6}$/), z.null()]),
    home_address: z.union([z.string(), z.null()]),
    home_address_line1: z.union([z.string(), z.null()]),
    home_address_line2: z.union([z.string(), z.null()]),
    home_city: z.union([z.string(), z.null()]),
    home_country: z.union([z.string().regex(/^[A-Z]{2}$/), z.null()]),
    home_lat: z.union([z.number(), z.null()]),
    home_lng: z.union([z.number(), z.null()]),
    home_postcode: z.union([z.string(), z.null()]),
    home_region: z.union([z.string(), z.null()]),
    initials: z.union([z.string().min(1).max(2), z.null()]),
    personal_email: z.union([z.string(), z.null()]),
    personal_phone: z.union([z.string(), z.null()]),
    preferred_language: z.union([z.string().regex(/^(de|en)$/), z.null()]),
    preferred_theme: z.union([
      z.string().regex(/^(dark|light|system)$/),
      z.null(),
    ]),
  })
  .partial();
export const UserSelfUpdateEnvelope = z
  .object({
    data: z.union([UserRow, z.null()]).optional(),
    message: z.union([z.string(), z.null()]).optional(),
    success: z.boolean(),
  })
  .passthrough();
export const GitHubPatStatusEnvelope = z
  .object({
    expired: z.boolean(),
    expires_at: z.union([z.string(), z.null()]).optional(),
    has_pat: z.boolean(),
    mask: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const GitHubPatPostBody = z.object({ pat: z.string() });
export const GithubResolveThreadEnvelope = z
  .object({ resolved: z.boolean() })
  .passthrough();
export const GithubRerunEnvelope = z
  .object({
    message: z.union([z.string(), z.null()]),
    rerun: z.union([z.boolean(), z.null()]),
  })
  .partial()
  .passthrough();
export const GithubClosePullEnvelope = z.object({ state: z.string() }).passthrough();
export const app__api__v1__users_github_mutations__CommentBody = z.object({
  body: z.string().min(1),
});
export const GithubCommentEnvelope = z
  .object({
    body: z.union([z.string(), z.null()]),
    created_at: z.union([z.string(), z.null()]),
    html_url: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.null()]),
    updated_at: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const EditPullBody = z
  .object({
    body: z.union([z.string().max(65536), z.null()]),
    draft: z.union([z.boolean(), z.null()]),
    title: z.union([z.string().min(1).max(300), z.null()]),
  })
  .partial();
export const GithubPullObjectEnvelope = z
  .object({
    body: z.union([z.string(), z.null()]),
    draft: z.union([z.boolean(), z.null()]),
    html_url: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.null()]),
    number: z.union([z.number().int(), z.null()]),
    state: z.union([z.string(), z.null()]),
    title: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const MergeBody = z
  .object({
    bypass: z.union([z.boolean(), z.null()]),
    commit_message: z.union([z.string(), z.null()]),
    sha: z.union([z.string(), z.null()]),
  })
  .partial();
export const GithubMergePullEnvelope = z
  .object({ merged: z.boolean(), sha: z.string() })
  .passthrough();
export const ReviewBody = z.object({
  body: z.union([z.string(), z.null()]).optional(),
  event: z.enum(["APPROVE", "REQUEST_CHANGES", "COMMENT"]),
});
export const GithubReviewEnvelope = z
  .object({
    body: z.union([z.string(), z.null()]),
    commit_id: z.union([z.string(), z.null()]),
    html_url: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.null()]),
    state: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const DismissBody = z.object({ message: z.string().min(1) });
export const GithubDismissReviewEnvelope = z
  .object({
    id: z.union([z.number().int(), z.string(), z.null()]).optional(),
    state: z.string(),
  })
  .passthrough();
export const GithubUpdateBranchEnvelope = z
  .object({
    message: z.union([z.string(), z.null()]),
    url: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const UsersSyncSummary = z
  .object({
    created: z.number().int(),
    errors: z.number().int(),
    skipped: z.number().int(),
    total: z.number().int(),
    updated: z.number().int(),
  })
  .passthrough();
export const UsersSyncEnvelope = z
  .object({
    code: z.union([z.string(), z.null()]).optional(),
    errors: z.array(z.object({}).partial().passthrough()),
    note: z.string(),
    skipped: z.array(z.string()),
    success: z.boolean(),
    summary: UsersSyncSummary,
    synced: z.array(z.object({}).partial().passthrough()),
  })
  .passthrough();
export const PlzAreasUpdateRequest = z.object({
  plz_areas: z.array(z.string()).max(500),
});
export const UserPlzAreasRow = z
  .object({
    email: z.union([z.string(), z.null()]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    plz_areas: z.union([z.array(z.string()), z.null()]),
  })
  .partial()
  .passthrough();
export const UserPlzAreasEnvelope = z
  .object({ data: UserPlzAreasRow, success: z.boolean() })
  .passthrough();
export const UserUpdateRequest = z
  .object({
    allowed_countries: z.union([z.array(z.string()), z.null()]),
    color: z.union([z.string().regex(/^#[0-9A-Fa-f]{6}$/), z.null()]),
    company_email: z.union([z.string(), z.null()]),
    company_name: z.union([z.string(), z.null()]),
    company_phone: z.union([z.string(), z.null()]),
    department: z.union([z.string(), z.null()]),
    employee_number: z.union([z.string(), z.null()]),
    employment_type: z.union([
      z.string().regex(/^(employed|self_employed|contractor)$/),
      z.null(),
    ]),
    external_domain: z.union([z.string(), z.null()]),
    full_name: z.union([z.string(), z.null()]),
    hire_date: z.union([z.string(), z.null()]),
    home_address: z.union([z.string(), z.null()]),
    home_address_line1: z.union([z.string(), z.null()]),
    home_address_line2: z.union([z.string(), z.null()]),
    home_city: z.union([z.string(), z.null()]),
    home_country: z.union([z.string().regex(/^[A-Z]{2}$/), z.null()]),
    home_lat: z.union([z.number(), z.null()]),
    home_lng: z.union([z.number(), z.null()]),
    home_postcode: z.union([z.string(), z.null()]),
    home_region: z.union([z.string(), z.null()]),
    initials: z.union([z.string().min(1).max(2), z.null()]),
    is_active: z.union([z.boolean(), z.null()]),
    is_internal: z.union([z.boolean(), z.null()]),
    manager_id: z.union([z.string(), z.null()]),
    odoo_user_id: z.union([z.string(), z.null()]),
    personal_email: z.union([z.string(), z.null()]),
    personal_phone: z.union([z.string(), z.null()]),
    phone: z.union([z.string(), z.null()]),
    plz_areas: z.union([z.array(z.string()), z.null()]),
    position: z.union([z.string(), z.null()]),
    preferred_language: z.union([z.string().regex(/^(de|en)$/), z.null()]),
    preferred_theme: z.union([
      z.string().regex(/^(dark|light|system)$/),
      z.null(),
    ]),
    role: z.union([
      z
        .string()
        .regex(/^(superadmin|sales_manager|field_sales|handelsvertreter)$/),
      z.null(),
    ]),
    tax_id: z.union([z.string(), z.null()]),
    termination_date: z.union([z.string(), z.null()]),
    vat_id: z.union([z.string(), z.null()]),
  })
  .partial();
export const AppAccessItem_Output = z
  .object({ app_id: z.string(), enabled: z.boolean() })
  .passthrough();
export const AppAccessListEnvelope = z
  .object({ data: z.array(AppAccessItem_Output), success: z.boolean() })
  .passthrough();
export const AppAccessItem_Input = z
  .object({ app_id: z.string(), enabled: z.boolean().optional().default(true) })
  .passthrough();
export const AppAccessUpdateRequest = z.object({ apps: z.array(AppAccessItem_Input) });
export const app__api__v1__users_models__MessageEnvelope = z
  .object({ message: z.string(), success: z.boolean() })
  .passthrough();
export const FeatureAccessItem_Output = z
  .object({ enabled: z.boolean(), feature_id: z.string() })
  .passthrough();
export const FeatureAccessEnvelope = z
  .object({
    data: z.record(z.array(FeatureAccessItem_Output)),
    success: z.boolean(),
  })
  .passthrough();
export const FeatureAccessItem_Input = z
  .object({
    enabled: z.boolean().optional().default(true),
    feature_id: z.string(),
  })
  .passthrough();
export const FeatureAccessUpdateRequest = z.object({
  features: z.record(z.array(FeatureAccessItem_Input)),
});
export const HomeAddressData = z
  .object({
    home_address: z.union([z.string(), z.null()]),
    home_lat: z.union([z.number(), z.null()]),
    home_lng: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const HomeAddressEnvelope = z
  .object({ data: HomeAddressData, success: z.boolean() })
  .passthrough();
export const JokerQuotaData = z
  .object({
    max_per_day: z.number().int(),
    remaining: z.number().int(),
    used_today: z.number().int(),
  })
  .passthrough();
export const JokerQuotaEnvelope = z
  .object({ data: JokerQuotaData, success: z.boolean() })
  .passthrough();
export const PLZZoneResponse = z
  .object({
    assigned_at: z.string(),
    assigned_by: z.union([z.string(), z.null()]).optional(),
    created_at: z.string(),
    id: z.string(),
    plz_prefix: z.string(),
    reason: z.union([z.string(), z.null()]).optional(),
    updated_at: z.string(),
    user_id: z.string(),
    zone_type: z.string(),
  })
  .passthrough();
export const UserPLZZonesResponse = z
  .object({
    green_zones: z.array(z.string()).optional(),
    grey_zones: z.array(z.string()).optional(),
    user_id: z.string(),
    zones: z.array(PLZZoneResponse).optional(),
  })
  .passthrough();
export const PLZZoneAssignmentRequest = z.object({
  plz_prefix: z.string().min(1).max(10),
  reason: z.union([z.string().max(500), z.null()]).optional(),
  zone_type: z.string().regex(/^(green|grey)$/),
});
export const PLZZoneRemovedEnvelope = z
  .object({ message: z.string(), success: z.boolean() })
  .passthrough();
export const Ops247ActiveLoopRow = z
  .object({
    call_sign: z.string().nullable(),
    ci_status: z.string().nullable(),
    continuation_policy: z.string().nullable(),
    embodiment_bound: z.boolean().nullable(),
    embodiment_id: z.string().uuid().nullable(),
    embodiment_last_heartbeat_at: z
      .string()
      .datetime({ offset: true })
      .nullable(),
    embodiment_machine: z.string().nullable(),
    embodiment_started_at: z.string().datetime({ offset: true }).nullable(),
    embodiment_status: z.string().nullable(),
    entity_type: z.string().nullable(),
    last_session_at: z.string().datetime({ offset: true }).nullable(),
    lifecycle_node: z.string().nullable(),
    manifest_entry_id: z.string().uuid().nullable(),
    me_call_sign: z.string().nullable(),
    me_closed_at: z.string().datetime({ offset: true }).nullable(),
    me_last_activity_at: z.string().datetime({ offset: true }).nullable(),
    me_persona: z.string().nullable(),
    me_status: z.string().nullable(),
    mo_created_at: z.string().datetime({ offset: true }).nullable(),
    mo_doc_id: z.string().uuid().nullable(),
    mo_doc_status: z.string().nullable(),
    mo_doc_title: z.string().nullable(),
    mo_doc_type: z.string().nullable(),
    mo_id: z.string(),
    mo_title: z.string(),
    persona: z.string().nullable(),
    pinned_at: z.string().datetime({ offset: true }).nullable(),
    pr_number: z.number().int().nullable(),
    pr_url: z.string().nullable(),
    priority: z.string(),
    repo: z.string().nullable(),
    source_doc_id: z.string().uuid().nullable(),
  })
  .passthrough();
export const Ops247ActiveLoopEnvelope = z
  .object({
    data: z.array(Ops247ActiveLoopRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ViewProxyErrorCode = z.enum([
  "VIEW_NOT_FOUND",
  "FORBIDDEN",
  "MISSING_NAMESPACE",
  "INVALID_NAMESPACE",
  "INVALID_FILTER",
  "INVALID_FILTER_VALUE",
  "FORBIDDEN_KEY_PREFIX",
  "UNAUTHORIZED",
  "SESSION_EXPIRED",
  "VIEW_QUERY_FAILED",
  "CIRCUIT_OPEN",
  "ATC_NOT_CONFIGURED",
]);
export const ViewProxyErrorDetailV1 = z
  .object({
    code: ViewProxyErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const ViewProxyErrorEnvelopeV1 = z
  .object({ error: ViewProxyErrorDetailV1 })
  .passthrough();
export const Ops247DispatchLogRow = z
  .object({
    agent_name: z.string().nullable(),
    consumed: z.boolean(),
    consumed_at: z.string().datetime({ offset: true }).nullable(),
    context: z.object({}).partial().passthrough().nullable(),
    created_at: z.string().datetime({ offset: true }),
    escalation_depth: z.number().int().nullable(),
    from_call_sign: z.string().nullable(),
    from_embodiment_id: z.string().uuid().nullable(),
    from_work_item_id: z.string().nullable(),
    kind: z.string().nullable(),
    payload: z.object({}).partial().passthrough().nullable(),
    process_error: z.string().nullable(),
    process_result: z.string().nullable(),
    processed_at: z.string().datetime({ offset: true }).nullable(),
    signal_id: z.string().uuid(),
    signal_type: z.string(),
    source: z.string().nullable(),
    target: z.string().nullable(),
    target_embodiment_id: z.string().uuid().nullable(),
  })
  .passthrough();
export const Ops247DispatchLogEnvelope = z
  .object({
    data: z.array(Ops247DispatchLogRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const Ops247PendingDispatchesRow = z
  .object({
    fulfilled_at: z.string().datetime({ offset: true }).nullable(),
    handoff_card_id: z.string().uuid().nullable(),
    next_mo_entity_type: z.string().nullable(),
    next_mo_id: z.string(),
    next_mo_lifecycle_node: z.string().nullable(),
    next_mo_repo: z.string().nullable(),
    next_mo_source_doc_id: z.string().uuid().nullable(),
    next_mo_title: z.string().nullable(),
    notes: z.string().nullable(),
    outgoing_mo_entity_type: z.string().nullable(),
    outgoing_mo_id: z.string().nullable(),
    outgoing_mo_lifecycle_node: z.string().nullable(),
    outgoing_mo_repo: z.string().nullable(),
    outgoing_mo_source_doc_id: z.string().uuid().nullable(),
    outgoing_mo_title: z.string().nullable(),
    persona: z.string(),
    requested_at: z.string().datetime({ offset: true }),
  })
  .passthrough();
export const Ops247PendingDispatchesEnvelope = z
  .object({
    data: z.array(Ops247PendingDispatchesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const AgentEmbodimentsUnifiedRow = z
  .object({
    agent_id: z.string().nullable(),
    embodiment_id: z.string().uuid(),
    external_session_id: z.string().nullable(),
    location: z.string().nullable(),
    machine: z.string().nullable(),
    metadata: z.object({}).partial().passthrough().nullable(),
    retired_at: z.string().datetime({ offset: true }).nullable(),
    shorthandle: z.string().nullable(),
    source: z.string(),
    started_at: z.string().datetime({ offset: true }).nullable(),
    status: z.string(),
    vendor: z.string().nullable(),
  })
  .passthrough();
export const AgentEmbodimentsUnifiedEnvelope = z
  .object({
    data: z.array(AgentEmbodimentsUnifiedRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const AgentFlightRightsGrantsRow = z.object({}).partial().passthrough();
export const AgentFlightRightsGrantsEnvelope = z
  .object({
    data: z.array(AgentFlightRightsGrantsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const AgentPersonaPearlChainRow = z
  .object({
    agent_id: z.string().nullable(),
    chain_status: z
      .enum([
        "no_op",
        "op_missing",
        "op_inactive",
        "no_sf",
        "sf_missing",
        "sf_inactive",
        "valid",
      ])
      .nullable(),
    current_priority_inherits: z.boolean().nullable(),
    op_status: z.string().nullable(),
    op_title: z.string().nullable(),
    parent_op: z.string().uuid().nullable(),
    parent_sf: z.string().uuid().nullable(),
    scope_summary: z.string().nullable(),
    sf_priority: z.string().nullable(),
    sf_status: z.string().nullable(),
    sf_title: z.string().nullable(),
  })
  .passthrough();
export const AgentPersonaPearlChainEnvelope = z
  .object({
    data: z.array(AgentPersonaPearlChainRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const AgentPersonasRow = z
  .object({
    actor_type: z.string().nullable(),
    agent_id: z.string().nullable(),
    auth_type: z.string().nullable(),
    badge_variant: z.string().nullable(),
    bootstrap_doc_id: z.string().uuid().nullable(),
    comm_targets: z.array(z.string()).nullable(),
    companion_of: z.string().uuid().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    current_priority_inherits: z.boolean().nullable(),
    default_mcp_grants: z.object({}).partial().passthrough().nullable(),
    display_name: z.string().nullable(),
    google_email: z.string().nullable(),
    llm_model: z.string().nullable(),
    llm_provider: z.string().nullable(),
    north_star: z.string().nullable(),
    parent_op: z.string().uuid().nullable(),
    parent_persona_id: z.string().nullable(),
    parent_sf: z.string().uuid().nullable(),
    poll_schedule: z.string().nullable(),
    repo: z.string().nullable(),
    retirement_config: z.object({}).partial().passthrough().nullable(),
    role_id: z.string().nullable(),
    scope_summary: z.string().nullable(),
    shorthandle: z.string().nullable(),
    spawn_prompt: z.string().nullable(),
    status: z.string().nullable(),
    system_prompt_override: z.string().nullable(),
    system_prompt_ref: z.string().uuid().nullable(),
    tier: z.number().int().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    wake_triggers: z.object({}).partial().passthrough().nullable(),
    working_doc_id: z.string().uuid().nullable(),
  })
  .partial()
  .passthrough();
export const AgentPersonasEnvelope = z
  .object({
    data: z.array(AgentPersonasRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const AgentSignalsRow = z
  .object({
    ack_note: z.string().nullish(),
    acked_at: z.string().datetime({ offset: true }).nullish(),
    acked_by: z.string().nullish(),
    agent_name: z.string().nullable(),
    consumed: z.boolean(),
    consumed_at: z.string().datetime({ offset: true }).nullable(),
    consumed_by_embodiment_id: z.string().uuid().nullish(),
    context: z.object({}).partial().passthrough().nullable(),
    created_at: z.string().datetime({ offset: true }),
    dedup_key: z.string().nullish(),
    escalation_depth: z.number().int().nullish(),
    from_call_sign: z.string().nullish(),
    from_embodiment_id: z.string().uuid().nullish(),
    from_work_item_id: z.string().nullish(),
    id: z.string().uuid(),
    kind: z.string().nullish(),
    payload: z.object({}).partial().passthrough().nullable(),
    process_error: z.string().nullish(),
    process_result: z.string().nullish(),
    processed_at: z.string().datetime({ offset: true }).nullish(),
    requires_ack: z.boolean().nullish(),
    severity: z.string().nullish(),
    signal_type: z.string(),
    source: z.string().nullable(),
    target: z.string().nullable(),
    target_embodiment_id: z.string().uuid().nullish(),
    to_requested: z.string().nullish(),
    wa_dispatch_outcome: z.object({}).partial().passthrough().nullish(),
    wa_dispatched_at: z.string().datetime({ offset: true }).nullish(),
  })
  .passthrough();
export const AgentSignalsEnvelope = z
  .object({
    data: z.array(AgentSignalsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const AgentTriggersRow = z.object({}).partial().passthrough();
export const AgentTriggersEnvelope = z
  .object({
    data: z.array(AgentTriggersRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const AgentWorkBundleRow = z
  .object({
    call_sign: z.string(),
    embodiment_ended_at: z.string().datetime({ offset: true }).nullable(),
    embodiment_id: z.string().uuid().nullable(),
    embodiment_machine: z.string().nullable(),
    embodiment_started_at: z.string().datetime({ offset: true }).nullable(),
    execution_manifest_id: z.string().nullable(),
    execution_manifest_priority: z.string().nullable(),
    execution_manifest_title: z.string().nullable(),
    manifest_closeout_profile: z.string().nullable(),
    manifest_entry_id: z.string().uuid(),
    manifest_entry_status: z.string(),
    manifest_lifecycle_node: z.string().nullable(),
    persona_agent_id: z.string(),
    pr_merged_at: z.string().datetime({ offset: true }).nullable(),
    pr_state: z.string().nullable(),
    pr_url: z.string().nullable(),
  })
  .passthrough();
export const AgentWorkBundleEnvelope = z
  .object({
    data: z.array(AgentWorkBundleRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const AgentsRow = z
  .object({
    created_at: z.string().datetime({ offset: true }).nullable(),
    dispatch_config: z.object({}).partial().passthrough().nullable(),
    dispatch_method: z.string().nullable(),
    governance_tier: z.number().int().nullable(),
    guards: z.object({}).partial().passthrough().nullable(),
    id: z.string().uuid().nullable(),
    profile: z.string().nullable(),
    repo: z.string().nullable(),
    runtime_config: z.object({}).partial().passthrough().nullable(),
    session_types: z.object({}).partial().passthrough().nullable(),
    system_prompt_append: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .partial()
  .passthrough();
export const AgentsEnvelope = z
  .object({
    data: z.array(AgentsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const AppointmentsRow = z
  .object({
    commitment: z.string().nullable(),
    contact_person_id: z.string().uuid().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    date_target: z.string().nullable(),
    ends_at: z.string().datetime({ offset: true }).nullable(),
    id: z.string().uuid().nullable(),
    lead_id: z.string().uuid().nullable(),
    location_text: z.string().nullable(),
    notes: z.string().nullable(),
    org_id: z.string().nullable(),
    owner_email: z.string().nullable(),
    starts_at: z.string().datetime({ offset: true }).nullable(),
    status: z.string().nullable(),
    time_label: z.string().nullable(),
    time_type: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .partial()
  .passthrough();
export const AppointmentsEnvelope = z
  .object({
    data: z.array(AppointmentsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const BridgeEntriesRow = z
  .object({
    assignee: z.string().nullable(),
    blocked_by: z.array(z.string()).nullable(),
    blocker_reason: z.string().nullable(),
    child_count: z.number().int().nullable(),
    children_done: z.number().int().nullable(),
    ci_status: z.string().nullable(),
    close_out_via_cloud: z.boolean().nullable(),
    closure_reason: z.string().nullable(),
    commander_action: z.string().nullable(),
    commander_comment: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    created_by: z.string().nullable(),
    description: z.string().nullable(),
    dispatchable: z.boolean().nullable(),
    doc_content: z.string().nullable(),
    doc_created_at: z.string().datetime({ offset: true }).nullable(),
    doc_created_by: z.string().nullable(),
    doc_frontmatter: z.object({}).partial().passthrough().nullable(),
    doc_gcs_path: z.string().nullable(),
    doc_has_body: z.boolean().nullable(),
    doc_id: z.string().uuid().nullable(),
    doc_namespace: z.string().nullable(),
    doc_repo: z.string().nullable(),
    doc_status: z.string().nullable(),
    doc_store_id: z.string().uuid().nullable(),
    doc_title: z.string().nullable(),
    doc_type: z.string().nullable(),
    doc_updated_at: z.string().datetime({ offset: true }).nullable(),
    doc_version: z.number().int().nullable(),
    entity_type: z.string().nullable(),
    execution_mode: z.string().nullable(),
    execution_mode_inherited: z.boolean().nullable(),
    id: z.string().nullable(),
    is_blocked: z.boolean().nullable(),
    last_session_at: z.string().datetime({ offset: true }).nullable(),
    last_session_note: z.string().nullable(),
    lifecycle_node: z.string().nullable(),
    owner: z.string().nullable(),
    parent_id: z.string().nullable(),
    phase: z.string().nullable(),
    pipeline_entity_id: z.string().nullable(),
    pr_number: z.number().int().nullable(),
    pr_url: z.string().nullable(),
    priority: z.string().nullable(),
    repo: z.string().nullable(),
    session_purpose: z.string().nullable(),
    ship_rate: z.number().nullable(),
    sort_order: z.number().int().nullable(),
    sorties_done: z.number().int().nullable(),
    sorties_total: z.number().int().nullable(),
    source_type: z.string().nullable(),
    tenant_id: z.string().nullable(),
    title: z.string().nullable(),
    track: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .partial()
  .passthrough();
export const BridgeEntriesEnvelope = z
  .object({
    data: z.array(BridgeEntriesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CallbackQueueRow = z
  .object({
    callback_at: z.string().datetime({ offset: true }).nullable(),
    callback_time: z.string().datetime({ offset: true }).nullable(),
    company_name: z.string().nullable(),
    contact_person: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }),
    notes: z.string().nullable(),
    phone: z.string().nullable(),
    reason: z.string().nullable(),
    rep: z.string().uuid().nullable(),
    status: z.string().nullable(),
    unified_lead_id: z.string().uuid(),
  })
  .passthrough();
export const CallbackQueueEnvelope = z
  .object({
    data: z.array(CallbackQueueRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CallerWorkLogRow = z
  .object({
    caller_id: z.string().uuid().nullable(),
    disqualified: z.number().int().nullable(),
    first_call: z.string().datetime({ offset: true }).nullable(),
    last_call: z.string().datetime({ offset: true }).nullable(),
    not_reached: z.number().int().nullable(),
    qualified: z.number().int().nullable(),
    reached: z.number().int().nullable(),
    span_seconds: z.number().int().nullable(),
    total_calls: z.number().int().nullable(),
    work_date: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const CallerWorkLogEnvelope = z
  .object({
    data: z.array(CallerWorkLogRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CallingLeadCardRow = z
  .object({
    assigned_caller_id: z.string().uuid().nullable(),
    attempt_count: z.number().int().nullable(),
    available_at: z.string().datetime({ offset: true }).nullable(),
    campaign_id: z.string().uuid().nullable(),
    company_name: z.string(),
    contact_name: z.string().nullable(),
    contact_phone: z.string().nullable(),
    contact_role: z.string().nullable(),
    detection_suggestion: z.object({}).partial().passthrough().nullable(),
    gp_business_status: z.string().nullable(),
    gp_opening_hours: z.object({}).partial().passthrough().nullable(),
    gp_phone: z.string().nullable(),
    gp_rating: z.number().nullable(),
    imprint_email: z.string().nullable(),
    imprint_gf: z.string().nullable(),
    is_decision_maker: z.boolean().nullable(),
    last_outcome: z.string().nullable(),
    lead_briefing: z.object({}).partial().passthrough().nullable(),
    phone: z.string(),
    plz_mismatch: z.boolean().nullable(),
    previous_call_count: z.number().int().nullable(),
    priority: z.number().int().nullable(),
    queue_contact_name: z.string().nullable(),
    queue_id: z.string().uuid(),
    queue_status: z.string().nullable(),
    session_id: z.string().uuid().nullable(),
    suggested_demo_use_case: z.string().nullable(),
    unified_lead_id: z.string().uuid(),
  })
  .passthrough();
export const CallingLeadCardEnvelope = z
  .object({
    data: z.array(CallingLeadCardRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CallingScriptActiveRow = z
  .object({
    caller_id: z.string().uuid().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    id: z.string().uuid().nullable(),
    objections: z.array(z.object({}).partial().passthrough()).nullable(),
    sections: z.array(z.object({}).partial().passthrough()).nullable(),
    version: z.number().int().nullable(),
  })
  .passthrough();
export const CallingScriptActiveEnvelope = z
  .object({
    data: z.array(CallingScriptActiveRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CallingSessionBillingRow = z
  .object({
    caller_id: z.string().uuid().nullable(),
    campaign_id: z.string().uuid().nullable(),
    completed_at: z.string().datetime({ offset: true }).nullable(),
    completion_reason: z.string().nullable(),
    paid_seconds: z.number().int().nullable(),
    session_id: z.string().uuid().nullable(),
    started_at: z.string().datetime({ offset: true }).nullable(),
    stint_count: z.number().int().nullable(),
  })
  .partial()
  .passthrough();
export const CallingSessionBillingEnvelope = z
  .object({
    data: z.array(CallingSessionBillingRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CallingSessionStateRow = z
  .object({
    caller_id: z.string().uuid(),
    campaign_config: z.object({}).partial().passthrough().nullable(),
    campaign_id: z.string().uuid().nullable(),
    campaign_status: z.string().nullable(),
    campaign_title: z.string().nullable(),
    checklist_completed: z.object({}).partial().passthrough().nullable(),
    duration_seconds: z.number().int().nullable(),
    paused_at: z.string().datetime({ offset: true }).nullable(),
    planned_duration_min: z.number().int().nullable(),
    session_config: z.object({}).partial().passthrough().nullable(),
    session_id: z.string().uuid(),
    session_status: z.enum([
      "created",
      "active",
      "paused",
      "completed",
      "reviewed",
      "auto_ended",
    ]),
    started_at: z.string().datetime({ offset: true }).nullable(),
    today_calls: z.number().int().nullable(),
    today_qualified: z.number().int().nullable(),
    today_reached: z.number().int().nullable(),
    total_break_seconds: z.number().int().nullable(),
    total_calls: z.number().int().nullable(),
    total_reached: z.number().int().nullable(),
  })
  .passthrough();
export const CallingSessionStateEnvelope = z
  .object({
    data: z.array(CallingSessionStateRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CallingSessionStintsRow = z
  .object({
    caller_id: z.string().uuid().nullable(),
    session_id: z.string().uuid().nullable(),
    stint_duration_seconds: z.number().int().nullable(),
    stint_ended_at: z.string().datetime({ offset: true }).nullable(),
    stint_id: z.string().nullable(),
    stint_no: z.number().int().nullable(),
    stint_started_at: z.string().datetime({ offset: true }).nullable(),
  })
  .partial()
  .passthrough();
export const CallingSessionStintsEnvelope = z
  .object({
    data: z.array(CallingSessionStintsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CampaignDashboardRow = z
  .object({
    active_sessions: z.number().int().nullable(),
    campaign_id: z.string().uuid(),
    config: z.object({}).partial().passthrough().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    queue_completed: z.number().int().nullable(),
    queue_exhausted: z.number().int().nullable(),
    queue_in_progress: z.number().int().nullable(),
    queue_pending: z.number().int().nullable(),
    status: z.string(),
    title: z.string(),
    total_sessions: z.number().int().nullable(),
  })
  .passthrough();
export const CampaignDashboardEnvelope = z
  .object({
    data: z.array(CampaignDashboardRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CampaignQueueOverviewRow = z
  .object({
    assigned_caller_id: z.string().uuid().nullable(),
    attempt_count: z.number().int().nullable(),
    available_at: z.string().datetime({ offset: true }).nullable(),
    callback_at: z.string().datetime({ offset: true }).nullable(),
    campaign_id: z.string().uuid().nullable(),
    company_name: z.string(),
    completed_at: z.string().datetime({ offset: true }).nullable(),
    contact_name: z.string().nullable(),
    last_call_at: z.string().datetime({ offset: true }).nullable(),
    last_call_outcome: z.string().nullable(),
    latest_note: z.string().nullable(),
    outcome: z.string().nullable(),
    phone: z.string(),
    priority: z.number().int().nullable(),
    queue_id: z.string().uuid(),
    status: z.string().nullable(),
    unified_lead_id: z.string().uuid(),
  })
  .passthrough();
export const CampaignQueueOverviewEnvelope = z
  .object({
    data: z.array(CampaignQueueOverviewRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CaseDetailRow = z
  .object({
    assigned_at: z.string().datetime({ offset: true }).nullable(),
    assigned_to: z.string().nullable(),
    case_number: z.string(),
    category: z.string().nullable(),
    closed_at: z.string().datetime({ offset: true }).nullable(),
    company_id: z.string().uuid().nullable(),
    company_name: z.string().nullable(),
    contact_email: z.string().nullable(),
    contact_id: z.string().uuid().nullable(),
    contact_name: z.string().nullable(),
    contact_phone: z.string().nullable(),
    contact_title: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    delivery_ref: z.string().nullable(),
    description: z.string().nullable(),
    entity_id: z.string().uuid().nullable(),
    entity_type: z.string().nullable(),
    final_response: z.string().nullable(),
    id: z.string().uuid(),
    lifecycle_node: z.string().nullable(),
    mailbox: z.string().nullable(),
    odoo_ticket_id: z.string().uuid().nullable(),
    partner_email: z.string().nullable(),
    partner_name: z.string().nullable(),
    priority: z.number().int().nullable(),
    procedure_output: z.string().nullable(),
    sale_order_ref: z.string().nullable(),
    sla_breached: z.boolean().nullable(),
    sla_deadline: z.string().datetime({ offset: true }).nullable(),
    source: z.string().nullable(),
    subject: z.string(),
    tags: z.array(z.string()).nullable(),
    team: z.string().nullable(),
    triage_confidence: z.number().nullable(),
    triage_output: z.object({}).partial().passthrough().nullable(),
    type_code: z.string().nullable(),
    type_name: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .passthrough();
export const CaseDetailEnvelope = z
  .object({
    data: z.array(CaseDetailRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CasesRow = z
  .object({
    assigned_to: z.string().nullable(),
    case_number: z.string(),
    category: z.string().nullable(),
    closed_at: z.string().datetime({ offset: true }).nullable(),
    company_id: z.string().uuid().nullable(),
    company_name: z.string().nullable(),
    contact_id: z.string().uuid().nullable(),
    contact_name: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    entity_id: z.string().uuid().nullable(),
    entity_type: z.string().nullable(),
    id: z.string().uuid(),
    lifecycle_node: z.string().nullable(),
    mailbox: z.string().nullable(),
    partner_email: z.string().nullable(),
    partner_name: z.string().nullable(),
    priority: z.number().int().nullable(),
    sale_order_ref: z.string().nullable(),
    sla_breached: z.boolean().nullable(),
    sla_deadline: z.string().datetime({ offset: true }).nullable(),
    subject: z.string(),
    tags: z.array(z.string()).nullable(),
    team: z.string().nullable(),
    triage_confidence: z.number().nullable(),
    type_code: z.string().nullable(),
    type_name: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .passthrough();
export const CasesEnvelope = z
  .object({
    data: z.array(CasesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ChatInboxRow = z
  .object({
    agent_name: z.string().nullable(),
    consumed: z.boolean(),
    consumed_at: z.string().datetime({ offset: true }).nullable(),
    context: z.object({}).partial().passthrough().nullable(),
    created_at: z.string().datetime({ offset: true }),
    from_call_sign: z.string().nullish(),
    from_embodiment_id: z.string().uuid().nullish(),
    from_work_item_id: z.string().nullish(),
    id: z.string().uuid(),
    kind: z.string().nullish(),
    lane: z.string().nullish(),
    payload: z.object({}).partial().passthrough().nullable(),
    session_id: z.string().nullish(),
    signal_type: z.string(),
    source: z.string().nullable(),
    target: z.string().nullable(),
    target_embodiment_id: z.string().uuid().nullish(),
  })
  .passthrough();
export const ChatInboxEnvelope = z
  .object({
    data: z.array(ChatInboxRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CommsDrift1hRow = z
  .object({
    first_signal_at: z.string().datetime({ offset: true }).nullable(),
    kind: z.string().nullable(),
    last_signal_at: z.string().datetime({ offset: true }).nullable(),
    signal_count: z.number().int().nullable(),
    source: z.string().nullable(),
  })
  .passthrough();
export const CommsDrift1hEnvelope = z
  .object({
    data: z.array(CommsDrift1hRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CommsDrift24hRow = z
  .object({
    first_signal_at: z.string().datetime({ offset: true }).nullable(),
    kind: z.string().nullable(),
    last_signal_at: z.string().datetime({ offset: true }).nullable(),
    signal_count: z.number().int().nullable(),
    source: z.string().nullable(),
  })
  .passthrough();
export const CommsDrift24hEnvelope = z
  .object({
    data: z.array(CommsDrift24hRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CompanyRow = z.object({}).partial().passthrough();
export const CompanyEnvelope = z
  .object({
    data: z.array(CompanyRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ContactPersonsRow = z
  .object({
    created_at: z.string().datetime({ offset: true }).nullable(),
    created_by: z.string().nullable(),
    email: z.string().nullable(),
    full_name: z.string().nullable(),
    id: z.string().uuid().nullable(),
    lead_id: z.string().uuid().nullable(),
    mobile: z.string().nullable(),
    notes: z.string().nullable(),
    org_id: z.string().nullable(),
    phone: z.string().nullable(),
    position: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .partial()
  .passthrough();
export const ContactPersonsEnvelope = z
  .object({
    data: z.array(ContactPersonsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CustomersRow = z
  .object({
    active: z.boolean().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    customer_rank: z.number().int().nullable(),
    id: z.string().uuid().nullable(),
    name: z.string().nullable(),
    partner_email: z.string().nullable(),
    partner_name: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .partial()
  .passthrough();
export const CustomersEnvelope = z
  .object({
    data: z.array(CustomersRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const DaemonCommandsRow = z
  .object({
    claimed_at: z.string().datetime({ offset: true }).nullable(),
    claimed_by: z.string().nullable(),
    command: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    error_message: z.string().nullable(),
    executed_at: z.string().datetime({ offset: true }).nullable(),
    id: z.string().uuid().nullable(),
    issued_by: z.string().nullable(),
    model: z.string().nullable(),
    params: z.object({}).partial().passthrough().nullable(),
    role: z.string().nullable(),
    runtime: z.string().nullable(),
    status: z.string().nullable(),
    target_agent: z.string().nullable(),
    target_embodiment_id: z.string().uuid().nullable(),
    tenant_id: z.string().nullable(),
    vendor: z.string().nullable(),
    workitem_id: z.string().nullable(),
  })
  .passthrough();
export const DaemonCommandsEnvelope = z
  .object({
    data: z.array(DaemonCommandsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const DaemonLogsRow = z
  .object({
    authoritative_state: z.object({}).partial().passthrough().nullable(),
    caller_identity: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    data: z.object({}).partial().passthrough().nullable(),
    dispatch_id: z.string().nullable(),
    event: z.string().nullable(),
    id: z.string().uuid().nullable(),
    level: z.string().nullable(),
    preflight_result: z.object({}).partial().passthrough().nullable(),
    sortie_id: z.string().nullable(),
  })
  .passthrough();
export const DaemonLogsEnvelope = z
  .object({
    data: z.array(DaemonLogsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const DaemonStatusRow = z
  .object({
    activity: z.string().nullable(),
    agent_name: z.string().nullable(),
    ak_version: z.string().nullable(),
    branch: z.string().nullable(),
    ci_status: z.object({}).partial().passthrough().nullable(),
    context_pct: z.number().nullable(),
    id: z.string().uuid().nullable(),
    idle_seconds: z.number().int().nullable(),
    pid: z.number().int().nullable(),
    push_age_min: z.number().int().nullable(),
    restarts: z.number().int().nullable(),
    uncommitted_loc: z.number().int().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .passthrough();
export const DaemonStatusEnvelope = z
  .object({
    data: z.array(DaemonStatusRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const DecisionsPendingRow = z
  .object({
    active_skills: z.object({}).partial().passthrough().nullable(),
    alternatives_considered: z.object({}).partial().passthrough().nullable(),
    blast_radius: z.string().nullable(),
    context_doc_id: z.string().uuid().nullable(),
    created_at: z.string().datetime({ offset: true }),
    ctx_pct_at_decision: z.number().int().nullable(),
    decision_id: z.string(),
    door_type: z.string().nullable(),
    id: z.string().uuid(),
    parent_op_id: z.string().uuid().nullable(),
    parent_sf_id: z.string().uuid().nullable(),
    proposed_at: z.string().datetime({ offset: true }),
    proposed_by_embodiment_id: z.string().uuid().nullable(),
    proposed_by_shorthandle: z.string(),
    question: z.string(),
    rollback_plan: z.string().nullable(),
    tier: z.string(),
    title: z.string(),
    updated_at: z.string().datetime({ offset: true }),
  })
  .passthrough();
export const DecisionsPendingEnvelope = z
  .object({
    data: z.array(DecisionsPendingRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const AgentEmbodimentsTrackingRow = z
  .object({
    agent_id: z.string().nullable(),
    ctx_remaining_pct: z.number().nullable(),
    embodiment_id: z.string().uuid().nullable(),
    external_session_id: z.string().nullable(),
    last_heartbeat_at: z.string().datetime({ offset: true }).nullable(),
    last_turn_at: z.string().datetime({ offset: true }).nullable(),
    lcin_doc_id: z.string().uuid().nullable(),
    lcout_doc_id: z.string().uuid().nullable(),
    location: z.string().nullable(),
    machine: z.string().nullable(),
    metadata: z.object({}).partial().passthrough().nullable(),
    phantom_count: z.number().int().nullable(),
    retired_at: z.string().datetime({ offset: true }).nullable(),
    session_id: z.string().uuid().nullable(),
    session_node: z.string().nullable(),
    session_work_item_id: z.string().nullable(),
    shorthandle: z.string().nullable(),
    source: z.string().nullable(),
    started_at: z.string().datetime({ offset: true }).nullable(),
    status: z.string().nullable(),
    vendor: z.string().nullable(),
    workright_branch: z.string().nullable(),
    workright_expires_at: z.string().datetime({ offset: true }).nullable(),
    workright_label: z.string().nullable(),
    workright_lifecycle_node: z.string().nullable(),
    workright_workitem_id: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const AgentEmbodimentsTrackingEnvelope = z
  .object({
    data: z.array(AgentEmbodimentsTrackingRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ExecutionManifestRow = z
  .object({
    assignee: z.string().nullable(),
    blocked_by: z.array(z.string()).nullable(),
    blocker_reason: z.string().nullable(),
    bucket: z.string().nullable(),
    child_count: z.number().int().nullable(),
    children_done: z.number().int().nullable(),
    ci_status: z.string().nullable(),
    claimed_at: z.string().datetime({ offset: true }).nullable(),
    claimed_by: z.string().nullable(),
    close_approval: z.string().nullable(),
    close_approval_at: z.string().datetime({ offset: true }).nullable(),
    close_approval_by: z.string().nullable(),
    close_out_via_cloud: z.boolean().nullable(),
    closed_at: z.string().datetime({ offset: true }).nullable(),
    closed_by: z.string().nullable(),
    closeout_profile: z.string().nullable(),
    closure_reason: z.string().nullable(),
    commander_action: z.string().nullable(),
    commander_comment: z.string().nullable(),
    continuation_policy: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    created_by: z.string().nullable(),
    description: z.string().nullable(),
    dispatchable: z.boolean().nullable(),
    due_at: z.string().datetime({ offset: true }).nullable(),
    embedding: z.string().nullable(),
    engagement_mode: z.string().nullable(),
    entity_type: z.string().nullable(),
    execution_lane: z.string().nullable(),
    execution_mode: z.string().nullable(),
    execution_mode_inherited: z.boolean().nullable(),
    halt_reason: z.string().nullable(),
    id: z.string().nullable(),
    is_blocked: z.boolean().nullable(),
    last_session_at: z.string().datetime({ offset: true }).nullable(),
    last_session_note: z.string().nullable(),
    lifecycle_node: z.string().nullable(),
    merge_commit_sha: z.string().nullable(),
    merged_at: z.string().datetime({ offset: true }).nullable(),
    metadata: z.object({}).partial().passthrough().nullable(),
    notes: z.string().nullable(),
    owner: z.string().nullable(),
    parent_id: z.string().nullable(),
    phase: z.string().nullable(),
    pilot_hosts: z.object({}).partial().passthrough().nullable(),
    pipeline_entity_id: z.string().nullable(),
    plan_approval_state: z.string().nullable(),
    pr_number: z.number().int().nullable(),
    pr_url: z.string().nullable(),
    priority: z.string().nullable(),
    repo: z.string().nullable(),
    session_purpose: z.string().nullable(),
    ship_rate: z.number().nullable(),
    sort_order: z.number().int().nullable(),
    sorties_done: z.number().int().nullable(),
    sorties_total: z.number().int().nullable(),
    source_doc_id: z.string().uuid().nullable(),
    source_type: z.string().nullable(),
    status: z.string().nullable(),
    tenant_id: z.string().nullable(),
    title: z.string().nullable(),
    track: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .passthrough();
export const ExecutionManifestEnvelope = z
  .object({
    data: z.array(ExecutionManifestRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const GithubEventsRow = z
  .object({
    created_at: z.string().datetime({ offset: true }),
    delivery_id: z.string().nullable(),
    event_type: z.string(),
    id: z.string().uuid(),
    payload: z.object({}).partial().passthrough(),
    pr_number: z.number().int().nullable(),
    process_error: z.string().nullable(),
    process_status: z.string(),
    processed_at: z.string().datetime({ offset: true }).nullable(),
    provider: z.string(),
    received_at: z.string().datetime({ offset: true }),
    repo: z.string().nullable(),
    sender_login: z.string().nullable(),
  })
  .passthrough();
export const GithubEventsEnvelope = z
  .object({
    data: z.array(GithubEventsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const GovernanceDocumentsRow = z
  .object({
    approved_at: z.string().datetime({ offset: true }).nullable(),
    approved_by: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    created_by: z.string().nullable(),
    id: z.string().uuid().nullable(),
    intake_status: z.string().nullable(),
    proposed_by: z.string().nullable(),
    reviewed_at: z.string().datetime({ offset: true }).nullable(),
    reviewed_by: z.string().nullable(),
    status: z.string().nullable(),
    tags_raw: z.string().nullable(),
    title: z.string().nullable(),
    type: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    version: z.number().int().nullable(),
  })
  .partial()
  .passthrough();
export const GovernanceDocumentsEnvelope = z
  .object({
    data: z.array(GovernanceDocumentsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const IdentityStackRow = z
  .object({
    block_label: z.string().nullable(),
    block_no: z.number().int().nullable(),
    doc_id: z.string().uuid().nullable(),
    doc_title: z.string().nullable(),
    frontmatter: z.object({}).partial().passthrough().nullable(),
    gcs_path: z.string().nullable(),
    inject_hint: z.string().nullable(),
    live_title: z.string().nullable(),
    sort_order: z.number().int().nullable(),
    status: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    version: z.number().int().nullable(),
  })
  .partial()
  .passthrough();
export const IdentityStackEnvelope = z
  .object({
    data: z.array(IdentityStackRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const IntakePipelineRow = z
  .object({
    doc_count: z.number().int().nullable(),
    doc_type: z.string(),
    earliest_doc_updated_at: z.string().datetime({ offset: true }).nullable(),
    intake_status: z.string().nullable(),
    last_doc_updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .passthrough();
export const IntakePipelineEnvelope = z
  .object({
    data: z.array(IntakePipelineRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const InvoicesRow = z
  .object({
    amount_total: z.number().nullable(),
    amount_untaxed: z.number().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    customer_id: z.string().uuid().nullable(),
    due_date: z.string().nullable(),
    id: z.string().uuid().nullable(),
    invoice_date: z.string().nullable(),
    name: z.string().nullable(),
    order_id: z.string().uuid().nullable(),
    payment_status: z.string().nullable(),
    sales_rep_user_id: z.string().uuid().nullable(),
    status: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const InvoicesEnvelope = z
  .object({
    data: z.array(InvoicesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const KdpMonthlyCrosstabRow = z
  .object({
    eur_impact: z.number().nullable(),
    kdp_direction: z.string().nullable(),
    kdp_name: z.string().nullable(),
    kdp_status: z.string().nullable(),
    pattern_id: z.string().nullable(),
    period_month: z.string().nullable(),
    reconciliation_count: z.number().int().nullable(),
    units: z.number().int().nullable(),
  })
  .partial()
  .passthrough();
export const KdpMonthlyCrosstabEnvelope = z
  .object({
    data: z.array(KdpMonthlyCrosstabRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const LeadCallHistoryRow = z
  .object({
    call_timestamp: z.string().datetime({ offset: true }).nullable(),
    contact_name: z.string().nullable(),
    direct_phone: z.string().nullable(),
    duration_seconds: z.number().int().nullable(),
    id: z.string().uuid().nullable(),
    notes: z.string().nullable(),
    outcome: z.string().nullable(),
    phone_status: z.string().nullable(),
    rep_name: z.string().nullable(),
    unified_lead_id: z.string().uuid().nullable(),
  })
  .partial()
  .passthrough();
export const LeadCallHistoryEnvelope = z
  .object({
    data: z.array(LeadCallHistoryRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const LeadsRow = z
  .object({
    accepted_at: z.string().datetime({ offset: true }).nullable(),
    anchor_source: z.string().nullable(),
    briefing: z.object({}).partial().passthrough().nullable(),
    briefing_generated_at: z.string().datetime({ offset: true }).nullable(),
    company: z.object({}).partial().passthrough().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    demo: z.object({}).partial().passthrough().nullable(),
    discovered_company_id: z.string().uuid().nullable(),
    dm: z.object({}).partial().passthrough().nullable(),
    id: z.string().uuid().nullable(),
    is_anchor: z.boolean().nullable(),
    joker_reason: z.string().nullable(),
    joker_source: z.string().nullable(),
    lead_briefing: z.object({}).partial().passthrough().nullable(),
    lead_id: z.string().uuid().nullable(),
    mission_id: z.string().uuid().nullable(),
    mission_lead_id: z.string().uuid().nullable(),
    order_index: z.number().int().nullable(),
    pinned: z.boolean().nullable(),
    planned_time: z.string().nullable(),
    preferred_time: z.string().nullable(),
    prequal: z.object({}).partial().passthrough().nullable(),
    qualification_stage: z.string().nullable(),
    rejection_date: z.string().datetime({ offset: true }).nullable(),
    rejection_detail: z.string().nullable(),
    rejection_reason: z.string().nullable(),
    snooze_until: z.string().nullable(),
    state: z.string().nullable(),
    state_reason: z.string().nullable(),
    status: z.string().nullable(),
    stop_type: z.string().nullable(),
    suggested_demo_use_case: z.string().nullable(),
    unified_lead_id: z.string().uuid().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    visited_at: z.string().datetime({ offset: true }).nullable(),
    visited_by: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const LeadsEnvelope = z
  .object({
    data: z.array(LeadsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const LibraryCardsRow = z
  .object({
    consumed_at: z.string().datetime({ offset: true }).nullable(),
    consumed_by_session_id: z.string().uuid().nullable(),
    created_at: z.string().datetime({ offset: true }),
    for_persona: z.string(),
    id: z.string().uuid(),
    payload_md: z.string(),
    source_mo_id: z.string().nullable(),
    source_session_id: z.string().uuid().nullable(),
  })
  .passthrough();
export const LibraryCardsEnvelope = z
  .object({
    data: z.array(LibraryCardsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ManifestActivityFeedRow = z
  .object({
    activity_type: z.string().nullable(),
    author: z.string().nullable(),
    content: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    entry_closure_reason: z.string().nullable(),
    entry_entity_type: z.string().nullable(),
    entry_id: z.string().nullable(),
    entry_is_blocked: z.boolean().nullable(),
    entry_lifecycle_node: z.string().nullable(),
    entry_title: z.string().nullable(),
    id: z.string().uuid().nullable(),
    metadata: z.object({}).partial().passthrough().nullable(),
  })
  .partial()
  .passthrough();
export const ManifestActivityFeedEnvelope = z
  .object({
    data: z.array(ManifestActivityFeedRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ManifestDepsRow = z
  .object({
    created_at: z.string().datetime({ offset: true }).nullable(),
    dependency_type: z.string().nullable(),
    id: z.string().uuid().nullable(),
    source_id: z.string().nullable(),
    source_is_blocked: z.boolean().nullable(),
    source_lifecycle_node: z.string().nullable(),
    source_title: z.string().nullable(),
    target_id: z.string().nullable(),
    target_is_blocked: z.boolean().nullable(),
    target_lifecycle_node: z.string().nullable(),
    target_title: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const ManifestDepsEnvelope = z
  .object({
    data: z.array(ManifestDepsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ManifestEntriesRow = z
  .object({
    call_sign: z.string().nullable(),
    closed_at: z.string().datetime({ offset: true }).nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    depth: z.number().int().nullable(),
    doc_ref: z.string().nullable(),
    id: z.string().uuid().nullable(),
    kind: z.string().nullable(),
    last_activity_at: z.string().datetime({ offset: true }).nullable(),
    metadata: z.object({}).partial().passthrough().nullable(),
    parent_id: z.string().uuid().nullable(),
    path: z.array(z.string().uuid()).nullable(),
    persona: z.string().nullable(),
    retention_floor_until: z.string().datetime({ offset: true }).nullable(),
    root_id: z.string().uuid().nullable(),
    status: z.string().nullable(),
    title: z.string().nullable(),
  })
  .passthrough();
export const ManifestEntriesEnvelope = z
  .object({
    data: z.array(ManifestEntriesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ManifestEscalationsRow = z
  .object({
    assignee: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }),
    halt_reason: z.string().nullable(),
    id: z.string(),
    lifecycle_node: z.string(),
    manifest_entity_type: z.string().nullable(),
    manifest_id: z.string().nullable(),
    manifest_title: z.string().nullable(),
    metadata: z.object({}).partial().passthrough().nullable(),
    name: z.string(),
    priority: z.string().nullable(),
    status: z.string(),
  })
  .passthrough();
export const ManifestEscalationsEnvelope = z
  .object({
    data: z.array(ManifestEscalationsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ManifestHealthRow = z
  .object({
    dim1: z.string().nullable(),
    dim2: z.string().nullable(),
    metric: z.string().nullable(),
    n: z.number().int().nullable(),
  })
  .partial()
  .passthrough();
export const ManifestHealthEnvelope = z
  .object({
    data: z.array(ManifestHealthRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ManifestTreeRow = z
  .object({
    assignee: z.string().nullable(),
    child_count: z.number().int().nullable(),
    children_done: z.number().int().nullable(),
    ci_status: z.string().nullable(),
    closure_reason: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    depth: z.number().int().nullable(),
    doc_store_id: z.string().uuid().nullable(),
    entity_type: z.string().nullable(),
    execution_mode: z.string().nullable(),
    execution_mode_inherited: z.boolean().nullable(),
    id: z.string(),
    is_blocked: z.boolean(),
    lifecycle_node: z.string().nullable(),
    parent_id: z.string().nullable(),
    path: z.array(z.string()).nullable(),
    phase: z.string().nullable(),
    pipeline_entity_id: z.string().nullable(),
    pr_number: z.number().int().nullable(),
    pr_url: z.string().nullable(),
    priority: z.string().nullable(),
    repo: z.string().nullable(),
    root_id: z.string().nullable(),
    ship_rate: z.number().nullable(),
    sort_order: z.number().int().nullable(),
    tenant_id: z.string().nullable(),
    title: z.string(),
    track: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .passthrough();
export const ManifestTreeEnvelope = z
  .object({
    data: z.array(ManifestTreeRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ManifestTriageRow = z
  .object({
    assignee: z.string().nullable(),
    entity_type: z.string().nullable(),
    fs_blocked: z.boolean().nullable(),
    id: z.string().nullable(),
    is_active: z.boolean().nullable(),
    is_blocked: z.boolean().nullable(),
    lifecycle_node: z.string().nullable(),
    owner: z.string().nullable(),
    parent_id: z.string().nullable(),
    phase: z.string().nullable(),
    priority: z.string().nullable(),
    repo: z.string().nullable(),
    status: z.string().nullable(),
    title: z.string().nullable(),
    track: z.string().nullable(),
    triage_state: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const ManifestTriageEnvelope = z
  .object({
    data: z.array(ManifestTriageRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const MissionDayReadRow = z
  .object({
    completion_status: z.string().nullable(),
    day_end_lat: z.number().nullable(),
    day_end_lng: z.number().nullable(),
    day_start_lat: z.number().nullable(),
    day_start_lng: z.number().nullable(),
    decision_version: z.string().nullable(),
    ended_at: z.string().datetime({ offset: true }).nullable(),
    freeze_state: z.string().nullable(),
    modality: z.string().nullable(),
    region: z.string().nullable(),
    route_km: z.number().nullable(),
    session_mode: z.string().nullable(),
    started_at: z.string().datetime({ offset: true }).nullable(),
    visits_done: z.number().int().nullable(),
    visits_planned: z.number().int().nullable(),
    work_date: z.string().nullable(),
    work_day_id: z.string().uuid().nullable(),
    worker_id: z.string().uuid().nullable(),
  })
  .partial()
  .passthrough();
export const MissionDayReadEnvelope = z
  .object({
    data: z.array(MissionDayReadRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const MissionSummaryRow = z
  .object({
    anchor_count: z.number().int().nullable(),
    date: z.string().nullable(),
    lead_count: z.number().int().nullable(),
    mission_id: z.string().uuid().nullable(),
    region: z.string().nullable(),
    rep_email: z.string().nullable(),
    rep_id: z.string().uuid().nullable(),
    route_km: z.number().nullable(),
    status: z.string().nullable(),
    status_breakdown: z.object({}).partial().passthrough().nullable(),
    stop_counts_by_type: z.object({}).partial().passthrough().nullable(),
    title: z.string().nullable(),
    weekday: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const MissionSummaryEnvelope = z
  .object({
    data: z.array(MissionSummaryRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const MyCampaignRow = z
  .object({
    callable_count: z.number().int().nullable(),
    caller_id: z.string().uuid(),
    caller_role: z.string(),
    campaign_id: z.string().uuid(),
    config: z.object({}).partial().passthrough().nullable(),
    id: z.string().uuid(),
    queue_remaining: z.number().int().nullable(),
    session_config: z.object({}).partial().passthrough().nullable(),
    status: z.string(),
    title: z.string(),
  })
  .passthrough();
export const MyCampaignEnvelope = z
  .object({
    data: z.array(MyCampaignRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const MyEffectiveScopeRow = z
  .object({
    active_workrights: z.array(z.object({}).partial().passthrough()).nullable(),
    allowed_surfaces: z.array(z.string()).nullable(),
    embodiment_id: z.string().uuid(),
    last_heartbeat_at: z.string().datetime({ offset: true }).nullable(),
    machine: z.string().nullable(),
    persona: z.string().nullable(),
    persona_display_name: z.string().nullable(),
    persona_repo: z.string().nullable(),
    persona_role_id: z.string().nullable(),
    persona_status: z.string().nullable(),
    persona_tier: z.number().int().nullable(),
    recent_acks: z.array(z.object({}).partial().passthrough()).nullable(),
    session_id: z.string().nullable(),
    shorthandle: z.string().nullable(),
    started_at: z.string().datetime({ offset: true }).nullable(),
    vendor: z.string().nullable(),
  })
  .passthrough();
export const MyEffectiveScopeEnvelope = z
  .object({
    data: z.array(MyEffectiveScopeRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const OdooMirrorFreshnessMailMessageRow = z
  .object({
    age: z.string().nullable(),
    model: z.string().nullable(),
    newest: z.string().datetime({ offset: true }).nullable(),
    row_count: z.number().int().nullable(),
  })
  .partial()
  .passthrough();
export const OdooMirrorFreshnessMailMessageEnvelope = z
  .object({
    data: z.array(OdooMirrorFreshnessMailMessageRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const OpTrackingRow = z
  .object({
    assignee: z.string().nullable(),
    dh_gate: z.string().nullable(),
    entity_type: z.string().nullable(),
    id: z.string().nullable(),
    is_blocked: z.boolean().nullable(),
    lifecycle_node: z.string().nullable(),
    owner: z.string().nullable(),
    parent_id: z.string().nullable(),
    plan_label: z.string().nullable(),
    priority: z.string().nullable(),
    sub_id: z.string().nullable(),
    title: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    wave_id: z.string().nullable(),
    wave_sort: z.number().int().nullable(),
  })
  .partial()
  .passthrough();
export const OpTrackingEnvelope = z
  .object({
    data: z.array(OpTrackingRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const PendingMigrationsRow = z
  .object({
    applied_at: z.string().datetime({ offset: true }).nullable(),
    approved_at: z.string().datetime({ offset: true }).nullable(),
    approved_by: z.string().nullable(),
    dry_run_output: z.object({}).partial().passthrough().nullable(),
    dry_run_status: z.string().nullable(),
    id: z.string().uuid(),
    migration_name: z.string(),
    migration_sql: z.string(),
    proposed_at: z.string().datetime({ offset: true }),
    proposed_by: z.string(),
    rejected_at: z.string().datetime({ offset: true }).nullable(),
    rejected_by: z.string().nullable(),
    rejection_reason: z.string().nullable(),
  })
  .passthrough();
export const PendingMigrationsEnvelope = z
  .object({
    data: z.array(PendingMigrationsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const PersonaStackRow = z
  .object({
    active_embodiments: z.object({}).partial().passthrough().nullable(),
    active_workrights: z.object({}).partial().passthrough().nullable(),
    agent_id: z.string(),
    identity_docs: z.object({}).partial().passthrough().nullable(),
    last_signal_at: z.string().datetime({ offset: true }).nullable(),
    repo: z.string().nullable(),
    shorthandle: z.string().nullable(),
    status: z.string(),
    system_prompt_ref: z.string().uuid().nullable(),
    tier: z.number().int(),
  })
  .passthrough();
export const PersonaStackEnvelope = z
  .object({
    data: z.array(PersonaStackRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const PipelineConfigViewRow = z
  .object({
    description: z.string().nullable(),
    key: z.string(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    updated_by: z.string().nullable(),
    value: z.string(),
  })
  .passthrough();
export const PipelineConfigViewEnvelope = z
  .object({
    data: z.array(PipelineConfigViewRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const PostCallBriefingRow = z
  .object({
    availability: z.string().nullable(),
    available_from: z.string().nullable(),
    available_time_preference: z.string().nullable(),
    available_to: z.string().nullable(),
    call_timestamp: z.string().datetime({ offset: true }),
    caller_id: z.string().uuid(),
    cluster_id: z.string().nullable(),
    competitor_info: z.string().nullable(),
    contact_name: z.string().nullable(),
    contact_role: z.string().nullable(),
    direct_phone: z.string().nullable(),
    email: z.string().nullable(),
    field_corrections: z.object({}).partial().passthrough().nullable(),
    id: z.string().uuid(),
    infrastructure: z.array(z.string()).nullable(),
    interest_level: z.number().int().nullable(),
    is_decision_maker: z.boolean().nullable(),
    notes: z.string().nullable(),
    outcome: z.string(),
    qualification_answers: z.object({}).partial().passthrough().nullable(),
    script_version_id: z.string().uuid().nullable(),
    system_type_prediction: z.string().nullable(),
    unified_lead_id: z.string().uuid(),
  })
  .passthrough();
export const PostCallBriefingEnvelope = z
  .object({
    data: z.array(PostCallBriefingRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const PrequalAssignmentRow = z
  .object({
    assigned_date: z.string().nullable(),
    id: z.string().nullable(),
    lead_count: z.number().int().nullable(),
    mission_type: z.string().nullable(),
    owner_email: z.string().nullable(),
    region: z.string().nullable(),
    status: z.string().nullable(),
    title: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const PrequalAssignmentEnvelope = z
  .object({
    data: z.array(PrequalAssignmentRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const PrequalReferenceClustersRow = z
  .object({
    contact_roles: z.object({}).partial().passthrough().nullable(),
    description: z.string().nullable(),
    display_order: z.number().int().nullable(),
    gatekeeper_template: z.string().nullable(),
    id: z.string().nullable(),
    is_primary: z.boolean().nullable(),
    label: z.string().nullable(),
    opening_template: z.string().nullable(),
    product_ids: z.object({}).partial().passthrough().nullable(),
    qualification_questions: z.object({}).partial().passthrough().nullable(),
    type_id: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const PrequalReferenceClustersEnvelope = z
  .object({
    data: z.array(PrequalReferenceClustersRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const PrequalReferenceRolesRow = z
  .object({
    branch_code: z.string().nullable(),
    display_order: z.number().int().nullable(),
    occurrence_count: z.number().int().nullable(),
    role_label: z.string().nullable(),
    source: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const PrequalReferenceRolesEnvelope = z
  .object({
    data: z.array(PrequalReferenceRolesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const PrequalReferenceUsecasesRow = z
  .object({
    branch_code: z.string().nullable(),
    dilution_typical: z.string().nullable(),
    display_order: z.number().int().nullable(),
    id: z.string().nullable(),
    name: z.string().nullable(),
    object: z.string().nullable(),
    problem: z.string().nullable(),
    product_primary: z.string().nullable(),
    relevance_score: z.number().int().nullable(),
  })
  .partial()
  .passthrough();
export const PrequalReferenceUsecasesEnvelope = z
  .object({
    data: z.array(PrequalReferenceUsecasesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ProcessInstancesRow = z
  .object({
    artifacts: z.object({}).partial().passthrough().nullable(),
    closed_at: z.string().datetime({ offset: true }).nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    domain_labels: z.object({}).partial().passthrough().nullable(),
    entity_id: z.string().nullable(),
    entity_type: z.string().nullable(),
    gate_results: z.object({}).partial().passthrough().nullable(),
    halt_reason: z.string().nullable(),
    id: z.string().uuid().nullable(),
    lifecycle_node: z.string().nullable(),
    metadata: z.object({}).partial().passthrough().nullable(),
    parent_instance_id: z.string().uuid().nullable(),
    status: z.string().nullable(),
    template_id: z.string().uuid().nullable(),
    template_version: z.number().int().nullable(),
    tenant_id: z.string().uuid().nullable(),
    triggered_by: z.string().uuid().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .partial()
  .passthrough();
export const ProcessInstancesEnvelope = z
  .object({
    data: z.array(ProcessInstancesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ProcessTemplatesRow = z
  .object({
    actors: z.object({}).partial().passthrough().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    created_by: z.string().nullable(),
    description: z.string().nullable(),
    display_name: z.string().nullable(),
    domain: z.string().nullable(),
    domain_config: z.object({}).partial().passthrough().nullable(),
    entity_registry_ref: z.string().nullable(),
    gate_criteria: z.object({}).partial().passthrough().nullable(),
    id: z.string().uuid().nullable(),
    lifecycle_labels: z.object({}).partial().passthrough().nullable(),
    name: z.string().nullable(),
    node_input_schema: z.object({}).partial().passthrough().nullable(),
    orient_min_tokens: z.number().int().nullable(),
    reads_tables: z.object({}).partial().passthrough().nullable(),
    required_artifacts: z.object({}).partial().passthrough().nullable(),
    sla: z.object({}).partial().passthrough().nullable(),
    status: z.string().nullable(),
    triggers_on_close: z.object({}).partial().passthrough().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    version: z.number().int().nullable(),
    writes_tables: z.object({}).partial().passthrough().nullable(),
  })
  .partial()
  .passthrough();
export const ProcessTemplatesEnvelope = z
  .object({
    data: z.array(ProcessTemplatesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ProductsRow = z
  .object({
    active: z.boolean().nullable(),
    category_name: z.string().nullable(),
    id: z.string().uuid().nullable(),
    name: z.string().nullable(),
    sku: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const ProductsEnvelope = z
  .object({
    data: z.array(ProductsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const RepoRegistryRow = z
  .object({
    created_at: z.string().datetime({ offset: true }).nullable(),
    description: z.string().nullable(),
    github_path: z.string().nullable(),
    id: z.string().nullable(),
    kind: z.string().nullable(),
    retired_at: z.string().datetime({ offset: true }).nullable(),
  })
  .partial()
  .passthrough();
export const RepoRegistryEnvelope = z
  .object({
    data: z.array(RepoRegistryRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const SalesOrdersRow = z
  .object({
    amount_total: z.number().nullable(),
    carrier: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    customer_id: z.string().uuid().nullable(),
    delivery_status: z.string().nullable(),
    id: z.string().uuid().nullable(),
    invoice_status: z.string().nullable(),
    name: z.string().nullable(),
    order_datetime: z.string().datetime({ offset: true }).nullable(),
    payment_status: z.string().nullable(),
    payment_terms: z.string().nullable(),
    sales_rep_user_id: z.string().uuid().nullable(),
    status: z.string().nullable(),
    team: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .partial()
  .passthrough();
export const SalesOrdersEnvelope = z
  .object({
    data: z.array(SalesOrdersRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const SessionEventsRow = z
  .object({
    event_type: z.string().nullable(),
    id: z.string().uuid().nullable(),
    metadata: z.object({}).partial().passthrough().nullable(),
    session_id: z.string().uuid().nullable(),
    timestamp: z.string().datetime({ offset: true }).nullable(),
  })
  .partial()
  .passthrough();
export const SessionEventsEnvelope = z
  .object({
    data: z.array(SessionEventsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const TicketsRow = z
  .object({
    active: z.boolean().nullable(),
    assigned_user: z.string().nullable(),
    closed_at: z.string().datetime({ offset: true }).nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    description: z.string().nullable(),
    id: z.string().uuid().nullable(),
    name: z.string().nullable(),
    partner_email: z.string().nullable(),
    partner_name: z.string().nullable(),
    priority: z.string().nullable(),
    sla_deadline: z.string().datetime({ offset: true }).nullable(),
    stage: z.string().nullable(),
    team: z.string().nullable(),
    ticket_type: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
  })
  .partial()
  .passthrough();
export const TicketsEnvelope = z
  .object({
    data: z.array(TicketsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const VisitQuestionnaireActiveRow = z
  .object({
    config: z.object({}).partial().passthrough().nullable(),
    questions: z
      .array(
        z
          .object({
            add_label: z.string().nullish(),
            einheit: z.string().nullish(),
            einheit_fixed: z.boolean().nullish(),
            hint: z.string().nullish(),
            key: z.string(),
            kinds: z
              .array(z.object({ label: z.string(), value: z.string() }))
              .nullish(),
            label: z.string(),
            option_labels: z.record(z.string()).nullish(),
            options: z.array(z.string()).nullish(),
            placeholder: z.string().nullish(),
            required: z.boolean(),
            seed_source: z.string().nullish(),
            type: z.string(),
          })
          .nullable()
      )
      .nullable(),
    trigger_rules: z
      .object({
        always: z.boolean(),
        required_when: z.record(
          z.record(
            z.union([z.string(), z.object({ any: z.array(z.string()) })])
          )
        ),
        visible_when: z.record(
          z.record(
            z.union([z.string(), z.object({ any: z.array(z.string()) })])
          )
        ),
      })
      .nullable(),
    version: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const VisitQuestionnaireActiveEnvelope = z
  .object({
    data: z.array(VisitQuestionnaireActiveRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const VisitReportReadRow = z
  .object({
    access_result: z.string().nullable(),
    answers: z.object({}).partial().passthrough().nullable(),
    company_id: z.string().uuid().nullable(),
    company_name: z.string().nullable(),
    contact_first_name: z.string().nullable(),
    contact_is_decision_maker: z.boolean().nullable(),
    contact_last_name: z.string().nullable(),
    contact_role: z.string().nullable(),
    conversation_result: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    date: z.string().nullable(),
    demo_given: z.boolean().nullable(),
    entity_id: z.string().uuid().nullable(),
    follow_up_date: z.string().nullable(),
    follow_up_scheduled: z.boolean().nullable(),
    id: z.string().uuid().nullable(),
    mission_id: z.string().uuid().nullable(),
    mission_lead_id: z.string().uuid().nullable(),
    next_step: z.string().nullable(),
    next_steps: z.string().nullable(),
    no_access_detail: z.string().nullable(),
    no_access_reason: z.string().nullable(),
    no_dm_detail: z.string().nullable(),
    no_dm_reason: z.string().nullable(),
    notes: z.string().nullable(),
    objections: z.array(z.string()).nullable(),
    odoo_order_id: z.number().int().nullable(),
    odoo_order_name: z.string().nullable(),
    products_interested: z.array(z.string()).nullable(),
    products_of_interest: z.array(z.string()).nullable(),
    products_presented: z.array(z.string()).nullable(),
    products_sold: z.array(z.string()).nullable(),
    questionnaire_version: z.string().nullable(),
    rejection_detail: z.string().nullable(),
    rejection_reason: z.string().nullable(),
    rep_customer_status: z.string().nullable(),
    rep_user_id: z.string().uuid().nullable(),
    sale_amount_estimated: z.number().nullable(),
    submitted_at: z.string().datetime({ offset: true }).nullable(),
    system_use_cases: z.array(z.string()).nullable(),
    unified_lead_id: z.string().uuid().nullable(),
    use_cases_confirmed: z.array(z.string()).nullable(),
    visit_ended_at: z.string().datetime({ offset: true }).nullable(),
    visit_started_at: z.string().datetime({ offset: true }).nullable(),
    visit_type: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const VisitReportReadEnvelope = z
  .object({
    data: z.array(VisitReportReadRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const VisitReportV2Row = z
  .object({
    account_ref: z.string().nullable(),
    ap_reached: z.boolean().nullable(),
    branche_correct: z.boolean().nullable(),
    branche_correction: z.string().nullable(),
    contamination_confirmed: z.array(z.string()).nullable(),
    demo_done: z.boolean().nullable(),
    dm_info_correct: z.boolean().nullable(),
    dm_info_correction: z.string().nullable(),
    engagement_id: z.string().uuid().nullable(),
    entered: z.boolean().nullable(),
    erstbesuch: z.boolean().nullable(),
    gatekeeper_passed: z.enum(["durch", "blockiert", "keiner"]).nullable(),
    jahresbedarf: z
      .array(z.object({ liter_jahr: z.number(), product: z.string() }))
      .nullable(),
    kunde_status: z.enum(["neukunde", "bestand"]).nullable(),
    lead_invalid_reason: z
      .enum([
        "privathaus_kein_fit",
        "dauerhaft_geschlossen",
        "falsche_firma_adresse",
        "nicht_icp",
      ])
      .nullable(),
    lead_valid: z.boolean().nullable(),
    next_action: z
      .array(
        z.enum([
          "folgetermin",
          "angebot",
          "muster",
          "rueckruf",
          "wiedervorlage",
          "nichts",
        ])
      )
      .nullable(),
    next_when_date: z.string().nullable(),
    next_when_kind: z
      .enum(["datum", "kw", "monat", "zeitraum", "offen"])
      .nullable(),
    next_when_label: z.string().nullable(),
    no_ap_reason: z
      .enum([
        "ap_nicht_da",
        "abgewimmelt",
        "kein_termin",
        "folgetermin",
        "sonstiges",
      ])
      .nullable(),
    no_entry_reason: z
      .enum([
        "firma_geschlossen_dauerhaft",
        "falsche_oeffnungszeiten",
        "kein_zutritt",
        "falsche_firma_adresse",
        "nicht_icp",
        "sonstiges",
      ])
      .nullable(),
    no_sale_reason: z
      .enum([
        "kein_bedarf",
        "bestandslieferant",
        "preis_budget",
        "bedenkzeit",
        "kein_interesse",
        "sonstiges",
      ])
      .nullable(),
    notizen: z.string().nullable(),
    objects_confirmed: z.array(z.string()).nullable(),
    product_correct: z.boolean().nullable(),
    relevante_produkte: z.array(z.string()).nullable(),
    schon_mal_verkauft: z.boolean().nullable(),
    sold: z.boolean().nullable(),
    source_event_id: z.string().uuid().nullable(),
    spin_correct: z.boolean().nullable(),
    stop_type: z.enum(["planned", "joker"]).nullable(),
    visited_at: z.string().datetime({ offset: true }).nullable(),
    wettbewerb: z.string().nullable(),
    zeichnungsberechtigt_info: z.string().nullable(),
    zeichnungsberechtigt_wer: z
      .enum([
        "ansprechpartner_selbst",
        "geschaeftsfuehrung",
        "einkauf",
        "gremium",
        "unbekannt",
      ])
      .nullable(),
  })
  .partial()
  .passthrough();
export const VisitReportV2Envelope = z
  .object({
    data: z.array(VisitReportV2Row),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const CoreVisitTelemetryReadRow = z
  .object({
    access_result: z.string().nullable(),
    account_ref: z.string().nullable(),
    anfahren_at: z.string().datetime({ offset: true }).nullable(),
    arrival_accuracy: z.number().nullable(),
    arrival_ist: z.string().datetime({ offset: true }).nullable(),
    arrival_lat: z.number().nullable(),
    arrival_lng: z.number().nullable(),
    arrival_soll: z.string().datetime({ offset: true }).nullable(),
    besuch_beenden_at: z.string().datetime({ offset: true }).nullable(),
    besuch_starten_at: z.string().datetime({ offset: true }).nullable(),
    company_name: z.string().nullable(),
    confirmed_object: z.string().nullable(),
    conversation_result: z.string().nullable(),
    departure_accuracy: z.number().nullable(),
    departure_lat: z.number().nullable(),
    departure_lng: z.number().nullable(),
    dm_confirmed: z.boolean().nullable(),
    dm_name: z.string().nullable(),
    expected_arrival_at: z.string().datetime({ offset: true }).nullable(),
    is_anchor: z.boolean().nullable(),
    modality: z.string().nullable(),
    odoo_order_ref: z.string().nullable(),
    onsite: z.boolean().nullable(),
    order_index: z.number().int().nullable(),
    rep_customer_status: z.string().nullable(),
    screentime_seconds: z.number().int().nullable(),
    session_mode: z.string().nullable(),
    sold: z.boolean().nullable(),
    spin_outcome: z.string().nullable(),
    stop_id: z.string().uuid().nullable(),
    stop_lifecycle_node: z.string().nullable(),
    stop_origin: z.string().nullable(),
    submit_at: z.string().datetime({ offset: true }).nullable(),
    visit_notes: z.string().nullable(),
    visited_at: z.string().datetime({ offset: true }).nullable(),
    visited_by: z.string().nullable(),
    work_date: z.string().nullable(),
    work_day_id: z.string().uuid().nullable(),
    worker_id: z.string().uuid().nullable(),
  })
  .partial()
  .passthrough();
export const CoreVisitTelemetryReadEnvelope = z
  .object({
    data: z.array(CoreVisitTelemetryReadRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerAccountOverviewRow = z
  .object({
    credit_note_number: z.string().nullable(),
    credited: z.number().nullable(),
    invoice_date: z.string().nullable(),
    invoice_number: z.string().nullable(),
    invoiced: z.number().nullable(),
    label: z.string().nullable(),
    paid: z.number().nullable(),
    period_month: z.string().nullable(),
    remaining: z.number().nullable(),
    saldo: z.number().nullable(),
    track: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const WacklerAccountOverviewEnvelope = z
  .object({
    data: z.array(WacklerAccountOverviewRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerBillsRow = z
  .object({
    bill_id: z.string().uuid().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    credit_note_number: z.string().nullable(),
    credited_amount: z.number().nullable(),
    days_outstanding: z.number().int().nullable(),
    document_storage_path: z.string().nullable(),
    entity_id: z.string().uuid().nullable(),
    entity_type: z.string().nullable(),
    gross_amount: z.number().nullable(),
    has_pdf: z.boolean().nullable(),
    invoice_date: z.string().nullable(),
    invoice_number: z.string().nullable(),
    label: z.string().nullable(),
    lifecycle_node: z.string().nullable(),
    net_outstanding: z.number().nullable(),
    our_bill_number: z.string().nullable(),
    paid_amount: z.number().nullable(),
    period_month: z.string().nullable(),
    track: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const WacklerBillsEnvelope = z
  .object({
    data: z.array(WacklerBillsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerCommunicationsRow = z
  .object({
    attachment_refs: z.array(z.string()).nullable(),
    body: z.string().nullable(),
    channel: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    created_by: z.string().nullable(),
    direction: z.string().nullable(),
    id: z.string().uuid().nullable(),
    our_ref: z.string().nullable(),
    recipient: z.string().nullable(),
    scope_ref: z.string().nullable(),
    scope_type: z.string().nullable(),
    sender: z.string().nullable(),
    sent_at: z.string().datetime({ offset: true }).nullable(),
    subject: z.string().nullable(),
    wackler_ref: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const WacklerCommunicationsEnvelope = z
  .object({
    data: z.array(WacklerCommunicationsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerConfigRow = z
  .object({
    config: z.object({}).partial().passthrough().nullable(),
    rank: z.number().int().nullable(),
  })
  .passthrough();
export const WacklerConfigEnvelope = z
  .object({
    data: z.array(WacklerConfigRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerFreightLinesRow = z
  .object({
    auftrag: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    destination: z.string().nullable(),
    diesel: z.number().nullable(),
    dpd_paket: z.number().nullable(),
    fp_tauschgebuehr: z.number().nullable(),
    fracht: z.number().nullable(),
    gefahrgutzuschlag: z.number().nullable(),
    id: z.string().uuid().nullable(),
    invoice_number: z.string().nullable(),
    la: z.string().nullable(),
    line_total: z.number().nullable(),
    pallet_type: z.string().nullable(),
    period: z.string().nullable(),
    sicherheitsgebuehr: z.number().nullable(),
    weight_kg: z.number().int().nullable(),
    zustellmonat: z.string().nullable(),
    zustellung_2: z.number().nullable(),
  })
  .partial()
  .passthrough();
export const WacklerFreightLinesEnvelope = z
  .object({
    data: z.array(WacklerFreightLinesRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerInvoiceDetailRow = z
  .object({
    auftrag_id: z.string().nullable(),
    bill_gross: z.number().nullable(),
    carrier_actual: z.string().nullable(),
    carrier_planned: z.string().nullable(),
    combined_diff: z.number().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    engine_derived: z.object({}).partial().passthrough().nullable(),
    engine_derived_at: z.string().datetime({ offset: true }).nullable(),
    expected_freight_components: z
      .object({})
      .partial()
      .passthrough()
      .nullable(),
    expected_freight_total: z.number().nullable(),
    expected_total: z.number().nullable(),
    freight: z.object({}).partial().passthrough().nullable(),
    freight_components: z.object({}).partial().passthrough().nullable(),
    freight_total: z.number().nullable(),
    internal_comment: z.string().nullable(),
    invoice_date: z.string().nullable(),
    invoice_number: z.string().nullable(),
    kdp_adjustment: z.number().nullable(),
    kdp_hits: z.object({}).partial().passthrough().nullable(),
    kdp_impacts: z.object({}).partial().passthrough().nullable(),
    line_state: z.string().nullable(),
    our_bill_number: z.string().nullable(),
    panel: z.object({}).partial().passthrough().nullable(),
    period_month: z.string().nullable(),
    phase: z.number().int().nullable(),
    recon_id: z.string().uuid().nullable(),
    residual_eur: z.number().nullable(),
    reviewed_at: z.string().datetime({ offset: true }).nullable(),
    reviewed_by: z.string().nullable(),
    track: z.string().nullable(),
    unexplained_after_all_kdps: z.number().nullable(),
    unexplained_against_us: z.number().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    verdict: z.string().nullable(),
    wackler_comment: z.string().nullable(),
    wackler_total: z.number().nullable(),
  })
  .partial()
  .passthrough();
export const WacklerInvoiceDetailEnvelope = z
  .object({
    data: z.array(WacklerInvoiceDetailRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerInvoicePreSendReviewRow = z
  .object({
    accepted_la_count: z.number().int().nullable(),
    disputed_la_count: z.number().int().nullable(),
    inconclusive_lines: z.number().int().nullable(),
    invoice_number: z.string().nullable(),
    match_lines: z.number().int().nullable(),
    overcharge_lines: z.number().int().nullable(),
    period_month: z.string().nullable(),
    total_combined_diff_eur: z.number().nullable(),
    total_freight_billed_eur: z.number().nullable(),
    total_freight_diff_eur: z.number().nullable(),
    total_freight_expected_eur: z.number().nullable(),
    total_kdp_credit_eur: z.number().nullable(),
    total_lines: z.number().int().nullable(),
    total_residual_eur: z.number().nullable(),
    undercharge_lines: z.number().int().nullable(),
  })
  .partial()
  .passthrough();
export const WacklerInvoicePreSendReviewEnvelope = z
  .object({
    data: z.array(WacklerInvoicePreSendReviewRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerInvoiceSummaryRow = z
  .object({
    accepted_la_count: z.number().int().nullable(),
    bill_gross: z.number().nullable(),
    credit_note_amount_gross: z.number().nullable(),
    credit_note_number: z.string().nullable(),
    disputed_la_count: z.number().int().nullable(),
    entity_id: z.string().uuid().nullable(),
    has_kdp_hits: z.boolean().nullable(),
    inconclusive_lines: z.number().int().nullable(),
    invoice_date: z.string().nullable(),
    invoice_number: z.string().nullable(),
    label: z.string().nullable(),
    match_lines: z.number().int().nullable(),
    our_bill_number: z.string().nullable(),
    overcharge_lines: z.number().int().nullable(),
    period_month: z.string().nullable(),
    saldo: z.number().nullable(),
    total_combined_diff_eur: z.number().nullable(),
    total_freight_billed_eur: z.number().nullable(),
    total_freight_diff_eur: z.number().nullable(),
    total_freight_expected_eur: z.number().nullable(),
    total_kdp_credit_eur: z.number().nullable(),
    total_lines: z.number().int().nullable(),
    total_residual_eur: z.number().nullable(),
    track: z.string().nullable(),
    undercharge_lines: z.number().int().nullable(),
  })
  .partial()
  .passthrough();
export const WacklerInvoiceSummaryEnvelope = z
  .object({
    data: z.array(WacklerInvoiceSummaryRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerMonthDetailRow = z
  .object({
    auftrag_id: z.string().nullable(),
    carrier_actual: z.string().nullable(),
    carrier_planned: z.string().nullable(),
    carrier_tier: z.string().nullable(),
    component_diffs: z.object({}).partial().passthrough().nullable(),
    d4_count: z.number().int().nullable(),
    diff: z.number().nullable(),
    engine_derived: z.object({}).partial().passthrough().nullable(),
    engine_derived_at: z.string().datetime({ offset: true }).nullable(),
    expected_components: z.object({}).partial().passthrough().nullable(),
    expected_freight_components: z
      .object({})
      .partial()
      .passthrough()
      .nullable(),
    expected_freight_total: z.number().nullable(),
    expected_total: z.number().nullable(),
    freight_components: z.object({}).partial().passthrough().nullable(),
    freight_notes: z.object({}).partial().passthrough().nullable(),
    freight_total: z.number().nullable(),
    has_hazmat: z.boolean().nullable(),
    id: z.string().uuid().nullable(),
    internal_comment: z.string().nullable(),
    invoice_number: z.string().nullable(),
    is_at: z.boolean().nullable(),
    kdp_adjustment: z.number().nullable(),
    kdp_hits: z.object({}).partial().passthrough().nullable(),
    line_state: z.string().nullable(),
    period_month: z.string().nullable(),
    phase: z.number().int().nullable(),
    ref_ids_used: z.array(z.number().int()).nullable(),
    reviewed_at: z.string().datetime({ offset: true }).nullable(),
    reviewed_by: z.string().nullable(),
    unexplained: z.number().nullable(),
    verdict: z.string().nullable(),
    wackler_comment: z.string().nullable(),
    wackler_components: z.object({}).partial().passthrough().nullable(),
    wackler_doc_id: z.string().uuid().nullable(),
    wackler_total: z.number().nullable(),
  })
  .partial()
  .passthrough();
export const WacklerMonthDetailEnvelope = z
  .object({
    data: z.array(WacklerMonthDetailRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerParetoPeriodRow = z
  .object({
    abs_residual_eur: z.number().nullable(),
    auftrag_id: z.string().nullable(),
    kdp_count: z.number().int().nullable(),
    kdp_ids: z.array(z.string()).nullable(),
    period_month: z.string().nullable(),
    residual_eur: z.number().nullable(),
    residual_rank: z.number().int().nullable(),
    verdict: z.string().nullable(),
  })
  .partial()
  .passthrough();
export const WacklerParetoPeriodEnvelope = z
  .object({
    data: z.array(WacklerParetoPeriodRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerPaymentsRow = z
  .object({
    allocated: z.number().nullable(),
    amount: z.number().nullable(),
    bank_reference: z.string().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    id: z.string().uuid().nullable(),
    invoice_count: z.number().int().nullable(),
    notes: z.string().nullable(),
    odoo_payment_id: z.string().uuid().nullable(),
    payment_date: z.string().nullable(),
    reference: z.string().nullable(),
    source: z.string().nullable(),
    unallocated: z.number().nullable(),
  })
  .partial()
  .passthrough();
export const WacklerPaymentsEnvelope = z
  .object({
    data: z.array(WacklerPaymentsRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerReconciliationRow = z
  .object({
    auftrag_id: z.string().nullable(),
    carrier_actual: z.string().nullable(),
    carrier_planned: z.string().nullable(),
    component_diffs: z.object({}).partial().passthrough().nullable(),
    created_at: z.string().datetime({ offset: true }).nullable(),
    diff: z.number().nullable(),
    expected_components: z.object({}).partial().passthrough().nullable(),
    expected_total: z.number().nullable(),
    id: z.string().uuid().nullable(),
    internal_comment: z.string().nullable(),
    kdp_adjustment: z.number().nullable(),
    kdp_count: z.number().int().nullable(),
    kdp_ids: z.array(z.string()).nullable(),
    la_number: z.string().nullable(),
    line_state: z.string().nullable(),
    period_month: z.string().nullable(),
    phase: z.number().int().nullable(),
    ref_ids_used: z.array(z.number().int()).nullable(),
    reviewed_at: z.string().datetime({ offset: true }).nullable(),
    reviewed_by: z.string().nullable(),
    unexplained: z.number().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    verdict: z.string().nullable(),
    wackler_comment: z.string().nullable(),
    wackler_components: z.object({}).partial().passthrough().nullable(),
    wackler_doc_id: z.string().uuid().nullable(),
    wackler_total: z.number().nullable(),
  })
  .partial()
  .passthrough();
export const WacklerReconciliationEnvelope = z
  .object({
    data: z.array(WacklerReconciliationRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerWorkspaceRow = z.object({}).partial().passthrough();
export const WacklerWorkspaceEnvelope = z
  .object({
    data: z.array(WacklerWorkspaceRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WacklerDieselByMonthResponse = z
  .object({
    billing_month: z.union([z.string(), z.null()]),
    diesel_index: z.union([z.number(), z.null()]),
    index_month: z.union([z.string(), z.null()]),
    pct: z.union([z.number(), z.null()]),
  })
  .partial()
  .passthrough();
export const WacklerRefCase = z
  .object({
    carton_type: z.union([z.string(), z.null()]),
    confidence: z.union([z.unknown(), z.null()]),
    expected_components: z.union([
      z.object({}).partial().passthrough(),
      z.null(),
    ]),
    expected_cost: z.union([z.number(), z.null()]),
    product_exception: z.union([z.array(z.unknown()), z.null()]),
    product_mix: z.union([z.object({}).partial().passthrough(), z.null()]),
    ref_id: z.union([z.number().int(), z.null()]),
  })
  .partial()
  .passthrough();
export const WikiBucketsByRepoRow = z
  .object({ count: z.number().int().nullable(), repo: z.string() })
  .passthrough();
export const WikiBucketsByRepoEnvelope = z
  .object({
    data: z.array(WikiBucketsByRepoRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WikiBucketsByTypeRow = z
  .object({ count: z.number().int().nullable(), type: z.string() })
  .passthrough();
export const WikiBucketsByTypeEnvelope = z
  .object({
    data: z.array(WikiBucketsByTypeRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WikiByRepoRow = z
  .object({
    frontmatter: z.object({}).partial().passthrough().nullable(),
    id: z.string().uuid().nullable(),
    repo: z.string().nullable(),
    status: z.string().nullable(),
    title: z.string().nullable(),
    type: z.string().nullable(),
    updated_at: z.string().datetime({ offset: true }).nullable(),
    version: z.number().int().nullable(),
  })
  .passthrough();
export const WikiByRepoEnvelope = z
  .object({
    data: z.array(WikiByRepoRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WikiByTypeRow = z
  .object({
    frontmatter: z.object({}).partial().passthrough().nullable(),
    id: z.string().uuid(),
    status: z.string(),
    title: z.string(),
    type: z.string(),
    updated_at: z.string().datetime({ offset: true }),
    version: z.number().int(),
  })
  .passthrough();
export const WikiByTypeEnvelope = z
  .object({
    data: z.array(WikiByTypeRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const WorkrightsViewRow = z
  .object({
    auto_renew_on_use: z.boolean(),
    current_embodiment_id: z.string().uuid().nullable(),
    expires_at: z.string().datetime({ offset: true }).nullable(),
    granted_at: z.string().datetime({ offset: true }),
    label: z.string(),
    last_used_at: z.string().datetime({ offset: true }).nullable(),
    manifest_call_sign: z.string().nullable(),
    manifest_id: z.string().uuid().nullable(),
    manifest_kind: z.string().nullable(),
    manifest_last_activity_at: z.string().datetime({ offset: true }).nullable(),
    manifest_persona: z.string().nullable(),
    manifest_status: z.string().nullable(),
    manifest_title: z.string().nullable(),
    persona_id: z.string(),
    revoked_at: z.string().datetime({ offset: true }).nullable(),
    scope: z.object({}).partial().passthrough().nullable(),
    workright_id: z.string(),
  })
  .passthrough();
export const WorkrightsViewEnvelope = z
  .object({
    data: z.array(WorkrightsViewRow),
    has_more: z.boolean().optional(),
    meta: z.object({}).partial().passthrough().optional(),
    total: z.number().int().gte(0),
  })
  .passthrough();
export const ViewProxyMeta = z
  .object({
    cache_ttl: z.union([z.number().int(), z.null()]),
    circuit_state: z.union([z.string(), z.null()]),
    degraded: z.union([z.boolean(), z.null()]),
    duration_ms: z.union([z.number(), z.null()]),
    ownership: z.union([z.string(), z.null()]),
    request_id: z.union([z.string(), z.null()]),
    served_at: z.union([z.string(), z.null()]),
    source: z.union([z.string(), z.null()]),
    view: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const ViewProxyEnvelope = z
  .object({
    data: z.array(z.object({}).partial().passthrough()),
    has_more: z.union([z.boolean(), z.null()]).optional(),
    meta: z.union([ViewProxyMeta, z.null()]).optional(),
    total: z.union([z.number().int(), z.null()]).optional(),
  })
  .passthrough();
export const VisitReportListResponse = z
  .object({
    data: z.array(z.object({}).partial().passthrough()),
    limit: z.number().int(),
    offset: z.number().int(),
    success: z.boolean(),
    total: z.number().int(),
  })
  .passthrough();
export const VoiceSessionProxyEnvelope = z
  .object({
    data: z.union([z.unknown(), z.null()]),
    error: z.union([z.unknown(), z.null()]),
    success: z.union([z.boolean(), z.null()]),
  })
  .partial()
  .passthrough();
export const VoiceTokenEnvelope = z
  .object({
    identity: z.union([z.string(), z.null()]),
    token: z.union([z.string(), z.null()]),
    ttl: z.union([z.number().int(), z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const CommunicationBody = z.object({
  attachment_refs: z.union([z.array(z.string()), z.null()]).optional(),
  body: z.string().min(1),
  channel: z.union([z.string(), z.null()]).optional(),
  direction: z.enum(["internal", "outbound", "inbound"]),
  our_ref: z.union([z.string(), z.null()]).optional(),
  recipient: z.union([z.string(), z.null()]).optional(),
  scope_ref: z.string().min(1),
  scope_type: z.string().min(1),
  sender: z.union([z.string(), z.null()]).optional(),
  subject: z.union([z.string(), z.null()]).optional(),
  wackler_ref: z.union([z.string(), z.null()]).optional(),
});
export const CommunicationResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const WacklerCreditAllocateRequest = z.object({
  amount: z.number().gt(0),
  bill_id: z.string(),
  notes: z.union([z.string().max(500), z.null()]).optional(),
});
export const WacklerCreditAllocateData = z.object({}).partial().passthrough();
export const WacklerCreditAllocateResponse = z
  .object({
    data: WacklerCreditAllocateData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const WacklerSignedUrlData = z
  .object({ expires_at: z.string(), url: z.string() })
  .passthrough();
export const WacklerSignedUrlResponse = z
  .object({
    data: WacklerSignedUrlData,
    success: z.literal(true).optional().default(true),
  })
  .passthrough();
export const LineStateBody = z.object({
  external_comment: z.union([z.string(), z.null()]).optional(),
  internal_comment: z.union([z.string(), z.null()]).optional(),
  state: z.enum(["accepted", "disputed"]),
});
export const LineStateResponse = z
  .object({ data: z.object({}).partial().passthrough(), success: z.boolean() })
  .passthrough();
export const WarehouseInventoryResponse = z
  .object({ data: z.array(z.unknown()), success: z.boolean() })
  .passthrough();
export const WarehouseShipmentConfirmResponse = z
  .object({ success: z.boolean() })
  .passthrough();
export const WikiRepoBucket = z
  .object({
    count: z.number().int(),
    repo: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const WikiTypeBucket = z
  .object({
    count: z.number().int(),
    type: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const WikiBucketsEnvelope = z
  .object({ repos: z.array(WikiRepoBucket), types: z.array(WikiTypeBucket) })
  .passthrough();
export const WikiDocRow = z
  .object({
    frontmatter: z.object({}).partial().passthrough().optional().default({}),
    id: z.union([z.number().int(), z.string()]),
    status: z.union([z.string(), z.null()]).optional(),
    title: z.union([z.string(), z.null()]).optional(),
    type: z.union([z.string(), z.null()]).optional(),
    updated_at: z.union([z.string(), z.null()]).optional(),
    version: z.union([z.number().int(), z.string(), z.null()]).optional(),
  })
  .passthrough();
export const WikiListEnvelope = z
  .object({
    data: z.array(WikiDocRow),
    has_more: z.boolean(),
    total: z.number().int(),
  })
  .passthrough();
export const WorkflowRunCreateRequest = z.object({
  completed_at: z
    .union([z.string().datetime({ offset: true }), z.null()])
    .optional(),
  conclusion: z
    .union([
      z.string().regex(/^(success|failure|cancelled|skipped)$/),
      z.null(),
    ])
    .optional(),
  created_at: z
    .union([z.string().datetime({ offset: true }), z.null()])
    .optional(),
  github_run_id: z.number().int(),
  head_branch: z.union([z.string(), z.null()]).optional(),
  name: z.string(),
  sprint_id: z.string(),
  started_at: z
    .union([z.string().datetime({ offset: true }), z.null()])
    .optional(),
  status: z.string().regex(/^(completed|in_progress|queued|cancelled)$/),
  updated_at: z
    .union([z.string().datetime({ offset: true }), z.null()])
    .optional(),
  url: z.union([z.string(), z.null()]).optional(),
});
export const WorkflowRunUpdateRequest = z
  .object({
    completed_at: z.union([z.string().datetime({ offset: true }), z.null()]),
    conclusion: z.union([
      z.string().regex(/^(success|failure|cancelled|skipped)$/),
      z.null(),
    ]),
    head_branch: z.union([z.string(), z.null()]),
    name: z.union([z.string(), z.null()]),
    sprint_id: z.union([z.string(), z.null()]),
    started_at: z.union([z.string().datetime({ offset: true }), z.null()]),
    status: z.union([
      z.string().regex(/^(completed|in_progress|queued|cancelled)$/),
      z.null(),
    ]),
    url: z.union([z.string(), z.null()]),
  })
  .partial();
export const WorkrightsGrantRow = z
  .object({
    agent_id: z.string(),
    expires_at: z.string(),
    granted_at: z.string(),
    granted_by: z.string(),
    granted_reason: z.string(),
    id: z.string(),
    last_used_at: z.union([z.string(), z.null()]).optional(),
    revoked_at: z.union([z.string(), z.null()]).optional(),
    revoked_reason: z.union([z.string(), z.null()]).optional(),
    scope_globs: z.array(z.string()),
    used_count: z.number().int().gte(0),
  })
  .passthrough();
export const WorkrightsListResponse = z
  .object({ data: z.array(WorkrightsGrantRow), total: z.number().int().gte(0) })
  .passthrough();
export const WorkrightsErrorCode = z.enum([
  "UNAUTHORIZED",
  "AUTHORITY_DENIED",
  "ATC_UNAVAILABLE",
  "WORKRIGHT_LOOKUP_FAILED",
  "INVALID_EXPIRES_AT",
  "EXPIRY_CAP_EXCEEDED",
  "WORKRIGHT_GRANT_FAILED",
  "WORKRIGHT_GRANT_WRITE_VERIFICATION_FAILED",
  "WORKRIGHT_NOT_FOUND",
  "WORKRIGHT_ALREADY_REVOKED",
  "WORKRIGHT_REVOKED",
  "WORKRIGHT_REVOKE_FAILED",
  "WORKRIGHT_REVOKE_WRITE_VERIFICATION_FAILED",
  "WORKRIGHT_EXTEND_FAILED",
  "WORKRIGHT_EXTEND_WRITE_VERIFICATION_FAILED",
  "FILTER_REQUIRED",
  "WORKRIGHTS_LIST_FAILED",
]);
export const WorkrightsErrorDetailV1 = z
  .object({
    code: WorkrightsErrorCode,
    message: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const WorkrightsErrorEnvelopeV1 = z
  .object({ error: WorkrightsErrorDetailV1 })
  .passthrough();
export const WorkrightsGrantRequest = z.object({
  agent_id: z.string().min(1),
  authority_policy: z.string(),
  expires_at: z.string().min(1),
  granted_reason: z.string().min(1),
  scope_globs: z.array(z.string()).min(1),
});
export const WorkrightsResponse = z.object({ data: WorkrightsGrantRow }).passthrough();
export const WorkrightsExtendRequest = z
  .object({
    expires_at: z.union([z.string(), z.null()]),
    extend_by_seconds: z.union([z.number().int().gt(0), z.null()]),
    reason: z.union([z.string().min(1), z.null()]),
  })
  .partial();
export const WorkrightsRevokeRequest = z.object({ revoked_reason: z.string().min(1) });
export const CloseoutConfig = z
  .object({
    auto_merge: z.boolean().default(false),
    close_issues: z.boolean().default(true),
    generate_retro: z.boolean().default(true),
  })
  .partial()
  .passthrough();
export const DevConfig = z
  .object({
    agent_count: z.number().int().gte(1).lte(20).default(5),
    loc_cap_per_agent: z.number().int().gte(50).lte(5000).default(500),
    loc_policy: z
      .string()
      .regex(/^(soft|hard)$/)
      .default("soft"),
    model: z.string().default("AUTO"),
    provider: z.string().default("cursor"),
    timeout_seconds: z.number().int().gte(60).lte(14400).default(3600),
  })
  .partial()
  .passthrough();
export const PlanningConfig = z
  .object({
    context_sources: z.array(z.string()),
    guard_profile: z.string().default("js-ts-react"),
    intent_doc_path: z
      .string()
      .default("domains/orchestrator/docs/ARCH_INTENT_PLANNER_STATE_DAG.md"),
    prd_path: z.string().default("planning/PRD.md"),
  })
  .partial()
  .passthrough();
export const RepoConfig = z
  .object({
    base_branch: z.string().optional().default("main"),
    name: z.string().min(1),
    owner: z.string().min(1),
  })
  .passthrough();
export const TelemetryWebhookConfig = z
  .object({
    notify_on: z.array(z.string()),
    webhook_url: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const SprintTriggerV2Request = z
  .object({
    closeout: CloseoutConfig.optional(),
    dev: DevConfig.optional(),
    dispatch_id: z.union([z.string(), z.null()]).optional(),
    force_new_branch: z.boolean().optional().default(false),
    planning: PlanningConfig.optional(),
    prd_content: z.union([z.string(), z.null()]).optional(),
    repo: RepoConfig,
    sprint_id: z.string().min(1),
    telemetry: TelemetryWebhookConfig.optional(),
  })
  .passthrough();
export const SprintTriggerV2Response = z
  .object({
    branch_name: z.union([z.string(), z.null()]).optional(),
    config_stored: z.boolean().optional().default(true),
    dispatch_id: z.string(),
    job_id: z.union([z.string(), z.null()]).optional(),
    pr_number: z.union([z.number().int(), z.null()]).optional(),
    pr_url: z.union([z.string(), z.null()]).optional(),
    sprint_id: z.string(),
    status: z.string().optional().default("planning"),
    workflow_id: z.union([z.string(), z.null()]).optional(),
  })
  .passthrough();
export const SprintEvent = z
  .object({
    conclusion: z.union([z.string(), z.null()]).optional(),
    from_state: z.union([z.string(), z.null()]).optional(),
    message: z.union([z.string(), z.null()]).optional(),
    metadata: z.object({}).partial().passthrough().optional(),
    phase: z.union([z.string(), z.null()]).optional(),
    source: z.union([z.string(), z.null()]).optional(),
    timestamp: z.string().datetime({ offset: true }),
    to_state: z.union([z.string(), z.null()]).optional(),
    type: z.string(),
  })
  .passthrough();
export const SprintEventsResponse = z
  .object({
    events: z.array(SprintEvent).optional(),
    sprint_id: z.string(),
    total: z.number().int().optional().default(0),
  })
  .passthrough();
export const AgentTelemetry = z
  .object({
    batch: z.number().int(),
    conclusion: z.union([z.string(), z.null()]).optional(),
    loc: z.record(z.number().int()).optional(),
    pr_number: z.union([z.number().int(), z.null()]).optional(),
    pr_url: z.union([z.string(), z.null()]).optional(),
    tickets: z.array(z.string()).optional(),
  })
  .passthrough();
export const PhaseTelemetry = z
  .object({
    agents: z.union([z.array(AgentTelemetry), z.null()]).optional(),
    completed_at: z
      .union([z.string().datetime({ offset: true }), z.null()])
      .optional(),
    conclusion: z.union([z.string(), z.null()]).optional(),
    duration_seconds: z.union([z.number().int(), z.null()]).optional(),
    job_id: z.union([z.string(), z.null()]).optional(),
    name: z.string(),
    started_at: z
      .union([z.string().datetime({ offset: true }), z.null()])
      .optional(),
  })
  .passthrough();
export const TelemetryTotals = z
  .object({
    agents_failed: z.number().int().default(0),
    agents_succeeded: z.number().int().default(0),
    dlq_items: z.number().int().default(0),
    duration_seconds: z.number().int().default(0),
    errors: z.number().int().default(0),
    loc: z.record(z.number().int()),
    tickets_completed: z.number().int().default(0),
    tickets_total: z.number().int().default(0),
  })
  .partial()
  .passthrough();
export const SprintTelemetryResponse = z
  .object({
    config: z
      .union([z.object({}).partial().passthrough(), z.null()])
      .optional(),
    phases: z.array(PhaseTelemetry).optional(),
    sprint_id: z.string(),
    status: z.string(),
    totals: TelemetryTotals.optional(),
  })
  .passthrough();
export const DeployVersionResponse = z
  .object({
    built_at: z.string(),
    env: z.string(),
    git_ref: z.string(),
    git_sha: z.string(),
    migration_tip: z.string(),
    provenance_ok: z.boolean(),
    warnings: z.array(z.string()),
  })
  .passthrough();
export const MiddlewareErrorCode = z.literal("ORIGIN_NOT_ALLOWED");
export const MiddlewareErrorDetailV1 = z
  .object({
    code: MiddlewareErrorCode,
    message: z.union([z.string(), z.null()]).optional().default(null),
  })
  .passthrough();
export const MiddlewareErrorEnvelopeV1 = z
  .object({ error: MiddlewareErrorDetailV1 })
  .passthrough();
export const NotificationPreferencesData = z
  .object({
    call_later_reminder: z.union([z.boolean(), z.null()]),
    day_summary: z.union([z.boolean(), z.null()]),
    mission_review: z.union([z.boolean(), z.null()]),
    push_enabled: z.union([z.boolean(), z.null()]),
    report_overdue: z.union([z.boolean(), z.null()]),
    session_stuck: z.union([z.boolean(), z.null()]),
    timesheet_reminder: z.union([z.boolean(), z.null()]),
    user_id: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();
export const RepPreferencesData = z
  .object({
    focus_industries: z.union([z.array(z.string()), z.null()]),
    focus_plz: z.union([z.array(z.string()), z.null()]),
    focus_products: z.union([z.array(z.string()), z.null()]),
    global_business_focus: z.union([
      z.object({}).partial().passthrough(),
      z.null(),
    ]),
    id: z.union([z.number().int(), z.string(), z.null()]),
    joker_max_per_day: z.union([z.number().int(), z.null()]),
    selected_bestandskunden: z.union([
      z.object({}).partial().passthrough(),
      z.null(),
    ]),
    updated_at: z.union([z.string(), z.null()]),
    updated_by: z.union([z.string(), z.null()]),
    user_email: z.union([z.string(), z.null()]),
  })
  .partial()
  .passthrough();

export const schemas: Record<string, z.ZodTypeAny> = {
  PlannerContextRequest,
  PlannerNodeEnvelope,
  ValidationError,
  HTTPValidationError,
  PlannerPlanRequest,
  AutopilotSprintState,
  AutopilotStateEnvelope,
  ImageRefOut,
  SeoMetaOut,
  BlogPostOut,
  ContentErrorOut,
  FaqItemOut,
  IndustryProductOut,
  IndustryOut,
  IndustryChallengeOut,
  FaqEntryOut,
  IndustryPageOut,
  JobMetaOut,
  JobOut,
  LegalDocumentOut,
  NavigationItemOut,
  CallToActionOut,
  HeroBlockOut,
  TextItemOut,
  ValueRowsBlockOut,
  StepsBlockOut,
  CtaBandBlockOut,
  EditorialHeroBlockOut,
  VideoHeroBlockOut,
  HairlineIndexItemOut,
  HairlineIndexBlockOut,
  FeaturedProductTeaserOut,
  FeaturedProductsBlockOut,
  SplitFactOut,
  SplitImageTextBlockOut,
  StatItemOut,
  StatsBandBlockOut,
  DecorativeImageRefOut,
  DarkCtaBandBlockOut,
  MediaBandBlockOut,
  SegmentCardOut,
  SegmentsBlockOut,
  ColorSwatchOut,
  ColorSpectrumBlockOut,
  StorySplitBlockOut,
  PageOut,
  ApplicationStepOut,
  MaterialCompatibilityOut,
  ProductRefOut,
  ProductOut,
  expect_sha,
  ComplianceManifestResponse,
  DiscoveryReviewRequest,
  DiscoveryValue,
  DiscoveryReviewEnvelope,
  EvalReadRequest,
  EvalReadEnvelope,
  ConfigPromoteRequest,
  LlmConfigVersionEnvelope,
  ConfigProposeRequest,
  HygieneBrokenRefRow,
  HygieneChildlessDocRow,
  HygieneForkRow,
  HygieneOrphanChunkRow,
  HygieneStaleEmbeddingRow,
  CrossStoreHygieneData,
  CrossStoreHygieneEnvelope,
  DocSweeperExpiredCadenceRow,
  DocSweeperStaleDraftRow,
  DocSweeperEnvelope,
  EntityJourneyMeta,
  EntityJourneyData,
  EntityJourneyEnvelope,
  GoldenRunRequest,
  GoldenRunEnvelope,
  EvalStatusEnvelope,
  GdprAnonymizeResponse,
  PiiTableExport,
  GdprExportResponse,
  GoldenAdmissionRequest,
  GoldenAdmissionEnvelope,
  ReconcilePauseAbandonEnvelope,
  StaleRefRow,
  StaleRefAuditData,
  StaleRefAuditEnvelope,
  RevokeSessionsRequest,
  RevokeSessionsResponse,
  EmbodimentRef,
  PersonaRow,
  AgentsRegistryEnvelope,
  AgentPinnedDocRow,
  AgentDocsListEnvelope,
  _PinBody,
  AgentDocPinEnvelope,
  AgentDocUnpinEnvelope,
  IdentityDocSlot,
  SystemPromptStack,
  AgentIdentityDocsEnvelope,
  MessageRequest,
  MessageResponse,
  app__api__v1__agents_models__MessageEnvelope,
  app__api__v1__agents_models__SpawnRequest,
  app__api__v1__agents_models__SpawnResponse,
  SpawnEnvelope,
  owner_email,
  lead_id,
  AppointmentRow,
  AppointmentListResponse,
  AppointmentCreateRequest,
  AppointmentRowResponse,
  AppointmentUpdateRequest,
  CookieHandoffBody,
  OnboardingOtpStartRequest,
  OnboardingOtpStartResponse,
  OnboardingOtpVerifyRequest,
  OnboardingOtpVerifyResponse,
  BatchJobResponse,
  BatchProcessingOptions,
  BatchProcessingRequest,
  BatchJobStatus,
  status,
  BatchJobListResponse,
  BatchStatsResponse,
  BulkDeleteRequest,
  BulkDeleteData,
  BulkDeleteEnvelope,
  BulkExportRequest,
  BulkExportData,
  BulkExportEnvelope,
  BulkStatusChangeRequest,
  BulkStatusData,
  BulkStatusEnvelope,
  CallQueueStatus,
  CallQueueRow,
  CallbackRemoveResponse,
  CallingError,
  CallingErrorResponse,
  CallbackQueuePatchRequest,
  CallResultRow,
  CallbackQueuePatchData,
  CallbackQueuePatchResponse,
  CallResultOutcome,
  CallResultCreateRequest,
  app__api__v1__calling_row_models__ContactPersonRow,
  CallResultCreateData,
  CallResultCreateResponse,
  CallResultErrorCode,
  CallResultErrorDetailV1,
  CallResultErrorEnvelopeV1,
  CampaignRow,
  CampaignListResponse,
  CampaignDetailResponse,
  CallingEventCreateRequest,
  CallingEventIngestResponse,
  ClaimNextLeadRequest,
  ClaimedLead,
  ClaimNextLeadResponse,
  DisqualifyLeadRequest,
  QueueActionResponse,
  CallingQueueCardData,
  CallingQueueNextResponse,
  CallingQueueCardErrorCode,
  CallingQueueCardErrorDetailV1,
  CallingQueueCardErrorEnvelopeV1,
  SkipLeadRequest,
  ClaimByIdRequest,
  ClaimByIdResponse,
  LeadEditRequest,
  LeadEditResponse,
  CallingSessionCreateRequest,
  CallingSession,
  CallingSessionResponse,
  CallingSessionUpdateRequest,
  SalesCohortResponse,
  SalesCohortRequest,
  VisitReportsCohortResponse,
  VisitReportsCohortRequest,
  AgentTriggerPatch,
  AgentTriggerPatchEnvelope,
  AgentTriggerFireEnvelope,
  DecisionRatifyBody,
  DecisionRatifyEnvelope,
  CommanderDocCreateEnvelope,
  DocResolveEnvelope,
  ReviewQueueRow,
  ReviewQueueEnvelope,
  CommanderDocSearchRow,
  CommanderDocsSearchEnvelope,
  CommanderDocTagRow,
  CommanderDocTagsEnvelope,
  CommanderDocDeleteEnvelope,
  CommanderDocEnvelope,
  CommanderDocUpdateRequest,
  CommanderDocUpdateEnvelope,
  DocApproveEnvelope,
  DocBacklinkRow,
  DocBacklinksEnvelope,
  DocBodySectionPatchRequest,
  DocBodySectionPatchEnvelope,
  DocBodyPatchErrorCode,
  DocBodyPatchErrorDetailV1,
  DocBodyPatchErrorEnvelopeV1,
  DocVersionSide,
  CommanderDocDiffEnvelope,
  FrontmatterValue,
  DocFrontmatterPatchRequest,
  DocFrontmatterPatchEnvelope,
  FrontmatterPatchErrorCode,
  FrontmatterPatchErrorDetailV1,
  FrontmatterPatchErrorEnvelopeV1,
  DocHistoryVersionRow,
  DocHistoryEnvelope,
  RatifyDocRequest,
  RatifyDocResponse,
  RatifyDocErrorCode,
  RatifyDocErrorDetailV1,
  RatifyDocErrorEnvelopeV1,
  CommanderDocRejectEnvelope,
  DocStatus,
  DocStampRequest,
  DocStampEnvelope,
  StampDocErrorCode,
  StampDocErrorDetailV1,
  StampDocErrorEnvelopeV1,
  EscalationItem,
  EscalationActionBody,
  EscalationActionResponse,
  app__api__v1__commander_inbox_iacp_send__InboxSendBody,
  InboxIacpSendData,
  InboxIacpSendEnvelope,
  app__api__v1__commander_inbox__InboxSendBody,
  InboxSendResponse,
  InboxAckBody,
  InboxAckData,
  InboxAckEnvelope,
  is_blocked,
  ManifestItem,
  ManifestEntryCreate,
  ManifestEntryRow,
  ManifestEntryWriteEnvelope,
  ManifestEntryDeleteData,
  ManifestEntryDeleteEnvelope,
  ManifestEntryPatch,
  PhaseSummary,
  ManifestPatchBody,
  app__api__v1__commander_manifest__CommentBody,
  ManifestCommentRow,
  ManifestCommentEnvelope,
  LifecyclePatchRequest,
  LifecycleResponse,
  ReDispatchRequest,
  ReDispatchResponse,
  MigrationApproveRequest,
  MigrationApproveEnvelope,
  MigrationRejectRequest,
  MigrationRejectEnvelope,
  NotificationPrefsBody,
  NotificationPreferencesResponse,
  app__api__v1__commander_pat_spawn_models__SpawnRequest,
  app__api__v1__commander_pat_spawn_models__SpawnResponse,
  CommanderPrCISummary,
  CommanderPrComments,
  CommanderPrDiffSummary,
  CommanderPrListRow,
  CommanderPrsListMeta,
  CommanderPrsListEnvelope,
  BatchApproveItem,
  PRBatchApproveResultItem,
  PRBatchApproveResponse,
  PRInfo,
  PRGroup,
  CommanderPrReadyRow,
  CommanderPrsNotificationsEnvelope,
  CommanderPrDetailCheck,
  CommanderPrDetailFile,
  CommanderPrIssueComment,
  CommanderPrDetailPr,
  CommanderPrThreadComment,
  CommanderPrReviewThread,
  CommanderPrReview,
  CommanderPrDetail,
  PRApproveResponse,
  _MergeBody,
  merge_as_admin_v1_commander_prs__repo___number__merge_as_admin_post_Body,
  PRMergeAsAdminResponse,
  PRMergePromoteResponse,
  PRRejectBody,
  reject_pr_v1_commander_prs__repo___number__reject_post_Body,
  PRRejectResponse,
  RegisterWorkRequest,
  RegisterWorkEnvelope,
  SessionCommandBody,
  SessionCommandResponse,
  CommanderSkillFamilyRow,
  CommanderSkillFamiliesEnvelope,
  StagingDelta,
  PromoteBody,
  promote_staging_v1_commander_staging__repo__promote_post_Body,
  StagingPromoteResponse,
  app__api__v1__commander_workright_grant_models__WorkrightGrantRequest,
  app__api__v1__commander_workright_grant_models__WorkrightGrantResponse,
  WorkrightGrantErrorCode,
  WorkrightGrantErrorDetailV1,
  WorkrightGrantErrorEnvelopeV1,
  app__api__v1__commander_workrights_g2_models__WorkrightGrantRequest,
  app__api__v1__commander_workrights_g2_models__WorkrightGrantResponse,
  WorkrightEventsErrorCode,
  WorkrightEventsErrorDetailV1,
  WorkrightEventsErrorEnvelopeV1,
  Urgency,
  WorkrightScopeRequestRequest,
  WorkrightScopeRequestResponse,
  WorkrightRevokeRequest,
  WorkrightRevokeResponse,
  PayloadValidateRequest,
  Verdict,
  DiscoveryOptions,
  CompanyDiscoveryRequest,
  CompanyDiscoveryResponse,
  app__api__v1__company_discovery__ServiceHealthResponse,
  CompanyWithSalesOrdersRow,
  CompaniesWithSalesOrdersData,
  CompaniesWithSalesOrdersEnvelope,
  CompanyRowV1,
  CompanyByIdV1Envelope,
  CompanyErrorCode,
  CompanyErrorDetailV1,
  CompanyErrorEnvelopeV1,
  Address,
  Company,
  CompanyAutocompleteData,
  CompanyAutocompleteEnvelope,
  CompanyLookupRequest,
  WaterfallStep,
  CompanyLookupResponse,
  CompanyLookupEnvelope,
  CompanyByIdData,
  CompanyByIdEnvelope,
  app__api__v1__appointments_response_models__ContactPersonRow,
  ContactPersonListResponse,
  ContactPersonCreateRequest,
  ContactPersonRowResponse,
  ContactPersonUpdateRequest,
  WebhookProcessCounts,
  WebhookProcessEnvelope,
  CustomerTypeRow,
  CustomerTypesEnvelope,
  DocumentChunkRowEnvelope,
  DocumentChunkListEnvelope,
  DocSearchHit,
  DocumentVersionRowEnvelope,
  DocumentVersionListEnvelope,
  DocumentRowEnvelope,
  DocumentListEnvelope,
  DocumentIngestData,
  DocumentIngestEnvelope,
  DataProxyRowEnvelope,
  DataProxyListEnvelope,
  MetadataMergeRow,
  MetadataMergeEnvelope,
  DeliberationCreateRequest,
  DeliberationCreateEnvelope,
  DeliberationStatusEnvelope,
  DeliberationEventsEnvelope,
  GateDecisionRequest,
  DeliberationGateEnvelope,
  DeliberationTraceEnvelope,
  DeliberationVersionEnvelope,
  DispatchCallerIdentity,
  DispatchScopeIn,
  DispatchContract,
  DispatchGatewayRequest,
  DispatchRouted,
  DispatchFallback,
  CommsProxyResponseEnvelope,
  EmbodimentCloseReason,
  EmbodimentStatus,
  EmbodimentRow,
  EmbodimentListResponse,
  EmbodimentErrorCode,
  EmbodimentErrorDetailV1,
  EmbodimentErrorEnvelopeV1,
  EmbodimentStartRequest,
  EmbodimentResponse,
  EmbodimentKillRequest,
  EmbodimentSendMessageRequest,
  EmbodimentSendMessageResponse,
  EmbodimentRebootRequest,
  EmbodimentResumeRequest,
  DispatchRequest,
  DispatchResponse,
  LiveEmbodimentRow,
  TransitionRequest,
  TransitionResponse,
  ModuleEntitlements,
  ModuleEntitlementsResponse,
  DirectionsLeg,
  DirectionsOverviewPolyline,
  DirectionsRoute,
  DirectionsResponse,
  language,
  components,
  GeocodeResponse,
  PlacesAutocompleteStructuredFormatting,
  PlacesAutocompletePrediction,
  PlacesAutocompleteResponse,
  fields,
  GooglePlaceDetailV1Response,
  PlacesDetailsGeometry,
  PlacesDetailsPhoto,
  PlacesDetailsResult,
  PlacesDetailsResponse,
  PlacesSearchRequest,
  GooglePlacesV1SearchResponse,
  PlacesSearchAlongRouteRequest,
  LatLng,
  PlacesSearchNearbyRequest,
  PlacesSearchTextRequest,
  RoutesRequest,
  RoutesResponse,
  RoutesCalculateRequest,
  RoutesCalculatePolyline,
  RoutesCalculateRoute,
  RoutesCalculateResponse,
  GovernancePendingRow,
  GovernancePendingEnvelope,
  GovernancePromoteEnvelope,
  GovernanceRejectEnvelope,
  CircuitBreakerResponse,
  HealthResponse,
  app__api__v1__health_monitoring_models__ServiceHealthResponse,
  services,
  CaseLookupRequest,
  CaseLookupResponse,
  HelpdeskDoorErrorCode,
  HelpdeskDoorRetryWith,
  HelpdeskDoorErrorDetailV1,
  HelpdeskDoorErrorEnvelopeV1,
  CaseMapRequest,
  CaseMapEntry,
  CaseMapResponse,
  DoorName,
  DoorCallResponse,
  call_helpdesk_door_v1_helpdesk_doors__door__post_Body,
  IamRow,
  IamRowsEnvelope,
  PermissionCheckRequest,
  IamCheckEnvelope,
  InvocationIncrementRequest,
  IamIncrementEnvelope,
  PermissionEntry,
  SetUserPermissionsRequest,
  IamOkEnvelope,
  RoleLevelEntry,
  SetRoleLevelsRequest,
  RolePermissionEntry,
  SetRolePermissionsRequest,
  IamRoleRow,
  IamRolesListEnvelope,
  app__api__v1__iam_models__RoleCreateRequest,
  IamRoleEnvelope,
  IamMessageEnvelope,
  app__api__v1__iam_models__RoleUpdateRequest,
  ImpersonationCandidateRow,
  ImpersonationCandidatesEnvelope,
  StartRequest,
  TargetUser,
  StartResponse,
  StopRequest,
  StopResponse,
  IndustryRow,
  IndustriesEnvelope,
  CallingCampaignConfigRefreshData,
  CallingCampaignConfigRefreshEnvelope,
  NightAutomergeProcessBody,
  process_night_automerge_queue_v1_internal_night_automerge_process_post_Body,
  NightAutomergeDetail,
  NightAutomergeProcessEnvelope,
  TelemetryAlert,
  TelemetryChannelOutcome,
  TelemetryEmission,
  AggregateRunCounters,
  TelemetrySweepData,
  TelemetrySweepEnvelope,
  SweepRequest,
  post_scout_telemetry_aggregate_v1_internal_scout_telemetry_aggregate_post_Body,
  TopupRunRow,
  TopupRunListEnvelope,
  TopupRunReport,
  TopupRunRecordEnvelope,
  LeadRow,
  LeadsListMeta,
  LeadsListEnvelope,
  UnifiedLeadCreateRequest,
  LeadCreateEnvelope,
  LeadBackfillGeocodeEnvelope,
  BatchLeadsRequest,
  LeadsBatchData,
  LeadsBatchEnvelope,
  UnifiedLeadUpdateRequest,
  LeadUpdateEnvelope,
  LeadEnrichmentRequest,
  LeadEnrichmentResult,
  LeadEnrichData,
  LeadEnrichEnvelope,
  LeadVisitRequest,
  LeadVisitEnvelope,
  LeadVisitRow,
  LeadVisitHistoryData,
  LeadVisitHistoryEnvelope,
  EllisIslandTouchpoint,
  EllisIslandProcessRequest,
  EllisIslandProcessResponse,
  EllisIslandErrorCode,
  EllisIslandErrorDetailV1,
  EllisIslandErrorEnvelopeV1,
  ReconcileDocStoreRequest,
  ReconcileDetailRow,
  ReconcileDocStoreResponse,
  LibraryCardFrontmatterExcerpt,
  LibraryCardInboxRow,
  LibraryCardInboxEnvelope,
  RunInput,
  RunCreateRequest,
  RunResponse,
  VisionVerifyEnvelope,
  ManifestControlsBody,
  ManifestControlsResponse,
  MappingUnmatchedEntry,
  MappingExportUnmatchedData,
  MappingExportUnmatchedEnvelope,
  MappedLinksResponse,
  MappingReviewData,
  MappingReviewEnvelope,
  ReviewActionRequest,
  ReviewActionResponse,
  MappingRunRequest,
  MappingRunResponse,
  MappingConfidenceBand,
  MappingMunicipalityRate,
  MappingStatsData,
  MappingStatsEnvelope,
  McpJsonRpcError,
  McpJsonRpcEnvelope,
  MetricsTargetsData,
  MetricsTargetsEnvelope,
  MissionRowV1,
  MissionListResponse,
  MissionRowErrorCode,
  MissionRowErrorDetailV1,
  MissionRowErrorEnvelopeV1,
  MissionCreateRequest,
  MissionRowResponse,
  MissionCreateErrorCode,
  MissionCreateErrorDetailV1,
  MissionCreateErrorEnvelopeV1,
  MissionCapacityCheckData,
  MissionCapacityCheckResponse,
  MissionPrefsErrorCode,
  MissionPrefsErrorDetailV1,
  MissionPrefsErrorEnvelopeV1,
  MissionCapacityStatusData,
  MissionCapacityStatusResponse,
  MissionComplianceDataV1,
  MissionComplianceResponse,
  MissionGenerationRequest,
  MissionGenerateData,
  MissionGenerateResponse,
  MissionIdempotencyCleanupData,
  MissionIdempotencyCleanupResponse,
  MissionOpsErrorCode,
  MissionOpsErrorDetailV1,
  MissionOpsErrorEnvelopeV1,
  MissionIdempotencyStatsData,
  MissionIdempotencyStatsResponse,
  MissionPreferencesRowV1,
  MissionPreferencesListResponse,
  MissionPreferencesResponse,
  MissionPreferencesRequest,
  MissionScenariosData,
  MissionScenariosResponse,
  MissionScoringSnapshotData,
  MissionScoringSnapshotResponse,
  MissionLeadsErrorCode,
  MissionLeadsErrorDetailV1,
  MissionLeadsErrorEnvelopeV1,
  StopTransitionRequest,
  StopTransitionData,
  StopTransitionResponse,
  AnchorEventRequest,
  MissionAnchorEventV1,
  MissionAnchorEventResponse,
  MissionStopsErrorCode,
  MissionStopsErrorDetailV1,
  MissionStopsErrorEnvelopeV1,
  VisitReportAccessResult,
  VisitReportConversationResult,
  VisitReportTypeCorrect,
  VisitReportSubmitRequest,
  MissionVisitReportData,
  MissionVisitReportResponse,
  MissionRejectErrorCode,
  MissionRejectErrorDetailV1,
  MissionRejectErrorEnvelopeV1,
  VisitReportV2JahresbedarfItem,
  VisitReportV2SubmitRequest,
  VisitReportV2Engagement,
  VisitReportDeadLetter,
  VisitReportV2SubmitResponse,
  VisitReportV8Bedarf,
  VisitReportV8Paar,
  VisitReportV8ProduktZuweisung,
  VisitReportV8Upsell,
  VisitReportV8SubmitRequest,
  VisitReportV8Result,
  VisitReportV8DeadLetter,
  VisitReportV8SubmitResponse,
  MissionUpdateRequest,
  PendingLeadRow,
  MissionBacklogDataV1,
  MissionBacklogResponse,
  MissionJokerGoogleAutocompleteV1,
  MissionJokerManualEntryV1,
  JokerCreateRequest,
  MissionJokerQuotaV1,
  MissionStopV1,
  MissionJokerCreateDataV1,
  MissionJokerResponse,
  MissionJokerListResponse,
  JokerDeleteResponse,
  MissionLeadAssignment,
  MissionAddLeadsInputV1,
  AddedLeadRow,
  MissionAddLeadsDataV1,
  MissionAddLeadsResponse,
  MissionLeadStateName,
  MissionLeadStateReason,
  MissionLeadUpdateRequest,
  MissionLeadStateData,
  MissionLeadStateResponse,
  MissionAnchorEventListResponse,
  MissionLeadRejectionReason,
  MissionLeadRejectRequest,
  MissionLeadRejectData,
  MissionLeadRejectResponse,
  MissionLeadSkipRequest,
  MissionLeadSkipData,
  MissionLeadSkipResponse,
  MissionLeadVisitRequest,
  MissionLeadVisitData,
  MissionLeadVisitResponse,
  MissionRejectRequest,
  MissionRejectResponse,
  MissionResumeRequest,
  MissionResumeDataV1,
  MissionResumeResponse,
  MissionLifecycleErrorCode,
  MissionLifecycleErrorDetailV1,
  MissionLifecycleErrorEnvelopeV1,
  MissionStopListResponse,
  StopReorderRequest,
  MissionStopReorderResponse,
  MissionStopRowResponse,
  StopUpdateRequest,
  MissionTransitionNode,
  MissionTransitionRequest,
  MeetingPoint,
  MissionBuildOverrides,
  MissionBuildRequest,
  MissionBuildMetadata,
  MissionBuildResponseEnvelope,
  HealthCheckResponse,
  MetricsResponse,
  NoteIn,
  NoteLogData,
  NoteLogEnvelope,
  NotificationRow,
  NotificationsListEnvelope,
  NotificationsMarkAllReadData,
  NotificationsMarkAllReadEnvelope,
  NotificationPreferencesRow,
  NotificationPreferencesEnvelope,
  NotificationPreferencesUpdate,
  NotificationsUnreadCountData,
  NotificationsUnreadCountEnvelope,
  NotificationUpdate,
  NotificationUpdateEnvelope,
  OdooSalesAnalyticsData,
  OdooSalesAnalyticsEnvelope,
  BatchUpdateRequest,
  OdooBatchUpdateData,
  OdooBatchUpdateEnvelope,
  OdooSalesCompanyRow,
  OdooSalesCompaniesData,
  OdooSalesCompaniesEnvelope,
  OdooAddressRow,
  OdooAddressesData,
  OdooAddressesEnvelope,
  year,
  OdooBesuchsberichtRow,
  OdooBesuchsberichteData,
  OdooBesuchsberichteEnvelope,
  OdooContactRow,
  OdooContactsData,
  OdooContactsEnvelope,
  OdooEnrichmentUpdateData,
  OdooEnrichmentUpdateEnvelope,
  OdooFinancialRow,
  OdooFinancialsData,
  OdooFinancialsEnvelope,
  OdooInvoiceRow,
  OdooInvoicesData,
  OdooInvoicesEnvelope,
  OdooProductRow,
  OdooProductsData,
  OdooProductsEnvelope,
  PipelineConfigUpsertRequest,
  PipelineConfigRow,
  PipelineConfigUpsertEnvelope,
  AddLabelRequest,
  POActionResult,
  AnswerQuestionRequest,
  ApproveSprintRequest,
  PauseSprintRequest,
  PostCommentRequest,
  RejectSprintRequest,
  RemoveLabelRequest,
  RequestChangesRequest,
  RerunWorkflowRequest,
  ResumeSprintRequest,
  StartPlanningRequest,
  POStartPlanningEnvelope,
  TriggerWorkflowRequest,
  POArtifactsData,
  POArtifactsEnvelope,
  POBudgetTotals,
  POBudget,
  POBudgetEnvelope,
  POCurrentSprintEnvelope,
  POGithubActivityEnvelope,
  POPrDetailsEnvelope,
  POQaEnvelope,
  POWavesEnvelope,
  POWorkflowRunsEnvelope,
  POSprintListItem,
  POSprintListEnvelope,
  POSprintDetailEnvelope,
  PrequalSessionEventCreateRequest,
  Item,
  LaEstimateRequest,
  LaEstimateEnvelope,
  ProductRow,
  ProductListEnvelope,
  ProductCategoryRow,
  ProductCategoryListEnvelope,
  PseCompanyDetailsRequest,
  PseCompanyDetailsResponse,
  PseRawRequest,
  PseRawResponse,
  PseStatusResponse,
  PushNotificationRequest,
  PushSendData,
  PushSendEnvelope,
  PushSubscription,
  PushSubscribeData,
  PushSubscribeEnvelope,
  PushUnsubscribeData,
  PushUnsubscribeEnvelope,
  VapidPublicKeyResponse,
  CompaniesSampleResponse,
  CompanyGT,
  EvalItem,
  ImprintEvalRequest,
  ImprintEvalMismatch,
  ImprintEvalData,
  ImprintEvalMeta,
  ImprintEvalResponse,
  ImprintInputCompany,
  ImprintOptions,
  ImprintExtractRequest,
  ImprintExtractExtractor,
  ImprintExtractInput,
  ImprintExtractResult,
  ImprintExtractData,
  ImprintExtractMeta,
  ImprintExtractResponse,
  SchemaCompaniesData,
  SchemaCompaniesMeta,
  SchemaCompaniesResponse,
  ImprintUpsertItem,
  ImprintUpsertRequest,
  ImprintUpsertResponse,
  MissionQueryFilters,
  MissionQueryPagination,
  MissionQuerySort,
  MissionQueryRequest,
  MissionQueryResponse,
  CrawlWebsiteRequest,
  RaiderResponse,
  ExtractImprintRequest,
  UrParseRequest,
  RepPreferencesWeightsUpdate,
  RepPreferencesWeightsRow,
  RepPreferencesWeightsEnvelope,
  RepPreferencesRow,
  RepPreferencesEnvelope,
  RepPreferencesUpdate,
  RoleRow,
  RolesListEnvelope,
  app__api__v1__roles__RoleCreateRequest,
  RoleMutationEnvelope,
  RoleDeleteEnvelope,
  app__api__v1__roles__RoleUpdateRequest,
  RouteComputeData,
  RouteComputeEnvelope,
  RouteOptimizeRequest,
  RouteOptimizeData,
  RouteOptimizeEnvelope,
  RouteStop,
  RoutePreviewRequest,
  RoutePreviewData,
  RoutePreviewEnvelope,
  ApplyVariantRequest,
  RouteApplyVariantData,
  RouteApplyVariantEnvelope,
  RouteVariantRow,
  RouteVariantsData,
  RouteVariantsEnvelope,
  ScanOrderRow,
  ScanOrdersListMeta,
  ScanOrdersListEnvelope,
  Body_upload_scan_v1_scan_orders_post,
  ScanOrderResultEnvelope,
  ScanOrderExtractRequest,
  ResolveContextData,
  ResolveContextEnvelope,
  BestellerContact,
  ResolveOrCreateBillingRequest,
  ResolveOrCreateBillingResponse,
  ScanOrderDetailMeta,
  ScanOrderDetailEnvelope,
  Besteller,
  CommsDoc,
  CommsRecipient,
  CommsRouting,
  ContractPartner,
  DeliveryAddress,
  OrderPosition,
  OrderTerms,
  ScanOrderConfirmRequest,
  EmailVerificationNotice,
  ScanOrderConfirmEnvelope,
  ScanOrderRejectRequest,
  ScanOrderRejectEnvelope,
  ScanReviewEnvelope,
  ScanReviewLinkData,
  ScanReviewLinkEnvelope,
  RequestedScope,
  ScopeRequestUrgency,
  ScopeRequestRequest,
  ScopeRequestResponse,
  ScopeRequestErrorCode,
  ScopeRequestErrorDetailV1,
  ScopeRequestErrorEnvelopeV1,
  ActivityRow,
  ActivityTotals,
  ActivityTableResponse,
  HeatmapBreakdown,
  HeatmapRegion,
  HeatmapScale,
  HeatmapResponse,
  PeriodInfo,
  KpiTile,
  KpisResponse,
  AnnualTargets,
  SeasonBlock,
  DerivedTargets,
  MonthlyOverride,
  TargetsResponse,
  PutTargetsBody,
  TopBrancheRow,
  TopBranchenResponse,
  TopProduktRow,
  TopProdukteResponse,
  ScoutActivityEvent,
  DemoRateBlock,
  RepeatVisitFlag,
  SystemVsManualDelta,
  TerritorySaturationItem,
  VisitDepthScore,
  RepDiagnosticsResponse,
  TeamRepSummary,
  TeamAverages,
  TeamDiagnosticsResponse,
  UseCaseProduct,
  UseCaseItem,
  LeadUseCasesResponse,
  MissionTargets,
  MissionConfigBlock,
  MissionConfigResponse,
  MissionConfigPatchBody,
  DayStateUpsertRequest,
  DayStateResponse,
  NextLeadSuggestionRequest,
  AlternativeLead,
  KmWarning,
  ScoreBreakdown,
  SuggestedLead,
  NextLeadSuggestionResponse,
  ScoutCallQueueRow,
  ScoutCompanyRow,
  ScoutOutcomeRow,
  ScoutScriptRow,
  ScoutPrequalStats,
  PrequalContextData,
  PrequalContextResponse,
  GreyZoneItem,
  GreyZonesResponse,
  GreyZoneUpdateBody,
  ScoutLeadRow,
  ScoutMissionRow,
  ScoutRepPreferences,
  ScoutRepTargets,
  TagesplanungContextData,
  TagesplanungContextResponse,
  ScoutAppointmentRow,
  ScoutRegionRow,
  ScoutRepSettings,
  WochenplanungContextData,
  WochenplanungContextResponse,
  ZoneApprovalListItem,
  ZoneApprovalRequest,
  ZoneApprovalResponse,
  ZoneApprovalPatchBody,
  SearchData,
  SearchEnvelope,
  SessionChatIdentity,
  SessionChatRole,
  SessionChatMessageRow,
  SessionChatListResponse,
  SessionChatErrorCode,
  SessionChatErrorDetailV1,
  SessionChatErrorEnvelopeV1,
  SessionChatSendRequest,
  SessionChatSendResponse,
  SettingsEnvelope,
  SettingsUpdateRequest,
  SettingsUpdateEnvelope,
  ObjectionRow,
  ObjectionListResponse,
  ScriptRow,
  ScriptListResponse,
  TemplateListSummary,
  TemplateCompleteness,
  TemplateRow,
  TemplateListResponse,
  SprintResponse,
  SprintListResponse,
  SprintCreateRequest,
  SuccessResponse,
  SprintUpdateRequest,
  SprintArtifactResponse,
  SprintArtifactListResponse,
  SprintArtifactCreateRequest,
  SprintEventResponse,
  SprintEventListResponse,
  SprintEventCreateRequest,
  WorkflowRunResponse,
  WorkflowRunListResponse,
  CreateRunRequest,
  CreateRunResponse,
  CompleteRunRequest,
  StagingCompleteEnvelope,
  AppendErrorRequest,
  StagingAckEnvelope,
  AppendResultRequest,
  StagingMetaTablesEnvelope,
  StagingTableColumn,
  StagingTableConstraint,
  StagingMetaTableEnvelope,
  SupabaseCompanyWithSalesOrdersRow,
  SupabaseCompaniesWithSalesOrdersData,
  SupabaseCompaniesWithSalesOrdersEnvelope,
  SupabaseQueryRequest,
  SupabaseQueryRow,
  SupabaseQueryEnvelope,
  SupabaseSchemaData,
  SupabaseSchemaEnvelope,
  SupplierDocumentEnvelope,
  TaskRow,
  TasksEnvelope,
  TeamMember,
  TeamMembersListEnvelope,
  TeamRow,
  TeamsListEnvelope,
  TeamMemberEnvelope,
  TenantBranding,
  TenantData,
  TenantResolveEnvelope,
  TimeEntryRow,
  TimeEntryListEnvelope,
  TimeEntryCreate,
  TimeEntryEnvelope,
  TimeEntryUpdate,
  TimesheetRow,
  TimesheetListEnvelope,
  TimesheetSubmit,
  TimesheetEnvelope,
  since,
  TriggerFireRow,
  TriggerFiresListEnvelope,
  TriggerRespondEnvelope,
  TriggerRow,
  TriggerListEnvelope,
  TriggerCreateRequest,
  TriggerDispatchResult,
  TriggerDispatchEnvelope,
  TriggerPatchRequest,
  TriggerFireRequest,
  TriggerFireResultEnvelope,
  TwinControlRestartRequest,
  TwinStatus,
  TwinControlRow,
  TwinControlErrorCode,
  TwinControlError,
  TwinControlEnvelope,
  TwinControlResumeRequest,
  TwinControlStartRequest,
  TwinControlStopRequest,
  min_score,
  min_gp_eur,
  min_employees,
  max_employees,
  UnifiedLeadRow,
  UnifiedLeadsData,
  UnifiedLeadsEnvelope,
  UnifiedLeadsQueryRequest,
  UserRow,
  UsersListEnvelope,
  UserCreateRequest,
  UserMutationEnvelope,
  UserSelfUpdateRequest,
  UserSelfUpdateEnvelope,
  GitHubPatStatusEnvelope,
  GitHubPatPostBody,
  GithubResolveThreadEnvelope,
  GithubRerunEnvelope,
  GithubClosePullEnvelope,
  app__api__v1__users_github_mutations__CommentBody,
  GithubCommentEnvelope,
  EditPullBody,
  GithubPullObjectEnvelope,
  MergeBody,
  GithubMergePullEnvelope,
  ReviewBody,
  GithubReviewEnvelope,
  DismissBody,
  GithubDismissReviewEnvelope,
  GithubUpdateBranchEnvelope,
  UsersSyncSummary,
  UsersSyncEnvelope,
  PlzAreasUpdateRequest,
  UserPlzAreasRow,
  UserPlzAreasEnvelope,
  UserUpdateRequest,
  AppAccessItem_Output,
  AppAccessListEnvelope,
  AppAccessItem_Input,
  AppAccessUpdateRequest,
  app__api__v1__users_models__MessageEnvelope,
  FeatureAccessItem_Output,
  FeatureAccessEnvelope,
  FeatureAccessItem_Input,
  FeatureAccessUpdateRequest,
  HomeAddressData,
  HomeAddressEnvelope,
  JokerQuotaData,
  JokerQuotaEnvelope,
  PLZZoneResponse,
  UserPLZZonesResponse,
  PLZZoneAssignmentRequest,
  PLZZoneRemovedEnvelope,
  Ops247ActiveLoopRow,
  Ops247ActiveLoopEnvelope,
  ViewProxyErrorCode,
  ViewProxyErrorDetailV1,
  ViewProxyErrorEnvelopeV1,
  Ops247DispatchLogRow,
  Ops247DispatchLogEnvelope,
  Ops247PendingDispatchesRow,
  Ops247PendingDispatchesEnvelope,
  AgentEmbodimentsUnifiedRow,
  AgentEmbodimentsUnifiedEnvelope,
  AgentFlightRightsGrantsRow,
  AgentFlightRightsGrantsEnvelope,
  AgentPersonaPearlChainRow,
  AgentPersonaPearlChainEnvelope,
  AgentPersonasRow,
  AgentPersonasEnvelope,
  AgentSignalsRow,
  AgentSignalsEnvelope,
  AgentTriggersRow,
  AgentTriggersEnvelope,
  AgentWorkBundleRow,
  AgentWorkBundleEnvelope,
  AgentsRow,
  AgentsEnvelope,
  AppointmentsRow,
  AppointmentsEnvelope,
  BridgeEntriesRow,
  BridgeEntriesEnvelope,
  CallbackQueueRow,
  CallbackQueueEnvelope,
  CallerWorkLogRow,
  CallerWorkLogEnvelope,
  CallingLeadCardRow,
  CallingLeadCardEnvelope,
  CallingScriptActiveRow,
  CallingScriptActiveEnvelope,
  CallingSessionBillingRow,
  CallingSessionBillingEnvelope,
  CallingSessionStateRow,
  CallingSessionStateEnvelope,
  CallingSessionStintsRow,
  CallingSessionStintsEnvelope,
  CampaignDashboardRow,
  CampaignDashboardEnvelope,
  CampaignQueueOverviewRow,
  CampaignQueueOverviewEnvelope,
  CaseDetailRow,
  CaseDetailEnvelope,
  CasesRow,
  CasesEnvelope,
  ChatInboxRow,
  ChatInboxEnvelope,
  CommsDrift1hRow,
  CommsDrift1hEnvelope,
  CommsDrift24hRow,
  CommsDrift24hEnvelope,
  CompanyRow,
  CompanyEnvelope,
  ContactPersonsRow,
  ContactPersonsEnvelope,
  CustomersRow,
  CustomersEnvelope,
  DaemonCommandsRow,
  DaemonCommandsEnvelope,
  DaemonLogsRow,
  DaemonLogsEnvelope,
  DaemonStatusRow,
  DaemonStatusEnvelope,
  DecisionsPendingRow,
  DecisionsPendingEnvelope,
  AgentEmbodimentsTrackingRow,
  AgentEmbodimentsTrackingEnvelope,
  ExecutionManifestRow,
  ExecutionManifestEnvelope,
  GithubEventsRow,
  GithubEventsEnvelope,
  GovernanceDocumentsRow,
  GovernanceDocumentsEnvelope,
  IdentityStackRow,
  IdentityStackEnvelope,
  IntakePipelineRow,
  IntakePipelineEnvelope,
  InvoicesRow,
  InvoicesEnvelope,
  KdpMonthlyCrosstabRow,
  KdpMonthlyCrosstabEnvelope,
  LeadCallHistoryRow,
  LeadCallHistoryEnvelope,
  LeadsRow,
  LeadsEnvelope,
  LibraryCardsRow,
  LibraryCardsEnvelope,
  ManifestActivityFeedRow,
  ManifestActivityFeedEnvelope,
  ManifestDepsRow,
  ManifestDepsEnvelope,
  ManifestEntriesRow,
  ManifestEntriesEnvelope,
  ManifestEscalationsRow,
  ManifestEscalationsEnvelope,
  ManifestHealthRow,
  ManifestHealthEnvelope,
  ManifestTreeRow,
  ManifestTreeEnvelope,
  ManifestTriageRow,
  ManifestTriageEnvelope,
  MissionDayReadRow,
  MissionDayReadEnvelope,
  MissionSummaryRow,
  MissionSummaryEnvelope,
  MyCampaignRow,
  MyCampaignEnvelope,
  MyEffectiveScopeRow,
  MyEffectiveScopeEnvelope,
  OdooMirrorFreshnessMailMessageRow,
  OdooMirrorFreshnessMailMessageEnvelope,
  OpTrackingRow,
  OpTrackingEnvelope,
  PendingMigrationsRow,
  PendingMigrationsEnvelope,
  PersonaStackRow,
  PersonaStackEnvelope,
  PipelineConfigViewRow,
  PipelineConfigViewEnvelope,
  PostCallBriefingRow,
  PostCallBriefingEnvelope,
  PrequalAssignmentRow,
  PrequalAssignmentEnvelope,
  PrequalReferenceClustersRow,
  PrequalReferenceClustersEnvelope,
  PrequalReferenceRolesRow,
  PrequalReferenceRolesEnvelope,
  PrequalReferenceUsecasesRow,
  PrequalReferenceUsecasesEnvelope,
  ProcessInstancesRow,
  ProcessInstancesEnvelope,
  ProcessTemplatesRow,
  ProcessTemplatesEnvelope,
  ProductsRow,
  ProductsEnvelope,
  RepoRegistryRow,
  RepoRegistryEnvelope,
  SalesOrdersRow,
  SalesOrdersEnvelope,
  SessionEventsRow,
  SessionEventsEnvelope,
  TicketsRow,
  TicketsEnvelope,
  VisitQuestionnaireActiveRow,
  VisitQuestionnaireActiveEnvelope,
  VisitReportReadRow,
  VisitReportReadEnvelope,
  VisitReportV2Row,
  VisitReportV2Envelope,
  CoreVisitTelemetryReadRow,
  CoreVisitTelemetryReadEnvelope,
  WacklerAccountOverviewRow,
  WacklerAccountOverviewEnvelope,
  WacklerBillsRow,
  WacklerBillsEnvelope,
  WacklerCommunicationsRow,
  WacklerCommunicationsEnvelope,
  WacklerConfigRow,
  WacklerConfigEnvelope,
  WacklerFreightLinesRow,
  WacklerFreightLinesEnvelope,
  WacklerInvoiceDetailRow,
  WacklerInvoiceDetailEnvelope,
  WacklerInvoicePreSendReviewRow,
  WacklerInvoicePreSendReviewEnvelope,
  WacklerInvoiceSummaryRow,
  WacklerInvoiceSummaryEnvelope,
  WacklerMonthDetailRow,
  WacklerMonthDetailEnvelope,
  WacklerParetoPeriodRow,
  WacklerParetoPeriodEnvelope,
  WacklerPaymentsRow,
  WacklerPaymentsEnvelope,
  WacklerReconciliationRow,
  WacklerReconciliationEnvelope,
  WacklerWorkspaceRow,
  WacklerWorkspaceEnvelope,
  WacklerDieselByMonthResponse,
  WacklerRefCase,
  WikiBucketsByRepoRow,
  WikiBucketsByRepoEnvelope,
  WikiBucketsByTypeRow,
  WikiBucketsByTypeEnvelope,
  WikiByRepoRow,
  WikiByRepoEnvelope,
  WikiByTypeRow,
  WikiByTypeEnvelope,
  WorkrightsViewRow,
  WorkrightsViewEnvelope,
  ViewProxyMeta,
  ViewProxyEnvelope,
  VisitReportListResponse,
  VoiceSessionProxyEnvelope,
  VoiceTokenEnvelope,
  CommunicationBody,
  CommunicationResponse,
  WacklerCreditAllocateRequest,
  WacklerCreditAllocateData,
  WacklerCreditAllocateResponse,
  WacklerSignedUrlData,
  WacklerSignedUrlResponse,
  LineStateBody,
  LineStateResponse,
  WarehouseInventoryResponse,
  WarehouseShipmentConfirmResponse,
  WikiRepoBucket,
  WikiTypeBucket,
  WikiBucketsEnvelope,
  WikiDocRow,
  WikiListEnvelope,
  WorkflowRunCreateRequest,
  WorkflowRunUpdateRequest,
  WorkrightsGrantRow,
  WorkrightsListResponse,
  WorkrightsErrorCode,
  WorkrightsErrorDetailV1,
  WorkrightsErrorEnvelopeV1,
  WorkrightsGrantRequest,
  WorkrightsResponse,
  WorkrightsExtendRequest,
  WorkrightsRevokeRequest,
  CloseoutConfig,
  DevConfig,
  PlanningConfig,
  RepoConfig,
  TelemetryWebhookConfig,
  SprintTriggerV2Request,
  SprintTriggerV2Response,
  SprintEvent,
  SprintEventsResponse,
  AgentTelemetry,
  PhaseTelemetry,
  TelemetryTotals,
  SprintTelemetryResponse,
  DeployVersionResponse,
  MiddlewareErrorCode,
  MiddlewareErrorDetailV1,
  MiddlewareErrorEnvelopeV1,
  NotificationPreferencesData,
  RepPreferencesData,
};
